(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.hD.bE === region.gB.bE)
	{
		return 'on line ' + region.hD.bE;
	}
	return 'on lines ' + region.hD.bE + ' through ' + region.gB.bE;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iX,
		impl.j6,
		impl.jZ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (
		(typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		||
		(Array.isArray(_Json_unwrap(value)) && _VirtualDom_RE_js_html.test(String(_Json_unwrap(value))))
	)
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		aB: func(record.aB),
		fY: record.fY,
		fQ: record.fQ
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.aB;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.fY;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.fQ) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iX,
		impl.j6,
		impl.jZ,
		function(sendToApp, initialModel) {
			var view = impl.ka;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iX,
		impl.j6,
		impl.jZ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.fW && impl.fW(sendToApp)
			var view = impl.ka;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.ic);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.j2) && (_VirtualDom_doc.title = title = doc.j2);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.jr;
	var onUrlRequest = impl.js;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		fW: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.jB === next.jB
							&& curr.iS === next.iS
							&& curr.jx.a === next.jx.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		iX: function(flags)
		{
			return A3(impl.iX, flags, _Browser_getUrl(), key);
		},
		ka: impl.ka,
		j6: impl.j6,
		jZ: impl.jZ
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { iR: 'hidden', ig: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { iR: 'mozHidden', ig: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { iR: 'msHidden', ig: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { iR: 'webkitHidden', ig: 'webkitvisibilitychange' }
		: { iR: 'hidden', ig: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		hv: _Browser_getScene(),
		hS: {
			hX: _Browser_window.pageXOffset,
			hY: _Browser_window.pageYOffset,
			hW: _Browser_doc.documentElement.clientWidth,
			fs: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		hW: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		fs: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			hv: {
				hW: node.scrollWidth,
				fs: node.scrollHeight
			},
			hS: {
				hX: node.scrollLeft,
				hY: node.scrollTop,
				hW: node.clientWidth,
				fs: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			hv: _Browser_getScene(),
			hS: {
				hX: x,
				hY: y,
				hW: _Browser_doc.documentElement.clientWidth,
				fs: _Browser_doc.documentElement.clientHeight
			},
			iw: {
				hX: x + rect.left,
				hY: y + rect.top,
				hW: rect.width,
				fs: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.fj.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.fj.b, xhr)); });
		$elm$core$Maybe$isJust(request.hM) && _Http_track(router, xhr, request.hM.a);

		try {
			xhr.open(request.g5, request.bS, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.bS));
		}

		_Http_configureRequest(xhr, request);

		request.ic.a && xhr.setRequestHeader('Content-Type', request.ic.a);
		xhr.send(request.ic.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.gN; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.hK.a || 0;
	xhr.responseType = request.fj.d;
	xhr.withCredentials = request.h3;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		bS: xhr.responseURL,
		hE: xhr.status,
		jW: xhr.statusText,
		gN: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			jS: event.loaded,
			hz: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			jE: event.loaded,
			hz: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.jf) { flags += 'm'; }
	if (options.$8) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Update$NoOp = {$: 0};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.q) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.t);
		} else {
			var treeLen = builder.q * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.u) : builder.u;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.q);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.t);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{u: nodeList, q: (len / $elm$core$Array$branchFactor) | 0, t: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {gJ: fragment, iS: host, hh: path, jx: port_, jB: protocol, hm: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Update$Now = function (a) {
	return {$: 5, a: a};
};
var $author$project$Update$Timezone = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Domain$Total$Amount$CAD = 0;
var $author$project$Language$French = 1;
var $author$project$Domain$User$Orisha = 0;
var $author$project$Domain$User$accreditedUsers = _List_fromArray(
	[
		{ik: 0, gy: $elm$core$Maybe$Nothing, fq: 0, cJ: 0, i$: 1, hg: 'BananaPricing', hQ: 'Orisha'}
	]);
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Domain$User$decode = function (token) {
	return A2(
		$elm$core$Maybe$andThen,
		function (t) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (u) {
						return _Utils_eq(u.cJ, t);
					},
					$author$project$Domain$User$accreditedUsers));
		},
		A2($elm$core$Maybe$andThen, $elm$core$String$toInt, token));
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Update$QuoteBuilderV3 = 1;
var $author$project$Update$Saved = 0;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Login$Components$initialModel = {gZ: false, hg: '', hQ: ''};
var $author$project$Login$Page$initialModel = {at: $author$project$Login$Components$initialModel, bz: $elm$core$Maybe$Nothing};
var $author$project$Domain$Quote$Actuator$ActivationV2AndSideCurtainsUnits = 2;
var $author$project$Page$Discovery$CustomField$Update$Edited = {$: 1};
var $author$project$Page$Discovery$CustomField$Update$fromQuote = function (ps) {
	return {
		il: A2(
			$elm$core$List$map,
			function (p) {
				return {is: p.is, jg: p.jg, jz: p.jz, jD: p.jD, jH: p.jH};
			},
			ps),
		H: $author$project$Page$Discovery$CustomField$Update$Edited
	};
};
var $author$project$Page$Discovery$Farm$Update$fromQuote = function (farm) {
	return {
		a6: $author$project$Page$Discovery$CustomField$Update$fromQuote(farm.il),
		jA: farm.jA,
		bq: false
	};
};
var $author$project$Page$Discovery$Greenhouse$Update$Edited = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$Default = 0;
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$initialModel = {H: 0, aR: $elm$core$Maybe$Nothing};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$fromQuote = function (m) {
	return _Utils_update(
		$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$initialModel,
		{aR: m});
};
var $author$project$Page$Discovery$Greenhouse$Update$fromQuote = F3(
	function (language, index, g) {
		return {
			a6: $author$project$Page$Discovery$CustomField$Update$fromQuote(g.il),
			cN: index,
			i$: language,
			aR: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$fromQuote(g.aR),
			jg: $author$project$Page$Discovery$Greenhouse$Update$Edited(g.jg),
			jA: g.jA
		};
	});
var $author$project$Page$Discovery$CustomField$Update$initialModel = {il: _List_Nil, H: $author$project$Page$Discovery$CustomField$Update$Edited};
var $author$project$Page$Discovery$Farm$Update$initialModel = {a6: $author$project$Page$Discovery$CustomField$Update$initialModel, jA: _List_Nil, bq: false};
var $author$project$Page$Discovery$Greenhouse$Update$Default = {$: 2};
var $author$project$Page$Discovery$Greenhouse$Update$initialModel = F2(
	function (language, index) {
		return {a6: $author$project$Page$Discovery$CustomField$Update$initialModel, cN: index, i$: language, aR: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$initialModel, jg: $author$project$Page$Discovery$Greenhouse$Update$Default, jA: _List_Nil};
	});
var $author$project$Page$Discovery$Update$initialModel = F2(
	function (language, quoteFromUrl) {
		if (!quoteFromUrl.$) {
			var q = quoteFromUrl.a;
			return {
				a1: q.a1,
				av: $author$project$Page$Discovery$Farm$Update$fromQuote(q.av),
				ay: A2(
					$elm$core$List$indexedMap,
					$author$project$Page$Discovery$Greenhouse$Update$fromQuote(language),
					q.ay),
				i$: language
			};
		} else {
			return {
				a1: 2,
				av: $author$project$Page$Discovery$Farm$Update$initialModel,
				ay: _List_fromArray(
					[
						A2($author$project$Page$Discovery$Greenhouse$Update$initialModel, language, 0)
					]),
				i$: language
			};
		}
	});
var $author$project$Page$PackingSlip$initialModel = {cf: false};
var $author$project$Page$QuoteBuilderV3$Discount$Update$Edited = {$: 1};
var $author$project$Page$QuoteBuilderV3$Discount$Update$initialModel = {ch: _List_Nil, H: $author$project$Page$QuoteBuilderV3$Discount$Update$Edited};
var $author$project$Page$QuoteBuilderV3$Discount$Update$fromQuote = function (discounts) {
	return _Utils_update(
		$author$project$Page$QuoteBuilderV3$Discount$Update$initialModel,
		{ch: discounts});
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Page$QuoteBuilderV3$CustomField$Update$Edited = {$: 1};
var $author$project$Page$QuoteBuilderV3$CustomField$Update$initialModel = {il: _List_Nil, H: $author$project$Page$QuoteBuilderV3$CustomField$Update$Edited};
var $author$project$Page$QuoteBuilderV3$CustomField$Update$fromQuote = function (customProducts) {
	return _Utils_update(
		$author$project$Page$QuoteBuilderV3$CustomField$Update$initialModel,
		{il: customProducts});
};
var $author$project$Page$QuoteBuilderV3$Quote$isExtra = function (product) {
	switch (product) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		case 15:
			return true;
		case 16:
			return false;
		case 17:
			return false;
		default:
			return false;
	}
};
var $author$project$Page$QuoteBuilderV3$Quote$PerFarm = 1;
var $author$project$Page$QuoteBuilderV3$Quote$PerGreenhouse = 0;
var $author$project$Page$QuoteBuilderV3$Quote$association = function (product) {
	switch (product) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 0;
		case 5:
			return 0;
		case 6:
			return 0;
		case 7:
			return 0;
		case 8:
			return 0;
		case 9:
			return 0;
		case 10:
			return 1;
		case 11:
			return 1;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 1;
		case 15:
			return 1;
		case 16:
			return 1;
		case 17:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Page$QuoteBuilderV3$Quote$isPerFarm = function (product) {
	return $author$project$Page$QuoteBuilderV3$Quote$association(product) === 1;
};
var $author$project$Page$QuoteBuilderV3$Farm$Update$fromQuote = function (farm) {
	return {
		a6: $author$project$Page$QuoteBuilderV3$CustomField$Update$fromQuote(farm.il),
		jA: farm.jA,
		bK: A2(
			$elm$core$List$any,
			function (p) {
				return $author$project$Page$QuoteBuilderV3$Quote$isExtra(p) && $author$project$Page$QuoteBuilderV3$Quote$isPerFarm(p);
			},
			farm.jA)
	};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Edited = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Quote$isPerGreenhouse = function (product) {
	return !$author$project$Page$QuoteBuilderV3$Quote$association(product);
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$fromQuote = F2(
	function (index, greenhouse) {
		return {
			a6: $author$project$Page$QuoteBuilderV3$CustomField$Update$fromQuote(greenhouse.il),
			cN: index,
			jg: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Edited(greenhouse.jg),
			jA: greenhouse.jA,
			bK: A2(
				$elm$core$List$any,
				function (p) {
					return $author$project$Page$QuoteBuilderV3$Quote$isExtra(p) && $author$project$Page$QuoteBuilderV3$Quote$isPerGreenhouse(p);
				},
				greenhouse.jA)
		};
	});
var $author$project$Language$English = 0;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$QuoteBuilderV3$Client$initialLanguage = function (user) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.i$;
		},
		user);
	if (!_v0.$) {
		if (!_v0.a) {
			var _v1 = _v0.a;
			return 0;
		} else {
			var _v2 = _v0.a;
			return 1;
		}
	} else {
		return 0;
	}
};
var $author$project$Domain$Total$Amount$USD = 1;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Page$QuoteBuilderV3$Client$userCurrency = function (user) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ik;
			},
			user));
};
var $author$project$Page$QuoteBuilderV3$Client$initialModel = function (user) {
	return {
		ik: $author$project$Page$QuoteBuilderV3$Client$userCurrency(user),
		ix: '',
		iF: '',
		iG: '',
		gG: '',
		i$: $author$project$Page$QuoteBuilderV3$Client$initialLanguage(user),
		g3: ''
	};
};
var $author$project$Page$QuoteBuilderV3$Farm$Update$initialModel = {a6: $author$project$Page$QuoteBuilderV3$CustomField$Update$initialModel, jA: _List_Nil, bK: false};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Default = {$: 2};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$initialModel = function (index) {
	return {a6: $author$project$Page$QuoteBuilderV3$CustomField$Update$initialModel, cN: index, jg: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Default, jA: _List_Nil, bK: false};
};
var $author$project$Page$QuoteBuilderV3$Update$initialModel = F2(
	function (user, urlQuote) {
		if (!urlQuote.$) {
			var q = urlQuote.a;
			return {
				bx: q.bx,
				gw: q.gw,
				gy: $author$project$Page$QuoteBuilderV3$Discount$Update$fromQuote(q.it),
				av: $author$project$Page$QuoteBuilderV3$Farm$Update$fromQuote(q.av),
				ay: A2($elm$core$List$indexedMap, $author$project$Page$QuoteBuilderV3$Greenhouse$Update$fromQuote, q.ay),
				dH: q.dH
			};
		} else {
			return {
				bx: $author$project$Page$QuoteBuilderV3$Client$initialModel(user),
				gw: '',
				gy: $author$project$Page$QuoteBuilderV3$Discount$Update$initialModel,
				av: $author$project$Page$QuoteBuilderV3$Farm$Update$initialModel,
				ay: _List_fromArray(
					[
						$author$project$Page$QuoteBuilderV3$Greenhouse$Update$initialModel(0)
					]),
				dH: ''
			};
		}
	});
var $author$project$Route$Quote$Entry$param = 'quote';
var $author$project$Route$Quote$Discovery$Model$DiscoveryData = function (greenhouse1) {
	return function (greenhouse2) {
		return function (greenhouse3) {
			return function (isFirstPurchase) {
				return function (isSameController) {
					return function (isLteController) {
						return function (isWifiSignalWithin250Ft) {
							return function (hasRainSensor) {
								return function (hasWindSensor) {
									return function (farmName) {
										return function (projectId) {
											return function (isProjectCustom) {
												return {iG: farmName, iK: greenhouse1, iL: greenhouse2, iM: greenhouse3, iN: hasRainSensor, iO: hasWindSensor, gY: isFirstPurchase, fv: isLteController, iZ: isProjectCustom, fw: isSameController, cS: isWifiSignalWithin250Ft, dH: projectId};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Route$Quote$Discovery$Model$Greenhouse1 = 0;
var $author$project$Route$Quote$Discovery$Model$Greenhouse2 = 1;
var $author$project$Route$Quote$Discovery$Model$Greenhouse3 = 2;
var $elm_community$json_extra$Json$Decode$Extra$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Route$Quote$Discovery$Model$GreenhouseData = F7(
	function (plan, extra, sideVentilation, heating, irrigation, fanVentilation, ridgeVentilation) {
		return {iC: extra, W: fanVentilation, X: heating, _: irrigation, jv: plan, aj: ridgeVentilation, ak: sideVentilation};
	});
var $author$project$Route$Quote$Discovery$Model$ExtraData = F7(
	function (alreadyHasOrisha, sideVentilation, heating, irrigation, fanVentilation, ridgeVentilation, diseasePrevention) {
		return {h5: alreadyHasOrisha, U: diseasePrevention, W: fanVentilation, X: heating, _: irrigation, aj: ridgeVentilation, ak: sideVentilation};
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Utils$Json$Decode$withField = F2(
	function (name, decoder) {
		return $elm_community$json_extra$Json$Decode$Extra$andMap(
			A2($elm$json$Json$Decode$field, name, decoder));
	});
var $author$project$Route$Quote$Discovery$Entry$extraDecoder = function (n) {
	return A3(
		$author$project$Utils$Json$Decode$withField,
		'ExtraDiseasePrevention' + n,
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			'ExtraRidgeVentilation' + n,
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				'ExtraFanVentilation' + n,
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Utils$Json$Decode$withField,
					'ExtraIrrigation' + n,
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Utils$Json$Decode$withField,
						'ExtraHeating' + n,
						$elm$json$Json$Decode$string,
						A3(
							$author$project$Utils$Json$Decode$withField,
							'ExtraSideVentilation' + n,
							$elm$json$Json$Decode$string,
							A3(
								$author$project$Utils$Json$Decode$withField,
								'Extra' + (n + 'AlreadyHasOrisha'),
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$ExtraData))))))));
};
var $author$project$Route$Quote$Discovery$Model$FanVentilationData = F5(
	function (louverHasFan, louverExceeds1Hp, louverBrand, fan, fanExceeds1Hp) {
		return {cv: fan, iE: fanExceeds1Hp, fE: louverBrand, i3: louverExceeds1Hp, i4: louverHasFan};
	});
var $author$project$Route$Quote$Discovery$Entry$fanVentilationDecoder = function (n) {
	var prefix = 'FanVentilation' + n;
	return A3(
		$author$project$Utils$Json$Decode$withField,
		prefix + 'FanExceeds1Hp',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			prefix + 'Fan',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				prefix + 'LouverBrand',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Utils$Json$Decode$withField,
					prefix + 'LouverExceeds1Hp',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Utils$Json$Decode$withField,
						prefix + 'LouverHasFan',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$FanVentilationData))))));
};
var $author$project$Route$Quote$Discovery$Model$HeatingData = F7(
	function (numberOfHeaters, heaterBrand1, heaterBrand2, thermostat1, thermostat2, wire1, wire2) {
		return {iP: heaterBrand1, iQ: heaterBrand2, jq: numberOfHeaters, j0: thermostat1, j1: thermostat2, kd: wire1, ke: wire2};
	});
var $author$project$Route$Quote$Discovery$Entry$heatingDecoder = function (n) {
	var prefix = 'Heating' + n;
	return A3(
		$author$project$Utils$Json$Decode$withField,
		prefix + 'Wire2',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			prefix + 'Wire1',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				prefix + 'Thermostat2',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Utils$Json$Decode$withField,
					prefix + 'Thermostat1',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Utils$Json$Decode$withField,
						prefix + 'HeaterBrand2',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$Utils$Json$Decode$withField,
							prefix + 'HeaterBrand1',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$Utils$Json$Decode$withField,
								prefix + 'NumberOfHeaters',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$HeatingData))))))));
};
var $author$project$Route$Quote$Discovery$Model$IrrigationData = F3(
	function (valvesToAutomate, valvesToSend, wireLength) {
		return {j8: valvesToAutomate, j9: valvesToSend, kf: wireLength};
	});
var $author$project$Route$Quote$Discovery$Entry$irrigationDecoder = function (n) {
	var prefix = 'Irrigation' + n;
	return A3(
		$author$project$Utils$Json$Decode$withField,
		prefix + 'WireLength',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			prefix + 'NumberOfValvesToSend',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				prefix + 'NumberOfValvesToAutomate',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$IrrigationData))));
};
var $author$project$Route$Quote$Discovery$Model$RidgeVentilationData = F4(
	function (roofType, inverter, actuatorInverterWire, motorInverterWire) {
		return {h1: actuatorInverterWire, gW: inverter, jc: motorInverterWire, fU: roofType};
	});
var $author$project$Route$Quote$Discovery$Entry$ridgeVentilationDecoder = function (n) {
	var prefix = 'RidgeVentilation' + n;
	return A3(
		$author$project$Utils$Json$Decode$withField,
		prefix + 'RoofMotorInverterWire',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			prefix + 'RoofActuatorInverterWire',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				prefix + 'RoofInverter',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Utils$Json$Decode$withField,
					prefix + 'RoofType',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$RidgeVentilationData)))));
};
var $author$project$Route$Quote$Discovery$Model$SideVentilationData = F7(
	function (sendMotor, numberOfSides, alreadyHasGuidePipe, pipeDiameter, motorBrand, length, height) {
		return {h4: alreadyHasGuidePipe, fs: height, i2: length, jb: motorBrand, fL: numberOfSides, fP: pipeDiameter, jR: sendMotor};
	});
var $author$project$Route$Quote$Discovery$Entry$sideVentilationDecoder = function (n) {
	var prefix = 'SideVent' + n;
	return A3(
		$author$project$Utils$Json$Decode$withField,
		prefix + 'Height',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			prefix + 'Length',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				prefix + 'MotorBrand',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Utils$Json$Decode$withField,
					prefix + 'GuidePipeDiameter',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Utils$Json$Decode$withField,
						prefix + 'AlreadyHasGuidePipe',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$Utils$Json$Decode$withField,
							prefix + 'NumberOfSides',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$Utils$Json$Decode$withField,
								prefix + 'SendMotor',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$SideVentilationData))))))));
};
var $author$project$Route$Quote$Discovery$Entry$greenhouseDecoder = function (location) {
	var n = function () {
		switch (location) {
			case 0:
				return '1';
			case 1:
				return '2';
			default:
				return '3';
		}
	}();
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$author$project$Route$Quote$Discovery$Entry$ridgeVentilationDecoder(n),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$author$project$Route$Quote$Discovery$Entry$fanVentilationDecoder(n),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				$author$project$Route$Quote$Discovery$Entry$irrigationDecoder(n),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					$author$project$Route$Quote$Discovery$Entry$heatingDecoder(n),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						$author$project$Route$Quote$Discovery$Entry$sideVentilationDecoder(n),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							$author$project$Route$Quote$Discovery$Entry$extraDecoder(n),
							A3(
								$author$project$Utils$Json$Decode$withField,
								'Plan' + n,
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$GreenhouseData))))))));
};
var $author$project$Route$Quote$Discovery$Entry$decoder = A3(
	$author$project$Utils$Json$Decode$withField,
	'IsProjectCustom',
	$elm$json$Json$Decode$string,
	A3(
		$author$project$Utils$Json$Decode$withField,
		'ProjectId',
		$elm$json$Json$Decode$string,
		A3(
			$author$project$Utils$Json$Decode$withField,
			'FarmName',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Utils$Json$Decode$withField,
				'HasWindSensor',
				$elm$json$Json$Decode$string,
				A3(
					$author$project$Utils$Json$Decode$withField,
					'HasRainSensor',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Utils$Json$Decode$withField,
						'IsWifiSignalWithin250Ft',
						$elm$json$Json$Decode$string,
						A3(
							$author$project$Utils$Json$Decode$withField,
							'IsLteController',
							$elm$json$Json$Decode$string,
							A3(
								$author$project$Utils$Json$Decode$withField,
								'IsSameController',
								$elm$json$Json$Decode$string,
								A3(
									$author$project$Utils$Json$Decode$withField,
									'IsFirstPurchase',
									$elm$json$Json$Decode$string,
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										$author$project$Route$Quote$Discovery$Entry$greenhouseDecoder(2),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											$author$project$Route$Quote$Discovery$Entry$greenhouseDecoder(1),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												$author$project$Route$Quote$Discovery$Entry$greenhouseDecoder(0),
												$elm$json$Json$Decode$succeed($author$project$Route$Quote$Discovery$Model$DiscoveryData)))))))))))));
var $author$project$Route$Quote$Discovery$Entry$param = 'discovery';
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elmcraft$core_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elmcraft$core_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {aM: frag, aT: params, aE: unvisited, hR: value, a_: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aE;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.hR);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.hR);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.hh),
					$elm$url$Url$Parser$prepareQuery(url.hm),
					url.gJ,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.a_;
		var unvisited = _v1.aE;
		var params = _v1.aT;
		var frag = _v1.aM;
		var value = _v1.hR;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$QueryParameters$parseQueryParam = F3(
	function (url, key, decoder) {
		var decodeStringToMaybe = function (value) {
			return $elm$core$Result$toMaybe(
				A2($elm$json$Json$Decode$decodeString, decoder, value));
		};
		var decode = function (value) {
			return A2(
				$elmcraft$core_extra$Maybe$Extra$or,
				A2($elm$core$Maybe$andThen, decodeStringToMaybe, value),
				A2(
					$elm$core$Maybe$andThen,
					decodeStringToMaybe,
					A2($elm$core$Maybe$andThen, $elm$url$Url$percentDecode, value)));
		};
		var parser = A2(
			$elm$url$Url$Parser$Query$map,
			decode,
			$elm$url$Url$Parser$Query$string(key));
		return $elmcraft$core_extra$Maybe$Extra$join(
			A2(
				$elm$url$Url$Parser$parse,
				A2($elm$url$Url$Parser$questionMark, $elm$url$Url$Parser$top, parser),
				url));
	});
var $author$project$Route$Quote$Discovery$Entry$parseQueryParam = function (url) {
	return A3($author$project$Route$QueryParameters$parseQueryParam, url, $author$project$Route$Quote$Discovery$Entry$param, $author$project$Route$Quote$Discovery$Entry$decoder);
};
var $author$project$Domain$Product$RainSensor = 4;
var $author$project$Domain$Product$WeatherBox = 7;
var $author$project$Domain$Product$WindSensor = 5;
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Route$Quote$Discovery$Farm$addWeatherBoxIfNeeded = function (products) {
	var hasRainOrWindSensors = A2($elm$core$List$member, 4, products) || A2($elm$core$List$member, 5, products);
	return hasRainOrWindSensors ? A2($elm$core$List$cons, 7, products) : products;
};
var $author$project$Domain$Product$Controller = 0;
var $author$project$Route$Quote$Discovery$Error$ControllerError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Product$ControllerLteCan = 2;
var $author$project$Domain$Product$ControllerLteUs = 1;
var $author$project$Route$Quote$Discovery$Error$CustomLteControllerError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$Quote$Discovery$Error$CustomSameController = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$Error$CustomWifiSignalRange = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$Quote$Discovery$Error$FirstPurchaseError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$Quote$Discovery$Error$LteControllerError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Quote$Discovery$Error$SameControllerError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Quote$Discovery$Error$WifiSignalRangeError = function (a) {
	return {$: 5, a: a};
};
var $elmcraft$core_extra$Result$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (!head.$) {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					var x = head.a;
					return $elm$core$Result$Err(x);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elmcraft$core_extra$Result$Extra$combine = function (list) {
	return A2($elmcraft$core_extra$Result$Extra$combineHelp, list, _List_Nil);
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Route$Quote$Discovery$Common$sanitizeTranslation = function (string) {
	switch (string) {
		case 'Oui':
			return 'Yes';
		case 'Non':
			return 'No';
		case '15 pieds':
			return '15 feet';
		case '25 pieds':
			return '25 feet';
		case '50 pieds':
			return '50 feet';
		case '75 pieds':
			return '75 feet';
		case '100 pieds':
			return '100 feet';
		case 'Non merci':
			return 'No thanks';
		case 'Plus':
			return 'More';
		case 'Serre 1':
			return 'Greenhouse 1';
		case 'Serre 2':
			return 'Greenhouse 2';
		case 'Oui, j\'ai besoin de moteur(s)':
			return 'Yes';
		case 'Yes, I need motor(s)':
			return 'Yes';
		case 'Non, j\'ai le(s) mien(s)':
			return 'No';
		case 'No, I have mine':
			return 'No';
		case 'Oui, j\'ai besoin de moteur(s) pour ma 2e serre':
			return 'Yes';
		case 'Yes, I need motor(s) for my 2nd greenhouse':
			return 'Yes';
		case 'Non, j\'ai le(s) mien(s) pour ma 2e serre':
			return 'No';
		case 'No, I have mine for my 2nd greenhouse':
			return 'No';
		case 'Oui, j\'ai besoin de moteur(s) pour ma 3e serre':
			return 'Yes';
		case 'Yes, I need motor(s) for my 3rd greenhouse':
			return 'Yes';
		case 'Non, j\'ai le(s) mien(s) pour ma 3e serre':
			return 'No';
		case 'No, I have mine for my 3rd greenhouse':
			return 'No';
		case 'Autre':
			return 'Other';
		case 'Je ne sais pas':
			return 'I don\'t know';
		case 'Plus de 6 pieds':
			return 'More than 6 feet';
		case '6 pieds ou moins':
			return '6 feet or less';
		case '1 ⁵⁄₁₆ pouces':
			return '1 ⁵⁄₁₆ inches';
		case '2 pouces':
			return '2 inches';
		case '200 pieds ou moins':
			return '200 feet or less';
		case 'Plus de 200 pieds':
			return 'More than 200 feet';
		case '110V avec ressort de rappel':
			return '110V with return spring';
		case 'Actuateur 12V':
			return '12V Actuator';
		default:
			return string;
	}
};
var $elmcraft$core_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elmcraft$core_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elmcraft$core_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Route$Quote$Discovery$Farm$controllerInterpreter = function (data) {
	var isWifiSignalWithin250Ft = function () {
		var _v3 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(data.cS);
		switch (_v3) {
			case 'Yes':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'No (validé)':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'No':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$CustomWifiSignalRange(data.cS)));
			case 'I don\'t know (validé)':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'I don\'t know':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$CustomWifiSignalRange(data.cS)));
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$WifiSignalRangeError(data.cS)));
		}
	}();
	var isSameController = function () {
		var _v2 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(data.fw);
		switch (_v2) {
			case 'Yes':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'No':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(0));
			case 'I don\'t know (validé)':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'I don\'t know':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$CustomSameController(data.fw)));
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$SameControllerError(data.fw)));
		}
	}();
	var isLteController = function () {
		var _v1 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(data.fv);
		switch (_v1) {
			case '0':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case '1':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$CustomLteControllerError(data.fv)));
			case '1 (validé us)':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(1));
			case '1 (validé can)':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(2));
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$LteControllerError(data.fv)));
		}
	}();
	var isFirstPurchase = function () {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(data.gY);
		switch (_v0) {
			case 'Yes':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(0));
			case 'No':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$FirstPurchaseError(data.gY)));
		}
	}();
	return A2(
		$elm$core$Result$map,
		$elm$core$List$head,
		A2(
			$elm$core$Result$map,
			$elmcraft$core_extra$Maybe$Extra$values,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[isLteController, isFirstPurchase, isSameController, isWifiSignalWithin250Ft]))));
};
var $elm$core$Result$map3 = F4(
	function (func, ra, rb, rc) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				if (rc.$ === 1) {
					var x = rc.a;
					return $elm$core$Result$Err(x);
				} else {
					var c = rc.a;
					return $elm$core$Result$Ok(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Route$Quote$Discovery$Error$RainSensorError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$Quote$Discovery$Farm$rainSensorInterpreter = function (input) {
	var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
	switch (_v0) {
		case '1':
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(4));
		case '0':
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		case 'EmptyCell':
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		default:
			return $elm$core$Result$Err(
				$author$project$Route$Quote$Discovery$Error$RainSensorError(input));
	}
};
var $author$project$Route$Quote$Discovery$Error$WindSensorError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Quote$Discovery$Farm$windSensorInterpreter = function (input) {
	var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
	switch (_v0) {
		case '1':
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(5));
		case '0':
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		case 'EmptyCell':
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		default:
			return $elm$core$Result$Err(
				$author$project$Route$Quote$Discovery$Error$WindSensorError(input));
	}
};
var $author$project$Route$Quote$Discovery$Farm$builder = function (data) {
	return A4(
		$elm$core$Result$map3,
		F3(
			function (rainSensor, windSensor, controller) {
				var products = $author$project$Route$Quote$Discovery$Farm$addWeatherBoxIfNeeded(
					$elmcraft$core_extra$Maybe$Extra$values(
						_List_fromArray(
							[rainSensor, windSensor, controller])));
				return {il: _List_Nil, jA: products};
			}),
		$author$project$Route$Quote$Discovery$Farm$rainSensorInterpreter(data.iN),
		$author$project$Route$Quote$Discovery$Farm$windSensorInterpreter(data.iO),
		$author$project$Route$Quote$Discovery$Farm$controllerInterpreter(data));
};
var $elmcraft$core_extra$Result$Extra$andMap = F2(
	function (ra, rb) {
		var _v0 = _Utils_Tuple2(ra, rb);
		if (_v0.b.$ === 1) {
			var x = _v0.b.a;
			return $elm$core$Result$Err(x);
		} else {
			var o = _v0.a;
			var fn = _v0.b.a;
			return A2($elm$core$Result$map, fn, o);
		}
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Domain$Product$ClimateSensor = 0;
var $author$project$Route$Quote$Discovery$Error$HasOrishaInGreenhouseError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$ClimateSensor$hasOrishaInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case 'Yes':
				return $elm$core$Result$Ok(_List_Nil);
			case 'No':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[0]));
			case 'EmptyCell':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[0]));
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$ControllerError(
						$author$project$Route$Quote$Discovery$Error$HasOrishaInGreenhouseError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Greenhouse$ClimateSensor$products = F2(
	function (greenhouseName, data) {
		return A2($author$project$Route$Quote$Discovery$Greenhouse$ClimateSensor$hasOrishaInterpreter, data.h5, greenhouseName);
	});
var $author$project$Domain$Product$Fan = 11;
var $author$project$Route$Quote$Discovery$Error$FanError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$Quote$Discovery$Error$FanVentilationError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$fanInterpreter = F3(
	function (fanInput, exceeds1HpInput, greenhouseName) {
		var _v0 = _Utils_Tuple2(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(fanInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(exceeds1HpInput));
		_v0$4:
		while (true) {
			switch (_v0.a) {
				case 'Yes':
					switch (_v0.b) {
						case 'Yes':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[11, 11]));
						case 'No':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[11]));
						default:
							break _v0$4;
					}
				case 'No':
					if (_v0.b === 'EmptyCell') {
						return $elm$core$Result$Ok(_List_Nil);
					} else {
						break _v0$4;
					}
				case 'EmptyCell':
					if (_v0.b === 'EmptyCell') {
						return $elm$core$Result$Ok(_List_Nil);
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$FanVentilationError(
				$author$project$Route$Quote$Discovery$Error$FanError(
					_Utils_ap(
						greenhouseName,
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								['Has fan : ' + fanInput, 'Fans exceed 1 Hp : ' + exceeds1HpInput]))))));
	});
var $author$project$Route$Quote$Discovery$Error$CustomLouverBrand = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$Error$LouverBrandError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$louverBrandInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '110V with return spring':
				return $elm$core$Result$Ok(_List_Nil);
			case '12V Actuator':
				return $elm$core$Result$Ok(_List_Nil);
			case 'Other (validé)':
				return $elm$core$Result$Ok(_List_Nil);
			case 'Other':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$FanVentilationError(
						$author$project$Route$Quote$Discovery$Error$CustomLouverBrand(
							_Utils_ap(greenhouseName, input))));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$FanVentilationError(
						$author$project$Route$Quote$Discovery$Error$LouverBrandError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Domain$Product$FanWithLouvers = 12;
var $author$project$Route$Quote$Discovery$Error$LouverError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$louverInterpreter = F3(
	function (hasFanInput, exceeds1HpInput, greenhouseName) {
		var _v0 = _Utils_Tuple2(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(hasFanInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(exceeds1HpInput));
		_v0$4:
		while (true) {
			switch (_v0.a) {
				case 'Yes':
					switch (_v0.b) {
						case 'Yes':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[12, 12]));
						case 'No':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[12]));
						default:
							break _v0$4;
					}
				case 'No':
					return $elm$core$Result$Ok(
						_List_fromArray(
							[11]));
				case 'EmptyCell':
					if (_v0.b === 'EmptyCell') {
						return $elm$core$Result$Ok(_List_Nil);
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$FanVentilationError(
				$author$project$Route$Quote$Discovery$Error$LouverError(
					_Utils_ap(
						greenhouseName,
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								['Louver has fan : ' + hasFanInput, 'Louvers with fans exceed 1 Hp : ' + exceeds1HpInput]))))));
	});
var $author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$products = F2(
	function (greenhouseName, data) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A3($author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$louverInterpreter, data.i4, data.i3, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$louverBrandInterpreter, data.fE, greenhouseName),
						A3($author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$fanInterpreter, data.cv, data.iE, greenhouseName)
					])));
	});
var $author$project$Domain$Product$BackUpThermostat = 3;
var $author$project$Route$Quote$Discovery$Error$BackUpThermostatError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$Quote$Discovery$Error$HeatingError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Domain$Product$WireThermostat10Ft = 29;
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$backUpThermostatInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case 'Yes':
				return $elm$core$Result$Ok(_List_Nil);
			case 'No':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[3, 29]));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$HeatingError(
						$author$project$Route$Quote$Discovery$Error$BackUpThermostatError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$backUpThermostatsInterpreter = F3(
	function (thermostat1, thermostat2, greenhouseName) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$backUpThermostatInterpreter, thermostat1, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$backUpThermostatInterpreter, thermostat2, greenhouseName)
					])));
	});
var $author$project$Route$Quote$Discovery$Error$CustomHeaterBrand = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Quote$Discovery$Error$HeaterBrandError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$heaterBrandInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case 'Modine':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'LB White':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'Other (validé)':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'Other':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$HeatingError(
						$author$project$Route$Quote$Discovery$Error$CustomHeaterBrand(
							_Utils_ap(greenhouseName, input))));
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$HeatingError(
						$author$project$Route$Quote$Discovery$Error$HeaterBrandError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$heaterBrandsInterpreter = F3(
	function (brand1, brand2, greenhouseName) {
		return A2(
			$elm$core$Result$map,
			$elmcraft$core_extra$Maybe$Extra$values,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$heaterBrandInterpreter, brand1, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$heaterBrandInterpreter, brand2, greenhouseName)
					])));
	});
var $author$project$Domain$Product$Heater = 4;
var $author$project$Route$Quote$Discovery$Error$HeaterError = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$heatersInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '0':
				return $elm$core$Result$Ok(_List_Nil);
			case '1':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[4]));
			case '2':
				return $elm$core$Result$Ok(
					A2($elm$core$List$repeat, 2, 4));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$HeatingError(
						$author$project$Route$Quote$Discovery$Error$HeaterError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Error$CustomHeaterWire = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Quote$Discovery$Error$HeaterWireError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Domain$Product$WireHeater100Ft = 27;
var $author$project$Domain$Product$WireHeater15Ft = 23;
var $author$project$Domain$Product$WireHeater25Ft = 24;
var $author$project$Domain$Product$WireHeater50Ft = 25;
var $author$project$Domain$Product$WireHeater75Ft = 26;
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$wireInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '15 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(23));
			case '25 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(24));
			case '50 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(25));
			case '75 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(26));
			case '100 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(27));
			case 'No thanks':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'More (validé)':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'More':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$HeatingError(
						$author$project$Route$Quote$Discovery$Error$CustomHeaterWire(
							_Utils_ap(greenhouseName, input))));
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$HeatingError(
						$author$project$Route$Quote$Discovery$Error$HeaterWireError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$wiresInterpreter = F3(
	function (wire1, wire2, greenhouseName) {
		return A2(
			$elm$core$Result$map,
			$elmcraft$core_extra$Maybe$Extra$values,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$wireInterpreter, wire1, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$wireInterpreter, wire2, greenhouseName)
					])));
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Heating$products = F2(
	function (greenhouseName, data) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$heatersInterpreter, data.jq, greenhouseName),
						A3($author$project$Route$Quote$Discovery$Greenhouse$Heating$backUpThermostatsInterpreter, data.j0, data.j1, greenhouseName),
						A3($author$project$Route$Quote$Discovery$Greenhouse$Heating$wiresInterpreter, data.kd, data.ke, greenhouseName),
						A3($author$project$Route$Quote$Discovery$Greenhouse$Heating$heaterBrandsInterpreter, data.iP, data.iQ, greenhouseName)
					])));
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Route$Quote$Discovery$Error$IrrigationError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Domain$Product$Valve = 14;
var $author$project$Route$Quote$Discovery$Error$ValveToAutomateError = function (a) {
	return {$: 1, a: a};
};
var $elmcraft$core_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Route$Quote$Discovery$Greenhouse$Irrigation$valvesToAutomateInterpreter = F3(
	function (input, greenhouseName, wire) {
		var _package = A2(
			$elm$core$List$cons,
			14,
			$elmcraft$core_extra$Maybe$Extra$toList(wire));
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '0':
				return $elm$core$Result$Ok(_List_Nil);
			case '1':
				return $elm$core$Result$Ok(_package);
			case '2':
				return $elm$core$Result$Ok(
					$elm$core$List$concat(
						A2($elm$core$List$repeat, 2, _package)));
			case '3':
				return $elm$core$Result$Ok(
					$elm$core$List$concat(
						A2($elm$core$List$repeat, 3, _package)));
			case '4':
				return $elm$core$Result$Ok(
					$elm$core$List$concat(
						A2($elm$core$List$repeat, 4, _package)));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$IrrigationError(
						$author$project$Route$Quote$Discovery$Error$ValveToAutomateError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Error$CustomValveWire = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$Error$ValveWireError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Product$WireValve15Ft = 19;
var $author$project$Domain$Product$WireValve25Ft = 20;
var $author$project$Route$Quote$Discovery$Greenhouse$Irrigation$wireLengthInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '15 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(19));
			case '25 feet':
				return $elm$core$Result$Ok(
					$elm$core$Maybe$Just(20));
			case 'No thanks':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'More (validé)':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			case 'More':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$IrrigationError(
						$author$project$Route$Quote$Discovery$Error$CustomValveWire(
							_Utils_ap(greenhouseName, input))));
			case 'EmptyCell':
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$IrrigationError(
						$author$project$Route$Quote$Discovery$Error$ValveWireError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Irrigation$valvesToAutomateAndWiresInterpreter = F3(
	function (wireLengthInput, numberOfValvesInput, greenhouseName) {
		return A2(
			$elm$core$Result$andThen,
			A2($author$project$Route$Quote$Discovery$Greenhouse$Irrigation$valvesToAutomateInterpreter, numberOfValvesInput, greenhouseName),
			A2($author$project$Route$Quote$Discovery$Greenhouse$Irrigation$wireLengthInterpreter, wireLengthInput, greenhouseName));
	});
var $author$project$Domain$Product$ElectricValve1Inch24V = 18;
var $author$project$Route$Quote$Discovery$Error$ValveToSendError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$Irrigation$valvesToSendInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '0':
				return $elm$core$Result$Ok(_List_Nil);
			case '1':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[18]));
			case '2':
				return $elm$core$Result$Ok(
					A2($elm$core$List$repeat, 2, 18));
			case '3':
				return $elm$core$Result$Ok(
					A2($elm$core$List$repeat, 3, 18));
			case '4':
				return $elm$core$Result$Ok(
					A2($elm$core$List$repeat, 4, 18));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$IrrigationError(
						$author$project$Route$Quote$Discovery$Error$ValveToSendError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Irrigation$products = F2(
	function (greenhouseName, data) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A2($author$project$Route$Quote$Discovery$Greenhouse$Irrigation$valvesToSendInterpreter, data.j9, greenhouseName),
						A3($author$project$Route$Quote$Discovery$Greenhouse$Irrigation$valvesToAutomateAndWiresInterpreter, data.kf, data.j8, greenhouseName)
					])));
	});
var $author$project$Route$Quote$Discovery$Error$CustomRoofActuatorInverterWire = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$Error$RidgeVentilationError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Quote$Discovery$Error$RoofActuatorInverterWireError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Product$WireInverter15Ft = 28;
var $author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$roofActuatorInverterWireInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '15 feet':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[28]));
			case 'More (validé)':
				return $elm$core$Result$Ok(_List_Nil);
			case 'More':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$RidgeVentilationError(
						$author$project$Route$Quote$Discovery$Error$CustomRoofActuatorInverterWire(
							_Utils_ap(greenhouseName, input))));
			case 'No thanks':
				return $elm$core$Result$Ok(_List_Nil);
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$RidgeVentilationError(
						$author$project$Route$Quote$Discovery$Error$RoofActuatorInverterWireError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Error$CustomRoofType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Product$RidgeVentWith24VInverter = 10;
var $author$project$Domain$Product$Roof = 5;
var $author$project$Route$Quote$Discovery$Error$RoofTypeError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Product$RoofWith240VInverter = 6;
var $author$project$Domain$Product$RoofWithHarnoisInverterKit = 7;
var $author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$roofInterpreter = F3(
	function (roofTypeInput, clientHasInverterInput, greenhouseName) {
		var _v0 = _Utils_Tuple2(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(roofTypeInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(clientHasInverterInput));
		_v0$8:
		while (true) {
			switch (_v0.a) {
				case 'Harnois':
					return $elm$core$Result$Ok(
						_List_fromArray(
							[7]));
				case 'Tessier':
					switch (_v0.b) {
						case 'Yes':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[5]));
						case 'No':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[6]));
						default:
							break _v0$8;
					}
				case '24V DC':
					switch (_v0.b) {
						case 'Yes':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[5]));
						case 'No':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[10]));
						default:
							break _v0$8;
					}
				case 'Other (validé)':
					return $elm$core$Result$Ok(_List_Nil);
				case 'Other':
					return $elm$core$Result$Err(
						$author$project$Route$Quote$Discovery$Error$RidgeVentilationError(
							$author$project$Route$Quote$Discovery$Error$CustomRoofType(
								_Utils_ap(greenhouseName, roofTypeInput))));
				case 'EmptyCell':
					if (_v0.b === 'EmptyCell') {
						return $elm$core$Result$Ok(_List_Nil);
					} else {
						break _v0$8;
					}
				default:
					break _v0$8;
			}
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$RidgeVentilationError(
				$author$project$Route$Quote$Discovery$Error$RoofTypeError(
					_Utils_ap(
						greenhouseName,
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								['Roof type : ' + roofTypeInput, 'Already has inverters : ' + clientHasInverterInput]))))));
	});
var $author$project$Route$Quote$Discovery$Error$CustomRoofMotorInverterWire = function (a) {
	return {$: 4, a: a};
};
var $author$project$Domain$Product$KitOfWiresTessier15Ft = 32;
var $author$project$Domain$Product$KitOfWiresTessier25Ft = 33;
var $author$project$Route$Quote$Discovery$Error$RoofMotorInverterWireError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Domain$Product$WireMotor15Ft = 21;
var $author$project$Domain$Product$WireMotor25Ft = 22;
var $author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$roofMotorInverterWireInterpreter = F4(
	function (wireInput, roofTypeInput, clientHasInverterInput, greenhouseName) {
		var _v0 = _Utils_Tuple3(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(wireInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(roofTypeInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(clientHasInverterInput));
		_v0$9:
		while (true) {
			_v0$11:
			while (true) {
				switch (_v0.c) {
					case 'Yes':
						return $elm$core$Result$Ok(_List_Nil);
					case 'No':
						switch (_v0.a) {
							case '15 feet':
								switch (_v0.b) {
									case '24V DC':
										return $elm$core$Result$Ok(
											_List_fromArray(
												[21]));
									case 'Tessier':
										return $elm$core$Result$Ok(
											_List_fromArray(
												[32]));
									default:
										break _v0$11;
								}
							case '25 feet':
								switch (_v0.b) {
									case '24V DC':
										return $elm$core$Result$Ok(
											_List_fromArray(
												[22]));
									case 'Tessier':
										return $elm$core$Result$Ok(
											_List_fromArray(
												[33]));
									default:
										break _v0$11;
								}
							case 'More (validé)':
								return $elm$core$Result$Ok(_List_Nil);
							case 'More':
								break _v0$9;
							default:
								break _v0$11;
						}
					case 'EmptyCell':
						switch (_v0.a) {
							case 'More':
								break _v0$9;
							case 'EmptyCell':
								switch (_v0.b) {
									case 'Harnois':
										return $elm$core$Result$Ok(_List_Nil);
									case 'Other (validé)':
										return $elm$core$Result$Ok(_List_Nil);
									case 'Other':
										return $elm$core$Result$Ok(_List_Nil);
									case 'EmptyCell':
										return $elm$core$Result$Ok(_List_Nil);
									default:
										break _v0$11;
								}
							default:
								break _v0$11;
						}
					default:
						if (_v0.a === 'More') {
							break _v0$9;
						} else {
							break _v0$11;
						}
				}
			}
			return $elm$core$Result$Err(
				$author$project$Route$Quote$Discovery$Error$RidgeVentilationError(
					$author$project$Route$Quote$Discovery$Error$RoofMotorInverterWireError(
						_Utils_ap(
							greenhouseName,
							A2(
								$elm$core$String$join,
								', ',
								_List_fromArray(
									['Wire length : ' + wireInput, 'Type : ' + roofTypeInput, 'Has inverter : ' + clientHasInverterInput]))))));
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$RidgeVentilationError(
				$author$project$Route$Quote$Discovery$Error$CustomRoofMotorInverterWire(
					_Utils_ap(greenhouseName, wireInput))));
	});
var $author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$products = F2(
	function (greenhouseName, data) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A3($author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$roofInterpreter, data.fU, data.gW, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$roofActuatorInverterWireInterpreter, data.h1, greenhouseName),
						A4($author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$roofMotorInverterWireInterpreter, data.jc, data.fU, data.gW, greenhouseName)
					])));
	});
var $author$project$Domain$Product$Motor24VDC = 16;
var $author$project$Route$Quote$Discovery$Error$SideVentMotorError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$Error$SideVentilationError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$motorInterpreter = F3(
	function (numberOfSidesInput, sendMotorInput, greenhouseName) {
		var _v0 = _Utils_Tuple2(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(sendMotorInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(numberOfSidesInput));
		_v0$4:
		while (true) {
			switch (_v0.a) {
				case 'No':
					return $elm$core$Result$Ok(_List_Nil);
				case 'Yes':
					switch (_v0.b) {
						case '1':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[16]));
						case '2':
							return $elm$core$Result$Ok(
								A2($elm$core$List$repeat, 2, 16));
						default:
							break _v0$4;
					}
				case 'EmptyCell':
					if (_v0.b === 'EmptyCell') {
						return $elm$core$Result$Ok(_List_Nil);
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$SideVentilationError(
				$author$project$Route$Quote$Discovery$Error$SideVentMotorError(
					_Utils_ap(
						greenhouseName,
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								['Send motors : ' + sendMotorInput, 'Number of sides : ' + numberOfSidesInput]))))));
	});
var $author$project$Route$Quote$Discovery$Error$CustomPipeDiameter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$Quote$Discovery$Error$PipeDiameterError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$pipeDiameterInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '1 ⁵⁄₁₆ inches':
				return $elm$core$Result$Ok(_List_Nil);
			case '2 inches':
				return $elm$core$Result$Ok(_List_Nil);
			case 'Other (validé)':
				return $elm$core$Result$Ok(_List_Nil);
			case 'Other':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$SideVentilationError(
						$author$project$Route$Quote$Discovery$Error$CustomPipeDiameter(
							_Utils_ap(greenhouseName, input))));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$SideVentilationError(
						$author$project$Route$Quote$Discovery$Error$PipeDiameterError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Domain$Product$Pipe6FtDia1p315In = 30;
var $author$project$Domain$Product$Pipe6FtDia2In = 31;
var $author$project$Route$Quote$Discovery$Error$PipeError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$pipeInterpreter = F4(
	function (numberOfSidesInput, alreadyHasPipeInput, pipeDiameterInput, greenhouseName) {
		var _v0 = _Utils_Tuple3(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(numberOfSidesInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(alreadyHasPipeInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(pipeDiameterInput));
		_v0$7:
		while (true) {
			switch (_v0.b) {
				case 'Yes':
					return $elm$core$Result$Ok(_List_Nil);
				case 'No':
					switch (_v0.c) {
						case '1 ⁵⁄₁₆ inches':
							switch (_v0.a) {
								case '1':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[30]));
								case '2':
									return $elm$core$Result$Ok(
										A2($elm$core$List$repeat, 2, 30));
								default:
									break _v0$7;
							}
						case '2 inches':
							switch (_v0.a) {
								case '1':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[31]));
								case '2':
									return $elm$core$Result$Ok(
										A2($elm$core$List$repeat, 2, 31));
								default:
									break _v0$7;
							}
						case 'Other (validé)':
							return $elm$core$Result$Ok(_List_Nil);
						default:
							break _v0$7;
					}
				case 'EmptyCell':
					return $elm$core$Result$Ok(_List_Nil);
				default:
					break _v0$7;
			}
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$SideVentilationError(
				$author$project$Route$Quote$Discovery$Error$PipeError(
					_Utils_ap(
						greenhouseName,
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								['Number of sides : ' + numberOfSidesInput, 'Already has pipes : ' + alreadyHasPipeInput, 'Pipe diameter : ' + pipeDiameterInput]))))));
	});
var $author$project$Route$Quote$Discovery$Error$CustomSideVentHeight = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$Quote$Discovery$Error$SideVentHeightError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$sideHeightInterpreter = F2(
	function (input, greenhouseName) {
		var _v0 = $author$project$Route$Quote$Discovery$Common$sanitizeTranslation(input);
		switch (_v0) {
			case '6 feet or less':
				return $elm$core$Result$Ok(_List_Nil);
			case 'More than 6 feet (validé)':
				return $elm$core$Result$Ok(_List_Nil);
			case 'More than 6 feet':
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$SideVentilationError(
						$author$project$Route$Quote$Discovery$Error$CustomSideVentHeight(
							_Utils_ap(greenhouseName, input))));
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$Error$SideVentilationError(
						$author$project$Route$Quote$Discovery$Error$SideVentHeightError(
							_Utils_ap(greenhouseName, input))));
		}
	});
var $author$project$Route$Quote$Discovery$Error$CustomMotorBrand = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Product$SideCurtain = 8;
var $author$project$Route$Quote$Discovery$Error$SideVentError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Domain$Product$SideVentWith24VInverter = 9;
var $author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$sidesInterpreter = F4(
	function (numberOfSidesInput, motorBrandInput, lengthInput, greenhouseName) {
		var _v0 = _Utils_Tuple3(
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(numberOfSidesInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(motorBrandInput),
			$author$project$Route$Quote$Discovery$Common$sanitizeTranslation(lengthInput));
		_v0$18:
		while (true) {
			switch (_v0.b) {
				case 'Other':
					return $elm$core$Result$Err(
						$author$project$Route$Quote$Discovery$Error$SideVentilationError(
							$author$project$Route$Quote$Discovery$Error$CustomMotorBrand(
								_Utils_ap(greenhouseName, motorBrandInput))));
				case 'Other (module de côté)':
					if (_v0.c === '200 feet or less') {
						switch (_v0.a) {
							case '1':
								return $elm$core$Result$Ok(
									_List_fromArray(
										[22, 8]));
							case '2':
								return $elm$core$Result$Ok(
									A2(
										$elm$core$List$cons,
										22,
										A2($elm$core$List$repeat, 2, 8)));
							default:
								break _v0$18;
						}
					} else {
						break _v0$18;
					}
				case 'Kingzo 24V DC':
					switch (_v0.a) {
						case '1':
							switch (_v0.c) {
								case '200 feet or less':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[22, 8]));
								case 'More than 200 feet':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[22, 9]));
								default:
									break _v0$18;
							}
						case '2':
							switch (_v0.c) {
								case '200 feet or less':
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											22,
											A2($elm$core$List$repeat, 2, 8)));
								case 'More than 200 feet':
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											22,
											A2($elm$core$List$repeat, 2, 9)));
								default:
									break _v0$18;
							}
						default:
							break _v0$18;
					}
				case 'LVM60/LVM100':
					switch (_v0.a) {
						case '1':
							switch (_v0.c) {
								case '200 feet or less':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[22, 8]));
								case 'More than 200 feet':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[22, 9]));
								default:
									break _v0$18;
							}
						case '2':
							switch (_v0.c) {
								case '200 feet or less':
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											22,
											A2($elm$core$List$repeat, 2, 8)));
								case 'More than 200 feet':
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											22,
											A2($elm$core$List$repeat, 2, 9)));
								default:
									break _v0$18;
							}
						default:
							break _v0$18;
					}
				case 'Other (contrôleur de côté)':
					switch (_v0.a) {
						case '1':
							return $elm$core$Result$Ok(
								_List_fromArray(
									[22, 9]));
						case '2':
							return $elm$core$Result$Ok(
								A2(
									$elm$core$List$cons,
									22,
									A2($elm$core$List$repeat, 2, 9)));
						default:
							break _v0$18;
					}
				case 'EmptyCell':
					switch (_v0.a) {
						case '1':
							switch (_v0.c) {
								case '200 feet or less':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[22, 8]));
								case 'More than 200 feet':
									return $elm$core$Result$Ok(
										_List_fromArray(
											[22, 9]));
								default:
									break _v0$18;
							}
						case '2':
							switch (_v0.c) {
								case '200 feet or less':
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											22,
											A2($elm$core$List$repeat, 2, 8)));
								case 'More than 200 feet':
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											22,
											A2($elm$core$List$repeat, 2, 9)));
								default:
									break _v0$18;
							}
						case 'EmptyCell':
							if (_v0.c === 'EmptyCell') {
								return $elm$core$Result$Ok(_List_Nil);
							} else {
								break _v0$18;
							}
						default:
							break _v0$18;
					}
				default:
					break _v0$18;
			}
		}
		return $elm$core$Result$Err(
			$author$project$Route$Quote$Discovery$Error$SideVentilationError(
				$author$project$Route$Quote$Discovery$Error$SideVentError(
					_Utils_ap(
						greenhouseName,
						A2(
							$elm$core$String$join,
							', ',
							_List_fromArray(
								['Number of sides : ' + numberOfSidesInput, 'Motor brand : ' + motorBrandInput, 'Length : ' + lengthInput]))))));
	});
var $author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$products = F2(
	function (greenhouseName, data) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A4($author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$sidesInterpreter, data.fL, data.jb, data.i2, greenhouseName),
						A4($author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$pipeInterpreter, data.fL, data.h4, data.fP, greenhouseName),
						A3($author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$motorInterpreter, data.fL, data.jR, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$sideHeightInterpreter, data.fs, greenhouseName),
						A2($author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$pipeDiameterInterpreter, data.fP, greenhouseName)
					])));
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Entry$greenhouse = F2(
	function (data, greenhouseName) {
		var name = greenhouseName + ' -> ';
		var buildWithFeature = F6(
			function (sideVentilation, heating, irrigation, fanVentilation, ridgeVentilation, climateSensor) {
				var otherProducts = _Utils_ap(
					sideVentilation,
					_Utils_ap(
						heating,
						_Utils_ap(fanVentilation, ridgeVentilation)));
				var isThereMoreThanIrrigation = !$elm$core$List$isEmpty(otherProducts);
				var irrigationProducts = irrigation;
				var isThereIrrigation = !$elm$core$List$isEmpty(irrigationProducts);
				var builtGreenhouse = function (products) {
					return $elm$core$Maybe$Just(
						{il: _List_Nil, aR: $elm$core$Maybe$Nothing, jg: greenhouseName, jA: products});
				};
				if (isThereMoreThanIrrigation) {
					var products = _Utils_ap(
						climateSensor,
						_Utils_ap(otherProducts, irrigationProducts));
					return builtGreenhouse(products);
				} else {
					if (isThereIrrigation) {
						return builtGreenhouse(irrigationProducts);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			});
		return A2(
			$elmcraft$core_extra$Result$Extra$andMap,
			A2($author$project$Route$Quote$Discovery$Greenhouse$ClimateSensor$products, name, data.iC),
			A2(
				$elmcraft$core_extra$Result$Extra$andMap,
				A2($author$project$Route$Quote$Discovery$Greenhouse$RidgeVentilation$products, name, data.aj),
				A2(
					$elmcraft$core_extra$Result$Extra$andMap,
					A2($author$project$Route$Quote$Discovery$Greenhouse$FanVentilation$products, name, data.W),
					A2(
						$elmcraft$core_extra$Result$Extra$andMap,
						A2($author$project$Route$Quote$Discovery$Greenhouse$Irrigation$products, name, data._),
						A2(
							$elmcraft$core_extra$Result$Extra$andMap,
							A2($author$project$Route$Quote$Discovery$Greenhouse$Heating$products, name, data.X),
							A2(
								$elmcraft$core_extra$Result$Extra$andMap,
								A2($author$project$Route$Quote$Discovery$Greenhouse$SideVentilation$products, name, data.ak),
								$elm$core$Result$Ok(buildWithFeature)))))));
	});
var $author$project$Route$Quote$Discovery$Greenhouse$Entry$builder = function (data) {
	return A2(
		$elm$core$Result$map,
		$elmcraft$core_extra$Maybe$Extra$values,
		$elmcraft$core_extra$Result$Extra$combine(
			_List_fromArray(
				[
					A2($author$project$Route$Quote$Discovery$Greenhouse$Entry$greenhouse, data.iK, 'Greenhouse 1'),
					A2($author$project$Route$Quote$Discovery$Greenhouse$Entry$greenhouse, data.iL, 'Greenhouse 2'),
					A2($author$project$Route$Quote$Discovery$Greenhouse$Entry$greenhouse, data.iM, 'Greenhouse 3')
				])));
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Route$Quote$Discovery$Entry$toQuote = function (data) {
	return A3(
		$elm$core$Result$map2,
		F2(
			function (farm, greenhouses) {
				return {a1: 2, av: farm, ay: greenhouses};
			}),
		$author$project$Route$Quote$Discovery$Farm$builder(data),
		$author$project$Route$Quote$Discovery$Greenhouse$Entry$builder(data));
};
var $author$project$Route$Quote$Discovery$Entry$parse = function (url) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Route$Quote$Discovery$Entry$toQuote,
		$author$project$Route$Quote$Discovery$Entry$parseQueryParam(url));
};
var $author$project$Domain$Quote$Actuator$Multibox = 0;
var $author$project$Domain$Quote$Entry$Quote = F3(
	function (farm, greenhouses, actuator) {
		return {a1: actuator, av: farm, ay: greenhouses};
	});
var $author$project$Domain$Quote$Actuator$ActivationV1AndSideCurtainsUnits = 1;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Route$Quote$Entry$actuatorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (actuator) {
		switch (actuator) {
			case 'Multibox':
				return $elm$json$Json$Decode$succeed(0);
			case 'ActivationV1AndSideCurtainsUnits':
				return $elm$json$Json$Decode$succeed(1);
			case 'ActivationV2AndSideCurtainsUnits':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Actuators');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Route$Quote$Entry$communicationCurrency = 0;
var $author$project$Domain$Quote$Farm$Farm = F2(
	function (products, customProducts) {
		return {il: customProducts, jA: products};
	});
var $author$project$Domain$Quote$CustomProduct$CustomProduct = F5(
	function (name, price, quantity, device, relay) {
		return {is: device, jg: name, jz: price, jD: quantity, jH: relay};
	});
var $author$project$Domain$Quote$CustomProduct$Fan = 3;
var $author$project$Domain$Quote$CustomProduct$Heater = 1;
var $author$project$Domain$Quote$CustomProduct$Mister = 5;
var $author$project$Domain$Quote$CustomProduct$NoDevice = 0;
var $author$project$Domain$Quote$CustomProduct$Opening = 2;
var $author$project$Domain$Quote$CustomProduct$Valve = 4;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm_community$json_extra$Json$Decode$Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(fallback),
			$elm$json$Json$Decode$maybe(decoder));
	});
var $author$project$Route$Quote$Utils$fieldDefault = F3(
	function (name, decoder, _default) {
		return A2(
			$elm_community$json_extra$Json$Decode$Extra$withDefault,
			_default,
			A2($elm$json$Json$Decode$field, name, decoder));
	});
var $author$project$Domain$Total$Amount$Amount = $elm$core$Basics$identity;
var $author$project$Domain$Total$Amount$cadToUsdRate = 0.8;
var $elm$core$Basics$round = _Basics_round;
var $author$project$Domain$Total$Amount$fromCurrency = F2(
	function (currency, amount) {
		var inCAD = function () {
			if (!currency) {
				return amount;
			} else {
				return $elm$core$Basics$round(
					function (n) {
						return n / $author$project$Domain$Total$Amount$cadToUsdRate;
					}(amount));
			}
		}();
		return {ft: inCAD};
	});
var $author$project$Domain$Total$Amount$fromCAD = $author$project$Domain$Total$Amount$fromCurrency(0);
var $author$project$Domain$Total$Amount$free = $author$project$Domain$Total$Amount$fromCAD(0);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Route$Quote$CustomProduct$decoder = function (currency) {
	var deviceDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (str) {
			switch (str) {
				case 'Furnace':
					return $elm$json$Json$Decode$succeed(1);
				case 'Opening':
					return $elm$json$Json$Decode$succeed(2);
				case 'RoofVenting':
					return $elm$json$Json$Decode$succeed(2);
				case 'SideCurtain':
					return $elm$json$Json$Decode$succeed(2);
				case 'Fan':
					return $elm$json$Json$Decode$succeed(3);
				case 'Valve':
					return $elm$json$Json$Decode$succeed(4);
				case 'Mister':
					return $elm$json$Json$Decode$succeed(5);
				case 'NoDevice':
					return $elm$json$Json$Decode$succeed(0);
				default:
					return $elm$json$Json$Decode$fail('Custom Product App Device Type');
			}
		},
		$elm$json$Json$Decode$string);
	return A6(
		$elm$json$Json$Decode$map5,
		$author$project$Domain$Quote$CustomProduct$CustomProduct,
		A3($author$project$Route$Quote$Utils$fieldDefault, 'name', $elm$json$Json$Decode$string, 'Produit custom'),
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'price',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Domain$Total$Amount$fromCurrency(currency),
				$elm$json$Json$Decode$int),
			$author$project$Domain$Total$Amount$free),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'quantity', $elm$json$Json$Decode$int, 0),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'device', deviceDecoder, 0),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'relay', $elm$json$Json$Decode$int, 0));
};
var $author$project$Domain$Product$OutdoorClimateSensor = 3;
var $author$project$Domain$Product$SolarSensor = 6;
var $author$project$Domain$Product$farmProductDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Controller':
				return $elm$json$Json$Decode$succeed(0);
			case 'ControllerLteUs':
				return $elm$json$Json$Decode$succeed(1);
			case 'ControllerLteCan':
				return $elm$json$Json$Decode$succeed(2);
			case 'OutdoorClimateSensor':
				return $elm$json$Json$Decode$succeed(3);
			case 'RainSensor':
				return $elm$json$Json$Decode$succeed(4);
			case 'SolarSensor':
				return $elm$json$Json$Decode$succeed(6);
			case 'WeatherBox':
				return $elm$json$Json$Decode$succeed(7);
			case 'WindSensor':
				return $elm$json$Json$Decode$succeed(5);
			default:
				var x = str;
				return $elm$json$Json$Decode$fail('FarmProduct error: ' + x);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Route$Quote$Farm$decoder = function (currency) {
	return A3(
		$elm$json$Json$Decode$map2,
		$author$project$Domain$Quote$Farm$Farm,
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'products',
			$elm$json$Json$Decode$list($author$project$Domain$Product$farmProductDecoder),
			_List_Nil),
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'customProducts',
			$elm$json$Json$Decode$list(
				$author$project$Route$Quote$CustomProduct$decoder(currency)),
			_List_Nil));
};
var $author$project$Domain$Quote$Greenhouse$Greenhouse = F4(
	function (name, products, customProducts, manualAdjustment) {
		return {il: customProducts, aR: manualAdjustment, jg: name, jA: products};
	});
var $author$project$Domain$Product$CirculationFan = 13;
var $author$project$Domain$Product$DryWetSensor = 1;
var $author$project$Domain$Product$Mister = 15;
var $author$project$Domain$Product$SoilTemperatureSensor = 2;
var $author$project$Domain$Product$ThermalScreen = 17;
var $author$project$Domain$Product$greenhouseProductDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'ClimateSensor':
				return $elm$json$Json$Decode$succeed(0);
			case 'DryWetSensor':
				return $elm$json$Json$Decode$succeed(1);
			case 'SoilTemperatureSensor':
				return $elm$json$Json$Decode$succeed(2);
			case 'BackUpThermostat':
				return $elm$json$Json$Decode$succeed(3);
			case 'Heater':
				return $elm$json$Json$Decode$succeed(4);
			case 'Roof':
				return $elm$json$Json$Decode$succeed(5);
			case 'RoofWith240VInverter':
				return $elm$json$Json$Decode$succeed(6);
			case 'RoofWithHarnoisInverterKit':
				return $elm$json$Json$Decode$succeed(7);
			case 'SideCurtain':
				return $elm$json$Json$Decode$succeed(8);
			case 'OpeningWith24VInverter':
				return $elm$json$Json$Decode$succeed(9);
			case 'SideVentWith24VInverter':
				return $elm$json$Json$Decode$succeed(9);
			case 'RidgeVentWith24VInverter':
				return $elm$json$Json$Decode$succeed(10);
			case 'Fan':
				return $elm$json$Json$Decode$succeed(11);
			case 'FanWithLouvers':
				return $elm$json$Json$Decode$succeed(12);
			case 'CirculationFan':
				return $elm$json$Json$Decode$succeed(13);
			case 'Valve':
				return $elm$json$Json$Decode$succeed(14);
			case 'Mister':
				return $elm$json$Json$Decode$succeed(15);
			case 'Motor24VDC':
				return $elm$json$Json$Decode$succeed(16);
			case 'ThermalScreen':
				return $elm$json$Json$Decode$succeed(17);
			case 'ElectricValve1Inch24V':
				return $elm$json$Json$Decode$succeed(18);
			case 'WireValve15Ft':
				return $elm$json$Json$Decode$succeed(19);
			case 'WireValve25Ft':
				return $elm$json$Json$Decode$succeed(20);
			case 'WireMotor15Ft':
				return $elm$json$Json$Decode$succeed(21);
			case 'WireMotor25Ft':
				return $elm$json$Json$Decode$succeed(22);
			case 'WireHeater15Ft':
				return $elm$json$Json$Decode$succeed(23);
			case 'WireHeater25Ft':
				return $elm$json$Json$Decode$succeed(24);
			case 'WireHeater50Ft':
				return $elm$json$Json$Decode$succeed(25);
			case 'WireHeater75Ft':
				return $elm$json$Json$Decode$succeed(26);
			case 'WireHeater100Ft':
				return $elm$json$Json$Decode$succeed(27);
			case 'WireInverter15Ft':
				return $elm$json$Json$Decode$succeed(28);
			case 'WireThermostat10Ft':
				return $elm$json$Json$Decode$succeed(29);
			case 'Pipe6FtDia1p315In':
				return $elm$json$Json$Decode$succeed(30);
			case 'Pipe6FtDia2In':
				return $elm$json$Json$Decode$succeed(31);
			case 'KitOfWiresTessier15Ft':
				return $elm$json$Json$Decode$succeed(32);
			case 'KitOfWiresTessier25Ft':
				return $elm$json$Json$Decode$succeed(33);
			default:
				var x = str;
				return $elm$json$Json$Decode$fail('GreenhouseProduct error: ' + x);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Domain$Quote$Greenhouse$ManualAdjustment = F7(
	function (activationUnitV1, activationUnitV2, sideCurtainsUnit, multibox, multiboxWithMotorDriver, relayBox110VAC, transformer24V) {
		return {h_: activationUnitV1, h$: activationUnitV2, jd: multibox, je: multiboxWithMotorDriver, jI: relayBox110VAC, jU: sideCurtainsUnit, j4: transformer24V};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Route$Quote$Greenhouse$manualAdjustmentDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Domain$Quote$Greenhouse$ManualAdjustment,
	A3($author$project$Route$Quote$Utils$fieldDefault, 'activationUnitV1', $elm$json$Json$Decode$int, 0),
	A3($author$project$Route$Quote$Utils$fieldDefault, 'activationUnitV2', $elm$json$Json$Decode$int, 0),
	A3($author$project$Route$Quote$Utils$fieldDefault, 'sideCurtainsUnit', $elm$json$Json$Decode$int, 0),
	A3($author$project$Route$Quote$Utils$fieldDefault, 'multibox', $elm$json$Json$Decode$int, 0),
	A3($author$project$Route$Quote$Utils$fieldDefault, 'multiWithMotorDriver', $elm$json$Json$Decode$int, 0),
	A3($author$project$Route$Quote$Utils$fieldDefault, 'relayBox110VAC', $elm$json$Json$Decode$int, 0),
	A3($author$project$Route$Quote$Utils$fieldDefault, 'transformer24V', $elm$json$Json$Decode$int, 0));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm_community$json_extra$Json$Decode$Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$value),
				json);
			if (!_v0.$) {
				var val = _v0.a;
				return A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, fieldName, decoder));
			} else {
				return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
			}
		};
		return A2($elm$json$Json$Decode$andThen, finishDecoding, $elm$json$Json$Decode$value);
	});
var $elm_community$json_extra$Json$Decode$Extra$optionalNullableField = F2(
	function (fieldName, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				fieldName,
				$elm$json$Json$Decode$nullable(decoder)));
	});
var $author$project$Route$Quote$Greenhouse$decoder = function (currency) {
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$Domain$Quote$Greenhouse$Greenhouse,
		A3($author$project$Route$Quote$Utils$fieldDefault, 'name', $elm$json$Json$Decode$string, 'Serre'),
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'products',
			$elm$json$Json$Decode$list($author$project$Domain$Product$greenhouseProductDecoder),
			_List_Nil),
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'customProducts',
			$elm$json$Json$Decode$list(
				$author$project$Route$Quote$CustomProduct$decoder(currency)),
			_List_Nil),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'manualAdjustment', $author$project$Route$Quote$Greenhouse$manualAdjustmentDecoder));
};
var $author$project$Route$Quote$Farm$default = {il: _List_Nil, jA: _List_Nil};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Route$Quote$Entry$quoteDecoder = function () {
	var greenhousesDecoder = $elm$json$Json$Decode$list(
		$author$project$Route$Quote$Greenhouse$decoder($author$project$Route$Quote$Entry$communicationCurrency));
	var defaultGreenhouses = _List_Nil;
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Domain$Quote$Entry$Quote,
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'farm',
			$author$project$Route$Quote$Farm$decoder($author$project$Route$Quote$Entry$communicationCurrency),
			$author$project$Route$Quote$Farm$default),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'greenhouses', greenhousesDecoder, defaultGreenhouses),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'actuator', $author$project$Route$Quote$Entry$actuatorDecoder, 0));
}();
var $author$project$Route$Quote$Entry$parseQuote = function (url) {
	var quoteFromDiscovery = $author$project$Route$Quote$Discovery$Entry$parse(url);
	var quoteFromApp = A3($author$project$Route$QueryParameters$parseQueryParam, url, $author$project$Route$Quote$Entry$param, $author$project$Route$Quote$Entry$quoteDecoder);
	var _v0 = _Utils_Tuple2(quoteFromApp, quoteFromDiscovery);
	if (!_v0.a.$) {
		var fromApp = _v0.a.a;
		return $elm$core$Maybe$Just(
			$elm$core$Result$Ok(fromApp));
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			return quoteFromDiscovery;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Page$QuoteBuilderV3$Quote$Quote = F6(
	function (client, projectId, customerId, greenhouses, farm, discounts) {
		return {bx: client, gw: customerId, it: discounts, av: farm, ay: greenhouses, dH: projectId};
	});
var $author$project$Domain$Quote$Client$Client = F7(
	function (firstName, lastName, farmName, farmAddress, email, language, currency) {
		return {ik: currency, ix: email, iF: farmAddress, iG: farmName, gG: firstName, i$: language, g3: lastName};
	});
var $author$project$Route$Quote$Client$currencyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (plan) {
		switch (plan) {
			case 'CAD':
				return $elm$json$Json$Decode$succeed(0);
			case 'USD':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Currency');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Route$Quote$Client$languageDecoder = A2(
	$elm$json$Json$Decode$map,
	function (str) {
		return (str === 'EN') ? 0 : 1;
	},
	$elm$json$Json$Decode$string);
var $author$project$Route$Quote$Client$decoder = function () {
	var farmAddressField = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'farmAddress', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed('')
			]));
	return A8(
		$elm$json$Json$Decode$map7,
		$author$project$Domain$Quote$Client$Client,
		A3($author$project$Route$Quote$Utils$fieldDefault, 'firstName', $elm$json$Json$Decode$string, ''),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'lastName', $elm$json$Json$Decode$string, ''),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'farmName', $elm$json$Json$Decode$string, ''),
		farmAddressField,
		A3($author$project$Route$Quote$Utils$fieldDefault, 'email', $elm$json$Json$Decode$string, ''),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'language', $author$project$Route$Quote$Client$languageDecoder, 1),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'currency', $author$project$Route$Quote$Client$currencyDecoder, 0));
}();
var $author$project$Route$Quote$Client$default = {ik: 1, ix: '', iF: '', iG: '', gG: '', i$: 0, g3: ''};
var $author$project$Page$QuoteBuilderV3$Quote$Discount = F5(
	function (name, discountType, durationInMonths, validUntil, precision) {
		return {aH: discountType, au: durationInMonths, jg: name, jy: precision, aF: validUntil};
	});
var $author$project$Page$QuoteBuilderV3$Quote$Percentage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Quote$Amount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Quote$discountTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (tag) {
		switch (tag) {
			case 'Percentage':
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (s, p) {
							return $author$project$Page$QuoteBuilderV3$Quote$Percentage(
								{jC: p, jY: s});
						}),
					A2($elm$json$Json$Decode$field, 'subscription', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'purchase', $elm$json$Json$Decode$int));
			case 'Amount':
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (s, p) {
							return $author$project$Page$QuoteBuilderV3$Quote$Amount(
								{jC: p, jY: s});
						}),
					A2($elm$json$Json$Decode$field, 'subscription', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'purchase', $elm$json$Json$Decode$int));
			default:
				var x = tag;
				return $elm$json$Json$Decode$fail('Discount Type: ' + x);
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Page$QuoteBuilderV3$Quote$discountDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Page$QuoteBuilderV3$Quote$Discount,
	A3($author$project$Route$Quote$Utils$fieldDefault, 'name', $elm$json$Json$Decode$string, 'Discount name'),
	A3(
		$author$project$Route$Quote$Utils$fieldDefault,
		'discountType',
		$author$project$Page$QuoteBuilderV3$Quote$discountTypeDecoder,
		$author$project$Page$QuoteBuilderV3$Quote$Percentage(
			{jC: 0, jY: 0})),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'durationInMonths', $elm$json$Json$Decode$int),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'validUntil', $elm$json$Json$Decode$string),
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'precision', $elm$json$Json$Decode$string));
var $author$project$Page$QuoteBuilderV3$Quote$Farm = F2(
	function (products, customProducts) {
		return {il: customProducts, jA: products};
	});
var $author$project$Page$QuoteBuilderV3$Quote$CustomProduct = F3(
	function (name, price, quantity) {
		return {jg: name, jz: price, jD: quantity};
	});
var $author$project$Page$QuoteBuilderV3$Quote$Normal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Quote$normalPrice = F2(
	function (subscription, purchase) {
		return $author$project$Page$QuoteBuilderV3$Quote$Normal(
			{jC: purchase, jY: subscription});
	});
var $author$project$Page$QuoteBuilderV3$Quote$SubscriptionOnly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Quote$subscriptionOnly = function (subscription) {
	return $author$project$Page$QuoteBuilderV3$Quote$SubscriptionOnly(
		{jY: subscription});
};
var $author$project$Page$QuoteBuilderV3$Quote$priceDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$elm$json$Json$Decode$map2,
			$author$project$Page$QuoteBuilderV3$Quote$normalPrice,
			A2($elm$json$Json$Decode$field, 'subscription', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'purchase', $elm$json$Json$Decode$int)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Page$QuoteBuilderV3$Quote$subscriptionOnly,
			A2($elm$json$Json$Decode$field, 'subscription', $elm$json$Json$Decode$int))
		]));
var $author$project$Page$QuoteBuilderV3$Quote$customProductDecoder = function () {
	var impossiblePrice = A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 1000000, 1000000);
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Page$QuoteBuilderV3$Quote$CustomProduct,
		A3($author$project$Route$Quote$Utils$fieldDefault, 'name', $elm$json$Json$Decode$string, 'Custom product'),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'price', $author$project$Page$QuoteBuilderV3$Quote$priceDecoder, impossiblePrice),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'quantity', $elm$json$Json$Decode$int, 0));
}();
var $author$project$Page$QuoteBuilderV3$Quote$AdditionalBrain = 14;
var $author$project$Page$QuoteBuilderV3$Quote$AdvancedClimateSensor = 8;
var $author$project$Page$QuoteBuilderV3$Quote$ChiefGrower = 18;
var $author$project$Page$QuoteBuilderV3$Quote$DiseasePrevention = 2;
var $author$project$Page$QuoteBuilderV3$Quote$FanVentilation = 4;
var $author$project$Page$QuoteBuilderV3$Quote$Heating = 6;
var $author$project$Page$QuoteBuilderV3$Quote$Helper = 17;
var $author$project$Page$QuoteBuilderV3$Quote$HumidityConservation = 7;
var $author$project$Page$QuoteBuilderV3$Quote$Irrigation = 3;
var $author$project$Page$QuoteBuilderV3$Quote$LTE = 16;
var $author$project$Page$QuoteBuilderV3$Quote$OrishaInTheGreenhouse = 0;
var $author$project$Page$QuoteBuilderV3$Quote$OutdoorClimateSensor = 15;
var $author$project$Page$QuoteBuilderV3$Quote$RainProtection = 10;
var $author$project$Page$QuoteBuilderV3$Quote$RangeExtensionKit = 13;
var $author$project$Page$QuoteBuilderV3$Quote$RidgeVentilation = 5;
var $author$project$Page$QuoteBuilderV3$Quote$SideVentilation = 1;
var $author$project$Page$QuoteBuilderV3$Quote$SolarSensor = 12;
var $author$project$Page$QuoteBuilderV3$Quote$ThermalScreen = 9;
var $author$project$Page$QuoteBuilderV3$Quote$WindProtection = 11;
var $author$project$Page$QuoteBuilderV3$Quote$productDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'OrishaInTheGreenhouse':
				return $elm$json$Json$Decode$succeed(0);
			case 'SideVentilation':
				return $elm$json$Json$Decode$succeed(1);
			case 'SideVentilationNoMotors':
				return $elm$json$Json$Decode$succeed(1);
			case 'RollupVentilation':
				return $elm$json$Json$Decode$succeed(1);
			case 'RollupVentilationNoMotors':
				return $elm$json$Json$Decode$succeed(1);
			case 'DiseasePrevention':
				return $elm$json$Json$Decode$succeed(2);
			case 'Irrigation':
				return $elm$json$Json$Decode$succeed(3);
			case 'FanVentilation':
				return $elm$json$Json$Decode$succeed(4);
			case 'RidgeVentilation':
				return $elm$json$Json$Decode$succeed(5);
			case 'Heating':
				return $elm$json$Json$Decode$succeed(6);
			case 'AdvancedClimateSensor':
				return $elm$json$Json$Decode$succeed(8);
			case 'HumidityConservation':
				return $elm$json$Json$Decode$succeed(7);
			case 'ThermalScreen':
				return $elm$json$Json$Decode$succeed(9);
			case 'RainProtection':
				return $elm$json$Json$Decode$succeed(10);
			case 'WindProtection':
				return $elm$json$Json$Decode$succeed(11);
			case 'SolarSensor':
				return $elm$json$Json$Decode$succeed(12);
			case 'RangeExtensionKit':
				return $elm$json$Json$Decode$succeed(13);
			case 'AdditionalBrain':
				return $elm$json$Json$Decode$succeed(14);
			case 'OutdoorClimateSensor':
				return $elm$json$Json$Decode$succeed(15);
			case 'LTE':
				return $elm$json$Json$Decode$succeed(16);
			case 'Helper':
				return $elm$json$Json$Decode$succeed(17);
			case 'ChiefGrower':
				return $elm$json$Json$Decode$succeed(18);
			default:
				var x = str;
				return $elm$json$Json$Decode$fail('Product error: ' + x);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Page$QuoteBuilderV3$Quote$productListDecoder = A2(
	$elm$json$Json$Decode$map,
	$elmcraft$core_extra$Maybe$Extra$values,
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$maybe($author$project$Page$QuoteBuilderV3$Quote$productDecoder)));
var $author$project$Page$QuoteBuilderV3$Quote$farmDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Page$QuoteBuilderV3$Quote$Farm,
	A3($author$project$Route$Quote$Utils$fieldDefault, 'products', $author$project$Page$QuoteBuilderV3$Quote$productListDecoder, _List_Nil),
	A3(
		$author$project$Route$Quote$Utils$fieldDefault,
		'customProducts',
		$elm$json$Json$Decode$list($author$project$Page$QuoteBuilderV3$Quote$customProductDecoder),
		_List_Nil));
var $author$project$Page$QuoteBuilderV3$Quote$Greenhouse = F3(
	function (name, products, customProducts) {
		return {il: customProducts, jg: name, jA: products};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Page$QuoteBuilderV3$Quote$greenhouseDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A5(
			$elm$json$Json$Decode$map4,
			F4(
				function (name, basePlan, products, customProducts) {
					var productsAndBase = basePlan ? A2($elm$core$List$cons, 0, products) : products;
					return A3($author$project$Page$QuoteBuilderV3$Quote$Greenhouse, name, productsAndBase, customProducts);
				}),
			A3($author$project$Route$Quote$Utils$fieldDefault, 'name', $elm$json$Json$Decode$string, 'Serre'),
			A2($elm$json$Json$Decode$field, 'basePlan', $elm$json$Json$Decode$bool),
			A3($author$project$Route$Quote$Utils$fieldDefault, 'products', $author$project$Page$QuoteBuilderV3$Quote$productListDecoder, _List_Nil),
			A3(
				$author$project$Route$Quote$Utils$fieldDefault,
				'customProducts',
				$elm$json$Json$Decode$list($author$project$Page$QuoteBuilderV3$Quote$customProductDecoder),
				_List_Nil)),
			A4(
			$elm$json$Json$Decode$map3,
			$author$project$Page$QuoteBuilderV3$Quote$Greenhouse,
			A3($author$project$Route$Quote$Utils$fieldDefault, 'name', $elm$json$Json$Decode$string, 'Serre'),
			A3($author$project$Route$Quote$Utils$fieldDefault, 'products', $author$project$Page$QuoteBuilderV3$Quote$productListDecoder, _List_Nil),
			A3(
				$author$project$Route$Quote$Utils$fieldDefault,
				'customProducts',
				$elm$json$Json$Decode$list($author$project$Page$QuoteBuilderV3$Quote$customProductDecoder),
				_List_Nil))
		]));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Page$QuoteBuilderV3$Quote$decoder = function () {
	var defaultGreenhouses = _List_Nil;
	var defaultFarm = {il: _List_Nil, jA: _List_Nil};
	var defaultDiscounts = _List_Nil;
	return A7(
		$elm$json$Json$Decode$map6,
		$author$project$Page$QuoteBuilderV3$Quote$Quote,
		A3($author$project$Route$Quote$Utils$fieldDefault, 'client', $author$project$Route$Quote$Client$decoder, $author$project$Route$Quote$Client$default),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'projectId', $elm$json$Json$Decode$string, ''),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'customerId', $elm$json$Json$Decode$string, ''),
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'greenhouses',
			$elm$json$Json$Decode$list($author$project$Page$QuoteBuilderV3$Quote$greenhouseDecoder),
			defaultGreenhouses),
		A3($author$project$Route$Quote$Utils$fieldDefault, 'farm', $author$project$Page$QuoteBuilderV3$Quote$farmDecoder, defaultFarm),
		A3(
			$author$project$Route$Quote$Utils$fieldDefault,
			'discounts',
			$elm$json$Json$Decode$list($author$project$Page$QuoteBuilderV3$Quote$discountDecoder),
			defaultDiscounts));
}();
var $author$project$Page$QuoteBuilderV3$QuoteUrl$param = 'quoteV3';
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$FarmNameError = {$: 0};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$farmNameInterpreter = function (input) {
	switch (input) {
		case 'EmptyCell':
			return $elm$core$Result$Err($author$project$Route$Quote$Discovery$QuoteBuilder$Common$FarmNameError);
		case '':
			return $elm$core$Result$Err($author$project$Route$Quote$Discovery$QuoteBuilder$Common$FarmNameError);
		default:
			return $elm$core$Result$Ok(input);
	}
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$clientBuilder = function (data) {
	return A2(
		$elm$core$Result$map,
		function (farmName) {
			return {ik: 1, ix: '', iF: '', iG: farmName, gG: '', i$: 0, g3: ''};
		},
		$author$project$Route$Quote$Discovery$QuoteBuilder$Entry$farmNameInterpreter(data.iG));
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$DiseasePreventionError = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter = F4(
	function (input, products, error, greenhouseName) {
		switch (input) {
			case '0':
				return $elm$core$Result$Ok(_List_Nil);
			case '1':
				return $elm$core$Result$Ok(products);
			case 'EmptyCell':
				return $elm$core$Result$Ok(_List_Nil);
			default:
				return $elm$core$Result$Err(
					error(
						_Utils_ap(greenhouseName, input)));
		}
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraDiseasePreventionInterpreter = F2(
	function (input, greenhouseName) {
		return A4(
			$author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter,
			input,
			_List_fromArray(
				[2]),
			$author$project$Route$Quote$Discovery$QuoteBuilder$Common$DiseasePreventionError,
			greenhouseName);
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$FanVentilationError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraFanVentilationInterpreter = F2(
	function (input, greenhouseName) {
		return A4(
			$author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter,
			input,
			_List_fromArray(
				[4]),
			$author$project$Route$Quote$Discovery$QuoteBuilder$Common$FanVentilationError,
			greenhouseName);
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$HeatingError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraHeatingInterpreter = F2(
	function (input, greenhouseName) {
		return A4(
			$author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter,
			input,
			_List_fromArray(
				[6]),
			$author$project$Route$Quote$Discovery$QuoteBuilder$Common$HeatingError,
			greenhouseName);
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$IrrigationError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraIrrigationInterpreter = F2(
	function (input, greenhouseName) {
		return A4(
			$author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter,
			input,
			_List_fromArray(
				[3]),
			$author$project$Route$Quote$Discovery$QuoteBuilder$Common$IrrigationError,
			greenhouseName);
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$RidgeVentilationError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraRidgeVentilationInterpreter = F2(
	function (input, greenhouseName) {
		return A4(
			$author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter,
			input,
			_List_fromArray(
				[5]),
			$author$project$Route$Quote$Discovery$QuoteBuilder$Common$RidgeVentilationError,
			greenhouseName);
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$RollupVentilationError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraSideVentilationInterpreter = F2(
	function (input, greenhouseName) {
		return A4(
			$author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$permissionInterpreter,
			input,
			_List_fromArray(
				[1]),
			$author$project$Route$Quote$Discovery$QuoteBuilder$Common$RollupVentilationError,
			greenhouseName);
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$PlanError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$planInterpreter = F2(
	function (input, greenhouseName) {
		switch (input) {
			case 'extra':
				return $elm$core$Result$Ok(_List_Nil);
			case 'none':
				return $elm$core$Result$Ok(_List_Nil);
			case 'helper':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[17]));
			case 'chief':
				return $elm$core$Result$Ok(
					_List_fromArray(
						[18]));
			default:
				return $elm$core$Result$Err(
					$author$project$Route$Quote$Discovery$QuoteBuilder$Common$PlanError(
						_Utils_ap(greenhouseName, input)));
		}
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$interpreter = F2(
	function (data, greenhouseName) {
		return A2(
			$elm$core$Result$map,
			$elm$core$List$concat,
			$elmcraft$core_extra$Result$Extra$combine(
				_List_fromArray(
					[
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$planInterpreter, data.jv, greenhouseName),
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraSideVentilationInterpreter, data.iC.ak, greenhouseName),
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraHeatingInterpreter, data.iC.X, greenhouseName),
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraIrrigationInterpreter, data.iC._, greenhouseName),
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraFanVentilationInterpreter, data.iC.W, greenhouseName),
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraRidgeVentilationInterpreter, data.iC.aj, greenhouseName),
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$extraDiseasePreventionInterpreter, data.iC.U, greenhouseName)
					])));
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$greenhouse = F2(
	function (data, greenhouseName) {
		var errorFormattedName = greenhouseName + ' ->';
		return A2(
			$elm$core$Result$map,
			function (permissionProducts) {
				return $elm$core$List$isEmpty(permissionProducts) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{il: _List_Nil, jg: greenhouseName, jA: permissionProducts});
			},
			A2($author$project$Route$Quote$Discovery$QuoteBuilder$Permissions$interpreter, data, errorFormattedName));
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$greenhousesBuilder = function (data) {
	return A2(
		$elm$core$Result$map,
		$elmcraft$core_extra$Maybe$Extra$values,
		$elmcraft$core_extra$Result$Extra$combine(
			_List_fromArray(
				[
					A2($author$project$Route$Quote$Discovery$QuoteBuilder$Entry$greenhouse, data.iK, 'Greenhouse 1'),
					A2($author$project$Route$Quote$Discovery$QuoteBuilder$Entry$greenhouse, data.iL, 'Greenhouse 2'),
					A2($author$project$Route$Quote$Discovery$QuoteBuilder$Entry$greenhouse, data.iM, 'Greenhouse 3')
				])));
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$CustomProject = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$isProjectCustomInterpreter = function (input) {
	switch (input) {
		case 'EmptyCell':
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		case 'Custom (validé)':
			return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
		case 'Custom':
			return $elm$core$Result$Err(
				$author$project$Route$Quote$Discovery$QuoteBuilder$Common$CustomProject(input));
		default:
			return $elm$core$Result$Err(
				$author$project$Route$Quote$Discovery$QuoteBuilder$Common$CustomProject(input));
	}
};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$quoteBuilder = function (data) {
	var _v0 = $author$project$Route$Quote$Discovery$QuoteBuilder$Entry$isProjectCustomInterpreter(data.iZ);
	if (!_v0.$) {
		return $elm$core$Result$Ok(data.dH);
	} else {
		var e = _v0.a;
		return $elm$core$Result$Err(e);
	}
};
var $author$project$Route$Quote$Discovery$Entry$toQuoteBuilder = function (data) {
	return A4(
		$elm$core$Result$map3,
		F3(
			function (client, greenhouses, projectId) {
				return {
					bx: client,
					gw: '',
					it: _List_Nil,
					av: {il: _List_Nil, jA: _List_Nil},
					ay: greenhouses,
					dH: projectId
				};
			}),
		$author$project$Route$Quote$Discovery$QuoteBuilder$Entry$clientBuilder(data),
		$author$project$Route$Quote$Discovery$QuoteBuilder$Entry$greenhousesBuilder(data),
		$author$project$Route$Quote$Discovery$QuoteBuilder$Entry$quoteBuilder(data));
};
var $author$project$Route$Quote$Discovery$Entry$parseQuoteBuilder = function (url) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Route$Quote$Discovery$Entry$toQuoteBuilder,
		$author$project$Route$Quote$Discovery$Entry$parseQueryParam(url));
};
var $author$project$Page$QuoteBuilderV3$QuoteUrl$quoteFromUrl = function (url) {
	var quoteFromDiscovery = $author$project$Route$Quote$Discovery$Entry$parseQuoteBuilder(url);
	var quoteFromApp = A3($author$project$Route$QueryParameters$parseQueryParam, url, $author$project$Page$QuoteBuilderV3$QuoteUrl$param, $author$project$Page$QuoteBuilderV3$Quote$decoder);
	var _v0 = _Utils_Tuple2(quoteFromApp, quoteFromDiscovery);
	if (!_v0.a.$) {
		var fromApp = _v0.a.a;
		return $elm$core$Maybe$Just(
			$elm$core$Result$Ok(fromApp));
	} else {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			return quoteFromDiscovery;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Update$initialModel = F4(
	function (navigationKey, url, urlLanguage, user) {
		var _v0 = function () {
			var _v1 = $author$project$Page$QuoteBuilderV3$QuoteUrl$quoteFromUrl(url);
			if (!_v1.$) {
				if (!_v1.a.$) {
					var quoteV3 = _v1.a.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(quoteV3),
						$elm$core$Maybe$Nothing);
				} else {
					var error = _v1.a.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(error));
				}
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		}();
		var quoteV3FromUrl = _v0.a;
		var discoveryQuoteBuilderError = _v0.b;
		var clientLanguage = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bx;
					},
					function ($) {
						return $.i$;
					}),
				quoteV3FromUrl));
		var _v2 = function () {
			var _v3 = $author$project$Route$Quote$Entry$parseQuote(url);
			if (!_v3.$) {
				if (!_v3.a.$) {
					var quote = _v3.a.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(quote),
						$elm$core$Maybe$Nothing);
				} else {
					var error = _v3.a.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(error));
				}
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		}();
		var quoteFromUrl = _v2.a;
		var discoveryError = _v2.b;
		return {
			aI: A2($author$project$Page$Discovery$Update$initialModel, clientLanguage, quoteFromUrl),
			fe: discoveryError,
			ff: discoveryQuoteBuilderError,
			cH: '',
			gX: false,
			i$: urlLanguage,
			c2: $author$project$Login$Page$initialModel,
			fJ: navigationKey,
			dn: $elm$core$Maybe$Nothing,
			dv: $author$project$Page$PackingSlip$initialModel,
			bG: 1,
			bH: $elm$core$Maybe$Nothing,
			ag: A2($author$project$Page$QuoteBuilderV3$Update$initialModel, user, quoteV3FromUrl),
			d2: 0,
			er: $elm$core$Maybe$Nothing,
			bS: url,
			bT: user
		};
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Route$QueryParameters$decodeLanguage = function (str) {
	if ((!str.$) && (str.a === 'EN')) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Route$QueryParameters$languageParser = A2(
	$elm$url$Url$Parser$Query$map,
	$author$project$Route$QueryParameters$decodeLanguage,
	$elm$url$Url$Parser$Query$string('language'));
var $author$project$Route$QueryParameters$parseLanguage = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		A2(
			$elm$url$Url$Parser$parse,
			A2($elm$url$Url$Parser$questionMark, $elm$url$Url$Parser$top, $author$project$Route$QueryParameters$languageParser),
			url));
};
var $author$project$Update$init = F3(
	function (flags, url, navigationKey) {
		var user = $author$project$Domain$User$decode(flags.j3);
		var languageParameters = $author$project$Route$QueryParameters$parseLanguage(url);
		return _Utils_Tuple2(
			A4($author$project$Update$initialModel, navigationKey, url, languageParameters, user),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Update$Now, $elm$time$Time$now),
						A2($elm$core$Task$perform, $author$project$Update$Timezone, $elm$time$Time$here)
					])));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$cons = _String_cons;
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {a4: charsProcessed, bb: hash, hw: seed, bj: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Bitwise$or = _Bitwise_or;
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.bb)) ? (data.hw ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.bb)))) : data.hw;
	var h0 = acc ^ data.a4;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.bb | ((255 & $elm$core$Char$toCode(c)) << data.bj);
		var _v0 = data.bj;
		if (_v0 === 24) {
			return {
				a4: data.a4 + 1,
				bb: 0,
				hw: A2($robinheghan$murmur3$Murmur3$mix, data.hw, res),
				bj: 0
			};
		} else {
			return {a4: data.a4 + 1, bb: res, hw: data.hw, bj: data.bj + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\n' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (!accumulatedStyles.$) {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\n' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Theme$ImgPath$base = 'https://devis.orisha.ca/';
var $author$project$Theme$ImgPath$background = $author$project$Theme$ImgPath$base + 'bg-1366.jpg';
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.hR);
	});
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $rtfeldman$elm_css$Css$backgroundSize = $rtfeldman$elm_css$Css$prop1('background-size');
var $author$project$Update$DiscoveryMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Update$DownloadQuote = {$: 11};
var $author$project$Update$Failed = 2;
var $author$project$Update$PackingSlipMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Update$QuoteBuilderV3Msg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Update$SaveQuote = {$: 9};
var $author$project$Update$Saving = 1;
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $elm$core$String$fromFloat = _String_fromNumber;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			gd: 0,
			gq: 0,
			a9: 0,
			D: 0,
			i2: 0,
			bd: 0,
			az: 0,
			be: 0,
			bf: 0,
			aO: 0,
			aP: 0,
			ap: 0,
			bg: 0,
			aC: numericValue,
			bm: 0,
			bo: unitLabel,
			bR: units,
			hR: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.hR);
};
var $rtfeldman$elm_css$Css$bold = {aL: 0, hR: 'bold'};
var $author$project$Style$Bulma$box = 'box';
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		bv: 1,
		ib: 0,
		ao: 0,
		iJ: 0,
		jF: 0,
		hR: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$String$toLower = _String_toLower;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				bv: alpha / 255,
				ib: blue,
				ao: 0,
				iJ: green,
				jF: red,
				hR: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$Theme$Color$brightRed = $rtfeldman$elm_css$Css$hex('#ff0000');
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.hR);
};
var $rtfeldman$elm_css$Css$row = {fl: 0, bA: 0, hR: 'row'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{hR: 'column'});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.$9) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.jg, record.$9, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{$9: decl, jg: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.gs;
	var imports = _v0.gR;
	var namespaces = _v0.g7;
	var declarations = _v0.io;
	return {
		gs: charset,
		io: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		gR: imports,
		g7: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.gE + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.hR)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.jg;
			var declaration = decl.a.$9;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.gs;
	var imports = _v0.gR;
	var namespaces = _v0.g7;
	var declarations = _v0.io;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{$9: str, jg: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.gs;
	var imports = _v0.gR;
	var namespaces = _v0.g7;
	var snippets = _v0.hB;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {gs: charset, io: declarations, gR: imports, g7: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {gs: $elm$core$Maybe$Nothing, gR: _List_Nil, g7: _List_Nil, hB: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$S$empty = $rtfeldman$elm_css$Html$Styled$text('');
var $author$project$View$en = {b3: 'The technical discovery link might be broken.', cp: 'Download', bz: 'ERROR!', cu: 'Failed to save', cP: 'If the mistake is not triggered by a custom product or a missing farm name, inform dev team that a problem occured while decoding', dA: 'Please provide a project ID and a customer ID', dE: 'Print', bJ: 'Save', d1: 'Saving'};
var $author$project$Route$Quote$Discovery$Error$en = {
	cc: {e1: 'The client has a LTE controller: ', e7: 'The client chose a custom (same) controller: ', e9: 'The client chose a custom wifi signal range (controller): ', fk: 'Controller (first purchase): ', fr: 'Orisha is already in the greenhouse in ', fF: 'LTE controller: ', fV: 'Controller (same controller): ', ga: 'Controller (wifi signal range): '},
	W: {e0: 'The client chose a custom louver brand in ', cv: 'Fans in ', fD: 'Louvers in ', fE: 'Louver brand in '},
	X: {eY: 'Heater brand in ', e_: 'The client chose a custom heater brand in ', fa: 'The client chose a custom heater wires length in ', cG: 'Heaters in ', f2: 'Back up thermostat in ', gb: 'Heater wires in '},
	_: {e8: 'The client chose a custom valve wires length in ', f6: 'Valves to automate in ', f7: 'Physical valves to be sent in ', f8: 'Valve wires in '},
	dO: 'Rain sensor: ',
	aj: {e4: 'The client has a custom length of roof actuator to inverter wire in ', e5: 'The client has a custom length of roof motor to to inverter wire in ', e6: 'The client has a custom roof model in ', fS: 'Roof inverter wire to actuator in ', fT: 'Roof inverter wire to motor in ', fU: 'Roof type in '},
	ak: {e$: 'The client chose a custom side vent height in ', e2: 'The client chose a custom motor brand for side ventilation in ', e3: 'The client chose a custom guide pipes diameter in ', fs: 'Side vent height in ', fI: 'Side vents motor in ', fO: 'Already has guide pipes for side vents in ', fP: 'Side vent guide pipes diameter in ', fX: 'Side vents in '},
	eA: 'Wind sensor: '
};
var $author$project$Route$Quote$Discovery$Error$fr = {
	cc: {e1: 'Le client a un contrôleur LTE : ', e7: 'Le client a choisi une valeur de (même) contrôleur hors norme : ', e9: 'Le client a choisi une valeur de rayon de signal wifi (contrôleur) hors norme : ', fk: 'Contrôleur (premier achat) : ', fr: 'Orisha est déjà dans la serre : ', fF: 'Contrôler LTE : ', fV: 'Contrôleur (même contrôleur) : ', ga: 'Contrôleur (rayon signal wifi) : '},
	W: {e0: 'Le client a un modèle de louvre hors norme dans ', cv: 'Pression positive dans ', fD: 'Louvres dans ', fE: 'Modèle de louvre dans '},
	X: {eY: 'Modèle de fournaise dans ', e_: 'Le client a un modèle de fournaise hors norme dans ', fa: 'Le client a choisi une valeur sur mesure de longueur de fils de fournaise dans ', cG: 'Fournaises dans ', f2: 'Thermostat de secours dans ', gb: 'Fils de fournaise dans '},
	_: {e8: 'Le client a choisi une valeur sur mesure de longueur de fils de valve dans ', f6: 'Valves à automatiser dans ', f7: 'Valves physiques à envoyer dans ', f8: 'Fils de valves dans '},
	dO: 'Capteur de pluie : ',
	aj: {e4: 'Le client a choisi une longueur sur mesure de fil entre l\'actuateur et l\'inverseur de toit dans ', e5: 'Le client a choisi une longueur sur mesure de fil entre le moteur et l\'inverseur dans ', e6: 'Le client a un modèle de toit sur mesure dans ', fS: 'Fil d\'inverseur de toit au boîtier dans ', fT: 'Fil d\'inverseur de toit au moteur dans ', fU: 'Type de toit dans '},
	ak: {e$: 'Le client a choisi une valeur de hauteur de côté ouvrant hors norme dans ', e2: 'Le client a un modèle de moteur de côté ouvrant hors norme dans ', e3: 'Le client a choisi un diamètre de tuyaux guides hors norme dans ', fs: 'Hauteur de côté ouvrant dans ', fI: 'Moteur de côtés ouvrants dans ', fO: 'A déjà des tuyaux guides pour les côtés ouvrants dans ', fP: 'Diamètre de tuyaux guides pour côté ouvrant dans ', fX: 'Côtés ouvrants dans '},
	eA: 'Capteur de vent : '
};
var $author$project$Language$getTranslation = F2(
	function (language, translations) {
		if (!language) {
			return translations.iy;
		} else {
			return translations.iI;
		}
	});
var $author$project$Route$Quote$Discovery$Error$errorMessage = F2(
	function (language, error) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Route$Quote$Discovery$Error$en, iI: $author$project$Route$Quote$Discovery$Error$fr});
		switch (error.$) {
			case 0:
				var e = error.a;
				return _Utils_ap(translation.dO, e);
			case 1:
				var e = error.a;
				return _Utils_ap(translation.eA, e);
			case 2:
				var sub = error.a;
				switch (sub.$) {
					case 0:
						var e = sub.a;
						return _Utils_ap(translation.cc.fk, e);
					case 1:
						var e = sub.a;
						return _Utils_ap(translation.cc.fV, e);
					case 2:
						var e = sub.a;
						return _Utils_ap(translation.cc.e7, e);
					case 3:
						var e = sub.a;
						return _Utils_ap(translation.cc.fF, e);
					case 4:
						var e = sub.a;
						return _Utils_ap(translation.cc.e1, e);
					case 5:
						var e = sub.a;
						return _Utils_ap(translation.cc.ga, e);
					case 6:
						var e = sub.a;
						return _Utils_ap(translation.cc.e9, e);
					default:
						var e = sub.a;
						return _Utils_ap(translation.cc.fr, e);
				}
			case 3:
				var sub = error.a;
				switch (sub.$) {
					case 0:
						var e = sub.a;
						return _Utils_ap(translation.ak.fX, e);
					case 1:
						var e = sub.a;
						return _Utils_ap(translation.ak.fO, e);
					case 2:
						var e = sub.a;
						return _Utils_ap(translation.ak.fI, e);
					case 3:
						var e = sub.a;
						return _Utils_ap(translation.ak.e2, e);
					case 4:
						var e = sub.a;
						return _Utils_ap(translation.ak.e$, e);
					case 5:
						var e = sub.a;
						return _Utils_ap(translation.ak.fs, e);
					case 6:
						var e = sub.a;
						return _Utils_ap(translation.ak.e3, e);
					default:
						var e = sub.a;
						return _Utils_ap(translation.ak.fP, e);
				}
			case 4:
				var sub = error.a;
				switch (sub.$) {
					case 0:
						var e = sub.a;
						return _Utils_ap(translation.X.cG, e);
					case 1:
						var e = sub.a;
						return _Utils_ap(translation.X.e_, e);
					case 2:
						var e = sub.a;
						return _Utils_ap(translation.X.eY, e);
					case 3:
						var e = sub.a;
						return _Utils_ap(translation.X.fa, e);
					case 4:
						var e = sub.a;
						return _Utils_ap(translation.X.gb, e);
					default:
						var e = sub.a;
						return _Utils_ap(translation.X.f2, e);
				}
			case 5:
				var sub = error.a;
				switch (sub.$) {
					case 0:
						var e = sub.a;
						return _Utils_ap(translation._.f7, e);
					case 1:
						var e = sub.a;
						return _Utils_ap(translation._.f6, e);
					case 2:
						var e = sub.a;
						return _Utils_ap(translation._.e8, e);
					default:
						var e = sub.a;
						return _Utils_ap(translation._.f8, e);
				}
			case 6:
				var sub = error.a;
				switch (sub.$) {
					case 0:
						var e = sub.a;
						return _Utils_ap(translation.W.cv, e);
					case 1:
						var e = sub.a;
						return _Utils_ap(translation.W.fD, e);
					case 2:
						var e = sub.a;
						return _Utils_ap(translation.W.e0, e);
					default:
						var e = sub.a;
						return _Utils_ap(translation.W.fE, e);
				}
			default:
				var sub = error.a;
				switch (sub.$) {
					case 0:
						var e = sub.a;
						return _Utils_ap(translation.aj.e6, e);
					case 1:
						var e = sub.a;
						return _Utils_ap(translation.aj.fU, e);
					case 2:
						var e = sub.a;
						return _Utils_ap(translation.aj.e4, e);
					case 3:
						var e = sub.a;
						return _Utils_ap(translation.aj.fS, e);
					case 4:
						var e = sub.a;
						return _Utils_ap(translation.aj.e5, e);
					default:
						var e = sub.a;
						return _Utils_ap(translation.aj.fT, e);
				}
		}
	});
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$en = {cj: 'This project is custom and should be checked: ', U: 'Disease prevention permission in ', W: 'Fan ventilation permission in ', iG: 'Farm name is missing', X: 'Heating permission in ', _: 'Irrigation permission in ', jv: 'Plan in ', aj: 'Ridge ventilation permission in ', dW: 'Roll up ventilation permission in '};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$fr = {cj: 'Le projet est sur mesure et mérite donc votre attention : ', U: 'Permission de protection contre les maladies dans ', W: 'Permission de ventilation par ventilateurs dans ', iG: 'Nom de la ferme absent', X: 'Permission de chauffage dans ', _: 'Permission d\'irrigation dans ', jv: 'Plan dans ', aj: 'Permission de ventilation des toits dans ', dW: 'Permission de ventilation par côté ouvrant dans '};
var $author$project$Route$Quote$Discovery$QuoteBuilder$Common$errorMessage = F2(
	function (language, error) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Route$Quote$Discovery$QuoteBuilder$Common$en, iI: $author$project$Route$Quote$Discovery$QuoteBuilder$Common$fr});
		switch (error.$) {
			case 0:
				return translation.iG;
			case 1:
				var e = error.a;
				return _Utils_ap(translation.cj, e);
			case 2:
				var e = error.a;
				return _Utils_ap(translation.jv, e);
			case 3:
				var e = error.a;
				return _Utils_ap(translation.dW, e);
			case 4:
				var e = error.a;
				return _Utils_ap(translation.X, e);
			case 5:
				var e = error.a;
				return _Utils_ap(translation._, e);
			case 6:
				var e = error.a;
				return _Utils_ap(translation.W, e);
			case 7:
				var e = error.a;
				return _Utils_ap(translation.aj, e);
			default:
				var e = error.a;
				return _Utils_ap(translation.U, e);
		}
	});
var $rtfeldman$elm_css$Css$fixed = {bw: 0, bI: 0, el: 0, hR: 'fixed'};
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.hR;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $author$project$View$fr = {b3: 'Le lien de la découverte technique est peut-être brisé.', cp: 'Télécharger', bz: 'ERREUR!', cu: 'Erreur de sauvegarde', cP: 'Si l\'erreur ne vient pas d\'un produit sur mesure ou d\'un nom de ferme manquant, informez l\'équipe de développement qu\'un problème est survenu dans le décodage de', dA: 'Veuillez fournir un project ID et un customer ID', dE: 'Imprimer', bJ: 'Sauvegarder', d1: 'Enregistrement'};
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		aL: 0,
		cR: 0,
		aP: 0,
		ap: 0,
		jp: 0,
		$7: 0,
		aC: val,
		bo: '',
		bR: 0,
		hR: $elm$core$String$fromInt(val)
	};
};
var $elmcraft$core_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $author$project$Update$SetLanguage = function (a) {
	return {$: 13, a: a};
};
var $rtfeldman$elm_css$Css$boxShadow = $rtfeldman$elm_css$Css$prop1('box-shadow');
var $elm$core$String$endsWith = _String_endsWith;
var $rtfeldman$elm_css$Css$makeImportant = function (_v0) {
	var str = _v0;
	return A2(
		$elm$core$String$endsWith,
		' !important',
		$elm$core$String$toLower(str)) ? str : (str + ' !important');
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Preprocess$mapAllProperties = F2(
	function (update, styles) {
		if (!styles.b) {
			return styles;
		} else {
			if (!styles.b.b) {
				var only = styles.a;
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$Preprocess$mapProperties, update, only)
					]);
			} else {
				var first = styles.a;
				var rest = styles.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Preprocess$mapAllProperties, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$mapProperties = F2(
	function (update, style) {
		switch (style.$) {
			case 0:
				var property = style.a;
				return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(
					update(property));
			case 1:
				var selector = style.a;
				var styles = style.b;
				return A2(
					$rtfeldman$elm_css$Css$Preprocess$ExtendSelector,
					selector,
					A2($rtfeldman$elm_css$Css$Preprocess$mapAllProperties, update, styles));
			case 2:
				return style;
			case 3:
				return style;
			case 4:
				return style;
			case 5:
				return style;
			default:
				var otherStyles = style.a;
				return $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$mapProperties(update),
						otherStyles));
		}
	});
var $rtfeldman$elm_css$Css$important = $rtfeldman$elm_css$Css$Preprocess$mapProperties($rtfeldman$elm_css$Css$makeImportant);
var $rtfeldman$elm_css$Css$initial = {gg: 0, v: 0, bw: 0, gj: 0, a2: 0, gk: 0, a3: 0, as: 0, G: 0, b2: 0, ao: 0, d: 0, p: 0, a9: 0, fl: 0, bA: 0, cA: 0, aK: 0, D: 0, bB: 0, j: 0, aL: 0, cR: 0, g$: 0, fC: 0, i2: 0, bd: 0, az: 0, be: 0, bf: 0, aO: 0, aP: 0, ap: 0, bg: 0, c1: 0, f: 0, e: 0, aS: 0, jp: 0, aC: 0, du: 0, bh: 0, af: 0, el: 0, bl: 0, aX: 0, bm: 0, bn: 0, aY: 0, M: 0, bo: '', bR: 0, hR: 'initial', bU: 0, a0: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{hR: 'inherit'});
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$none = {a2: 0, gm: 0, G: 0, d: 0, p: 0, iU: 0, gT: 0, fC: 0, bf: 0, aO: 0, ap: 0, f: 0, e: 0, aS: 0, du: 0, jw: 0, af: 0, dS: 0, jO: 0, bl: 0, aY: 0, M: 0, l: 0, j7: 0, hR: 'none'};
var $rtfeldman$elm_css$Css$pointer = {d: 0, hR: 'pointer'};
var $rtfeldman$elm_css$Html$Styled$styled = F4(
	function (fn, styles, attrs, children) {
		return A2(
			fn,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Internal$css(styles),
				attrs),
			children);
	});
var $rtfeldman$elm_css$Css$transparent = {ao: 0, hR: 'transparent'};
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$Style$Buttons$cleanButton = F2(
	function (attrs, body) {
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]),
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
				attrs),
			body);
	});
var $author$project$S$cleanButton = $author$project$Style$Buttons$cleanButton;
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $author$project$Theme$Color$linkBlue = $rtfeldman$elm_css$Css$hex('#3273dc');
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$View$languageSelectionView = F2(
	function (language, msg) {
		var _v0 = function () {
			if (!language) {
				return _Utils_Tuple2('Français', 1);
			} else {
				return _Utils_Tuple2('English', 0);
			}
		}();
		var languageOption = _v0.a;
		var selectedLanguage = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$em(-3)),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$em(2))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$S$cleanButton,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$important(
									$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$em(1))),
									$rtfeldman$elm_css$Css$color($author$project$Theme$Color$linkBlue),
									$rtfeldman$elm_css$Css$zIndex(
									$rtfeldman$elm_css$Css$int(10))
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							msg(selectedLanguage))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(languageOption)
						]))
				]));
	});
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$Structure$OnlyQuery = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$only = $rtfeldman$elm_css$Css$Structure$OnlyQuery;
var $rtfeldman$elm_css$Css$Structure$Print = 0;
var $rtfeldman$elm_css$Css$Media$print = 0;
var $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$withMedia = $rtfeldman$elm_css$Css$Preprocess$WithMedia;
var $author$project$Style$Media$onPrint = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$Media$only, $rtfeldman$elm_css$Css$Media$print, _List_Nil)
		]));
var $author$project$S$onPrint = $author$project$Style$Media$onPrint;
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.hR + (' ' + argB.hR));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$RemUnits = 0;
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var $rtfeldman$elm_css$Css$VwUnits = 0;
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vw');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$View$mainBox = F2(
	function (language, html) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$box),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$vw(51)),
							$rtfeldman$elm_css$Css$maxWidth(
							$rtfeldman$elm_css$Css$px(1000)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(1.5)),
							$rtfeldman$elm_css$Css$important(
							A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$rem(6),
								$rtfeldman$elm_css$Css$rem(6))),
							$author$project$S$onPrint(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$inherit),
									$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$inherit),
									$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
									$rtfeldman$elm_css$Css$important(
									$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$inherit))
								]))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$View$languageSelectionView, language, $author$project$Update$SetLanguage),
					html
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
	function (transform, _v0) {
		var prop = _v0.a;
		var isCssStyle = _v0.b;
		var cssTemplate = _v0.c;
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
			isCssStyle,
			cssTemplate);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$map = F2(
	function (transform, vdomNode) {
		switch (vdomNode.$) {
			case 0:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$Node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 1:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 2:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var child = _v1.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			case 3:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var key = _v2.a;
							var child = _v2.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			default:
				var vdom = vdomNode.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
					A2($elm$virtual_dom$VirtualDom$map, transform, vdom));
		}
	});
var $rtfeldman$elm_css$Html$Styled$map = $rtfeldman$elm_css$VirtualDom$Styled$map;
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$Structure$NotQuery = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$not = $rtfeldman$elm_css$Css$Structure$NotQuery;
var $author$project$Style$Media$notOnPrint = $rtfeldman$elm_css$Css$Media$withMedia(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$Media$not, $rtfeldman$elm_css$Css$Media$print, _List_Nil)
		]));
var $author$project$S$notOnPrint = $author$project$Style$Media$notOnPrint;
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		aP: 0,
		ap: 0,
		bg: 0,
		jp: 0,
		$7: 0,
		aC: val,
		bo: '',
		bR: 0,
		hR: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $author$project$Theme$Color$orishaGreen = $rtfeldman$elm_css$Css$hex('#25b14e');
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $rtfeldman$elm_css$Css$pointerEvents = $rtfeldman$elm_css$Css$prop1('pointer-events');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $author$project$Update$Print = {$: 12};
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.hR + (' ' + (argB.hR + (' ' + (argC.hR + (' ' + argD.hR))))));
	});
var $rtfeldman$elm_css$Css$textShadow4 = $rtfeldman$elm_css$Css$prop4('text-shadow');
var $author$project$Theme$Color$veryDarkGrey = $rtfeldman$elm_css$Css$hex('#222222');
var $author$project$Style$Buttons$button = F2(
	function (attrs, children) {
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontSize(
					$rtfeldman$elm_css$Css$rem(1.5)),
					$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
					$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0.7)),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$opacity(
							$rtfeldman$elm_css$Css$num(0.7))
						])),
					A2($rtfeldman$elm_css$Css$property, 'transition', 'all 0.5s ease'),
					A4(
					$rtfeldman$elm_css$Css$textShadow4,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$px(1),
					$author$project$Theme$Color$veryDarkGrey)
				]),
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('button-hover'),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
					attrs)),
			children);
	});
var $author$project$Theme$Color$darkWhite = $rtfeldman$elm_css$Css$hex('#cccccc');
var $rtfeldman$elm_css$Html$Styled$i = $rtfeldman$elm_css$Html$Styled$node('i');
var $rtfeldman$elm_css$Css$inlineFlex = {p: 0, hR: 'inline-flex'};
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$Theme$Icon$faIcon = F2(
	function (fontAwesomeClass, color) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$color(color)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$i,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('fa fa-' + fontAwesomeClass)
						]),
					_List_Nil)
				]));
	});
var $author$project$Utils$Style$gap = function (length) {
	return A2($rtfeldman$elm_css$Css$property, 'gap', length.hR);
};
var $author$project$Style$Buttons$faButton = F4(
	function (fontAwesomeClass, color, str, attrs) {
		return A2(
			$author$project$Style$Buttons$button,
			attrs,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$em(0.3))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$Theme$Color$darkWhite)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(str)
								])),
							A2($author$project$Theme$Icon$faIcon, fontAwesomeClass, color)
						]))
				]));
	});
var $author$project$Theme$Color$green = $rtfeldman$elm_css$Css$hex('#149614');
var $author$project$Style$Buttons$printButton = A2($author$project$Style$Buttons$faButton, 'print', $author$project$Theme$Color$green);
var $author$project$S$printButton = $author$project$Style$Buttons$printButton;
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $author$project$View$printLayout = F2(
	function (model, body) {
		var translation = A2(
			$author$project$Language$getTranslation,
			model.i$,
			{iy: $author$project$View$en, iI: $author$project$View$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					body,
					A2(
					$author$project$S$printButton,
					translation.dE,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
									$rtfeldman$elm_css$Css$top(
									$rtfeldman$elm_css$Css$rem(4)),
									$rtfeldman$elm_css$Css$right(
									$rtfeldman$elm_css$Css$rem(4)),
									$author$project$S$onPrint(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
										]))
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Update$Print)
						]))
				]));
	});
var $author$project$Theme$Color$red = $rtfeldman$elm_css$Css$hex('#b42828');
var $rtfeldman$elm_css$Css$stringsToValue = function (list) {
	return $elm$core$List$isEmpty(list) ? {hR: 'none'} : {
		hR: A2($elm$core$String$join, ', ', list)
	};
};
var $rtfeldman$elm_css$Css$fontFamilies = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('font-family'),
	$rtfeldman$elm_css$Css$stringsToValue);
var $author$project$Theme$Font$rubik = $rtfeldman$elm_css$Css$fontFamilies(
	_List_fromArray(
		['Rubik']));
var $author$project$Style$Buttons$saveButton = A2($author$project$Style$Buttons$faButton, 'floppy-o', $author$project$Theme$Color$green);
var $author$project$S$saveButton = $author$project$Style$Buttons$saveButton;
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $author$project$Utils$Style$noStyle = $rtfeldman$elm_css$Css$batch(_List_Nil);
var $author$project$Utils$Style$styleIf = F2(
	function (condition, style) {
		return condition ? $rtfeldman$elm_css$Css$batch(style) : $author$project$Utils$Style$noStyle;
	});
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Page$Discovery$Farm$Update$toQuote = function (model) {
	return {il: model.a6.il, jA: model.jA};
};
var $author$project$Page$Discovery$Greenhouse$Update$en = {cE: 'Greenhouse '};
var $author$project$Page$Discovery$Greenhouse$Update$fr = {cE: 'Serre '};
var $author$project$Page$Discovery$Greenhouse$Update$defaultName = function (model) {
	var translation = A2(
		$author$project$Language$getTranslation,
		model.i$,
		{iy: $author$project$Page$Discovery$Greenhouse$Update$en, iI: $author$project$Page$Discovery$Greenhouse$Update$fr});
	return _Utils_ap(
		translation.cE,
		$elm$core$String$fromInt(model.cN + 1));
};
var $author$project$Page$Discovery$CustomField$Update$toQuote = function (model) {
	return A2(
		$elm$core$List$map,
		function (p) {
			return {is: p.is, jg: p.jg, jz: p.jz, jD: p.jD, jH: p.jH};
		},
		model.il);
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$toQuote = function ($) {
	return $.aR;
};
var $author$project$Page$Discovery$Greenhouse$Update$toQuote = function (model) {
	var name = function () {
		var _v0 = model.jg;
		switch (_v0.$) {
			case 0:
				var initial = _v0.a.bC;
				return initial;
			case 1:
				var n = _v0.a;
				return n;
			default:
				return $author$project$Page$Discovery$Greenhouse$Update$defaultName(model);
		}
	}();
	return {
		il: $author$project$Page$Discovery$CustomField$Update$toQuote(model.a6),
		aR: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$toQuote(model.aR),
		jg: name,
		jA: model.jA
	};
};
var $author$project$Page$Discovery$Update$toQuote = function (model) {
	return {
		a1: model.a1,
		av: $author$project$Page$Discovery$Farm$Update$toQuote(model.av),
		ay: A2($elm$core$List$map, $author$project$Page$Discovery$Greenhouse$Update$toQuote, model.ay)
	};
};
var $author$project$Page$QuoteBuilderV3$Farm$Update$toQuote = function (model) {
	return {il: model.a6.il, jA: model.jA};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$en = {cE: 'Greenhouse '};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$fr = {cE: 'Serre '};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$defaultName = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$en, iI: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$fr});
		return _Utils_ap(
			translation.cE,
			$elm$core$String$fromInt(model.cN + 1));
	});
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$toQuote = F2(
	function (language, g) {
		return {
			il: g.a6.il,
			jg: function () {
				var _v0 = g.jg;
				switch (_v0.$) {
					case 0:
						var initial = _v0.a.bC;
						return initial;
					case 1:
						var n = _v0.a;
						return n;
					default:
						return A2($author$project$Page$QuoteBuilderV3$Greenhouse$Update$defaultName, language, g);
				}
			}(),
			jA: g.jA
		};
	});
var $author$project$Page$QuoteBuilderV3$Update$toQuote = function (model) {
	return {
		bx: model.bx,
		gw: model.gw,
		it: model.gy.ch,
		av: $author$project$Page$QuoteBuilderV3$Farm$Update$toQuote(model.av),
		ay: A2(
			$elm$core$List$map,
			$author$project$Page$QuoteBuilderV3$Greenhouse$Update$toQuote(model.bx.i$),
			model.ay),
		dH: model.dH
	};
};
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $author$project$Update$Logout = {$: 15};
var $rtfeldman$elm_css$Css$block = {p: 0, hR: 'block'};
var $author$project$Menu$en = {dv: 'Packing Slip', dJ: 'Quote', eb: 'Sign Out', em: 'Technical Discovery'};
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $author$project$Menu$fr = {dv: 'Bon de livraison', dJ: 'Soumission', eb: 'Se déconnecter', em: 'Découverte technique'};
var $author$project$Update$ResetUrl = {$: 16};
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $author$project$Theme$ImgPath$logo = $author$project$Theme$ImgPath$base + 'orisha-logo.svg';
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $author$project$Theme$Color$white = $rtfeldman$elm_css$Css$hex('#eeeeee');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			bv: alpha,
			ib: b,
			ao: 0,
			iJ: g,
			jF: r,
			hR: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $author$project$Theme$Color$withOpacity = F2(
	function (opacity, color) {
		return A4($rtfeldman$elm_css$Css$rgba, color.jF, color.iJ, color.ib, opacity);
	});
var $author$project$Menu$layout = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
						$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$vh(2.5)),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$backgroundColor(
						A2($author$project$Theme$Color$withOpacity, 0.3, $author$project$Theme$Color$white)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$vw(24)),
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$px(400)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$vh(95)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(3)),
						$author$project$S$onPrint(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
							]))
					]))
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$px(200)),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$rem(2))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Update$ResetUrl)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$logo)
									]),
								_List_Nil)
							]))
					])),
			content));
};
var $author$project$Update$Discovery = 0;
var $author$project$Update$PackingSlip = 2;
var $rtfeldman$elm_css$Css$flex = $rtfeldman$elm_css$Css$prop1('flex');
var $author$project$Domain$User$isOrisha = function (user) {
	var _v0 = user.fq;
	return true;
};
var $author$project$Update$GoToPage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Theme$Color$darkGrey = $rtfeldman$elm_css$Css$hex('#363636');
var $author$project$Menu$link = F3(
	function (page, currentPage, label) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							A2(
							$author$project$Utils$Style$styleIf,
							_Utils_eq(currentPage, page),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color($author$project$Theme$Color$darkGrey)
								]))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Update$GoToPage(page))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node('nav');
var $author$project$Style$Grid$rowGap = function (length) {
	return A2($rtfeldman$elm_css$Css$property, 'row-gap', length.hR);
};
var $rtfeldman$elm_css$Css$spaceAround = $rtfeldman$elm_css$Css$prop1('space-around');
var $author$project$S$when = F2(
	function (predicate, content) {
		return predicate ? content : $author$project$S$empty;
	});
var $author$project$Menu$links = F3(
	function (user, translation, currentPage) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flex(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$nav,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
									$author$project$Style$Grid$rowGap(
									$rtfeldman$elm_css$Css$rem(1.25)),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$rem(1.2))
								]))
						]),
					_List_fromArray(
						[
							A3($author$project$Menu$link, 1, currentPage, translation.dJ),
							A3($author$project$Menu$link, 0, currentPage, translation.em),
							A2(
							$author$project$S$when,
							$author$project$Domain$User$isOrisha(user),
							A3($author$project$Menu$link, 2, currentPage, translation.dv))
						]))
				]));
	});
var $author$project$Menu$view = F3(
	function (language, user, currentPage) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Menu$en, iI: $author$project$Menu$fr});
		return $author$project$Menu$layout(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$S$cleanButton,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
											$rtfeldman$elm_css$Css$marginTop(
											$rtfeldman$elm_css$Css$rem(-0.1)),
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$rem(0.7))
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Update$Logout)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$color($author$project$Theme$Color$linkBlue)
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(translation.eb)
										]))
								]))
						])),
					A3($author$project$Menu$links, user, translation, currentPage)
				]));
	});
var $author$project$Page$Discovery$Update$SetActuator = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Quote$Actuator$allActuators = _List_fromArray(
	[0, 1, 2]);
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $author$project$Style$Form$labeled = F2(
	function (labelText, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$px(0)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$label,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('label'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(0.9)),
									$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(300))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(labelText)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('control')
						]),
					children)
				]));
	});
var $author$project$S$labeled = $author$project$Style$Form$labeled;
var $author$project$Style$Bulma$control = 'control';
var $elmcraft$core_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elmcraft$core_extra$List$Extra$findIndex = $elmcraft$core_extra$List$Extra$findIndexHelp(0);
var $elmcraft$core_extra$List$Extra$elemIndex = function (x) {
	return $elmcraft$core_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $elm_community$json_extra$Json$Decode$Extra$fromMaybe = F2(
	function (error, val) {
		if (!val.$) {
			var v = val.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail(error);
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elmcraft$core_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $author$project$Style$Bulma$select = 'select';
var $elm$json$Json$Encode$bool = _Json_wrap;
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Style$Form$select = F5(
	function (initial, options, toLabel, toMsg, attrs) {
		var onInput = A2(
			$elm$json$Json$Decode$andThen,
			function (index) {
				return A2(
					$elm_community$json_extra$Json$Decode$Extra$fromMaybe,
					'Index not found',
					A2(
						$elm$core$Maybe$map,
						toMsg,
						A2(
							$elm$core$Maybe$andThen,
							function (i) {
								return A2($elmcraft$core_extra$List$Extra$getAt, i, options);
							},
							$elm$core$String$toInt(index))));
			},
			$rtfeldman$elm_css$Html$Styled$Events$targetValue);
		var initialIndex = A2($elmcraft$core_extra$List$Extra$elemIndex, initial, options);
		var toOption = F2(
			function (index, elem) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$option,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(
								$elm$core$Maybe$Just(index),
								initialIndex)),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							$elm$core$String$fromInt(index))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							toLabel(elem))
						]));
			});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$control)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$select)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							A2(
								$elm$core$List$cons,
								A2($rtfeldman$elm_css$Html$Styled$Events$on, 'input', onInput),
								attrs),
							A2($elm$core$List$indexedMap, toOption, options))
						]))
				]));
	});
var $author$project$S$select = $author$project$Style$Form$select;
var $author$project$Page$Discovery$View$actuatorView = F3(
	function (translation, user, initialActuator) {
		var toLabel = function (actuator) {
			switch (actuator) {
				case 0:
					return translation.df;
				case 1:
					return translation.bV;
				default:
					return translation.bW;
			}
		};
		return A2(
			$author$project$S$when,
			$author$project$Domain$User$isOrisha(user),
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$em(3))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$S$labeled,
								translation.bX,
								_List_fromArray(
									[
										A5($author$project$S$select, initialActuator, $author$project$Domain$Quote$Actuator$allActuators, toLabel, $author$project$Page$Discovery$Update$SetActuator, _List_Nil)
									]))
							]))
					])));
	});
var $author$project$Page$Discovery$View$en = {bV: 'Activation V1 and side curtains units', bW: 'Activation V2 and side curtains units', bX: 'Actuators', df: 'Multiboxes', dg: 'New greenhouse', jA: 'Products', jD: 'Quantity'};
var $author$project$Page$Discovery$View$fr = {bV: 'Boîtiers d\'activation V1 et de côtés ouvrants', bW: 'Boîtiers d\'activation V2 et de côtés ouvrants', bX: 'Actuateurs', df: 'Boîtiers multifonctions', dg: 'Nouvelle serre', jA: 'Produit', jD: 'Quantité'};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $author$project$Page$Discovery$Update$FarmMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Discovery$Update$GreenhouseMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Page$Discovery$Update$AddGreenhouse = {$: 0};
var $author$project$Style$Buttons$addButton = A2($author$project$Style$Buttons$faButton, 'plus', $author$project$Theme$Color$green);
var $author$project$S$addButton = $author$project$Style$Buttons$addButton;
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$colspan = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Theme$Color$blue = $rtfeldman$elm_css$Css$hex('#00a2ea');
var $author$project$Theme$Color$sectionBlue = A2($author$project$Theme$Color$withOpacity, 0.2, $author$project$Theme$Color$blue);
var $rtfeldman$elm_css$Html$Styled$td = $rtfeldman$elm_css$Html$Styled$node('td');
var $rtfeldman$elm_css$Html$Styled$thead = $rtfeldman$elm_css$Html$Styled$node('thead');
var $author$project$Page$Discovery$View$greenhouseAddition = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$important(
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$sectionBlue))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(4)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
										$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
										$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$Update$AddGreenhouse)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.dg),
								A2($author$project$S$addButton, '', _List_Nil)
							]))
					]))
			]));
};
var $author$project$Utils$Style$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A2($elm$core$String$join, ' ', classes));
};
var $author$project$Style$Bulma$isStriped = 'is-striped';
var $rtfeldman$elm_css$Html$Styled$table = $rtfeldman$elm_css$Html$Styled$node('table');
var $author$project$Style$Bulma$table = 'table';
var $author$project$Style$Table$table = F2(
	function (attrs, children) {
		var classes = $author$project$Utils$Style$classList(
			_List_fromArray(
				[$author$project$Style$Bulma$table, $author$project$Style$Bulma$isStriped, 'is-fullwidth']));
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$important(
					$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$px(0)))
				]),
			A2($elm$core$List$cons, classes, attrs),
			children);
	});
var $author$project$S$table = $author$project$Style$Table$table;
var $rtfeldman$elm_css$Html$Styled$th = $rtfeldman$elm_css$Html$Styled$node('th');
var $author$project$Page$Discovery$View$tableHeader = function (translation) {
	var centeredTitle = F2(
		function (widthInEm, str) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$em(widthInEm)),
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)),
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(200)))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(str)
					]));
		});
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$rem(1.1))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(2),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(200)))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.jA)
					])),
				A2(centeredTitle, 7, translation.jD)
			]));
};
var $author$project$Page$Discovery$Farm$Update$CustomFieldMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Discovery$Farm$Update$SetProduct = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Domain$Product$allFarmProducts = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $author$project$Page$Discovery$Farm$View$en = {cB: 'For the farm'};
var $rtfeldman$elm_css$Css$auto = {h2: 0, d: 0, a9: 0, cR: 0, i_: 0, bd: 0, az: 0, ap: 0, bh: 0, af: 0, el: 0, bn: 0, M: 0, hR: 'auto'};
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $author$project$Theme$Icon$fromImage = function (path) {
	var fullPath = $author$project$Theme$ImgPath$base + ('icons/' + path);
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$em(1)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$em(1.25))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src(fullPath),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$maxHeight(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
								$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$auto)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Theme$Icon$controller = $author$project$Theme$Icon$fromImage('controller.png');
var $author$project$Theme$Icon$rainSensor = $author$project$Theme$Icon$fromImage('rain.png');
var $author$project$Theme$Icon$solarSensor = $author$project$Theme$Icon$fromImage('sun2.png');
var $author$project$Theme$Icon$thermometer = $author$project$Theme$Icon$fromImage('thermometer.png');
var $author$project$Theme$Icon$weatherBox = $author$project$Theme$Icon$fromImage('weather-box-icon.png');
var $author$project$Theme$Icon$windSensor = $author$project$Theme$Icon$fromImage('wind.png');
var $author$project$Page$Product$farmProductIcon = function (product) {
	switch (product) {
		case 0:
			return $author$project$Theme$Icon$controller;
		case 1:
			return $author$project$Theme$Icon$controller;
		case 2:
			return $author$project$Theme$Icon$controller;
		case 3:
			return $author$project$Theme$Icon$thermometer;
		case 4:
			return $author$project$Theme$Icon$rainSensor;
		case 5:
			return $author$project$Theme$Icon$windSensor;
		case 6:
			return $author$project$Theme$Icon$solarSensor;
		default:
			return $author$project$Theme$Icon$weatherBox;
	}
};
var $author$project$Page$Product$en = {b1: 'Back up thermostat', b8: 'HAF', b9: 'Temperature and humidity sensor', cc: 'Central controller', cd: 'Central controller LTE CAN', ce: 'Central controller LTE US', cq: 'Dry bulb wet bulb sensor', cr: '1 Inch 24 Volts FPT Irritrol Electric Valve', cv: 'Positive/negative pressure vent', cx: 'Positive pressure and louvers', cG: 'Heater ON/OFF type', cX: 'Kit of wires Tessier (15 feet)', cY: 'Kit of wires Tessier (25 feet)', c7: 'Mister', da: 'Motor 24V DC', dt: 'Outdoor temperature and humidity sensor', dy: 'Pipe 6 feet 1.315 inches diameter', dz: 'Pipe 6 feet 2 inches diameter', dO: 'Rain sensor', dV: 'Ridge vent with 24V motor driver', dX: 'Roof', dY: 'Roof 240V with inverter', dZ: 'Roof 240V with Harnois inverter kit', d7: 'Roll-Up', d9: 'Roll-Up with 24V motor driver', ec: 'Soil temperature sensor', ed: 'Solar sensor', eq: 'Thermal screen', ex: 'Valve (automation and relays)', ey: 'Weather box', eA: 'Wind sensor', eB: 'Wire for heater (100 feet)', eC: 'Wire for heater (15 feet)', eD: 'Wire for heater (25 feet)', eE: 'Wire for heater (50 feet)', eF: 'Wire for heater (75 feet)', eG: 'Wire for motor driver to actuator (15 feet)', eH: 'Wire for motor (15 feet)', eI: 'Wire for motor (25 feet)', eJ: 'Wire for backup thermostat (10 feet)', eK: 'Wire for valve (15 feet)', eL: 'Wire for valve (25 feet)'};
var $author$project$Page$Product$fr = {b1: 'Thermostat de secours', b8: 'HAF', b9: 'Capteur de température et d\'humidité', cc: 'Contrôleur central', cd: 'Contrôleur central internet mobile CAN', ce: 'Contrôleur central internet mobile US', cq: 'Capteur bulbe sec bulbe humide', cr: 'Valve électrique 24 Volts 1 Pouce FPT Irritrol', cv: 'Pression positive/négative', cx: 'Pression positive et louvres', cG: 'Fournaise de type On/Off', cX: 'Kit de fils Tessier (15 pieds)', cY: 'Kit de fils Tessier (25 pieds)', c7: 'Brumisateur', da: 'Moteur 24V DC', dt: 'Capteur de température et d\'humidité extérieur', dy: 'Tuyau 6 pieds 1.315 pouces diamètre', dz: 'Tuyau 6 pieds 2 pouces diamètre', dO: 'Capteur de pluie', dV: 'Toit ouvrant avec contrôleur 24V', dX: 'Toit ouvrant', dY: 'Toit ouvrant 240V avec inverseur', dZ: 'Toit ouvrant 240V avec kit d\'inverseur Harnois', d7: 'Côté ouvrant', d9: 'Côté ouvrant avec contrôleur 24V', ec: 'Capteur de température de sol', ed: 'Capteur solaire', eq: 'Toile thermique', ex: 'Valve (automatisation et relais)', ey: 'Boîtier météo', eA: 'Capteur de vent', eB: 'Fil pour fournaise (100 pieds)', eC: 'Fil pour fournaise (15 pieds)', eD: 'Fil pour fournaise (25 pieds)', eE: 'Fil pour fournaise (50 pieds)', eF: 'Fil pour fournaise (75 pieds)', eG: 'Fil pour actuateur à contrôleur de toit (15 pieds)', eH: 'Fil pour moteur (15 pieds)', eI: 'Fil pour moteur (25 pieds)', eJ: 'Fil pour thermostat de backup (10 pieds)', eK: 'Fil pour valve (15 pieds)', eL: 'Fil pour valve (25 pieds)'};
var $author$project$Page$Product$farmProductName = F2(
	function (language, product) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Product$en, iI: $author$project$Page$Product$fr});
		switch (product) {
			case 0:
				return translation.cc;
			case 1:
				return translation.ce;
			case 2:
				return translation.cd;
			case 3:
				return translation.dt;
			case 4:
				return translation.dO;
			case 5:
				return translation.eA;
			case 6:
				return translation.ed;
			default:
				return translation.ey;
		}
	});
var $author$project$Page$Discovery$Farm$View$fr = {cB: 'Pour toute la ferme'};
var $author$project$S$exactPrint = A2($rtfeldman$elm_css$Css$property, '-webkit-print-color-adjust', 'exact');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $author$project$Theme$Table$headerStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$sectionBlue)),
			$author$project$S$exactPrint,
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$paddingTop(
				$rtfeldman$elm_css$Css$rem(1))),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$rem(3))
		]));
var $author$project$Theme$Table$header = A2(
	$rtfeldman$elm_css$Html$Styled$styled,
	$rtfeldman$elm_css$Html$Styled$thead,
	_List_fromArray(
		[$author$project$Theme$Table$headerStyle]));
var $author$project$Style$Bulma$checkbox = 'checkbox';
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $author$project$Style$Form$checkbox = F2(
	function (attrs, body) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$checkbox),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$lineHeight($rtfeldman$elm_css$Css$inherit)
						]))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$input,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
						attrs),
					_List_Nil),
				body));
	});
var $author$project$S$checkbox = $author$project$Style$Form$checkbox;
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $author$project$Page$Discovery$Entry$centered = $rtfeldman$elm_css$Html$Styled$td(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]))
		]));
var $author$project$Page$Discovery$Entry$iconCell = function (icon) {
	return $author$project$Page$Discovery$Entry$centered(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.7))
							]))
					]),
				_List_fromArray(
					[icon]))
			]));
};
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Html$Styled$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $rtfeldman$elm_css$Html$Styled$Events$onCheck = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetChecked));
};
var $rtfeldman$elm_css$Html$Styled$tr = $rtfeldman$elm_css$Html$Styled$node('tr');
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Page$Discovery$Entry$toggleView = F4(
	function (icon, productName, isAdded, onToggle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Discovery$Entry$iconCell(icon),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(productName)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$important(
									$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$S$checkbox,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(isAdded),
											$rtfeldman$elm_css$Html$Styled$Events$onCheck(onToggle)
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$Discovery$CustomField$Update$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Discovery$CustomField$Update$Remove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Discovery$CustomField$Update$StartEdition = function (a) {
	return {$: 0, a: a};
};
var $author$project$Theme$Icon$custom = $author$project$Theme$Icon$fromImage('custom.png');
var $author$project$Domain$Quote$CustomProduct$en = {cv: 'Ventilation fan', cG: 'Heater', c7: 'Mister', di: 'None', dq: 'Opening', ex: 'Valve'};
var $author$project$Domain$Quote$CustomProduct$fr = {cv: 'Pression +/-', cG: 'Fournaise', c7: 'Brumisateur', di: 'Aucun', dq: 'Ouvrant', ex: 'Valve'};
var $author$project$Domain$Quote$CustomProduct$deviceName = F2(
	function (language, device) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Domain$Quote$CustomProduct$en, iI: $author$project$Domain$Quote$CustomProduct$fr});
		switch (device) {
			case 0:
				return translation.di;
			case 1:
				return translation.cG;
			case 2:
				return translation.dq;
			case 3:
				return translation.cv;
			case 4:
				return translation.ex;
			default:
				return translation.c7;
		}
	});
var $author$project$Theme$Color$yellow = $rtfeldman$elm_css$Css$hex('#ffa319');
var $author$project$Style$Buttons$editButton = A2($author$project$Style$Buttons$faButton, 'pencil', $author$project$Theme$Color$yellow);
var $author$project$S$editButton = $author$project$Style$Buttons$editButton;
var $author$project$Style$Buttons$removeButton = A2($author$project$Style$Buttons$faButton, 'trash-o', $author$project$Theme$Color$red);
var $author$project$S$removeButton = $author$project$Style$Buttons$removeButton;
var $author$project$Page$Discovery$CustomField$View$editedView = F5(
	function (language, index, name, device, quantity) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$important(
									$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$marginLeft(
												$rtfeldman$elm_css$Css$em(-0.15)))
										]))
								]),
							_List_fromArray(
								[$author$project$Theme$Icon$custom]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(name)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$em(0.8))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Domain$Quote$CustomProduct$deviceName, language, device))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$S$editButton,
									'',
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(1)))
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$Discovery$CustomField$Update$StartEdition(index))
										])),
									A2(
									$author$project$S$removeButton,
									'',
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(1)))
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$Discovery$CustomField$Update$Remove(index))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(quantity))
						]))
				]));
	});
var $author$project$Page$Discovery$CustomField$Update$CancelEdition = {$: 2};
var $author$project$Page$Discovery$CustomField$Update$ConfirmEdition = {$: 1};
var $author$project$Style$Buttons$cancelButton = A2($author$project$Style$Buttons$faButton, 'times', $author$project$Theme$Color$red);
var $author$project$S$cancelButton = $author$project$Style$Buttons$cancelButton;
var $author$project$Style$Buttons$okButton = A2($author$project$Style$Buttons$faButton, 'check', $author$project$Theme$Color$green);
var $author$project$S$okButton = $author$project$Style$Buttons$okButton;
var $author$project$Page$Discovery$CustomField$View$editionButtons = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$S$okButton,
			'',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1))),
							$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$em(1))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$CustomField$Update$ConfirmEdition)
				])),
			A2(
			$author$project$S$cancelButton,
			'',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1)))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$CustomField$Update$CancelEdition)
				]))
		]));
var $author$project$Page$Discovery$CustomField$Form$Update$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Discovery$CustomField$Form$Update$Quantity = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $author$project$Style$Grid$displayGrid = A2($rtfeldman$elm_css$Css$property, 'display', 'grid');
var $author$project$Page$Discovery$CustomField$Form$View$en = {jD: 'Quantity', dQ: 'Relays needed'};
var $author$project$Page$Discovery$CustomField$Form$View$fr = {jD: 'Quantité', dQ: 'Relais nécessaires'};
var $author$project$Style$Grid$gridTemplateColumns = $rtfeldman$elm_css$Css$property('grid-template-columns');
var $author$project$Style$Form$control = $rtfeldman$elm_css$Html$Styled$div(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$control),
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit)
				]))
		]));
var $author$project$Style$Bulma$input = 'input';
var $author$project$Style$Form$input = F2(
	function (attrs, children) {
		return $author$project$Style$Form$control(
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Html$Styled$styled,
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit)
						]),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$input),
						attrs),
					children)
				]));
	});
var $author$project$S$input = $author$project$Style$Form$input;
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $author$project$Page$Discovery$CustomField$Form$Update$Relay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Discovery$CustomField$Form$View$relaySelectionView = F3(
	function (customProduct, title, isDisplayed) {
		return A2(
			$author$project$S$when,
			isDisplayed,
			A2(
				$author$project$S$labeled,
				title,
				_List_fromArray(
					[
						A2(
						$author$project$S$input,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$vw(2.5))
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$value(
								$elm$core$String$fromInt(customProduct.jH)),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$Discovery$CustomField$Form$Update$Relay)
							]),
						_List_Nil)
					])));
	});
var $author$project$Page$Discovery$CustomField$Form$View$view = F3(
	function (language, isInAGreenhouse, customProduct) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Discovery$CustomField$Form$View$en, iI: $author$project$Page$Discovery$CustomField$Form$View$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Style$Grid$displayGrid,
							$author$project$Style$Grid$gridTemplateColumns('2fr 1fr'),
							$author$project$Utils$Style$gap(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$S$labeled,
					'Description',
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$vw(20))
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(customProduct.jg),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-autofocus', ''),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$Discovery$CustomField$Form$Update$Name)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$S$labeled,
					translation.jD,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$vw(7.5))
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									$elm$core$String$fromInt(customProduct.jD)),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$Discovery$CustomField$Form$Update$Quantity)
								]),
							_List_Nil)
						])),
					A3($author$project$Page$Discovery$CustomField$Form$View$relaySelectionView, customProduct, translation.dQ, isInAGreenhouse)
				]));
	});
var $author$project$Page$Discovery$CustomField$View$editionView = F3(
	function (language, isInAGreenhouse, model) {
		var _v0 = model.H;
		if (!_v0.$) {
			var customProduct = _v0.b;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$colspan(4)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$displayFlex,
													$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
													$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
													$rtfeldman$elm_css$Css$padding(
													$rtfeldman$elm_css$Css$em(0.5))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											$author$project$Page$Discovery$CustomField$Update$FormMsg,
											A3($author$project$Page$Discovery$CustomField$Form$View$view, language, isInAGreenhouse, customProduct)),
											$author$project$Page$Discovery$CustomField$View$editionButtons
										]))
								]))
						]))
				]);
		} else {
			return A2(
				$elm$core$List$indexedMap,
				function (index) {
					return function (c) {
						return A5($author$project$Page$Discovery$CustomField$View$editedView, language, index, c.jg, c.is, c.jD);
					};
				},
				model.il);
		}
	});
var $author$project$Page$Discovery$CustomField$View$en = {ch: 'Custom Devices'};
var $author$project$Page$Discovery$CustomField$View$fr = {ch: 'Équipement sur mesure'};
var $author$project$Page$Discovery$CustomField$Update$Add = {$: 4};
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $author$project$Theme$Color$sectionGreen = A2(
	$author$project$Theme$Color$withOpacity,
	0.2,
	$rtfeldman$elm_css$Css$hex('#25b14e'));
var $author$project$Theme$Table$subHeaderStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$sectionGreen)),
			$author$project$S$exactPrint
		]));
var $author$project$Theme$Table$subHeader = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Theme$Table$subHeaderStyle]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$paddingLeft(
									$rtfeldman$elm_css$Css$em(1.2))),
								$rtfeldman$elm_css$Css$fontWeight(
								$rtfeldman$elm_css$Css$int(200))
							]))
					]),
				content)
			]));
};
var $author$project$Page$Discovery$CustomField$View$section = function (translation) {
	return _List_fromArray(
		[
			$author$project$Theme$Table$subHeader(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.ch)
								])),
							A2(
							$author$project$S$addButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$em(0.9))),
											$rtfeldman$elm_css$Css$marginRight(
											$rtfeldman$elm_css$Css$rem(0.5))
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$CustomField$Update$Add)
								]))
						]))
				]))
		]);
};
var $author$project$Page$Discovery$CustomField$View$view = F4(
	function (language, user, isInAGreenhouse, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Discovery$CustomField$View$en, iI: $author$project$Page$Discovery$CustomField$View$fr});
		return $author$project$Domain$User$isOrisha(user) ? $elm$core$List$concat(
			_List_fromArray(
				[
					$author$project$Page$Discovery$CustomField$View$section(translation),
					A3($author$project$Page$Discovery$CustomField$View$editionView, language, isInAGreenhouse, model)
				])) : _List_fromArray(
			[$author$project$S$empty]);
	});
var $author$project$Page$Discovery$Farm$View$view = F3(
	function (language, user, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Discovery$Farm$View$en, iI: $author$project$Page$Discovery$Farm$View$fr});
		var toggleView = function (product) {
			return A4(
				$author$project$Page$Discovery$Entry$toggleView,
				$author$project$Page$Product$farmProductIcon(product),
				A2($author$project$Page$Product$farmProductName, language, product),
				A2($elm$core$List$member, product, model.jA),
				$author$project$Page$Discovery$Farm$Update$SetProduct(product));
		};
		var isInAGreenhouse = false;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Theme$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$colspan(4)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.cB)
									]))
							]))
					]),
					A2($elm$core$List$map, toggleView, $author$project$Domain$Product$allFarmProducts),
					A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Page$Discovery$Farm$Update$CustomFieldMsg),
					A4($author$project$Page$Discovery$CustomField$View$view, language, user, isInAGreenhouse, model.a6))
				]));
	});
var $author$project$Page$Discovery$Greenhouse$Update$AddProduct = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Discovery$Greenhouse$Update$CustomFieldMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Discovery$Greenhouse$Update$ManualAdjustmentMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$Discovery$Greenhouse$Update$RemoveProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Domain$Product$allGreenhouseProducts = _List_fromArray(
	[0, 1, 2, 8, 9, 16, 21, 22, 30, 31, 4, 3, 29, 23, 24, 25, 26, 27, 14, 18, 19, 20, 11, 12, 5, 7, 6, 10, 28, 32, 33, 13, 15, 17]);
var $elmcraft$core_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$Page$Discovery$Greenhouse$Update$Clone = {$: 7};
var $author$project$Page$Discovery$Greenhouse$Update$Remove = function (a) {
	return {$: 6, a: a};
};
var $author$project$Style$Buttons$cloneButton = A2($author$project$Style$Buttons$faButton, 'clone', $author$project$Theme$Color$green);
var $author$project$S$cloneButton = $author$project$Style$Buttons$cloneButton;
var $author$project$Page$Discovery$Greenhouse$Update$CancelNameEdition = {$: 5};
var $author$project$Page$Discovery$Greenhouse$Update$ConfirmNameEdition = {$: 4};
var $author$project$Page$Discovery$Greenhouse$Update$Name = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Utils$Events$onEnter = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2(
			$elm$json$Json$Decode$andThen,
			function (code) {
				return (code === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('keyDown');
			},
			$rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $author$project$Page$Discovery$Greenhouse$View$nameEditionView = function (initial) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$S$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$value(initial),
						$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$Discovery$Greenhouse$Update$Name),
						$author$project$Utils$Events$onEnter($author$project$Page$Discovery$Greenhouse$Update$ConfirmNameEdition)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$S$okButton,
						'',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$important(
										$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$em(1))),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$em(1))
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$Greenhouse$Update$ConfirmNameEdition)
							])),
						A2(
						$author$project$S$cancelButton,
						'',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$important(
										$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$em(1)))
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$Greenhouse$Update$CancelNameEdition)
							]))
					]))
			]));
};
var $author$project$Page$Discovery$Greenhouse$Update$StartNameEdition = {$: 2};
var $author$project$Page$Discovery$Greenhouse$View$nameView = function (greenhouseName) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(greenhouseName),
				A2(
				$author$project$S$editButton,
				'',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(0.8))),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$em(1))
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$Greenhouse$Update$StartNameEdition)
					]))
			]));
};
var $author$project$Page$Discovery$Greenhouse$View$greenhouseHeader = function (model) {
	var nameDisplay = function () {
		var _v0 = model.jg;
		switch (_v0.$) {
			case 0:
				var input = _v0.a.fu;
				return $author$project$Page$Discovery$Greenhouse$View$nameEditionView(input);
			case 1:
				var greenhouseName = _v0.a;
				return $author$project$Page$Discovery$Greenhouse$View$nameView(greenhouseName);
			default:
				return $author$project$Page$Discovery$Greenhouse$View$nameView(
					$author$project$Page$Discovery$Greenhouse$Update$defaultName(model));
		}
	}();
	return A2(
		$author$project$Theme$Table$header,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(4)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
									]))
							]),
						_List_fromArray(
							[
								nameDisplay,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$S$cloneButton,
										'',
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$important(
														$rtfeldman$elm_css$Css$fontSize(
															$rtfeldman$elm_css$Css$rem(1.1))),
														$rtfeldman$elm_css$Css$marginRight(
														$rtfeldman$elm_css$Css$rem(1))
													])),
												$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$Greenhouse$Update$Clone)
											])),
										A2(
										$author$project$S$removeButton,
										'',
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$important(
														$rtfeldman$elm_css$Css$fontSize(
															$rtfeldman$elm_css$Css$rem(1.1)))
													])),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Page$Discovery$Greenhouse$Update$Remove(model.cN))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Theme$Icon$backUpThermostat = $author$project$Theme$Icon$fromImage('backup-thermostat.svg');
var $author$project$Theme$Icon$circulationFan = $author$project$Theme$Icon$fromImage('circulation-fan.svg');
var $author$project$Theme$Icon$dryWetSensor = $author$project$Theme$Icon$fromImage('dry-wet.svg');
var $author$project$Theme$Icon$fan = $author$project$Theme$Icon$fromImage('ventilation-fan.svg');
var $author$project$Theme$Icon$fanWithLouvers = $author$project$Theme$Icon$fromImage('louvers.svg');
var $author$project$Theme$Icon$heater = $author$project$Theme$Icon$fromImage('heater.svg');
var $author$project$Theme$Icon$mister = $author$project$Theme$Icon$fromImage('mister.svg');
var $author$project$Theme$Icon$roof = $author$project$Theme$Icon$fromImage('roof.svg');
var $author$project$Theme$Icon$sideCurtain = $author$project$Theme$Icon$fromImage('side-curtain.svg');
var $author$project$Theme$Icon$thermalScreen = $author$project$Theme$Icon$fromImage('thermal-screen.svg');
var $author$project$Theme$Icon$valve = $author$project$Theme$Icon$fromImage('valve.svg');
var $author$project$Page$Product$greenhouseProductIcon = function (product) {
	switch (product) {
		case 0:
			return $author$project$Theme$Icon$thermometer;
		case 1:
			return $author$project$Theme$Icon$dryWetSensor;
		case 2:
			return $author$project$Theme$Icon$thermometer;
		case 3:
			return $author$project$Theme$Icon$backUpThermostat;
		case 4:
			return $author$project$Theme$Icon$heater;
		case 5:
			return $author$project$Theme$Icon$roof;
		case 6:
			return $author$project$Theme$Icon$roof;
		case 7:
			return $author$project$Theme$Icon$roof;
		case 8:
			return $author$project$Theme$Icon$sideCurtain;
		case 9:
			return $author$project$Theme$Icon$sideCurtain;
		case 10:
			return $author$project$Theme$Icon$roof;
		case 11:
			return $author$project$Theme$Icon$fan;
		case 12:
			return $author$project$Theme$Icon$fanWithLouvers;
		case 13:
			return $author$project$Theme$Icon$circulationFan;
		case 14:
			return $author$project$Theme$Icon$valve;
		case 15:
			return $author$project$Theme$Icon$mister;
		case 16:
			return $author$project$Theme$Icon$sideCurtain;
		case 17:
			return $author$project$Theme$Icon$thermalScreen;
		case 18:
			return $author$project$Theme$Icon$valve;
		case 19:
			return $author$project$Theme$Icon$valve;
		case 20:
			return $author$project$Theme$Icon$valve;
		case 21:
			return $author$project$Theme$Icon$sideCurtain;
		case 22:
			return $author$project$Theme$Icon$sideCurtain;
		case 23:
			return $author$project$Theme$Icon$heater;
		case 24:
			return $author$project$Theme$Icon$heater;
		case 25:
			return $author$project$Theme$Icon$heater;
		case 26:
			return $author$project$Theme$Icon$heater;
		case 27:
			return $author$project$Theme$Icon$heater;
		case 28:
			return $author$project$Theme$Icon$roof;
		case 29:
			return $author$project$Theme$Icon$backUpThermostat;
		case 30:
			return $author$project$Theme$Icon$sideCurtain;
		case 31:
			return $author$project$Theme$Icon$sideCurtain;
		case 32:
			return $author$project$Theme$Icon$roof;
		default:
			return $author$project$Theme$Icon$roof;
	}
};
var $author$project$Page$Product$greenhouseProductName = F2(
	function (language, product) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Product$en, iI: $author$project$Page$Product$fr});
		switch (product) {
			case 0:
				return translation.b9;
			case 1:
				return translation.cq;
			case 2:
				return translation.ec;
			case 3:
				return translation.b1;
			case 4:
				return translation.cG;
			case 5:
				return translation.dX;
			case 6:
				return translation.dY;
			case 7:
				return translation.dZ;
			case 8:
				return translation.d7;
			case 9:
				return translation.d9;
			case 10:
				return translation.dV;
			case 11:
				return translation.cv;
			case 12:
				return translation.cx;
			case 13:
				return translation.b8;
			case 14:
				return translation.ex;
			case 15:
				return translation.c7;
			case 16:
				return translation.da;
			case 17:
				return translation.eq;
			case 18:
				return translation.cr;
			case 19:
				return translation.eK;
			case 20:
				return translation.eL;
			case 21:
				return translation.eH;
			case 22:
				return translation.eI;
			case 23:
				return translation.eC;
			case 24:
				return translation.eD;
			case 25:
				return translation.eE;
			case 26:
				return translation.eF;
			case 27:
				return translation.eB;
			case 28:
				return translation.eG;
			case 29:
				return translation.eJ;
			case 30:
				return translation.dy;
			case 31:
				return translation.dz;
			case 32:
				return translation.cX;
			default:
				return translation.cY;
		}
	});
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $author$project$Style$Buttons$minusButton = A2($author$project$Style$Buttons$faButton, 'minus', $author$project$Theme$Color$red);
var $author$project$S$minusButton = $author$project$Style$Buttons$minusButton;
var $author$project$S$noStyle = A2($rtfeldman$elm_css$Css$property, '', '');
var $author$project$Page$Discovery$Entry$normalView = F5(
	function (icon, productName, quantity, onRemove, onAdd) {
		var buttonSize = $rtfeldman$elm_css$Css$em(0.9);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Discovery$Entry$iconCell(icon),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(productName)
						])),
					$author$project$Page$Discovery$Entry$centered(
					_List_fromArray(
						[
							A2(
							$author$project$S$minusButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(buttonSize)),
											(!quantity) ? $rtfeldman$elm_css$Css$batch(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$opacity(
														$rtfeldman$elm_css$Css$num(0)))
												])) : $author$project$S$noStyle
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(onRemove)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$margin2,
											$rtfeldman$elm_css$Css$px(0),
											$rtfeldman$elm_css$Css$em(1))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(quantity))
								])),
							A2(
							$author$project$S$addButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(buttonSize))
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(onAdd)
								]))
						]))
				]));
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$FormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Domain$Hardware$ActivationUnitV1 = 4;
var $author$project$Domain$Hardware$ActivationUnitV2 = 5;
var $author$project$Domain$Hardware$MultiBoxR = 6;
var $author$project$Domain$Hardware$MultiBoxRMVT2 = 7;
var $author$project$Domain$Hardware$RelayBox110VAC = 13;
var $author$project$Domain$Hardware$SideCurtainsUnit = 3;
var $author$project$Domain$Hardware$Transformer24V = 8;
var $rtfeldman$elm_css$Css$hidden = {G: 0, bh: 0, hR: 'hidden', bU: 0};
var $author$project$Domain$Hardware$image = function (hardware) {
	var filename = function () {
		switch (hardware) {
			case 0:
				return 'controller.png';
			case 1:
				return 'controller.png';
			case 2:
				return 'controller.png';
			case 3:
				return 'side-curtains-unit.png';
			case 4:
				return 'activation-unit.png';
			case 5:
				return 'activation-unit.png';
			case 6:
				return 'multi-box-no-switches.jpg';
			case 7:
				return 'multi-box-with-switches.png';
			case 8:
				return 'transfo-24v.jpg';
			case 9:
				return 'transfo-24v-with-wago.jpg';
			case 10:
				return 'motor-24v-dc.png';
			case 11:
				return 'power-bar-kit.png';
			case 12:
				return 'weather-box.png';
			case 13:
				return 'relay-box-110V-AC.png';
			case 14:
				return 'multi-box-no-switches.jpg';
			case 15:
				return 'rw240-1phase-5wires-roof-motor-inverter.jpg';
			case 16:
				return 'harnois-inverter-kit.png';
			case 17:
				return 'inverter-24V-DC.jpg';
			case 18:
				return 'inverter-24V-DC.jpg';
			case 19:
				return 'temperature-humidity-sensor.png';
			case 20:
				return 'weather-box.png';
			case 21:
				return 'dry-bulb-wet-bulb-sensor.png';
			case 22:
				return 'thermostat.png';
			case 23:
				return 'anemometer.jpg';
			case 24:
				return 'rain-sensor.png';
			case 25:
				return 'solar-sensor.png';
			case 26:
				return 'electric-valve-1inch-24V.jpg';
			case 27:
				return 'wire2.png';
			case 28:
				return 'wire2.png';
			case 29:
				return 'wire2.png';
			case 30:
				return 'wire2.png';
			case 31:
				return 'wire2.png';
			case 32:
				return 'wire2.png';
			case 33:
				return 'wire2.png';
			case 34:
				return 'wire2.png';
			case 35:
				return 'wire2.png';
			case 36:
				return 'wire4.png';
			case 37:
				return 'wire2.png';
			case 38:
				return 'guide-pipe.jpg';
			case 39:
				return 'guide-pipe.jpg';
			case 40:
				return 'side-clasp-adaptor-lvm60-100.jpg';
			case 41:
				return 'wire-kit-tessier-15ft.png';
			default:
				return 'wire-kit-tessier-25ft.png';
		}
	}();
	return $author$project$Theme$ImgPath$base + ('packing-slip/' + filename);
};
var $author$project$Domain$Hardware$en = {h_: 'Activation Unit V1', h$: 'Activation Unit V2', cw: 'Fan and Louvers Box', cF: 'Harnois Inverter Kit', db: 'Multifunction Box R---', dc: 'Multifunction Box RMVT2', dd: 'Multifunction box with side curtains control', de: 'Multifunction box without side curtains control', dB: 'Power Bar Kit', dN: 'RW240 1 Phase 5 Wires Roof Motor Driver with time delay V2', jI: '110V Relay Box AC Version', dU: '24V DC Ridge Vent Motor Driver', d6: 'Side clasp Adaptor for LVM60/100', jU: 'Side Curtains Unit', d8: '24V DC Side Vent Motor Driver', j4: '24V 1A AC/AC Transformer', eu: '24V 1A AC/AC Transformer with wago'};
var $author$project$Domain$Hardware$fr = {h_: 'Module d\'activation V1', h$: 'Module d\'activation V2', cw: 'Boîtier de ventilateur et louvres', cF: 'Kit d\'inverseur Harnois', db: 'Boîtier multifonction R---', dc: 'Boîtier multifonction RMVT2', dd: 'Boîtier multifonction avec contrôle des côtés ouvrants', de: 'Boîtier multifonction sans contrôle des côtés ouvrants', dB: 'Kit de multiprise', dN: 'Contrôleur pour moteur de toit Ridder RW240 1 phase 5 fils avec time delay V2', jI: 'Boîtier de relais 110V version AC', dU: 'Contrôleur pour moteur 24V DC de toit ouvrant', d6: 'Side clasp Adaptor for LVM60/100', jU: 'Module de côtés ouvrants', d8: 'Contrôleur pour moteur 24V DC de côté ouvrant', j4: 'Transformateur AC/AC 24V 1A', eu: 'Transformateur AC/AC 24V 1A avec wago'};
var $author$project$Domain$Hardware$sku = function (hardware) {
	switch (hardware) {
		case 0:
			return 1480;
		case 1:
			return 1479;
		case 2:
			return 1478;
		case 3:
			return 1008;
		case 4:
			return 1028;
		case 5:
			return 1482;
		case 6:
			return 1012;
		case 7:
			return 1015;
		case 8:
			return 1536;
		case 9:
			return 1436;
		case 10:
			return 1433;
		case 11:
			return 1471;
		case 12:
			return 1006;
		case 13:
			return 1034;
		case 14:
			return 1022;
		case 15:
			return 1533;
		case 16:
			return 1536;
		case 17:
			return 1551;
		case 18:
			return 1517;
		case 19:
			return 1391;
		case 20:
			return 1029;
		case 21:
			return 1388;
		case 22:
			return 1088;
		case 23:
			return 1038;
		case 24:
			return 1027;
		case 25:
			return 1023;
		case 26:
			return 1544;
		case 27:
			return 1514;
		case 28:
			return 1508;
		case 29:
			return 1515;
		case 30:
			return 1509;
		case 31:
			return 1516;
		case 32:
			return 1510;
		case 33:
			return 1537;
		case 34:
			return 1539;
		case 35:
			return 1540;
		case 36:
			return 1511;
		case 37:
			return 1512;
		case 38:
			return 1521;
		case 39:
			return 1558;
		case 40:
			return 1558;
		case 41:
			return 1555;
		default:
			return 1556;
	}
};
var $author$project$Domain$Hardware$name = F3(
	function (language, hardware, isForCustomerDisplay) {
		var withSku = function (nameWithoutSku) {
			return nameWithoutSku + (' (' + ($elm$core$String$fromInt(
				$author$project$Domain$Hardware$sku(hardware)) + ')'));
		};
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Domain$Hardware$en, iI: $author$project$Domain$Hardware$fr});
		var hardwareName = function () {
			switch (hardware) {
				case 0:
					return A2($author$project$Page$Product$farmProductName, language, 0);
				case 1:
					return A2($author$project$Page$Product$farmProductName, language, 1);
				case 2:
					return A2($author$project$Page$Product$farmProductName, language, 2);
				case 3:
					return translation.jU;
				case 4:
					return translation.h_;
				case 5:
					return translation.h$;
				case 6:
					return isForCustomerDisplay ? translation.de : translation.db;
				case 7:
					return isForCustomerDisplay ? translation.dd : translation.dc;
				case 8:
					return translation.j4;
				case 9:
					return translation.eu;
				case 10:
					return A2($author$project$Page$Product$greenhouseProductName, language, 16);
				case 11:
					return translation.dB;
				case 12:
					return A2($author$project$Page$Product$farmProductName, language, 7);
				case 13:
					return translation.jI;
				case 14:
					return translation.cw;
				case 15:
					return translation.dN;
				case 16:
					return translation.cF;
				case 17:
					return translation.d8;
				case 18:
					return translation.dU;
				case 19:
					return A2($author$project$Page$Product$greenhouseProductName, language, 0);
				case 20:
					return A2($author$project$Page$Product$greenhouseProductName, language, 2);
				case 21:
					return A2($author$project$Page$Product$greenhouseProductName, language, 1);
				case 22:
					return A2($author$project$Page$Product$greenhouseProductName, language, 3);
				case 23:
					return A2($author$project$Page$Product$farmProductName, language, 5);
				case 24:
					return A2($author$project$Page$Product$farmProductName, language, 4);
				case 25:
					return A2($author$project$Page$Product$farmProductName, language, 6);
				case 26:
					return A2($author$project$Page$Product$greenhouseProductName, language, 18);
				case 27:
					return A2($author$project$Page$Product$greenhouseProductName, language, 19);
				case 28:
					return A2($author$project$Page$Product$greenhouseProductName, language, 20);
				case 29:
					return A2($author$project$Page$Product$greenhouseProductName, language, 21);
				case 30:
					return A2($author$project$Page$Product$greenhouseProductName, language, 22);
				case 31:
					return A2($author$project$Page$Product$greenhouseProductName, language, 23);
				case 32:
					return A2($author$project$Page$Product$greenhouseProductName, language, 24);
				case 33:
					return A2($author$project$Page$Product$greenhouseProductName, language, 25);
				case 34:
					return A2($author$project$Page$Product$greenhouseProductName, language, 26);
				case 35:
					return A2($author$project$Page$Product$greenhouseProductName, language, 27);
				case 36:
					return A2($author$project$Page$Product$greenhouseProductName, language, 28);
				case 37:
					return A2($author$project$Page$Product$greenhouseProductName, language, 29);
				case 38:
					return A2($author$project$Page$Product$greenhouseProductName, language, 30);
				case 39:
					return A2($author$project$Page$Product$greenhouseProductName, language, 31);
				case 40:
					return translation.d6;
				case 41:
					return A2($author$project$Page$Product$greenhouseProductName, language, 32);
				default:
					return A2($author$project$Page$Product$greenhouseProductName, language, 33);
			}
		}();
		return isForCustomerDisplay ? hardwareName : withSku(hardwareName);
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$productPhoto = function (path) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src(path),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$em(2))
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$editedView = F2(
	function (language, manualAdjustment) {
		var row = F2(
			function (hardware, getter) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$important(
									$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$hidden))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$productPhoto(
									$author$project$Domain$Hardware$image(hardware))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Domain$Hardware$name, language, hardware, true))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(
										getter(manualAdjustment)))
								]))
						]));
			});
		return _List_fromArray(
			[
				A2(
				row,
				3,
				function ($) {
					return $.jU;
				}),
				A2(
				row,
				4,
				function ($) {
					return $.h_;
				}),
				A2(
				row,
				5,
				function ($) {
					return $.h$;
				}),
				A2(
				row,
				7,
				function ($) {
					return $.je;
				}),
				A2(
				row,
				6,
				function ($) {
					return $.jd;
				}),
				A2(
				row,
				13,
				function ($) {
					return $.jI;
				}),
				A2(
				row,
				8,
				function ($) {
					return $.j4;
				})
			]);
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$CancelEdition = {$: 1};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$ConfirmEdition = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$editionButtons = function (manualAdjustment) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$S$okButton,
				'',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(1))),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$em(1))
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$ConfirmEdition(manualAdjustment))
					])),
				A2(
				$author$project$S$cancelButton,
				'',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(1)))
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$CancelEdition)
					]))
			]));
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$Add = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$Remove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$centered = $rtfeldman$elm_css$Html$Styled$td(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]))
		]));
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$productPhoto = function (path) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src(path),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$em(2))
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView = F3(
	function (language, hardware, quantity) {
		var buttonSize = $rtfeldman$elm_css$Css$em(0.9);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$hidden))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]),
					_List_fromArray(
						[
							$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$productPhoto(
							$author$project$Domain$Hardware$image(hardware))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Domain$Hardware$name, language, hardware, true))
						])),
					$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$centered(
					_List_fromArray(
						[
							A2(
							$author$project$S$minusButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(buttonSize)),
											(!quantity) ? $rtfeldman$elm_css$Css$batch(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$opacity(
														$rtfeldman$elm_css$Css$num(0)))
												])) : $author$project$S$noStyle
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$Remove(hardware))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$margin2,
											$rtfeldman$elm_css$Css$px(0),
											$rtfeldman$elm_css$Css$em(1))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(quantity))
								])),
							A2(
							$author$project$S$addButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(buttonSize))
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$Add(hardware))
								]))
						]))
				]));
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$view = F2(
	function (language, manualAdjustment) {
		return _List_fromArray(
			[
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 3, manualAdjustment.jU),
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 4, manualAdjustment.h_),
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 5, manualAdjustment.h$),
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 7, manualAdjustment.je),
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 6, manualAdjustment.jd),
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 13, manualAdjustment.jI),
				A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$entryView, language, 8, manualAdjustment.j4)
			]);
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$editionView = F2(
	function (language, model) {
		var _v0 = model.H;
		switch (_v0) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$td,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$colspan(4)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$displayFlex,
														$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
														$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
													]))
											]),
										A2(
											$elm$core$Maybe$withDefault,
											_List_fromArray(
												[$author$project$S$empty]),
											A2(
												$elm$core$Maybe$map,
												function (m) {
													return _List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
																		]))
																]),
															A2(
																$elm$core$List$map,
																$rtfeldman$elm_css$Html$Styled$map($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$FormMsg),
																A2($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$View$view, language, m))),
															$author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$editionButtons(m)
														]);
												},
												model.aR)))
									]))
							]))
					]);
			default:
				var _v1 = model.aR;
				if (!_v1.$) {
					var m = _v1.a;
					return A2($author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$editedView, language, m);
				} else {
					return _List_Nil;
				}
		}
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$en = {c3: 'Manual Adjustments'};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$fr = {c3: 'Ajustements manuels'};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$ManualSelection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse = F2(
	function (greenhouse, product) {
		return A2(
			$elmcraft$core_extra$List$Extra$count,
			$elm$core$Basics$eq(product),
			greenhouse.jA);
	});
var $author$project$Domain$Common$numberOfRelaysPerGreenhouseProduct = function (product) {
	switch (product) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 1;
		case 5:
			return 2;
		case 6:
			return 2;
		case 7:
			return 2;
		case 8:
			return 0;
		case 9:
			return 2;
		case 10:
			return 2;
		case 11:
			return 1;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 1;
		case 15:
			return 1;
		case 16:
			return 0;
		case 17:
			return 2;
		case 18:
			return 0;
		case 19:
			return 0;
		case 20:
			return 0;
		case 21:
			return 0;
		case 22:
			return 0;
		case 23:
			return 0;
		case 24:
			return 0;
		case 25:
			return 0;
		case 26:
			return 0;
		case 27:
			return 0;
		case 28:
			return 0;
		case 29:
			return 0;
		case 30:
			return 0;
		case 31:
			return 0;
		case 32:
			return 0;
		default:
			return 0;
	}
};
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Domain$Common$numberOfRelaysInGreenhouse = function (greenhouse) {
	var numberOfRelaysInGreenhouseProducts = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (p) {
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse, greenhouse, p) * $author$project$Domain$Common$numberOfRelaysPerGreenhouseProduct(p);
			},
			$author$project$Domain$Product$allGreenhouseProducts));
	var numberOfRelaysInCustomProducts = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (cp) {
				return cp.jD * cp.jH;
			},
			greenhouse.il));
	return numberOfRelaysInGreenhouseProducts + numberOfRelaysInCustomProducts;
};
var $author$project$Domain$Common$numberOfActivationUnitsV1 = F2(
	function (actuator, greenhouse) {
		var _default = function () {
			switch (actuator) {
				case 0:
					return 0;
				case 1:
					var numberOfRelaysPerUnit = 4;
					return $elm$core$Basics$ceiling(
						function (n) {
							return n / numberOfRelaysPerUnit;
						}(
							A2(
								$elm$core$Basics$max,
								0,
								$author$project$Domain$Common$numberOfRelaysInGreenhouse(greenhouse))));
				default:
					return 0;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.h_;
				},
				greenhouse.aR));
	});
var $author$project$Domain$Common$numberOfActivationUnitsV2 = F2(
	function (actuator, greenhouse) {
		var _default = function () {
			switch (actuator) {
				case 0:
					return 0;
				case 1:
					return 0;
				default:
					var numberOfRelaysPerUnit = 4;
					return $elm$core$Basics$ceiling(
						function (n) {
							return n / numberOfRelaysPerUnit;
						}(
							A2(
								$elm$core$Basics$max,
								0,
								$author$project$Domain$Common$numberOfRelaysInGreenhouse(greenhouse))));
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.h$;
				},
				greenhouse.aR));
	});
var $author$project$Domain$Common$numberMotorActuatorInGreenhouse = function (greenhouse) {
	return $elm$core$Basics$ceiling(
		function (n) {
			return n / 2;
		}(
			A2(
				$elmcraft$core_extra$List$Extra$count,
				$elm$core$Basics$eq(8),
				greenhouse.jA)));
};
var $author$project$Domain$Common$numberOfMultiWithMotorDrivers = F2(
	function (actuator, greenhouse) {
		var _default = function () {
			switch (actuator) {
				case 0:
					return $author$project$Domain$Common$numberMotorActuatorInGreenhouse(greenhouse);
				case 1:
					return 0;
				default:
					return 0;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.je;
				},
				greenhouse.aR));
	});
var $author$project$Domain$Common$numberOfMultiboxes = F2(
	function (actuator, greenhouse) {
		var _default = function () {
			var numberOfRelaysPerMultibox = 10;
			var multiWithMotorDriverRelays = A2($author$project$Domain$Common$numberOfMultiWithMotorDrivers, actuator, greenhouse) * 10;
			switch (actuator) {
				case 0:
					return $elm$core$Basics$ceiling(
						function (n) {
							return n / numberOfRelaysPerMultibox;
						}(
							A2(
								$elm$core$Basics$max,
								0,
								$author$project$Domain$Common$numberOfRelaysInGreenhouse(greenhouse) - multiWithMotorDriverRelays)));
				case 1:
					return 0;
				default:
					return 0;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jd;
				},
				greenhouse.aR));
	});
var $author$project$Domain$Common$numberOfRelayBoxes110VACInGreenhouse = function (greenhouse) {
	var _default = A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse, greenhouse, 11) + A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse, greenhouse, 13);
	return A2(
		$elm$core$Maybe$withDefault,
		_default,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.jI;
			},
			greenhouse.aR));
};
var $author$project$Domain$Common$numberOfSideCurtainsUnits = F2(
	function (actuator, greenhouse) {
		var _default = function () {
			switch (actuator) {
				case 0:
					return 0;
				case 1:
					return $author$project$Domain$Common$numberMotorActuatorInGreenhouse(greenhouse);
				default:
					return $author$project$Domain$Common$numberMotorActuatorInGreenhouse(greenhouse);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jU;
				},
				greenhouse.aR));
	});
var $author$project$Domain$Common$numberOfTransformer24V = function (greenhouse) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.j4;
			},
			greenhouse.aR));
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$selection = F3(
	function (translation, actuator, greenhouse) {
		var defaultSideCurtainsUnit = A2($author$project$Domain$Common$numberOfSideCurtainsUnits, actuator, greenhouse);
		var defaultNumberOfTransformers24V = $author$project$Domain$Common$numberOfTransformer24V(greenhouse);
		var defaultNumberOfRelayBoxes110VAC = $author$project$Domain$Common$numberOfRelayBoxes110VACInGreenhouse(greenhouse);
		var defaultMultibox = A2($author$project$Domain$Common$numberOfMultiboxes, actuator, greenhouse);
		var defaultMultiWithMotorDriver = A2($author$project$Domain$Common$numberOfMultiWithMotorDrivers, actuator, greenhouse);
		var defaultActivationUnitV2 = A2($author$project$Domain$Common$numberOfActivationUnitsV2, actuator, greenhouse);
		var defaultActivationUnitV1 = A2($author$project$Domain$Common$numberOfActivationUnitsV1, actuator, greenhouse);
		return _List_fromArray(
			[
				$author$project$Theme$Table$subHeader(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.c3)
									])),
								A2(
								$author$project$S$editButton,
								'',
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$important(
												$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$em(0.95))),
												$rtfeldman$elm_css$Css$marginRight(
												$rtfeldman$elm_css$Css$rem(0.5))
											])),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$ManualSelection(
											{h_: defaultActivationUnitV1, h$: defaultActivationUnitV2, jd: defaultMultibox, je: defaultMultiWithMotorDriver, jI: defaultNumberOfRelayBoxes110VAC, jU: defaultSideCurtainsUnit, j4: defaultNumberOfTransformers24V}))
									]))
							]))
					]))
			]);
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$view = F5(
	function (language, user, model, actuator, greenhouse) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$en, iI: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$fr});
		return $author$project$Domain$User$isOrisha(user) ? $elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$selection, translation, actuator, greenhouse),
					A2($author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$editionView, language, model)
				])) : _List_fromArray(
			[$author$project$S$empty]);
	});
var $author$project$Page$Discovery$Greenhouse$View$view = F4(
	function (language, user, actuator, model) {
		var normalView = function (product) {
			return A5(
				$author$project$Page$Discovery$Entry$normalView,
				$author$project$Page$Product$greenhouseProductIcon(product),
				A2($author$project$Page$Product$greenhouseProductName, language, product),
				A2(
					$elmcraft$core_extra$List$Extra$count,
					$elm$core$Basics$eq(product),
					model.jA),
				$author$project$Page$Discovery$Greenhouse$Update$RemoveProduct(product),
				$author$project$Page$Discovery$Greenhouse$Update$AddProduct(product));
		};
		var isInAGreenhouse = true;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Page$Discovery$Greenhouse$View$greenhouseHeader(model)
					]),
					A2($elm$core$List$map, normalView, $author$project$Domain$Product$allGreenhouseProducts),
					A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Page$Discovery$Greenhouse$Update$CustomFieldMsg),
					A4($author$project$Page$Discovery$CustomField$View$view, language, user, isInAGreenhouse, model.a6)),
					A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Page$Discovery$Greenhouse$Update$ManualAdjustmentMsg),
					A5(
						$author$project$Page$Discovery$Greenhouse$ManualAdjustment$View$view,
						language,
						user,
						model.aR,
						actuator,
						$author$project$Page$Discovery$Greenhouse$Update$toQuote(model)))
				]));
	});
var $author$project$Page$Discovery$View$tableView = F4(
	function (language, translation, model, user) {
		return A2(
			$author$project$S$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(5))
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Page$Discovery$View$tableHeader(translation)
						]),
						A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Page$Discovery$Update$FarmMsg),
						A3($author$project$Page$Discovery$Farm$View$view, language, user, model.av)),
						$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (index) {
								return $elm$core$List$map(
									$rtfeldman$elm_css$Html$Styled$map(
										$author$project$Page$Discovery$Update$GreenhouseMsg(index)));
							},
							A2(
								$elm$core$List$map,
								A3($author$project$Page$Discovery$Greenhouse$View$view, language, user, model.a1),
								model.ay))),
						_List_fromArray(
						[
							$author$project$Page$Discovery$View$greenhouseAddition(translation)
						])
					])));
	});
var $author$project$Page$Discovery$View$view = F3(
	function (language, model, user) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$Discovery$View$en, iI: $author$project$Page$Discovery$View$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$rem(3))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
											$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Page$Discovery$View$actuatorView, translation, user, model.a1)
										]))
								]))
						])),
					A4($author$project$Page$Discovery$View$tableView, language, translation, model, user)
				]));
	});
var $author$project$Page$PackingSlip$CopyToClipboard = $elm$core$Basics$identity;
var $author$project$Page$QuoteBuilderV3$Config$AdvancedVentilation = 0;
var $author$project$Page$QuoteBuilderV3$Config$DiseasePrevention = 1;
var $author$project$Page$QuoteBuilderV3$Config$Heating = 2;
var $author$project$Page$QuoteBuilderV3$Config$HumidityConservation = 3;
var $author$project$Page$QuoteBuilderV3$Config$Irrigation = 4;
var $author$project$Page$QuoteBuilderV3$Config$RollupVentilation = 5;
var $author$project$Page$QuoteBuilderV3$Config$ThermalScreen = 6;
var $author$project$Page$QuoteBuilderV3$Config$allConfigs = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6]);
var $author$project$Domain$Hardware$BackUpThermostat = 22;
var $author$project$Domain$Hardware$ClimateSensor = 19;
var $author$project$Domain$Hardware$Controller = 0;
var $author$project$Domain$Hardware$ControllerLteCan = 2;
var $author$project$Domain$Hardware$ControllerLteUs = 1;
var $author$project$Domain$Hardware$DryWetSensor = 21;
var $author$project$Domain$Hardware$ElectricValve1Inch24V = 26;
var $author$project$Domain$Hardware$FanAndLouversBox = 14;
var $author$project$Domain$Hardware$HarnoisInverterKit = 16;
var $author$project$Domain$Hardware$KitOfWiresTessier15Ft = 41;
var $author$project$Domain$Hardware$KitOfWiresTessier25Ft = 42;
var $author$project$Domain$Hardware$Motor24VDC = 10;
var $author$project$Domain$Hardware$Pipe6FtDia1p315In = 38;
var $author$project$Domain$Hardware$Pipe6FtDia2In = 39;
var $author$project$Domain$Hardware$PowerBarKit = 11;
var $author$project$Domain$Hardware$RW2401Phase5WiresRoofMotorInverter = 15;
var $author$project$Domain$Hardware$RainSensor = 24;
var $author$project$Domain$Hardware$RidgeVentInverter24VDC = 18;
var $author$project$Domain$Hardware$SideClaspAdaptorForLVM60And100 = 40;
var $author$project$Domain$Hardware$SideVentInverter24VDC = 17;
var $author$project$Domain$Hardware$SoilTemperatureSensor = 20;
var $author$project$Domain$Hardware$SolarSensor = 25;
var $author$project$Domain$Hardware$Transformer24VWithWago = 9;
var $author$project$Domain$Hardware$WeatherBox = 12;
var $author$project$Domain$Hardware$WindSensor = 23;
var $author$project$Domain$Hardware$WireHeater100Ft = 35;
var $author$project$Domain$Hardware$WireHeater15Ft = 31;
var $author$project$Domain$Hardware$WireHeater25Ft = 32;
var $author$project$Domain$Hardware$WireHeater50Ft = 33;
var $author$project$Domain$Hardware$WireHeater75Ft = 34;
var $author$project$Domain$Hardware$WireInverter15Ft = 36;
var $author$project$Domain$Hardware$WireMotor15Ft = 29;
var $author$project$Domain$Hardware$WireMotor25Ft = 30;
var $author$project$Domain$Hardware$WireThermostat10Ft = 37;
var $author$project$Domain$Hardware$WireValve15Ft = 27;
var $author$project$Domain$Hardware$WireValve25Ft = 28;
var $author$project$Domain$Hardware$allHardwares = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42]);
var $author$project$Page$QuoteBuilderV3$Config$fromProduct = function (product) {
	switch (product) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[5]);
		case 2:
			return _List_fromArray(
				[1]);
		case 3:
			return _List_fromArray(
				[4]);
		case 4:
			return _List_fromArray(
				[0]);
		case 5:
			return _List_fromArray(
				[0]);
		case 6:
			return _List_fromArray(
				[2]);
		case 7:
			return _List_fromArray(
				[3]);
		case 8:
			return _List_Nil;
		case 9:
			return _List_fromArray(
				[6]);
		case 10:
			return _List_Nil;
		case 11:
			return _List_Nil;
		case 12:
			return _List_Nil;
		case 13:
			return _List_Nil;
		case 14:
			return _List_Nil;
		case 15:
			return _List_Nil;
		case 16:
			return _List_Nil;
		case 17:
			return _List_fromArray(
				[5]);
		default:
			return _List_fromArray(
				[5, 1, 4, 0, 2]);
	}
};
var $elmcraft$core_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elmcraft$core_extra$List$Extra$unique = function (list) {
	return A4($elmcraft$core_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Page$PackingSlip$configCount = F2(
	function (quote, config) {
		var configsFromGreenhouse = function (g) {
			return $elmcraft$core_extra$List$Extra$unique(
				A2($elm$core$List$concatMap, $author$project$Page$QuoteBuilderV3$Config$fromProduct, g.jA));
		};
		var configs = A2($elm$core$List$concatMap, configsFromGreenhouse, quote.ay);
		return A2(
			$elmcraft$core_extra$List$Extra$count,
			$elm$core$Basics$eq(config),
			configs);
	});
var $author$project$Domain$Common$numberOfActuators = F2(
	function (actuator, greenhouse) {
		var sideCurtainsUnits = A2($author$project$Domain$Common$numberOfSideCurtainsUnits, actuator, greenhouse);
		var multiboxes = A2($author$project$Domain$Common$numberOfMultiboxes, actuator, greenhouse);
		var multiWithMotorDrivers = A2($author$project$Domain$Common$numberOfMultiWithMotorDrivers, actuator, greenhouse);
		var activationUnitsV2 = A2($author$project$Domain$Common$numberOfActivationUnitsV2, actuator, greenhouse);
		var activationUnitsV1 = A2($author$project$Domain$Common$numberOfActivationUnitsV1, actuator, greenhouse);
		var activationUnits = activationUnitsV1 + activationUnitsV2;
		return ((multiWithMotorDrivers + multiboxes) + activationUnits) + sideCurtainsUnits;
	});
var $author$project$Domain$Quote$Equipment$numberOfFarmProduct = F2(
	function (farm, product) {
		return A2(
			$elmcraft$core_extra$List$Extra$count,
			$elm$core$Basics$eq(product),
			farm.jA);
	});
var $author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct = F2(
	function (quote, product) {
		return $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (g) {
					return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse, g, product);
				},
				quote.ay));
	});
var $author$project$Domain$Common$totalOfActivationUnitsV1 = function (quote) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Domain$Common$numberOfActivationUnitsV1(quote.a1),
			quote.ay));
};
var $author$project$Domain$Common$totalOfActivationUnitsV2 = function (quote) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Domain$Common$numberOfActivationUnitsV2(quote.a1),
			quote.ay));
};
var $author$project$Domain$Common$totalOfMultiWithMotorDrivers = function (quote) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Domain$Common$numberOfMultiWithMotorDrivers(quote.a1),
			quote.ay));
};
var $author$project$Domain$Common$totalOfMultiboxes = function (quote) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Domain$Common$numberOfMultiboxes(quote.a1),
			quote.ay));
};
var $author$project$Domain$Common$totalOfRelayBoxes110VAC = function (quote) {
	return $elm$core$List$sum(
		A2($elm$core$List$map, $author$project$Domain$Common$numberOfRelayBoxes110VACInGreenhouse, quote.ay));
};
var $author$project$Domain$Common$totalOfSideCurtainsUnits = function (quote) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Domain$Common$numberOfSideCurtainsUnits(quote.a1),
			quote.ay));
};
var $author$project$Domain$Common$totalOfTransformer24V = function (quote) {
	return $elm$core$List$sum(
		A2($elm$core$List$map, $author$project$Domain$Common$numberOfTransformer24V, quote.ay));
};
var $author$project$Domain$Common$numberOfTransformer24VWithWago = F2(
	function (actuator, greenhouse) {
		var numberOfValves = A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse, greenhouse, 14);
		var numberOfMisters = A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProductForGreenhouse, greenhouse, 15);
		var numberOfValvesAndMisters = numberOfValves + numberOfMisters;
		switch (actuator) {
			case 0:
				return $elm$core$Basics$ceiling(
					function (n) {
						return n / 4;
					}(numberOfValvesAndMisters));
			case 1:
				return 0;
			default:
				return 0;
		}
	});
var $author$project$Domain$Common$totalOfTransformer24VWithWago = function (quote) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Domain$Common$numberOfTransformer24VWithWago(quote.a1),
			quote.ay));
};
var $author$project$Domain$Hardware$count = F2(
	function (quote, hardware) {
		switch (hardware) {
			case 0:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 0);
			case 1:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 1);
			case 2:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 2);
			case 3:
				return $author$project$Domain$Common$totalOfSideCurtainsUnits(quote);
			case 4:
				return $author$project$Domain$Common$totalOfActivationUnitsV1(quote);
			case 5:
				return $author$project$Domain$Common$totalOfActivationUnitsV2(quote);
			case 6:
				return $author$project$Domain$Common$totalOfMultiboxes(quote);
			case 7:
				return $author$project$Domain$Common$totalOfMultiWithMotorDrivers(quote);
			case 8:
				return $author$project$Domain$Common$totalOfTransformer24V(quote);
			case 9:
				return $author$project$Domain$Common$totalOfTransformer24VWithWago(quote);
			case 10:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 16);
			case 11:
				return $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						function (g) {
							return A2($author$project$Domain$Common$numberOfActuators, quote.a1, g) > 0;
						},
						quote.ay));
			case 12:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 7);
			case 13:
				return $author$project$Domain$Common$totalOfRelayBoxes110VAC(quote);
			case 14:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 12);
			case 15:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 6);
			case 16:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 7);
			case 17:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 9);
			case 18:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 10);
			case 19:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 0) + A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 3);
			case 20:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 2);
			case 21:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 1);
			case 22:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 3);
			case 23:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 5);
			case 24:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 4);
			case 25:
				return A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, quote.av, 6);
			case 26:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 18);
			case 27:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 19);
			case 28:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 20);
			case 29:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 21);
			case 30:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 22);
			case 31:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 23);
			case 32:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 24);
			case 33:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 25);
			case 34:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 26);
			case 35:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 27);
			case 36:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 28);
			case 37:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 29);
			case 38:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 30);
			case 39:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 31);
			case 40:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 31);
			case 41:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 32);
			default:
				return A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, quote, 33);
		}
	});
var $author$project$Page$QuoteBuilderV3$Config$sku = function (config) {
	switch (config) {
		case 0:
			return 1496;
		case 1:
			return 1497;
		case 2:
			return 1498;
		case 3:
			return 1499;
		case 4:
			return 1500;
		case 5:
			return 1501;
		default:
			return 1504;
	}
};
var $author$project$Page$PackingSlip$autoPopulateSnippet = F2(
	function (technicalDiscovery, quote) {
		var hardwarePart = function (hardware) {
			var count = A2($author$project$Domain$Hardware$count, technicalDiscovery, hardware);
			return (count > 0) ? $elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Domain$Hardware$sku(hardware)) + (' ' + $elm$core$String$fromInt(count))) : $elm$core$Maybe$Nothing;
		};
		var hardwares = A2($elm$core$List$map, hardwarePart, $author$project$Domain$Hardware$allHardwares);
		var configPart = function (config) {
			var count = A2($author$project$Page$PackingSlip$configCount, quote, config);
			return (count > 0) ? $elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Page$QuoteBuilderV3$Config$sku(config)) + (' ' + $elm$core$String$fromInt(count))) : $elm$core$Maybe$Nothing;
		};
		var configs = A2($elm$core$List$map, configPart, $author$project$Page$QuoteBuilderV3$Config$allConfigs);
		return A2(
			$elm$core$String$join,
			' ',
			$elmcraft$core_extra$Maybe$Extra$values(
				_Utils_ap(hardwares, configs)));
	});
var $author$project$Theme$Icon$check = A2($author$project$Theme$Icon$faIcon, 'check', $author$project$Theme$Color$green);
var $author$project$Theme$Icon$clipboard = A2($author$project$Theme$Icon$faIcon, 'clipboard', $rtfeldman$elm_css$Css$inherit);
var $rtfeldman$elm_css$Html$Styled$col = $rtfeldman$elm_css$Html$Styled$node('col');
var $rtfeldman$elm_css$Html$Styled$colgroup = $rtfeldman$elm_css$Html$Styled$node('colgroup');
var $author$project$Theme$Icon$humidity = A2($author$project$Theme$Icon$faIcon, 'tint', $author$project$Theme$Color$blue);
var $author$project$Page$QuoteBuilderV3$Config$icon = function (config) {
	switch (config) {
		case 0:
			return $author$project$Theme$Icon$fan;
		case 1:
			return $author$project$Theme$Icon$humidity;
		case 2:
			return $author$project$Theme$Icon$heater;
		case 3:
			return $author$project$Theme$Icon$mister;
		case 4:
			return $author$project$Theme$Icon$valve;
		case 5:
			return $author$project$Theme$Icon$roof;
		default:
			return $author$project$Theme$Icon$thermalScreen;
	}
};
var $author$project$Page$QuoteBuilderV3$Config$name = function (config) {
	switch (config) {
		case 0:
			return 'Advanced Ventilation';
		case 1:
			return 'Disease Prevention';
		case 2:
			return 'Heating';
		case 3:
			return 'Humidity Conservation';
		case 4:
			return 'Irrigation';
		case 5:
			return 'Roll-Up Ventilation';
		default:
			return 'Thermal Screen';
	}
};
var $author$project$Page$PackingSlip$configEntry = F2(
	function (configs, config) {
		var quantity = A2(
			$elmcraft$core_extra$List$Extra$count,
			$elm$core$Basics$eq(config),
			configs);
		return A2(
			$author$project$S$when,
			quantity > 0,
			A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
											]))
									]),
								_List_fromArray(
									[
										$author$project$Page$QuoteBuilderV3$Config$icon(config)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Page$QuoteBuilderV3$Config$name(config))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(quantity))
							]))
					])));
	});
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $author$project$Page$PackingSlip$configView = F2(
	function (translation, quote) {
		var configsFromGreenhouse = function (g) {
			return $elmcraft$core_extra$List$Extra$unique(
				A2($elm$core$List$concatMap, $author$project$Page$QuoteBuilderV3$Config$fromProduct, g.jA));
		};
		var configs = A2($elm$core$List$concatMap, configsFromGreenhouse, quote.ay);
		var colgroup = A2(
			$rtfeldman$elm_css$Html$Styled$colgroup,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$col,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(5))
								]))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$col,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(70))
								]))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$col,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(25))
								]))
						]),
					_List_Nil)
				]));
		var alignCenter = $rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$important(
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center))
				]));
		var header = A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$sectionBlue)),
							$author$project$S$exactPrint
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('V3')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(translation.cb)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[alignCenter]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(translation.jD)
						]))
				]));
		return A2(
			$author$project$S$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$rem(-5)),
							$rtfeldman$elm_css$Css$marginRight(
							$rtfeldman$elm_css$Css$rem(-5)),
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$inherit)),
							$author$project$S$onPrint(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$inherit)
								]))
						]))
				]),
			A2(
				$elm$core$List$cons,
				header,
				A2(
					$elm$core$List$cons,
					colgroup,
					A2(
						$elm$core$List$map,
						$author$project$Page$PackingSlip$configEntry(configs),
						$author$project$Page$QuoteBuilderV3$Config$allConfigs))));
	});
var $author$project$Page$PackingSlip$en = {b0: 'Auto populate snippet: ', cb: 'Configuration', cK: 'In the box', ds: 'ORISHA COPY', dv: 'Packing Slip', dG: 'Production manager:', jD: 'Quantity', eo: 'Tested', ez: 'Will be sent soon'};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Domain$Quote$Client$fullName = function (client) {
	return client.gG + (' ' + client.g3);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $author$project$Utils$Url$origin = function (url) {
	var protocol = function () {
		var _v1 = url.jB;
		if (!_v1) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	var portString = function () {
		var _v0 = url.jx;
		if (!_v0.$) {
			var p = _v0.a;
			return ':' + $elm$core$String$fromInt(p);
		} else {
			return '';
		}
	}();
	return _Utils_ap(
		protocol,
		_Utils_ap(url.iS, portString));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Page$QuoteBuilderV3$Quote$discountTypeEncoder = function (discountType) {
	if (!discountType.$) {
		var subscription = discountType.a.jY;
		var purchase = discountType.a.jC;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tag',
					$elm$json$Json$Encode$string('Percentage')),
					_Utils_Tuple2(
					'subscription',
					$elm$json$Json$Encode$int(subscription)),
					_Utils_Tuple2(
					'purchase',
					$elm$json$Json$Encode$int(purchase))
				]));
	} else {
		var subscription = discountType.a.jY;
		var purchase = discountType.a.jC;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tag',
					$elm$json$Json$Encode$string('Amount')),
					_Utils_Tuple2(
					'subscription',
					$elm$json$Json$Encode$int(subscription)),
					_Utils_Tuple2(
					'purchase',
					$elm$json$Json$Encode$int(purchase))
				]));
	}
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Page$QuoteBuilderV3$Quote$discountEncoder = function (d) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(d.jg)),
				_Utils_Tuple2(
				'discountType',
				$author$project$Page$QuoteBuilderV3$Quote$discountTypeEncoder(d.aH)),
				_Utils_Tuple2(
				'durationInMonths',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, d.au)),
				_Utils_Tuple2(
				'validUntil',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, d.aF)),
				_Utils_Tuple2(
				'precision',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, d.jy))
			]));
};
var $author$project$Route$Quote$Client$currencyEncoder = function (c) {
	if (!c) {
		return $elm$json$Json$Encode$string('CAD');
	} else {
		return $elm$json$Json$Encode$string('USD');
	}
};
var $author$project$Route$Quote$Client$languageEncoder = function (language) {
	var str = function () {
		if (!language) {
			return 'EN';
		} else {
			return 'FR';
		}
	}();
	return $elm$json$Json$Encode$string(str);
};
var $author$project$Route$Quote$Client$encoder = function (c) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(c.gG)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(c.g3)),
				_Utils_Tuple2(
				'farmName',
				$elm$json$Json$Encode$string(c.iG)),
				_Utils_Tuple2(
				'farmAddress',
				$elm$json$Json$Encode$string(c.iF)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(c.ix)),
				_Utils_Tuple2(
				'language',
				$author$project$Route$Quote$Client$languageEncoder(c.i$)),
				_Utils_Tuple2(
				'currency',
				$author$project$Route$Quote$Client$currencyEncoder(c.ik))
			]));
};
var $author$project$Page$QuoteBuilderV3$Quote$priceEncoder = function (price) {
	if (!price.$) {
		var subscription = price.a.jY;
		var purchase = price.a.jC;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'subscription',
					$elm$json$Json$Encode$int(subscription)),
					_Utils_Tuple2(
					'purchase',
					$elm$json$Json$Encode$int(purchase))
				]));
	} else {
		var subscription = price.a.jY;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'subscription',
					$elm$json$Json$Encode$int(subscription))
				]));
	}
};
var $author$project$Page$QuoteBuilderV3$Quote$customProductEncoder = function (p) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(p.jg)),
				_Utils_Tuple2(
				'price',
				$author$project$Page$QuoteBuilderV3$Quote$priceEncoder(p.jz)),
				_Utils_Tuple2(
				'quantity',
				$elm$json$Json$Encode$int(p.jD))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Page$QuoteBuilderV3$Quote$productEncoder = function (product) {
	switch (product) {
		case 0:
			return $elm$json$Json$Encode$string('OrishaInTheGreenhouse');
		case 1:
			return $elm$json$Json$Encode$string('SideVentilation');
		case 2:
			return $elm$json$Json$Encode$string('DiseasePrevention');
		case 3:
			return $elm$json$Json$Encode$string('Irrigation');
		case 4:
			return $elm$json$Json$Encode$string('FanVentilation');
		case 5:
			return $elm$json$Json$Encode$string('RidgeVentilation');
		case 6:
			return $elm$json$Json$Encode$string('Heating');
		case 7:
			return $elm$json$Json$Encode$string('HumidityConservation');
		case 8:
			return $elm$json$Json$Encode$string('AdvancedClimateSensor');
		case 9:
			return $elm$json$Json$Encode$string('ThermalScreen');
		case 10:
			return $elm$json$Json$Encode$string('RainProtection');
		case 11:
			return $elm$json$Json$Encode$string('WindProtection');
		case 12:
			return $elm$json$Json$Encode$string('SolarSensor');
		case 13:
			return $elm$json$Json$Encode$string('RangeExtensionKit');
		case 14:
			return $elm$json$Json$Encode$string('AdditionalBrain');
		case 15:
			return $elm$json$Json$Encode$string('OutdoorClimateSensor');
		case 16:
			return $elm$json$Json$Encode$string('LTE');
		case 17:
			return $elm$json$Json$Encode$string('Helper');
		default:
			return $elm$json$Json$Encode$string('ChiefGrower');
	}
};
var $author$project$Page$QuoteBuilderV3$Quote$farmEncoder = function (farm) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'products',
				A2($elm$json$Json$Encode$list, $author$project$Page$QuoteBuilderV3$Quote$productEncoder, farm.jA)),
				_Utils_Tuple2(
				'customProducts',
				A2($elm$json$Json$Encode$list, $author$project$Page$QuoteBuilderV3$Quote$customProductEncoder, farm.il))
			]));
};
var $author$project$Page$QuoteBuilderV3$Quote$greenhouseEncoder = function (greenhouse) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(greenhouse.jg)),
				_Utils_Tuple2(
				'products',
				A2($elm$json$Json$Encode$list, $author$project$Page$QuoteBuilderV3$Quote$productEncoder, greenhouse.jA)),
				_Utils_Tuple2(
				'customProducts',
				A2($elm$json$Json$Encode$list, $author$project$Page$QuoteBuilderV3$Quote$customProductEncoder, greenhouse.il))
			]));
};
var $author$project$Page$QuoteBuilderV3$Quote$encoder = function (q) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'client',
				$author$project$Route$Quote$Client$encoder(q.bx)),
				_Utils_Tuple2(
				'projectId',
				$elm$json$Json$Encode$string(q.dH)),
				_Utils_Tuple2(
				'customerId',
				$elm$json$Json$Encode$string(q.gw)),
				_Utils_Tuple2(
				'greenhouses',
				A2($elm$json$Json$Encode$list, $author$project$Page$QuoteBuilderV3$Quote$greenhouseEncoder, q.ay)),
				_Utils_Tuple2(
				'farm',
				$author$project$Page$QuoteBuilderV3$Quote$farmEncoder(q.av)),
				_Utils_Tuple2(
				'discounts',
				A2($elm$json$Json$Encode$list, $author$project$Page$QuoteBuilderV3$Quote$discountEncoder, q.it))
			]));
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Page$QuoteBuilderV3$QuoteUrl$queryParam = function (quote) {
	return A2(
		$elm$url$Url$Builder$string,
		$author$project$Page$QuoteBuilderV3$QuoteUrl$param,
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Page$QuoteBuilderV3$Quote$encoder(quote)));
};
var $author$project$Route$Quote$Entry$actuatorEncoder = function (actuator) {
	switch (actuator) {
		case 0:
			return $elm$json$Json$Encode$string('Multibox');
		case 1:
			return $elm$json$Json$Encode$string('ActivationV1AndSideCurtainsUnits');
		default:
			return $elm$json$Json$Encode$string('ActivationV2AndSideCurtainsUnits');
	}
};
var $author$project$Domain$Total$Amount$inCurrency = F2(
	function (currency, _v0) {
		var amount = _v0;
		if (!currency) {
			return amount.ft;
		} else {
			return $elm$core$Basics$round(
				function (inCAD) {
					return inCAD * $author$project$Domain$Total$Amount$cadToUsdRate;
				}(amount.ft));
		}
	});
var $author$project$Route$Quote$CustomProduct$encoder = F2(
	function (currency, p) {
		var deviceEncoder = function (d) {
			switch (d) {
				case 0:
					return $elm$json$Json$Encode$string('NoDevice');
				case 1:
					return $elm$json$Json$Encode$string('Furnace');
				case 2:
					return $elm$json$Json$Encode$string('Opening');
				case 3:
					return $elm$json$Json$Encode$string('Fan');
				case 4:
					return $elm$json$Json$Encode$string('Valve');
				default:
					return $elm$json$Json$Encode$string('Mister');
			}
		};
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(p.jg)),
					_Utils_Tuple2(
					'price',
					$elm$json$Json$Encode$int(
						A2($author$project$Domain$Total$Amount$inCurrency, currency, p.jz))),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(p.jD)),
					_Utils_Tuple2(
					'device',
					deviceEncoder(p.is)),
					_Utils_Tuple2(
					'relay',
					$elm$json$Json$Encode$int(p.jH))
				]));
	});
var $author$project$Domain$Product$farmProductEncoder = function (product) {
	switch (product) {
		case 0:
			return $elm$json$Json$Encode$string('Controller');
		case 1:
			return $elm$json$Json$Encode$string('ControllerLteUs');
		case 2:
			return $elm$json$Json$Encode$string('ControllerLteCan');
		case 3:
			return $elm$json$Json$Encode$string('OutdoorClimateSensor');
		case 4:
			return $elm$json$Json$Encode$string('RainSensor');
		case 5:
			return $elm$json$Json$Encode$string('WindSensor');
		case 6:
			return $elm$json$Json$Encode$string('SolarSensor');
		default:
			return $elm$json$Json$Encode$string('WeatherBox');
	}
};
var $author$project$Route$Quote$Farm$encoder = F2(
	function (currency, farm) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'products',
					A2($elm$json$Json$Encode$list, $author$project$Domain$Product$farmProductEncoder, farm.jA)),
					_Utils_Tuple2(
					'customProducts',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$Route$Quote$CustomProduct$encoder(currency),
						farm.il))
				]));
	});
var $author$project$Domain$Product$greenhouseProductEncoder = function (product) {
	switch (product) {
		case 0:
			return $elm$json$Json$Encode$string('ClimateSensor');
		case 1:
			return $elm$json$Json$Encode$string('DryWetSensor');
		case 2:
			return $elm$json$Json$Encode$string('SoilTemperatureSensor');
		case 3:
			return $elm$json$Json$Encode$string('BackUpThermostat');
		case 4:
			return $elm$json$Json$Encode$string('Heater');
		case 5:
			return $elm$json$Json$Encode$string('Roof');
		case 6:
			return $elm$json$Json$Encode$string('RoofWith240VInverter');
		case 7:
			return $elm$json$Json$Encode$string('RoofWithHarnoisInverterKit');
		case 8:
			return $elm$json$Json$Encode$string('SideCurtain');
		case 9:
			return $elm$json$Json$Encode$string('SideVentWith24VInverter');
		case 10:
			return $elm$json$Json$Encode$string('RidgeVentWith24VInverter');
		case 11:
			return $elm$json$Json$Encode$string('Fan');
		case 12:
			return $elm$json$Json$Encode$string('FanWithLouvers');
		case 13:
			return $elm$json$Json$Encode$string('CirculationFan');
		case 14:
			return $elm$json$Json$Encode$string('Valve');
		case 15:
			return $elm$json$Json$Encode$string('Mister');
		case 16:
			return $elm$json$Json$Encode$string('Motor24VDC');
		case 17:
			return $elm$json$Json$Encode$string('ThermalScreen');
		case 18:
			return $elm$json$Json$Encode$string('ElectricValve1Inch24V');
		case 19:
			return $elm$json$Json$Encode$string('WireValve15Ft');
		case 20:
			return $elm$json$Json$Encode$string('WireValve25Ft');
		case 21:
			return $elm$json$Json$Encode$string('WireMotor15Ft');
		case 22:
			return $elm$json$Json$Encode$string('WireMotor25Ft');
		case 23:
			return $elm$json$Json$Encode$string('WireHeater15Ft');
		case 24:
			return $elm$json$Json$Encode$string('WireHeater25Ft');
		case 25:
			return $elm$json$Json$Encode$string('WireHeater50Ft');
		case 26:
			return $elm$json$Json$Encode$string('WireHeater75Ft');
		case 27:
			return $elm$json$Json$Encode$string('WireHeater100Ft');
		case 28:
			return $elm$json$Json$Encode$string('WireInverter15Ft');
		case 29:
			return $elm$json$Json$Encode$string('WireThermostat10Ft');
		case 30:
			return $elm$json$Json$Encode$string('Pipe6FtDia1p315In');
		case 31:
			return $elm$json$Json$Encode$string('Pipe6FtDia2In');
		case 32:
			return $elm$json$Json$Encode$string('KitOfWiresTessier15Ft');
		default:
			return $elm$json$Json$Encode$string('KitOfWiresTessier25Ft');
	}
};
var $author$project$Route$Quote$Greenhouse$manualAdjustmentEncoder = function (manual) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'activationUnitV1',
				$elm$json$Json$Encode$int(manual.h_)),
				_Utils_Tuple2(
				'activationUnitV2',
				$elm$json$Json$Encode$int(manual.h$)),
				_Utils_Tuple2(
				'sideCurtainsUnit',
				$elm$json$Json$Encode$int(manual.jU)),
				_Utils_Tuple2(
				'multibox',
				$elm$json$Json$Encode$int(manual.jd)),
				_Utils_Tuple2(
				'multiWithMotorDriver',
				$elm$json$Json$Encode$int(manual.je)),
				_Utils_Tuple2(
				'relayBox110VAC',
				$elm$json$Json$Encode$int(manual.jI)),
				_Utils_Tuple2(
				'transformer24V',
				$elm$json$Json$Encode$int(manual.j4))
			]));
};
var $author$project$Route$Quote$Greenhouse$encoder = F2(
	function (currency, g) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(g.jg)),
					_Utils_Tuple2(
					'products',
					A2($elm$json$Json$Encode$list, $author$project$Domain$Product$greenhouseProductEncoder, g.jA)),
					_Utils_Tuple2(
					'customProducts',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$Route$Quote$CustomProduct$encoder(currency),
						g.il)),
					_Utils_Tuple2(
					'manualAdjustment',
					A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Route$Quote$Greenhouse$manualAdjustmentEncoder, g.aR))
				]));
	});
var $author$project$Route$Quote$Entry$quoteEncoder = function (quote) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'farm',
				A2($author$project$Route$Quote$Farm$encoder, $author$project$Route$Quote$Entry$communicationCurrency, quote.av)),
				_Utils_Tuple2(
				'greenhouses',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Route$Quote$Greenhouse$encoder($author$project$Route$Quote$Entry$communicationCurrency),
					quote.ay)),
				_Utils_Tuple2(
				'actuator',
				$author$project$Route$Quote$Entry$actuatorEncoder(quote.a1))
			]));
};
var $author$project$Route$Quote$Entry$queryParam = function (quote) {
	return A2(
		$elm$url$Url$Builder$string,
		$author$project$Route$Quote$Entry$param,
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Route$Quote$Entry$quoteEncoder(quote)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $author$project$Page$PackingSlip$fileHeader = F5(
	function (translation, url, technicalDiscovery, quote, isCustomerVersion) {
		var technicalDiscoveryParam = $author$project$Route$Quote$Entry$queryParam(technicalDiscovery);
		var quoteParam = $author$project$Page$QuoteBuilderV3$QuoteUrl$queryParam(quote);
		var link = A3(
			$elm$url$Url$Builder$crossOrigin,
			$author$project$Utils$Url$origin(url),
			_List_Nil,
			_List_fromArray(
				[technicalDiscoveryParam, quoteParam]));
		var languageLabel = function () {
			var _v0 = quote.bx.i$;
			if (!_v0) {
				return ' (EN)';
			} else {
				return ' (FR)';
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$rem(2))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$S$when,
							!isCustomerVersion,
							A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										_Utils_ap(translation.ds, languageLabel))
									]))),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Domain$Quote$Client$fullName(quote.bx))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(quote.bx.iG)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(quote.bx.iF)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$px(150)),
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(link),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$logo)
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$PackingSlip$fr = {b0: 'Auto populate snippet: ', cb: 'Configuration', cK: 'Dans la boîte', ds: 'COPIE ORISHA', dv: 'Bon de livraison', dG: 'Responsable de la production :', jD: 'Quantité', eo: 'Testé', ez: 'Sera envoyé prochainement'};
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $author$project$Style$Title$h2 = function (attrs) {
	return $rtfeldman$elm_css$Html$Styled$h2(
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$Attributes$class('title is-2'),
			attrs));
};
var $author$project$S$h2 = $author$project$Style$Title$h2;
var $author$project$Theme$Table$centeredTh = F2(
	function (attrs, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$th,
			attrs,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
								]))
						]),
					content)
				]));
	});
var $author$project$Page$PackingSlip$headerRow = function (translation) {
	var checkboxColumn = function (str) {
		return A2(
			$author$project$Theme$Table$centeredTh,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$rem(10)),
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)),
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$lineHeight(
								$rtfeldman$elm_css$Css$rem(1.5))),
							$author$project$S$onPrint(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$rem(5))
								]))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(str)
				]));
	};
	return A2(
		$author$project$Theme$Table$header,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$rem(10))
							]))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Description')
					])),
				checkboxColumn(translation.jD),
				checkboxColumn(translation.eo),
				checkboxColumn(translation.cK),
				checkboxColumn(translation.ez)
			]));
};
var $author$project$Theme$ImgPath$packingSlip = $author$project$Theme$ImgPath$base + 'packing-slip/';
var $author$project$Theme$ImgPath$custom = $author$project$Theme$ImgPath$packingSlip + 'custom.png';
var $author$project$Page$PackingSlip$customProducts = function (technicalDiscovery) {
	var greenhouseCustomProducts = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.il;
		},
		technicalDiscovery.ay);
	var farmCustomProducts = technicalDiscovery.av.il;
	return A2($elm$core$List$append, greenhouseCustomProducts, farmCustomProducts);
};
var $author$project$Theme$Table$centered = F2(
	function (attrs, content) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$td,
			attrs,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
								]))
						]),
					content)
				]));
	});
var $author$project$Page$PackingSlip$productPhoto = function (path) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src(path),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$rem(4)),
								$author$project$S$onPrint(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$maxWidth(
										$rtfeldman$elm_css$Css$rem(3))
									]))
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$PackingSlip$entry = F5(
	function (photoPath, description, quantity, isCustomerVersion, orishacheckboxes) {
		var checkboxColumn = A2(
			$author$project$Theme$Table$centered,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$S$checkbox, _List_Nil, _List_Nil)
				]));
		return A2(
			$author$project$S$when,
			quantity > 0,
			A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Page$PackingSlip$productPhoto(photoPath)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
												$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center)
											]))
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(description)
											])),
									isCustomerVersion ? _List_fromArray(
										[$author$project$S$empty]) : orishacheckboxes))
							])),
						A2(
						$author$project$Theme$Table$centered,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(quantity))
							])),
						checkboxColumn,
						checkboxColumn,
						checkboxColumn
					])));
	});
var $author$project$Page$PackingSlip$orishaTeamCheckboxes = F2(
	function (technicalDiscovery, hardware) {
		var numberOfOutdoorClimateSensors = A2($author$project$Domain$Quote$Equipment$numberOfFarmProduct, technicalDiscovery.av, 3);
		var numberOfIndoorClimateSensors = A2($author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct, technicalDiscovery, 0);
		var numberOfFans = $elm$core$String$fromInt(
			$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					$author$project$Domain$Quote$Equipment$numberOfGreenhouseProduct(technicalDiscovery),
					A2(
						$elm$core$List$filter,
						function (p) {
							return A2(
								$elm$core$List$member,
								p,
								_List_fromArray(
									[11, 12]));
						},
						$author$project$Domain$Product$allGreenhouseProducts))));
		var numberOfClimateSensorsBatteries = $elm$core$String$fromInt(
			function (sensors) {
				return 3 * sensors;
			}(numberOfIndoorClimateSensors + numberOfOutdoorClimateSensors));
		var checkbox = function (info) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(0.7)),
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$S$checkbox,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$em(1)),
										$rtfeldman$elm_css$Css$marginRight(
										$rtfeldman$elm_css$Css$em(0.2))
									]))
							]),
						_List_Nil),
						$rtfeldman$elm_css$Html$Styled$text(info)
					]));
		};
		switch (hardware) {
			case 0:
				return _List_fromArray(
					[
						checkbox('Permissions')
					]);
			case 1:
				return _List_fromArray(
					[
						checkbox('Permissions')
					]);
			case 2:
				return _List_fromArray(
					[
						checkbox('Permissions')
					]);
			case 3:
				return _List_fromArray(
					[
						checkbox('Transfo 24V DC')
					]);
			case 4:
				return _List_Nil;
			case 5:
				return _List_Nil;
			case 6:
				return _List_fromArray(
					[
						checkbox(numberOfFans + ' jumpers')
					]);
			case 7:
				return _List_fromArray(
					[
						checkbox(numberOfFans + ' jumpers'),
						checkbox('Transfo 24V DC')
					]);
			case 8:
				return _List_Nil;
			case 9:
				return _List_Nil;
			case 10:
				return _List_Nil;
			case 11:
				return _List_Nil;
			case 12:
				return _List_Nil;
			case 13:
				return _List_Nil;
			case 14:
				return _List_Nil;
			case 15:
				return _List_Nil;
			case 16:
				return _List_Nil;
			case 17:
				return _List_Nil;
			case 18:
				return _List_Nil;
			case 19:
				return _List_fromArray(
					[
						checkbox(numberOfClimateSensorsBatteries + ' piles')
					]);
			case 20:
				return _List_Nil;
			case 21:
				return _List_Nil;
			case 22:
				return _List_Nil;
			case 23:
				return _List_fromArray(
					[
						checkbox('Boîte de carton')
					]);
			case 24:
				return _List_Nil;
			case 25:
				return _List_fromArray(
					[
						checkbox('Feuille de calibration'),
						checkbox('Livre d\'instructions'),
						checkbox('Support')
					]);
			case 26:
				return _List_Nil;
			case 27:
				return _List_Nil;
			case 28:
				return _List_Nil;
			case 29:
				return _List_Nil;
			case 30:
				return _List_Nil;
			case 31:
				return _List_Nil;
			case 32:
				return _List_Nil;
			case 33:
				return _List_Nil;
			case 34:
				return _List_Nil;
			case 35:
				return _List_Nil;
			case 36:
				return _List_Nil;
			case 37:
				return _List_Nil;
			case 38:
				return _List_Nil;
			case 39:
				return _List_Nil;
			case 40:
				return _List_Nil;
			case 41:
				return _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$Page$PackingSlip$products = F3(
	function (language, technicalDiscovery, isCustomerVersion) {
		var noOrishaTeamCheckboxes = _List_Nil;
		var entry_ = function (hardware) {
			return A5(
				$author$project$Page$PackingSlip$entry,
				$author$project$Domain$Hardware$image(hardware),
				A3($author$project$Domain$Hardware$name, language, hardware, isCustomerVersion),
				A2($author$project$Domain$Hardware$count, technicalDiscovery, hardware),
				isCustomerVersion,
				A2($author$project$Page$PackingSlip$orishaTeamCheckboxes, technicalDiscovery, hardware));
		};
		var custom = A2(
			$elm$core$List$map,
			function (c) {
				return A5($author$project$Page$PackingSlip$entry, $author$project$Theme$ImgPath$custom, c.jg, c.jD, isCustomerVersion, noOrishaTeamCheckboxes);
			},
			$author$project$Page$PackingSlip$customProducts(technicalDiscovery));
		return function (hardwares) {
			return _Utils_ap(hardwares, custom);
		}(
			A2($elm$core$List$map, entry_, $author$project$Domain$Hardware$allHardwares));
	});
var $rtfeldman$elm_css$Css$borderBottom2 = $rtfeldman$elm_css$Css$prop2('border-bottom');
var $rtfeldman$elm_css$Css$solid = {G: 0, aX: 0, hR: 'solid'};
var $author$project$Page$PackingSlip$signature = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$property, 'align-self', 'flex-end'),
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(4))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.dG)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$rem(1.5)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$rem(25)),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$rem(2)),
								A2(
								$rtfeldman$elm_css$Css$borderBottom2,
								$rtfeldman$elm_css$Css$px(1),
								$rtfeldman$elm_css$Css$solid)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$PackingSlip$view = F5(
	function (url, technicalDiscovery, quote, isCustomerVersion, model) {
		var orishaTeamLanguage = 1;
		var language = isCustomerVersion ? quote.bx.i$ : orishaTeamLanguage;
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$PackingSlip$en, iI: $author$project$Page$PackingSlip$fr});
		var autoPopulateSnippet_ = A2($author$project$Page$PackingSlip$autoPopulateSnippet, technicalDiscovery, quote);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flex(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(2)),
							$author$project$S$onPrint(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$padding(
									$rtfeldman$elm_css$Css$px(25)),
									$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none)
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A5($author$project$Page$PackingSlip$fileHeader, translation, url, technicalDiscovery, quote, isCustomerVersion),
									A2(
									$author$project$S$h2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$marginBottom(
														$rtfeldman$elm_css$Css$rem(1))),
													$author$project$S$onPrint(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$important(
															$rtfeldman$elm_css$Css$fontSize(
																$rtfeldman$elm_css$Css$rem(1.3)))
														]))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(translation.dv)
										])),
									A2(
									$author$project$S$table,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$marginLeft(
													$rtfeldman$elm_css$Css$rem(-5)),
													$rtfeldman$elm_css$Css$marginRight(
													$rtfeldman$elm_css$Css$rem(-5)),
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$inherit)),
													$author$project$S$onPrint(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$inherit)
														]))
												]))
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Page$PackingSlip$headerRow(translation),
										A3($author$project$Page$PackingSlip$products, language, technicalDiscovery, isCustomerVersion)))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$rem(3)),
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
											$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
											A2(
											$rtfeldman$elm_css$Css$Media$withMedia,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Css$Media$only, $rtfeldman$elm_css$Css$Media$print, _List_Nil)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none))
												]))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
													$rtfeldman$elm_css$Css$marginRight(
													$rtfeldman$elm_css$Css$rem(0.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(translation.b0)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(autoPopulateSnippet_)
										]),
									_List_fromArray(
										[$author$project$Theme$Icon$clipboard])),
									A2(
									$author$project$S$when,
									model.cf,
									A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[$author$project$Theme$Icon$check])))
								])),
							A2(
							$author$project$S$when,
							!isCustomerVersion,
							A2($author$project$Page$PackingSlip$configView, translation, quote)),
							$author$project$Page$PackingSlip$signature(translation)
						]))
				]));
	});
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.hD, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		im: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		g6: month,
		hZ: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).im;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).g6;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hZ;
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			im: A2($elm$time$Time$toDay, zone, posix),
			iT: A2($elm$time$Time$toHour, zone, posix),
			i6: A2($elm$time$Time$toMillis, zone, posix),
			i9: A2($elm$time$Time$toMinute, zone, posix),
			g6: A2($elm$time$Time$toMonth, zone, posix),
			jQ: A2($elm$time$Time$toSecond, zone, posix),
			hZ: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$isInTrialPeriod = F2(
	function (here, now) {
		var timeParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, here, now);
		var isOfferValid = false;
		return A2(
			$elm$core$List$member,
			timeParts.g6,
			_List_fromArray(
				[8, 9, 10, 11])) && isOfferValid;
	});
var $author$project$Style$Grid$justifyItems = $rtfeldman$elm_css$Css$property('justify-items');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $author$project$Theme$Font$poppins = $rtfeldman$elm_css$Css$fontFamilies(
	_List_fromArray(
		['Poppins']));
var $rtfeldman$elm_css$Css$absolute = {bI: 0, hR: 'absolute'};
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {im: d, g6: m, hZ: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		fN: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		hZ: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.hZ, 0, date.fN);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.hZ - 1)) + ($justinmimbs$date$Date$monthToNumber(date.g6) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.im,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $rtfeldman$elm_css$Css$CMUnits = 0;
var $rtfeldman$elm_css$Css$cm = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'cm');
var $author$project$Formatter$Date$en = {b_: 'April', b$: 'August', ck: 'December', cy: 'February', cT: 'January', cU: 'July', cV: 'June', c4: 'March', c6: 'May', dm: 'November', dp: 'October', d4: 'September'};
var $author$project$Formatter$Date$fr = {b_: 'avril', b$: 'août', ck: 'décembre', cy: 'février', cT: 'janvier', cU: 'juillet', cV: 'juin', c4: 'mars', c6: 'mai', dm: 'novembre', dp: 'octobre', d4: 'septembre'};
var $author$project$Formatter$Date$month = F2(
	function (language, m) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Formatter$Date$en, iI: $author$project$Formatter$Date$fr});
		switch (m) {
			case 0:
				return translation.cT;
			case 1:
				return translation.cy;
			case 2:
				return translation.c4;
			case 3:
				return translation.b_;
			case 4:
				return translation.c6;
			case 5:
				return translation.cV;
			case 6:
				return translation.cU;
			case 7:
				return translation.b$;
			case 8:
				return translation.d4;
			case 9:
				return translation.dp;
			case 10:
				return translation.dm;
			default:
				return translation.ck;
		}
	});
var $author$project$Formatter$Date$dayMonthYear = F3(
	function (language, zone, posix) {
		var formattedYear = $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, posix));
		var formattedMonth = A2(
			$author$project$Formatter$Date$month,
			language,
			A2($elm$time$Time$toMonth, zone, posix));
		var formattedDay = $elm$core$String$fromInt(
			A2($elm$time$Time$toDay, zone, posix));
		return (!language) ? (formattedMonth + (' ' + (formattedDay + (', ' + formattedYear)))) : (formattedDay + (' ' + (formattedMonth + (' ' + formattedYear))));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Cover$en = {cD: 'Get Orisha on your Farm', aF: 'Valid until'};
var $author$project$Page$QuoteBuilderV3$Preview$Page$Cover$fr = {cD: 'Obtenez Orisha pour votre ferme', aF: 'Valide jusqu\'au'};
var $rtfeldman$elm_css$Css$InchUnits = 0;
var $rtfeldman$elm_css$Css$inches = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'in');
var $author$project$Page$QuoteBuilderV3$Preview$Common$pageContent = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(100)),
						A2(
						$rtfeldman$elm_css$Css$padding2,
						$rtfeldman$elm_css$Css$inches(0.9),
						$rtfeldman$elm_css$Css$inches(0.75))
					]))
			]),
		content);
};
var $rtfeldman$elm_css$Css$relative = {bI: 0, hR: 'relative'};
var $author$project$Page$QuoteBuilderV3$Preview$Common$title = function (str) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$color($author$project$Theme$Color$orishaGreen),
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$author$project$Theme$Font$rubik
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(str)
			]));
};
var $author$project$Page$QuoteBuilderV3$QuoteUrl$urlFromQuote = F2(
	function (url, quote) {
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			$author$project$Utils$Url$origin(url),
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$QuoteBuilderV3$QuoteUrl$queryParam(quote)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Cover$content = F4(
	function (here, now, url, quote) {
		var language = quote.bx.i$;
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Preview$Page$Cover$en, iI: $author$project$Page$QuoteBuilderV3$Preview$Page$Cover$fr});
		var inAMonth = A3(
			$author$project$Formatter$Date$dayMonthYear,
			language,
			here,
			A4($justinmimbs$time_extra$Time$Extra$add, 11, 30, here, now));
		var client = quote.bx;
		return $author$project$Page$QuoteBuilderV3$Preview$Common$pageContent(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$inches(2.75))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$cm(2)),
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$cm(1.5))
										]))
								]),
							_List_fromArray(
								[
									$author$project$Page$QuoteBuilderV3$Preview$Common$title(translation.cD)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$cm(16)),
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$cm(0.5)),
											$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											A2($author$project$Page$QuoteBuilderV3$QuoteUrl$urlFromQuote, url, quote)),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$color($rtfeldman$elm_css$Css$inherit)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Domain$Quote$Client$fullName(client))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(client.iG)
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$cm(20))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$cm(0.3125))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(translation.aF)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$cm(0.375)),
													$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(inAMonth)
										]))
								]))
						]))
				]));
	});
var $author$project$Theme$ImgPath$quote = $author$project$Theme$ImgPath$base + 'quote/';
var $author$project$Theme$ImgPath$coverV3 = $author$project$Theme$ImgPath$quote + 'cover-v3.jpg';
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $author$project$Theme$Color$trueWhite = $rtfeldman$elm_css$Css$hex('#ffffff');
var $author$project$Page$QuoteBuilderV3$Preview$Common$page = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$inches(8.5)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$inches(11)),
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$trueWhite),
						$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
						A2($rtfeldman$elm_css$Css$property, 'break-after', 'page'),
						A2($rtfeldman$elm_css$Css$property, 'break-inside', 'avoid')
					]))
			]),
		content);
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$Cover$view = F4(
	function (here, now, url, quote) {
		return $author$project$Page$QuoteBuilderV3$Preview$Common$page(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$coverV3),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100))
								]))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$pct(100)),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(50)),
									$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$trueWhite),
									$rtfeldman$elm_css$Css$opacity(
									$rtfeldman$elm_css$Css$num(0.9))
								]))
						]),
					_List_Nil),
					A4($author$project$Page$QuoteBuilderV3$Preview$Page$Cover$content, here, now, url, quote)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$Left = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$None = {$: 2};
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$Right = function (a) {
	return {$: 1, a: a};
};
var $author$project$Theme$ImgPath$testimonials = $author$project$Theme$ImgPath$quote + 'testimonials/';
var $author$project$Theme$ImgPath$benHartman = $author$project$Theme$ImgPath$testimonials + 'ben-hartman.webp';
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $author$project$Theme$ImgPath$drewCramer = $author$project$Theme$ImgPath$testimonials + 'drew-cramer.jpg';
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$TestimonyMessage = F3(
	function (start, focus, end) {
		return {gB: end, gI: focus, hD: start};
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$en = {
	eQ: 'Anytime on Eastern business hours.',
	eX: A3($author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$TestimonyMessage, 'I can ', 'take a lot of work out of my head', ' while Orisha makes sure that the environment stays optimal for plant growth.'),
	fg: 'Don’t waste time looking for answers!',
	fh: A3($author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$TestimonyMessage, 'As of today, August 30th, ', 'we have DOUBLED tomato production', ' compared to last year. That’s more than 2000 lbs of tomatoes harvested this summer ! Orisha allowed us to regulate temp and humidity as well as prevent splits with water management'),
	fn: 'For sales. Or support.',
	fB: A3($author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$TestimonyMessage, 'I ', 'got my cucumbers to market 2 weeks earlier this year', '. On May 31st vs mid-June. With Orisha, I keep more heat in my unheated tunnel and avoid transplant shock.'),
	f3: 'They’ll get them to you within 10 minutes.'
};
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $author$project$Theme$ImgPath$teamOrisha = $author$project$Theme$ImgPath$quote + 'team-orisha.jpg';
var $rtfeldman$elm_css$Html$Styled$b = $rtfeldman$elm_css$Html$Styled$node('b');
var $author$project$Theme$Color$beige = $rtfeldman$elm_css$Css$hex('#fcf7ed');
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$testimony = F4(
	function (testimonyMessage, clientName, farmName, imagePosition) {
		var imageSize = 3.5;
		var image = F2(
			function (src, positionStyle) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(src),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
									$rtfeldman$elm_css$Css$borderRadius(
									$rtfeldman$elm_css$Css$pct(50)),
									A2($rtfeldman$elm_css$Css$property, 'object-fit', 'cover'),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$cm(imageSize)),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$cm(imageSize)),
									$rtfeldman$elm_css$Css$bottom(
									$rtfeldman$elm_css$Css$cm(-1)),
									positionStyle(
									$rtfeldman$elm_css$Css$cm(-0.5))
								]))
						]),
					_List_Nil);
			});
		var boldGreen = function (str) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$orishaGreen)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(str)
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
							$rtfeldman$elm_css$Css$padding(
							$rtfeldman$elm_css$Css$cm(1)),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$cm(0.5)),
							$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$beige),
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$cm(0.3))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$cm(1)),
									$rtfeldman$elm_css$Css$lineHeight(
									$rtfeldman$elm_css$Css$cm(0.6))
								]))
						]),
					_List_fromArray(
						[
							boldGreen('“'),
							$rtfeldman$elm_css$Html$Styled$text(testimonyMessage.hD),
							A2(
							$rtfeldman$elm_css$Html$Styled$b,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(testimonyMessage.gI)
								])),
							$rtfeldman$elm_css$Html$Styled$text(testimonyMessage.gB),
							boldGreen('”')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									function () {
									switch (imagePosition.$) {
										case 0:
											return $rtfeldman$elm_css$Css$marginLeft(
												$rtfeldman$elm_css$Css$cm(imageSize - 1));
										case 1:
											return $author$project$Utils$Style$noStyle;
										default:
											return $author$project$Utils$Style$noStyle;
									}
								}()
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									boldGreen(clientName)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									boldGreen(farmName)
								]))
						])),
					function () {
					switch (imagePosition.$) {
						case 0:
							var src = imagePosition.a;
							return A2(image, src, $rtfeldman$elm_css$Css$left);
						case 1:
							var src = imagePosition.a;
							return A2(image, src, $rtfeldman$elm_css$Css$right);
						default:
							return $author$project$S$empty;
					}
				}()
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$view = function () {
	var translation = $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$en;
	return $author$project$Page$QuoteBuilderV3$Preview$Common$page(
		_List_fromArray(
			[
				$author$project$Page$QuoteBuilderV3$Preview$Common$pageContent(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$height(
										$rtfeldman$elm_css$Css$pct(60)),
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
										$author$project$Utils$Style$gap(
										$rtfeldman$elm_css$Css$cm(0.5))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$flex(
												$rtfeldman$elm_css$Css$int(4)),
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
												$author$project$Utils$Style$gap(
												$rtfeldman$elm_css$Css$cm(1.2))
											]))
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$testimony,
										translation.eX,
										'Ben Hartman',
										'Clay Bottom Farm',
										$author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$Left($author$project$Theme$ImgPath$benHartman)),
										A4($author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$testimony, translation.fB, 'Kevin Drouin', 'Leger Amelot Farm', $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$None)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$flex(
												$rtfeldman$elm_css$Css$int(3))
											]))
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$testimony,
										translation.fh,
										'Drew Cramer',
										'Ghosthouse Farm',
										$author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$Right($author$project$Theme$ImgPath$drewCramer))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$teamOrisha),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$bottom(
								$rtfeldman$elm_css$Css$px(0))
							]))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$cm(0.5)),
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$white),
								$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$green),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$cm(8.75)),
								$rtfeldman$elm_css$Css$bottom(
								$rtfeldman$elm_css$Css$cm(10)),
								$rtfeldman$elm_css$Css$right(
								$rtfeldman$elm_css$Css$cm(-0.5)),
								$rtfeldman$elm_css$Css$paddingTop(
								$rtfeldman$elm_css$Css$cm(0.5)),
								$rtfeldman$elm_css$Css$paddingBottom(
								$rtfeldman$elm_css$Css$cm(0.5)),
								$rtfeldman$elm_css$Css$paddingLeft(
								$rtfeldman$elm_css$Css$cm(0.5)),
								$rtfeldman$elm_css$Css$paddingRight(
								$rtfeldman$elm_css$Css$cm(1.25)),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$cm(0.35)),
										$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$cm(0.5))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.fg)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$cm(0.3))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.f3)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.fn)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.eQ)
									]))
							]))
					]))
			]));
}();
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $author$project$Style$List$li = function (attrs) {
	return A3(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$em(0.75))
			]),
		attrs);
};
var $author$project$S$li = $author$project$Style$List$li;
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$fr = {
	eO: 'Plus de 700 serres automatisées!',
	eP: 'Orisha m\'a permis d\'atteindre des rendements 25% plus élevés que mon objectif dès ma première année.',
	fd: 'Aidons nos maraîchers à mieux nourrir leur communauté',
	fx: 'Avec ma lieutenante Orisha, je peux aller sur le bord de l\'eau pour une crème glacée avec l\'équipe.',
	fy: _List_fromArray(
		['Tant à la Ferme des Quatre-Temps qu’aux Jardins de la Grelinette, on a équipé nos serres de systèmes Orisha.', 'Pour nous, c\'est un investissement d\'utiliser leurs services!']),
	fz: 'Grâce au contrôle climatique, j’ai remarqué une diminution des maladies.',
	fA: 'Ce qui m’a le plus surprise avec Orisha, c’est sa simplicité!',
	f1: 'Le Jardinier Maraîcher',
	f4: 'Les producteurs nous font confiance pour :',
	f5: _List_fromArray(
		[
			A2(
			$author$project$S$li,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Faciliter leurs opérations')
				])),
			A2(
			$author$project$S$li,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Sécuriser leur production')
				])),
			A2(
			$author$project$S$li,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Augmenter leur rendement')
				]))
		])
};
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$Style$Title$h3 = function (attrs) {
	return $rtfeldman$elm_css$Html$Styled$h3(
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$Attributes$class('title is-3'),
			attrs));
};
var $author$project$S$h3 = $author$project$Style$Title$h3;
var $rtfeldman$elm_css$Html$Styled$h6 = $rtfeldman$elm_css$Html$Styled$node('h6');
var $author$project$Style$Title$h6 = function (attrs) {
	return $rtfeldman$elm_css$Html$Styled$h6(
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$Attributes$class('title is-6'),
			attrs));
};
var $author$project$S$h6 = $author$project$Style$Title$h6;
var $author$project$Theme$ImgPath$map = $author$project$Theme$ImgPath$quote + 'map.png';
var $author$project$Theme$ImgPath$jaymie = $author$project$Theme$ImgPath$testimonials + 'jaymie.jpg';
var $author$project$Theme$ImgPath$julia2 = $author$project$Theme$ImgPath$testimonials + 'julia2.png';
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$oneLiner = function (str) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$rem(1.2)),
						$rtfeldman$elm_css$Css$fontWeight(
						$rtfeldman$elm_css$Css$int(400)),
						$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$rem(0.5)),
						$rtfeldman$elm_css$Css$lineHeight(
						$rtfeldman$elm_css$Css$pct(200)),
						$rtfeldman$elm_css$Css$color($author$project$Theme$Color$orishaGreen)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(str)
			]));
};
var $rtfeldman$elm_css$Css$boxShadow4 = $rtfeldman$elm_css$Css$prop4('box-shadow');
var $author$project$Theme$Color$lightGrey = $rtfeldman$elm_css$Css$hex('#999999');
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$cardStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$author$project$S$exactPrint,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$white),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(10),
			$author$project$Theme$Color$lightGrey),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$pct(150))
		]));
var $author$project$S$cursiveFont2 = $rtfeldman$elm_css$Css$fontFamilies(
	_List_fromArray(
		['Nothing You Could Do', 'cursive']));
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$photoCredit = F2(
	function (name, farmName) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$S$cursiveFont2,
							$rtfeldman$elm_css$Css$fontSize(
							$rtfeldman$elm_css$Css$rem(0.8)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(0.5))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(name)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(-0.2))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(farmName)
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteImage = function (photoPath) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$img,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$rem(7)),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$zIndex(
						$rtfeldman$elm_css$Css$int(3))
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$src(photoPath)
			]),
		_List_Nil);
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$testimonialView = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (t) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(t)
					]));
		}),
	$rtfeldman$elm_css$Html$Styled$div(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$author$project$Style$Grid$displayGrid,
						$author$project$Style$Grid$rowGap(
						$rtfeldman$elm_css$Css$rem(0.5))
					]))
			])));
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteLayout = F5(
	function (photoPath, testimonial, name, farmName, cardWidth) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flex(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteImage(photoPath),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$cardStyle,
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(-4)),
									$rtfeldman$elm_css$Css$paddingTop(
									$rtfeldman$elm_css$Css$rem(4)),
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(cardWidth))
								]))
						]),
					_List_fromArray(
						[
							$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$testimonialView(testimonial),
							A2($author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$photoCredit, name, farmName)
						]))
				]));
	});
var $author$project$Theme$ImgPath$antoineTestimony = $author$project$Theme$ImgPath$testimonials + 'antoine.png';
var $author$project$Theme$ImgPath$jeanMartin = $author$project$Theme$ImgPath$testimonials + 'jean-martin.png';
var $author$project$Theme$ImgPath$jimoClose = $author$project$Theme$ImgPath$testimonials + 'jimo-close.png';
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$threeTestimonialsView = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$rtfeldman$elm_css$Css$displayFlex]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$rem(0),
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						A5(
						$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteLayout,
						$author$project$Theme$ImgPath$antoineTestimony,
						_List_fromArray(
							[translation.eP]),
						'Antoine',
						'Les Jardins d\'Inverness',
						200)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$rem(0),
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						A5($author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteLayout, $author$project$Theme$ImgPath$jeanMartin, translation.fy, 'Jean-Martin Fortier', translation.f1, 200)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$rem(0),
								$rtfeldman$elm_css$Css$rem(1))
							]))
					]),
				_List_fromArray(
					[
						A5(
						$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteLayout,
						$author$project$Theme$ImgPath$jimoClose,
						_List_fromArray(
							[translation.fz]),
						'Jean-Michel',
						'La Gauloise Ferme Maraîchère',
						200)
					]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$testimonials = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$rem(0.7)),
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$rem(-2))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$padding2,
										$rtfeldman$elm_css$Css$rem(0),
										$rtfeldman$elm_css$Css$rem(1))
									]))
							]),
						_List_fromArray(
							[
								A5(
								$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteLayout,
								$author$project$Theme$ImgPath$jaymie,
								_List_fromArray(
									[translation.fx]),
								'Jaymie',
								'Rutabaga Ranch',
								300)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$padding2,
										$rtfeldman$elm_css$Css$rem(0),
										$rtfeldman$elm_css$Css$rem(1))
									]))
							]),
						_List_fromArray(
							[
								A5(
								$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$quoteLayout,
								$author$project$Theme$ImgPath$julia2,
								_List_fromArray(
									[translation.fA]),
								'Julia',
								'Ferme des Quatre-Temps',
								300)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$marginTop(
								$rtfeldman$elm_css$Css$rem(2))
							]))
					]),
				_List_fromArray(
					[
						$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$oneLiner(translation.fd)
					])),
				$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$threeTestimonialsView(translation)
			]));
};
var $rtfeldman$elm_css$Css$disc = {f: 0, e: 0, hR: 'disc'};
var $rtfeldman$elm_css$Css$listStyle = $rtfeldman$elm_css$Css$prop1('list-style');
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $author$project$Style$List$ul = function (attrs) {
	return A3(
		$rtfeldman$elm_css$Html$Styled$styled,
		$rtfeldman$elm_css$Html$Styled$ul,
		_List_fromArray(
			[
				$author$project$Style$Grid$displayGrid,
				$author$project$Style$Grid$rowGap(
				$rtfeldman$elm_css$Css$em(0.75)),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$em(2)),
				$rtfeldman$elm_css$Css$marginBottom(
				$rtfeldman$elm_css$Css$em(1)),
				$rtfeldman$elm_css$Css$listStyle($rtfeldman$elm_css$Css$disc)
			]),
		attrs);
};
var $author$project$S$ul = $author$project$Style$List$ul;
var $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$view = function () {
	var translation = $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$fr;
	var title = function (str) {
		return A2(
			$author$project$S$h3,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$px(0)))
						]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(str)
				]));
	};
	return $author$project$Page$QuoteBuilderV3$Preview$Common$page(
		_List_fromArray(
			[
				$author$project$Page$QuoteBuilderV3$Preview$Common$pageContent(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$Style$Grid$displayGrid,
										$author$project$Style$Grid$rowGap(
										$rtfeldman$elm_css$Css$rem(2)),
										$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
									]))
							]),
						_List_fromArray(
							[
								title(translation.eO),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$map),
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$width(
														$rtfeldman$elm_css$Css$rem(19))
													]))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$marginLeft(
														$rtfeldman$elm_css$Css$rem(2))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$S$h6,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(translation.f4)
													])),
												A2($author$project$S$ul, _List_Nil, translation.f5)
											]))
									])),
								$author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$testimonials(translation)
							]))
					]))
			]));
}();
var $author$project$Theme$ImgPath$antoine = $author$project$Theme$ImgPath$quote + 'antoine.jpg';
var $rtfeldman$elm_css$Css$borderRadius4 = $rtfeldman$elm_css$Css$prop4('border-radius');
var $author$project$Theme$Font$caveat = $rtfeldman$elm_css$Css$fontFamilies(
	_List_fromArray(
		['Caveat']));
var $author$project$Theme$Color$darkGreen = $rtfeldman$elm_css$Css$hex('#1a5c2a');
var $author$project$Page$QuoteBuilderV3$Preview$Page$HeadStart$en = {bZ: 'Antoine Ratheau', b4: 'But if I can ease the pressure for free…', co: 'Don’t add to your spring rush. Get a head start !', cI: 'I wouldn’t pay to get ready ahead of the season.', cQ: 'Install as early as next week', cZ: 'Les Jardins d\'Inverness', ee: 'Start paying on March 1st', eh: 'Subscribe now'};
var $author$project$Page$QuoteBuilderV3$Preview$Page$HeadStart$fr = {bZ: 'Antoine Ratheau', b4: 'Mais si on me l’offrait gratuitement…', co: 'Installez avant le rush de début de saison, à nos frais!', cI: 'Je ne payerais pas nécessairement juste pour être prêt d’avance.', cQ: 'Installez dès la semaine prochaine', cZ: 'Les Jardins d\'Inverness', ee: 'Débutez les paiements seulement en mars', eh: 'Abonnez-vous maintenant'};
var $rtfeldman$elm_css$Css$inside = {c1: 0, e: 0, hR: 'inside'};
var $rtfeldman$elm_css$Css$lighter = {aL: 0, hR: 'lighter'};
var $rtfeldman$elm_css$Css$listStylePosition = $rtfeldman$elm_css$Css$prop1('list-style-position');
var $author$project$Theme$ImgPath$maudeHelene = $author$project$Theme$ImgPath$quote + 'maude-helene.jpg';
var $rtfeldman$elm_css$Html$Styled$ol = $rtfeldman$elm_css$Html$Styled$node('ol');
var $rtfeldman$elm_css$Css$Structure$PseudoElement = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$pseudoElement = function (element) {
	return $rtfeldman$elm_css$Css$Preprocess$WithPseudoElement(element);
};
var $rtfeldman$elm_css$Css$scale = function (x) {
	return {
		l: 0,
		hR: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'scale',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(x)
				]))
	};
};
var $rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return $elm$core$List$isEmpty(list) ? {hR: 'none'} : {
		hR: A3(
			$rtfeldman$elm_css$Css$String$mapJoin,
			function ($) {
				return $.hR;
			},
			' ',
			list)
	};
};
var $rtfeldman$elm_css$Css$transforms = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('transform'),
	$rtfeldman$elm_css$Css$valuesOrNone);
var $author$project$Page$QuoteBuilderV3$Preview$Page$HeadStart$view = function (quote) {
	var listElement = function (str) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$paddingBottom(
							$rtfeldman$elm_css$Css$cm(0.5)),
							$rtfeldman$elm_css$Css$paddingLeft(
							$rtfeldman$elm_css$Css$cm(0.5)),
							$author$project$Theme$Font$poppins,
							A2(
							$rtfeldman$elm_css$Css$pseudoElement,
							'marker',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
									$rtfeldman$elm_css$Css$color($author$project$Theme$Color$orishaGreen)
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$paddingLeft(
									$rtfeldman$elm_css$Css$cm(0.4))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(str)
						]))
				]));
	};
	var language = quote.bx.i$;
	var translation = A2(
		$author$project$Language$getTranslation,
		language,
		{iy: $author$project$Page$QuoteBuilderV3$Preview$Page$HeadStart$en, iI: $author$project$Page$QuoteBuilderV3$Preview$Page$HeadStart$fr});
	return $author$project$Page$QuoteBuilderV3$Preview$Common$page(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$antoine),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$cm(12)),
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$cm(6.5)),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$cm(4)),
								A4(
								$rtfeldman$elm_css$Css$borderRadius4,
								$rtfeldman$elm_css$Css$cm(0),
								$rtfeldman$elm_css$Css$cm(0.5),
								$rtfeldman$elm_css$Css$cm(0.5),
								$rtfeldman$elm_css$Css$cm(0)),
								$rtfeldman$elm_css$Css$transforms(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$scale(1.1)
									])),
								A2($rtfeldman$elm_css$Css$property, 'object-fit', 'cover'),
								A2($rtfeldman$elm_css$Css$property, 'object-position', 'center top')
							]))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$cm(9)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$cm(0)),
								$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$beige),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$cm(0.5)),
								$author$project$Theme$Font$caveat,
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
								A2(
								$rtfeldman$elm_css$Css$padding2,
								$rtfeldman$elm_css$Css$cm(0),
								$rtfeldman$elm_css$Css$cm(0.5)),
								A4(
								$rtfeldman$elm_css$Css$borderRadius4,
								$rtfeldman$elm_css$Css$cm(0),
								$rtfeldman$elm_css$Css$cm(0.5),
								$rtfeldman$elm_css$Css$cm(0.5),
								$rtfeldman$elm_css$Css$cm(0))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$cm(0.6))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.bZ)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$cm(0.4))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.cZ)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$cm(8)),
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$cm(6)),
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
								$rtfeldman$elm_css$Css$bottom(
								$rtfeldman$elm_css$Css$cm(4)),
								$rtfeldman$elm_css$Css$right(
								$rtfeldman$elm_css$Css$px(0)),
								A4(
								$rtfeldman$elm_css$Css$borderRadius4,
								$rtfeldman$elm_css$Css$cm(0.5),
								$rtfeldman$elm_css$Css$cm(0),
								$rtfeldman$elm_css$Css$cm(0),
								$rtfeldman$elm_css$Css$cm(0.5))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$maudeHelene),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$height(
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$transforms(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$scale(1.2)
											])),
										A2($rtfeldman$elm_css$Css$property, 'transform-origin', 'bottom right'),
										A2($rtfeldman$elm_css$Css$property, 'object-fit', 'cover'),
										A2($rtfeldman$elm_css$Css$property, 'object-position', 'right bottom')
									]))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$cm(4)),
								$rtfeldman$elm_css$Css$right(
								$rtfeldman$elm_css$Css$cm(2)),
								$author$project$Theme$Font$poppins,
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$cm(0.55)),
								$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$lighter),
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$darkGreen),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$lineHeight(
								$rtfeldman$elm_css$Css$num(2)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$cm(6))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$cm(0.5))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.cI)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.b4)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$cm(14)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$cm(2)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$cm(15)),
								$author$project$Theme$Font$rubik,
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$cm(1)),
								$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$orishaGreen)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.co)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$bottom(
								$rtfeldman$elm_css$Css$cm(5)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$cm(2))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$ol,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$listStylePosition($rtfeldman$elm_css$Css$inside)
									]))
							]),
						_List_fromArray(
							[
								listElement(translation.eh),
								listElement(translation.cQ),
								listElement(translation.ee)
							]))
					]))
			]));
};
var $author$project$Theme$Icon$caretDown = A2($author$project$Theme$Icon$faIcon, 'caret-down', $rtfeldman$elm_css$Css$inherit);
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$en = {b6: 'You receive a government grant to buy', b7: 'Possibility to switch to Lifetime Access later on', cm: 'Details on your project below', cz: 'Financial resilience is not an issue on your farm', cC: 'Free', cM: 'Includes equipment', cO: 'Infinite warranty', cW: 'You\'d rather keep money in the bank to weather bad surprises', c_: 'Lifetime Access', c$: 'Lifetime replacements sounds good', c0: '5 years limited warranty', c8: 'Money is tight', dh: 'No commitment. Stop or adapt subscription anytime.', dj: 'No recurring costs', dk: 'No upfront costs. Equipment is lent free of charge.', dw: 'Pay as You Go', bi: '/month', dx: 'Pick what option fits you best', dP: 'Recommended when', ep: 'Then ', ev: 'until March 1st. ', eM: 'With the Head Start Plan'};
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$fr = {b6: 'Vous obtenez une subvention si vous achetez', b7: 'Possibilité de passer ultérieurement à l\'accès à vie', cm: 'Détails sur votre projet ci-dessous', cz: 'La résilience financière n’est pas un problème sur votre ferme', cC: 'Gratuit', cM: 'Comprend l\'équipement', cO: 'Garantie infinie', cW: 'Vous préférez garder de l\'argent en banque pour éviter les mauvaises surprises', c_: 'Accès à vie', c$: 'Les remplacements à vie vous semblent bons', c0: 'Garantie limitée de 5 ans', c8: 'L’endettement n’est pas une option', dh: 'Aucun engagement. Arrêtez ou adaptez votre abonnement à tout moment.', dj: 'Pas de frais récurrents', dk: 'Aucun frais initial. Le matériel est prêté gratuitement.', dw: 'Au fur et à mesure', bi: '/mois', dx: 'Choisissez ce qui convient', dP: 'Recommandé quand', ep: 'Puis ', ev: 'jusqu\'au 1er mars. ', eM: 'Avec le plan pré-saison'};
var $rtfeldman$elm_css$Css$listStyleType = $rtfeldman$elm_css$Css$prop1('list-style-type');
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$arguments = function (items) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$ul,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$disc)
					]))
			]),
		A2(
			$elm$core$List$map,
			function (str) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$cm(0.2))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(str)
						]));
			},
			items));
};
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.hR);
};
var $rtfeldman$elm_css$Css$borderWidth = $rtfeldman$elm_css$Css$prop1('border-width');
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$block = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$flex(
						$rtfeldman$elm_css$Css$int(1)),
						$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
						$rtfeldman$elm_css$Css$borderWidth(
						$rtfeldman$elm_css$Css$cm(0.05)),
						$rtfeldman$elm_css$Css$borderColor($author$project$Theme$Color$orishaGreen),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$cm(0.5)),
						$rtfeldman$elm_css$Css$padding(
						$rtfeldman$elm_css$Css$cm(1))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
							]))
					]),
				content)
			]));
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$buttonStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$cm(1)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$cm(0.25))
		]));
var $author$project$Domain$Quote$Plan$Purchase = 0;
var $author$project$Page$QuoteBuilderV3$Preview$Common$button = F2(
	function (src, label) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$darkGreen),
							$rtfeldman$elm_css$Css$color($author$project$Theme$Color$white),
							$rtfeldman$elm_css$Css$borderRadius(
							$rtfeldman$elm_css$Css$cm(2)),
							$rtfeldman$elm_css$Css$borderWidth(
							$rtfeldman$elm_css$Css$px(3)),
							$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
							$rtfeldman$elm_css$Css$borderColor($author$project$Theme$Color$darkGreen),
							A2(
							$rtfeldman$elm_css$Css$padding2,
							$rtfeldman$elm_css$Css$cm(0.2),
							$rtfeldman$elm_css$Css$cm(1)),
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$cm(4.25)),
							$rtfeldman$elm_css$Css$hover(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$color($author$project$Theme$Color$white)
								])),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(src),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Common$en = {b5: 'Buy Now', eg: 'Subscribe'};
var $author$project$Page$QuoteBuilderV3$Preview$Common$fr = {b5: 'Acheter', eg: 'S\'abonner'};
var $folkertdev$elm_flate$Flate$Dynamic = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Flate$WithWindowSize = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$map2 = F3(
	function (func, _v0, _v1) {
		var decodeA = _v0;
		var decodeB = _v1;
		return F2(
			function (bites, offset) {
				var _v2 = A2(decodeA, bites, offset);
				var aOffset = _v2.a;
				var a = _v2.b;
				var _v3 = A2(decodeB, bites, aOffset);
				var bOffset = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(
					bOffset,
					A2(func, a, b));
			});
	});
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case = function (i) {
	switch (i) {
		case 0:
			return 0;
		case 1:
			return 498536548;
		case 2:
			return 997073096;
		case 3:
			return 651767980;
		case 4:
			return 1994146192;
		case 5:
			return 1802195444;
		case 6:
			return 1303535960;
		case 7:
			return 1342533948;
		case 8:
			return 3988292384;
		case 9:
			return 4027552580;
		case 10:
			return 3604390888;
		case 11:
			return 3412177804;
		case 12:
			return 2607071920;
		case 13:
			return 2262029012;
		case 14:
			return 2685067896;
		default:
			return 3183342108;
	}
};
var $folkertdev$elm_flate$Checksum$Crc32$step = F2(
	function (_byte, crc) {
		var a = (crc ^ _byte) >>> 0;
		var b = ((a >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(a & 15)) >>> 0;
		var c = (b >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(b & 15);
		return c;
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $folkertdev$elm_flate$Checksum$Crc32$crc32Help = function (_v0) {
	var remaining = _v0.dR;
	var crc = _v0.cg;
	return (remaining >= 8) ? A3(
		$elm$bytes$Bytes$Decode$map2,
		F2(
			function (word1, word2) {
				var byte8 = 255 & word2;
				var byte7 = 255 & (word2 >>> 8);
				var byte6 = 255 & (word2 >>> 16);
				var byte5 = 255 & (word2 >>> 24);
				var byte4 = 255 & word1;
				var byte3 = 255 & (word1 >>> 8);
				var byte2 = 255 & (word1 >>> 16);
				var byte1 = 255 & (word1 >>> 24);
				return $elm$bytes$Bytes$Decode$Loop(
					{
						cg: A2(
							$folkertdev$elm_flate$Checksum$Crc32$step,
							byte8,
							A2(
								$folkertdev$elm_flate$Checksum$Crc32$step,
								byte7,
								A2(
									$folkertdev$elm_flate$Checksum$Crc32$step,
									byte6,
									A2(
										$folkertdev$elm_flate$Checksum$Crc32$step,
										byte5,
										A2(
											$folkertdev$elm_flate$Checksum$Crc32$step,
											byte4,
											A2(
												$folkertdev$elm_flate$Checksum$Crc32$step,
												byte3,
												A2(
													$folkertdev$elm_flate$Checksum$Crc32$step,
													byte2,
													A2($folkertdev$elm_flate$Checksum$Crc32$step, byte1, crc)))))))),
						dR: remaining - 8
					});
			}),
		$elm$bytes$Bytes$Decode$unsignedInt32(1),
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_byte) {
			return $elm$bytes$Bytes$Decode$Loop(
				{
					cg: A2($folkertdev$elm_flate$Checksum$Crc32$step, _byte, crc),
					dR: remaining - 1
				});
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done((crc ^ 4294967295) >>> 0)));
};
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$width = _Bytes_width;
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32 = function (buffer) {
	var length = $elm$bytes$Bytes$width(buffer);
	var initialCrc = 4294967295;
	return (!length) ? 0 : A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				{cg: initialCrc, dR: length},
				$folkertdev$elm_flate$Checksum$Crc32$crc32Help),
			buffer));
};
var $folkertdev$elm_flate$Checksum$Crc32$crc32 = $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32;
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $folkertdev$elm_flate$Deflate$Internal$chunksHelp = F2(
	function (chunkSize, _v0) {
		var sizeRemaining = _v0.a;
		var accum = _v0.b;
		return (!sizeRemaining) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(_List_Nil)) : ((_Utils_cmp(chunkSize, sizeRemaining) > -1) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Done(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(true, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(sizeRemaining)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						sizeRemaining - chunkSize,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(false, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(chunkSize)));
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $folkertdev$elm_flate$Deflate$Internal$chunks = F2(
	function (chunkSize, buffer) {
		var _v0 = A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				_Utils_Tuple2(
					$elm$bytes$Bytes$width(buffer),
					_List_Nil),
				$folkertdev$elm_flate$Deflate$Internal$chunksHelp(chunkSize)),
			buffer);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					true,
					$elm$bytes$Bytes$Encode$encode(
						$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
				]);
		} else {
			if (!_v0.a.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						true,
						$elm$bytes$Bytes$Encode$encode(
							$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
					]);
			} else {
				var value = _v0.a;
				return value;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Internal$default_block_size = 1024 * 1024;
var $folkertdev$elm_flate$Deflate$BitWriter$empty = {S: 0, V: _List_Nil, f_: 0};
var $folkertdev$elm_flate$Deflate$Symbol$code = function (symbol) {
	switch (symbol.$) {
		case 1:
			var _byte = symbol.a;
			return _byte;
		case 0:
			return 256;
		default:
			var length = symbol.a;
			return ((length >= 3) && (length <= 10)) ? ((257 + length) - 3) : (((length >= 11) && (length <= 18)) ? (265 + (((length - 11) / 2) | 0)) : (((length >= 19) && (length <= 34)) ? (269 + (((length - 19) / 4) | 0)) : (((length >= 35) && (length <= 66)) ? (273 + (((length - 35) / 8) | 0)) : (((length >= 67) && (length <= 130)) ? (277 + (((length - 67) / 16) | 0)) : (((length >= 131) && (length <= 257)) ? (281 + (((length - 131) / 32) | 0)) : ((length === 258) ? 285 : (-1)))))));
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$distance = function (symbol) {
	if (symbol.$ === 2) {
		var distance_ = symbol.b;
		if (distance_ <= 4) {
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(distance_ - 1, 0, 0));
		} else {
			var go = F3(
				function (extraBits, code_, base) {
					go:
					while (true) {
						if (_Utils_cmp(base * 2, distance_) < 0) {
							var $temp$extraBits = extraBits + 1,
								$temp$code_ = code_ + 2,
								$temp$base = base * 2;
							extraBits = $temp$extraBits;
							code_ = $temp$code_;
							base = $temp$base;
							continue go;
						} else {
							return _Utils_Tuple3(extraBits, code_, base);
						}
					}
				});
			var _v1 = A3(go, 1, 4, 4);
			var extraBits = _v1.a;
			var code_ = _v1.b;
			var base = _v1.c;
			var delta = (distance_ - base) - 1;
			var half = (base / 2) | 0;
			return (_Utils_cmp(distance_, base + half) < 1) ? $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta))) : $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_ + 1,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta)));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $folkertdev$elm_flate$Deflate$Symbol$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 1) {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies = F2(
	function (symbol, _v0) {
		var literalCounts = _v0.a;
		var distanceCounts = _v0.b;
		var emptyDistanceCount = _v0.c;
		var _v1 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
		if (_v1.$ === 1) {
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				distanceCounts,
				emptyDistanceCount);
		} else {
			var _v2 = _v1.a;
			var d = _v2.a;
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					d,
					function (v) {
						return v + 1;
					},
					distanceCounts),
				false);
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $elm$core$List$sortWith = _List_sortWith;
var $folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth = function (frequencies) {
	var heapModificationLoop = function (heap) {
		heapModificationLoop:
		while (true) {
			if (!heap.b) {
				return 0;
			} else {
				if (!heap.b.b) {
					var _v1 = heap.a;
					var value = _v1.b;
					return A2($elm$core$Basics$max, 1, value);
				} else {
					var _v2 = heap.a;
					var weight1 = _v2.a;
					var width1 = _v2.b;
					var _v3 = heap.b;
					var _v4 = _v3.a;
					var weight2 = _v4.a;
					var width2 = _v4.b;
					var rest = _v3.b;
					var $temp$heap = A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, b, a);
							}),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								weight1 + weight2,
								1 + A2($elm$core$Basics$max, width1, width2)),
							rest));
					heap = $temp$heap;
					continue heapModificationLoop;
				}
			}
		}
	};
	var createHeapFolder = F2(
		function (freq, heap) {
			return (freq > 0) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(-freq, 0),
				heap) : heap;
		});
	var createHeap = A3($elm$core$Array$foldl, createHeapFolder, _List_Nil, frequencies);
	return heapModificationLoop(createHeap);
};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{u: nodeList, q: nodeListSize, t: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			u: _List_Nil,
			q: 0,
			t: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.q * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						u: A2($elm$core$List$cons, mappedLeaf, builder.u),
						q: builder.q + 1,
						t: builder.t
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.t)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.t, tail);
		return (notAppended < 0) ? {
			u: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.u),
			q: builder.q + 1,
			t: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			u: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.u),
			q: builder.q + 1,
			t: $elm$core$Elm$JsArray$empty
		} : {u: builder.u, q: builder.q, t: appended});
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		u: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		q: (len / $elm$core$Array$branchFactor) | 0,
		t: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop = F3(
	function (xarr, yarr, accum) {
		mergeLoop:
		while (true) {
			var _v0 = _Utils_Tuple2(xarr, yarr);
			if (!_v0.a.b) {
				return A2(
					$elm$core$Array$append,
					accum,
					$elm$core$Array$fromList(yarr));
			} else {
				if (!_v0.b.b) {
					return A2(
						$elm$core$Array$append,
						accum,
						$elm$core$Array$fromList(xarr));
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xrest = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var yrest = _v2.b;
					if (_Utils_cmp(x.br, y.br) < 0) {
						var $temp$xarr = xrest,
							$temp$yarr = yarr,
							$temp$accum = A2($elm$core$Array$push, x, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					} else {
						var $temp$xarr = xarr,
							$temp$yarr = yrest,
							$temp$accum = A2($elm$core$Array$push, y, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					}
				}
			}
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge = F2(
	function (x, y) {
		return A3(
			$folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop,
			$elm$core$Array$toList(x),
			$elm$core$Array$toList(y),
			$elm$core$Array$empty);
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes = F2(
	function (node1, node2) {
		return {
			aV: A2($elm$core$Array$append, node1.aV, node2.aV),
			br: node1.br + node2.br
		};
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$package = function (nodes) {
	if ($elm$core$Array$length(nodes) >= 2) {
		var newLen = ($elm$core$Array$length(nodes) / 2) | 0;
		var loop = F2(
			function (currentNodes, accum) {
				loop:
				while (true) {
					if (currentNodes.b && currentNodes.b.b) {
						var self = currentNodes.a;
						var _v1 = currentNodes.b;
						var other = _v1.a;
						var rest = _v1.b;
						var $temp$currentNodes = rest,
							$temp$accum = A2(
							$elm$core$List$cons,
							A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes, self, other),
							accum);
						currentNodes = $temp$currentNodes;
						accum = $temp$accum;
						continue loop;
					} else {
						return $elm$core$Array$fromList(
							$elm$core$List$reverse(accum));
					}
				}
			});
		return A2(
			loop,
			$elm$core$Array$toList(nodes),
			_List_Nil);
	} else {
		return nodes;
	}
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode = F2(
	function (symbol, weight) {
		return {
			aV: A2($elm$core$Array$repeat, 1, symbol),
			br: weight
		};
	});
var $elm$core$List$sortBy = _List_sortBy;
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 1) {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate = F2(
	function (maxBitWidth, frequencies) {
		var source = $elm$core$Array$fromList(
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.br;
				},
				$elm$core$Array$toList(
					A2(
						$elm$core$Array$map,
						function (_v3) {
							var symbol = _v3.a;
							var weight = _v3.b;
							return A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode, symbol, weight);
						},
						A2(
							$elm$core$Array$filter,
							function (_v2) {
								var f = _v2.b;
								return f > 0;
							},
							A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, frequencies))))));
		var weighted = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, w) {
					return A2(
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge,
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(w),
						source);
				}),
			source,
			A2($elm$core$List$range, 0, maxBitWidth - 2));
		var loop = F2(
			function (symbols, accum) {
				loop:
				while (true) {
					if (!symbols.b) {
						return accum;
					} else {
						var symbol = symbols.a;
						var rest = symbols.b;
						var $temp$symbols = rest,
							$temp$accum = A3(
							$folkertdev$elm_flate$LengthLimitedHuffmanCodes$update,
							symbol,
							function (v) {
								return v + 1;
							},
							accum);
						symbols = $temp$symbols;
						accum = $temp$accum;
						continue loop;
					}
				}
			});
		var allSymbols = A2(
			$elm$core$List$concatMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aV;
				},
				$elm$core$Array$toList),
			$elm$core$Array$toList(
				$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(weighted)));
		return A2(
			loop,
			allSymbols,
			A2(
				$elm$core$Array$repeat,
				$elm$core$Array$length(frequencies),
				0));
	});
var $folkertdev$elm_flate$Huffman$Tree = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$Code = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$codeFromRecord = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$new = function (n) {
	return A2(
		$elm$core$Array$repeat,
		n,
		$folkertdev$elm_flate$Huffman$codeFromRecord(
			{aG: 0, hW: 0}));
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $folkertdev$elm_flate$Huffman$inverseEndianLoop = F4(
	function (i, limit, f, t) {
		inverseEndianLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var $temp$i = i + 1,
					$temp$limit = limit,
					$temp$f = f >> 1,
					$temp$t = (f & 1) | (t << 1);
				i = $temp$i;
				limit = $temp$limit;
				f = $temp$f;
				t = $temp$t;
				continue inverseEndianLoop;
			} else {
				return t;
			}
		}
	});
var $folkertdev$elm_flate$Huffman$inverseEndian = function (_v0) {
	var width = _v0.hW;
	var bits = _v0.aG;
	var inverseBits = A4($folkertdev$elm_flate$Huffman$inverseEndianLoop, 0, width, bits, 0);
	return {aG: inverseBits, hW: width};
};
var $folkertdev$elm_flate$Huffman$setMapping = F3(
	function (symbol, code, _v0) {
		var array = _v0;
		return A3(
			$elm$core$Array$set,
			symbol,
			$folkertdev$elm_flate$Huffman$inverseEndian(code),
			array);
	});
var $folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes = F2(
	function (bitWidths, tree) {
		var symbols = A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$second,
			$elm$core$Array$toList(
				A2(
					$elm$core$Array$filter,
					function (_v3) {
						var codeBitWidth = _v3.b;
						return codeBitWidth > 0;
					},
					A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))));
		var loop = F2(
			function (_v1, _v2) {
				var symbol = _v1.a;
				var bitWidth = _v1.b;
				var code = _v2.a;
				var prevWidth = _v2.b;
				var currentTree = _v2.c;
				var newBits = code << (bitWidth - prevWidth);
				var nextCode = {aG: newBits, hW: bitWidth};
				return _Utils_Tuple3(
					newBits + 1,
					bitWidth,
					A3($folkertdev$elm_flate$Huffman$setMapping, symbol, nextCode, currentTree));
			});
		return function (_v0) {
			var x = _v0.c;
			return x;
		}(
			A3(
				$elm$core$List$foldl,
				loop,
				_Utils_Tuple3(0, 0, tree),
				symbols));
	});
var $folkertdev$elm_flate$Huffman$fromBitWidths = function (bitWidths) {
	var symbolCount = function (v) {
		return v + 1;
	}(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				function (a) {
					return A2(
						$elm$core$Array$get,
						$elm$core$Array$length(a) - 1,
						a);
				}(
					A2(
						$elm$core$Array$filter,
						function (e) {
							return e.b > 0;
						},
						A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))))));
	return A2(
		$folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes,
		bitWidths,
		$folkertdev$elm_flate$Huffman$new(symbolCount));
};
var $folkertdev$elm_flate$Huffman$fromFrequencies = F2(
	function (symbolFrequencies, maxBitWidth_) {
		var maxBitWidth = A2(
			$elm$core$Basics$min,
			maxBitWidth_,
			$folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth(symbolFrequencies));
		var codeBitWidhts = A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate, maxBitWidth, symbolFrequencies);
		return $folkertdev$elm_flate$Huffman$fromBitWidths(codeBitWidhts);
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec = function (symbols) {
	var _v0 = A3(
		$elm$core$Array$foldl,
		$folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies,
		_Utils_Tuple3(
			A2($elm$core$Array$repeat, 286, 0),
			A2($elm$core$Array$repeat, 30, 0),
			true),
		symbols);
	var literalCounts = _v0.a;
	var distanceCounts = _v0.b;
	var emptyDistanceCount = _v0.c;
	return {
		aJ: emptyDistanceCount ? A2(
			$folkertdev$elm_flate$Huffman$fromFrequencies,
			A3($elm$core$Array$set, 0, 1, distanceCounts),
			15) : A2($folkertdev$elm_flate$Huffman$fromFrequencies, distanceCounts, 15),
		aQ: A2($folkertdev$elm_flate$Huffman$fromFrequencies, literalCounts, 15)
	};
};
var $folkertdev$elm_flate$Deflate$Symbol$EndOfBlock = {$: 0};
var $folkertdev$elm_flate$Deflate$Symbol$Literal = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Deflate$Symbol$Share = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $folkertdev$elm_flate$Deflate$Internal$codeToSymbol = function (code) {
	if (!code.$) {
		var v = code.a;
		return $folkertdev$elm_flate$Deflate$Symbol$Literal(v);
	} else {
		var length = code.a;
		var backwardDistance = code.b;
		return A2($folkertdev$elm_flate$Deflate$Symbol$Share, length, backwardDistance);
	}
};
var $folkertdev$elm_flate$LZ77$Literal = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_flate$LZ77$Pointer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$Small = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_flate$PrefixTable$Large = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$PrefixTable$LargePrefixTable = $elm$core$Basics$identity;
var $folkertdev$elm_flate$PrefixTable$insertInList = F6(
	function (i, array, p2, position, remaining, accum) {
		insertInList:
		while (true) {
			if (!remaining.b) {
				var newPositions = A2(
					$elm$core$List$cons,
					_Utils_Tuple2(p2, position),
					accum);
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Large(
						A3($elm$core$Array$set, i, newPositions, array)),
					$elm$core$Maybe$Nothing);
			} else {
				var current = remaining.a;
				var key = current.a;
				var oldValue = current.b;
				var rest = remaining.b;
				if (!(key - p2)) {
					var newPositions = _Utils_ap(
						accum,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(key, position),
							rest));
					return _Utils_Tuple2(
						$folkertdev$elm_flate$PrefixTable$Large(
							A3($elm$core$Array$set, i, newPositions, array)),
						$elm$core$Maybe$Just(oldValue));
				} else {
					var $temp$i = i,
						$temp$array = array,
						$temp$p2 = p2,
						$temp$position = position,
						$temp$remaining = rest,
						$temp$accum = A2($elm$core$List$cons, current, accum);
					i = $temp$i;
					array = $temp$array;
					p2 = $temp$p2;
					position = $temp$position;
					remaining = $temp$remaining;
					accum = $temp$accum;
					continue insertInList;
				}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$insert = F3(
	function (_v0, position, ptable) {
		var prefix_ = _v0;
		var prefix = 16777215 & (prefix_ >>> 0);
		if (!ptable.$) {
			var dict = ptable.a;
			var _v2 = A2($elm$core$Dict$get, prefix, dict);
			if (_v2.$ === 1) {
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Nothing);
			} else {
				var oldValue = _v2.a;
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Just(oldValue));
			}
		} else {
			var array = ptable.a;
			var index = prefix >> 8;
			var _v3 = A2($elm$core$Array$get, index, array);
			if (_v3.$ === 1) {
				return _Utils_Tuple2(ptable, $elm$core$Maybe$Nothing);
			} else {
				var positions = _v3.a;
				return A6($folkertdev$elm_flate$PrefixTable$insertInList, index, array, 255 & prefix, position, positions, _List_Nil);
			}
		}
	});
var $folkertdev$elm_flate$Experimental$ByteArray$length = function (_v0) {
	var array = _v0.a;
	var finalSize = _v0.b;
	var finalBytes = _v0.c;
	var _v1 = $elm$core$Array$length(array) * 4;
	if (!_v1) {
		return finalSize;
	} else {
		var l = _v1;
		return l + finalSize;
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$get = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalSize = _v0.b;
		var finalBytes = _v0.c;
		var offset = index % 4;
		if (_Utils_cmp(
			index,
			($elm$core$Array$length(array) * 4) + finalSize) > -1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_cmp(
				index,
				$elm$core$Array$length(array) * 4) > -1) {
				return $elm$core$Maybe$Just(255 & (finalBytes >>> (8 * (3 - offset))));
			} else {
				var internalIndex = (index / 4) | 0;
				var _v1 = A2($elm$core$Array$get, internalIndex, array);
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var int32 = _v1.a;
					return $elm$core$Maybe$Just(255 & (int32 >>> (8 * (3 - offset))));
				}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$longestCommonPrefixLoop = F5(
	function (i, j, limit, accum, array) {
		longestCommonPrefixLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, i, array);
				if (_v0.$ === 1) {
					return accum;
				} else {
					var value1 = _v0.a;
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, j, array);
					if (_v1.$ === 1) {
						return accum;
					} else {
						var value2 = _v1.a;
						if (!(value1 - value2)) {
							var $temp$i = i + 1,
								$temp$j = j + 1,
								$temp$limit = limit,
								$temp$accum = accum + 1,
								$temp$array = array;
							i = $temp$i;
							j = $temp$j;
							limit = $temp$limit;
							accum = $temp$accum;
							array = $temp$array;
							continue longestCommonPrefixLoop;
						} else {
							return accum;
						}
					}
				}
			} else {
				return accum;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$max_length = 258;
var $folkertdev$elm_flate$LZ77$longestCommonPrefix = F3(
	function (i, j, array) {
		var remaining = A2(
			$elm$core$Basics$min,
			$folkertdev$elm_flate$LZ77$max_length - 3,
			$folkertdev$elm_flate$Experimental$ByteArray$length(array) - j);
		return A5($folkertdev$elm_flate$LZ77$longestCommonPrefixLoop, i, j, i + remaining, 0, array);
	});
var $folkertdev$elm_flate$PrefixTable$OutOfBounds = {$: 3};
var $folkertdev$elm_flate$PrefixTable$Prefix = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$PrefixCode = $elm$core$Basics$identity;
var $folkertdev$elm_flate$PrefixTable$Trailing1 = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$PrefixTable$Trailing2 = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$getInt32 = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalBytes = _v0.c;
		var size = $elm$core$Array$length(array);
		return (!(index - size)) ? $elm$core$Maybe$Just(finalBytes) : A2($elm$core$Array$get, index, array);
	});
var $folkertdev$elm_flate$PrefixTable$prefixAt = F2(
	function (k, input) {
		var size = $folkertdev$elm_flate$Experimental$ByteArray$length(input);
		if (_Utils_cmp(k + 2, size) > -1) {
			if (_Utils_cmp(k, size) > -1) {
				return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
			} else {
				if (_Utils_cmp(k + 1, size) > -1) {
					var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v0.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var value = _v0.a;
						return $folkertdev$elm_flate$PrefixTable$Trailing1(value);
					}
				} else {
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v1.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var v1 = _v1.a;
						var _v2 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k + 1, input);
						if (_v2.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var v2 = _v2.a;
							return A2($folkertdev$elm_flate$PrefixTable$Trailing2, v1, v2);
						}
					}
				}
			}
		} else {
			var offset = k % 4;
			var internalIndex = (k / 4) | 0;
			switch (offset) {
				case 0:
					var _v4 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v4.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v4.a;
						var first = 255 & ((int32 >> 24) >>> 0);
						var code = int32 >> 8;
						return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
					}
				case 1:
					var _v5 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v5.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v5.a;
						var first = 255 & ((255 & (int32 >> 16)) >>> 0);
						var code = 16777215 & int32;
						return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
					}
				case 2:
					var _v6 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v6.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v6.a;
						var _v7 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v7.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v7.a;
							var first = 255 & ((255 & (int32 >> 8)) >>> 0);
							var code = 16777215 & (((255 & (nextInt32 >> 24)) | ((65535 & int32) << 8)) >>> 0);
							return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
						}
					}
				default:
					var _v8 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v8.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v8.a;
						var _v9 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v9.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v9.a;
							var first = 255 & ((255 & int32) >>> 0);
							var code = (65535 & (nextInt32 >> 16)) | ((255 & int32) << 16);
							return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
						}
					}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$updatePrefixTableLoop = F4(
	function (k, limit, buffer, prefixTable) {
		updatePrefixTableLoop:
		while (true) {
			if (_Utils_cmp(k, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, k, buffer);
				if (!_v0.$) {
					var code = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, code, k, prefixTable);
					var newPrefixTable = _v1.a;
					var $temp$k = k + 1,
						$temp$limit = limit,
						$temp$buffer = buffer,
						$temp$prefixTable = newPrefixTable;
					k = $temp$k;
					limit = $temp$limit;
					buffer = $temp$buffer;
					prefixTable = $temp$prefixTable;
					continue updatePrefixTableLoop;
				} else {
					return prefixTable;
				}
			} else {
				return prefixTable;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$flushLoop = F5(
	function (i, windowSize, buffer, prefixTable, encoders) {
		flushLoop:
		while (true) {
			var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, i, buffer);
			switch (_v0.$) {
				case 3:
					return encoders;
				case 1:
					var p1 = _v0.a;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p1),
						encoders);
				case 2:
					var p1 = _v0.a;
					var p2 = _v0.b;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p2),
						A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders));
				default:
					var p1 = _v0.a;
					var key = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, key, i, prefixTable);
					var newPrefixTable = _v1.a;
					var matched = _v1.b;
					if (!matched.$) {
						var j = matched.a;
						var distance = i - j;
						if ((distance - windowSize) <= 0) {
							var length = 3 + A3($folkertdev$elm_flate$LZ77$longestCommonPrefix, i + 3, j + 3, buffer);
							var newEncoders = A2(
								$elm$core$Array$push,
								A2($folkertdev$elm_flate$LZ77$Pointer, length, distance),
								encoders);
							var newerPrefixTable = A4($folkertdev$elm_flate$LZ77$updatePrefixTableLoop, i + 1, i + length, buffer, newPrefixTable);
							var $temp$i = i + length,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newerPrefixTable,
								$temp$encoders = newEncoders;
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						} else {
							var $temp$i = i + 1,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newPrefixTable,
								$temp$encoders = A2(
								$elm$core$Array$push,
								$folkertdev$elm_flate$LZ77$Literal(p1),
								encoders);
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						}
					} else {
						var $temp$i = i + 1,
							$temp$windowSize = windowSize,
							$temp$buffer = buffer,
							$temp$prefixTable = newPrefixTable,
							$temp$encoders = A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders);
						i = $temp$i;
						windowSize = $temp$windowSize;
						buffer = $temp$buffer;
						prefixTable = $temp$prefixTable;
						encoders = $temp$encoders;
						continue flushLoop;
					}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$max_distance = 32768;
var $folkertdev$elm_flate$PrefixTable$max_window_size = $folkertdev$elm_flate$PrefixTable$max_distance;
var $folkertdev$elm_flate$PrefixTable$newLargePrefixTable = A2($elm$core$Array$repeat, 65535, _List_Nil);
var $folkertdev$elm_flate$PrefixTable$new = function (nbytes) {
	return (_Utils_cmp(nbytes, $folkertdev$elm_flate$PrefixTable$max_window_size) < 0) ? $folkertdev$elm_flate$PrefixTable$Small($elm$core$Dict$empty) : $folkertdev$elm_flate$PrefixTable$Large($folkertdev$elm_flate$PrefixTable$newLargePrefixTable);
};
var $folkertdev$elm_flate$LZ77$flush = F2(
	function (windowSize, buffer) {
		var codes = A5(
			$folkertdev$elm_flate$LZ77$flushLoop,
			0,
			windowSize,
			buffer,
			$folkertdev$elm_flate$PrefixTable$new(
				$folkertdev$elm_flate$Experimental$ByteArray$length(buffer)),
			$elm$core$Array$empty);
		return codes;
	});
var $folkertdev$elm_flate$Experimental$ByteArray$ByteArray = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$empty = A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, $elm$core$Array$empty, 0, 0);
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var newOffset = _v1.a;
				var a = _v1.b;
				var _v2 = callback(a);
				var decodeB = _v2;
				return A2(decodeB, bites, newOffset);
			});
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $elm$bytes$Bytes$Decode$unsignedInt16 = function (endianness) {
	return _Bytes_read_u16(!endianness);
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp = function (_v0) {
	var remaining = _v0.a;
	var array = _v0.b;
	if (remaining >= 40) {
		return A2(
			$elm$bytes$Bytes$Decode$andThen,
			$elm$core$Basics$identity,
			A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return A6(
							$elm$bytes$Bytes$Decode$map5,
							F5(
								function (f, g, h, i, j) {
									return $elm$bytes$Bytes$Decode$Loop(
										_Utils_Tuple2(
											remaining - 40,
											A2(
												$elm$core$Array$append,
												array,
												$elm$core$Array$fromList(
													_List_fromArray(
														[a, b, c, d, e, f, g, h, i, j])))));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1)));
	} else {
		if (remaining >= 20) {
			return A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 20,
								A2(
									$elm$core$Array$push,
									e,
									A2(
										$elm$core$Array$push,
										d,
										A2(
											$elm$core$Array$push,
											c,
											A2(
												$elm$core$Array$push,
												b,
												A2($elm$core$Array$push, a, array)))))));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1));
		} else {
			if (remaining >= 4) {
				return A2(
					$elm$bytes$Bytes$Decode$map,
					function (a) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 4,
								A2($elm$core$Array$push, a, array)));
					},
					$elm$bytes$Bytes$Decode$unsignedInt32(1));
			} else {
				switch (remaining) {
					case 0:
						return $elm$bytes$Bytes$Decode$succeed(
							$elm$bytes$Bytes$Decode$Done(
								_Utils_Tuple3(0, 0, array)));
					case 1:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(1, _byte << 24, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt8);
					case 2:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(2, _byte << 16, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt16(1));
					default:
						return A3(
							$elm$bytes$Bytes$Decode$map2,
							F2(
								function (bytes, _byte) {
									return $elm$bytes$Bytes$Decode$Done(
										_Utils_Tuple3(3, (bytes << 16) | (_byte << 8), array));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt16(1),
							$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(
				$elm$bytes$Bytes$width(buffer),
				$elm$core$Array$empty),
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp),
		buffer);
	if (_v0.$ === 1) {
		return $folkertdev$elm_flate$Experimental$ByteArray$empty;
	} else {
		var _v1 = _v0.a;
		var finalSize = _v1.a;
		var finalBytes = _v1.b;
		var array = _v1.c;
		return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
	}
};
var $folkertdev$elm_flate$LZ77$encodeWithOptions = F2(
	function (_v0, buffer) {
		var windowSize = _v0.kc;
		return A2(
			$folkertdev$elm_flate$LZ77$flush,
			windowSize,
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytes(buffer));
	});
var $folkertdev$elm_flate$ByteArray$decodeByteArrayHelp = function (_v0) {
	var remaining = _v0.a;
	var accum = _v0.b;
	return (remaining >= 4) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			var byte4 = 255 & (_new >>> 0);
			var byte3 = 255 & ((_new >> 8) >>> 0);
			var byte2 = 255 & ((_new >> 16) >>> 0);
			var byte1 = 255 & ((_new >> 24) >>> 0);
			var newAccum = A2(
				$elm$core$Array$push,
				byte4,
				A2(
					$elm$core$Array$push,
					byte3,
					A2(
						$elm$core$Array$push,
						byte2,
						A2($elm$core$Array$push, byte1, accum))));
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(remaining - 4, newAccum));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($elm$core$Array$push, _new, accum)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(accum)));
};
var $folkertdev$elm_flate$ByteArray$decoder = function (n) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(n, $elm$core$Array$empty),
		$folkertdev$elm_flate$ByteArray$decodeByteArrayHelp);
};
var $folkertdev$elm_flate$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$ByteArray$decoder(
			$elm$bytes$Bytes$width(buffer)),
		buffer);
	if (_v0.$ === 1) {
		return $elm$core$Array$empty;
	} else {
		var value = _v0.a;
		return value;
	}
};
var $folkertdev$elm_flate$Deflate$Internal$compress = F2(
	function (maybeWindowSize, buf) {
		if (maybeWindowSize.$ === 1) {
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Symbol$Literal,
					$folkertdev$elm_flate$ByteArray$fromBytes(buf)));
		} else {
			var windowSize = maybeWindowSize.a;
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Internal$codeToSymbol,
					A2(
						$folkertdev$elm_flate$LZ77$encodeWithOptions,
						{kc: windowSize},
						buf)));
		}
	});
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded = F3(
	function (tag, bitsWritten, encoders) {
		return (bitsWritten >= 16) ? {
			S: bitsWritten - 16,
			V: A2(
				$elm$core$List$cons,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, tag),
				encoders),
			f_: tag >> 16
		} : {S: bitsWritten, V: encoders, f_: tag};
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBits = F3(
	function (bitwidth, bits, state) {
		return A3($folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded, state.f_ | (bits << state.S), state.S + bitwidth, state.V);
	});
var $folkertdev$elm_flate$Huffman$encode = F2(
	function (symbol, _v0) {
		var table = _v0;
		var _v1 = A2($elm$core$Array$get, symbol, table);
		if (_v1.$ === 1) {
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 0, 0);
		} else {
			var width = _v1.a.hW;
			var bits = _v1.a.aG;
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, width, bits);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$extraLength = function (symbol) {
	if (symbol.$ === 2) {
		var length = symbol.a;
		return (((length >= 3) && (length <= 10)) || (length === 258)) ? $elm$core$Maybe$Nothing : (((length >= 11) && (length <= 18)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				1,
				A2($elm$core$Basics$modBy, 2, length - 11))) : (((length >= 19) && (length <= 34)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				2,
				A2($elm$core$Basics$modBy, 4, length - 19))) : (((length >= 35) && (length <= 66)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				3,
				A2($elm$core$Basics$modBy, 8, length - 35))) : (((length >= 67) && (length <= 130)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				4,
				A2($elm$core$Basics$modBy, 16, length - 67))) : (((length >= 131) && (length <= 257)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				5,
				A2($elm$core$Basics$modBy, 32, length - 131))) : $elm$core$Maybe$Nothing)))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$encode = F3(
	function (symbol, htrees, bitWriter) {
		var maybeExtra = function () {
			var _v2 = $folkertdev$elm_flate$Deflate$Symbol$extraLength(symbol);
			if (_v2.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var _v3 = _v2.a;
				var bits = _v3.a;
				var extra = _v3.b;
				return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra);
			}
		}();
		var maybeDistance = function () {
			var _v0 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
			if (_v0.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var _v1 = _v0.a;
				var code_ = _v1.a;
				var bits = _v1.b;
				var extra = _v1.c;
				return A2(
					$elm$core$Basics$composeR,
					A2($folkertdev$elm_flate$Huffman$encode, code_, htrees.aJ),
					(bits > 0) ? A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra) : $elm$core$Basics$identity);
			}
		}();
		return maybeDistance(
			maybeExtra(
				A3(
					$folkertdev$elm_flate$Huffman$encode,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					htrees.aQ,
					bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order = _List_fromArray(
	[16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var $folkertdev$elm_flate$Deflate$Symbol$calculateCodes = function (runLengths) {
	var loop2 = F3(
		function (r, c, codes) {
			loop2:
			while (true) {
				if (c >= 3) {
					var n = A2($elm$core$Basics$min, 6, c);
					var $temp$r = r,
						$temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(16, 2, n - 3),
						codes);
					r = $temp$r;
					c = $temp$c;
					codes = $temp$codes;
					continue loop2;
				} else {
					return A2(
						$elm$core$Array$append,
						codes,
						A2(
							$elm$core$Array$repeat,
							c,
							_Utils_Tuple3(r.hR, 0, 0)));
				}
			}
		});
	var loop1 = F2(
		function (c, codes) {
			loop1:
			while (true) {
				if (c >= 11) {
					var n = A2($elm$core$Basics$min, 138, c);
					var $temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(18, 7, n - 11),
						codes);
					c = $temp$c;
					codes = $temp$codes;
					continue loop1;
				} else {
					if (c >= 3) {
						return A2(
							$elm$core$Array$push,
							_Utils_Tuple3(17, 3, c - 3),
							codes);
					} else {
						return A2(
							$elm$core$Array$append,
							codes,
							A2(
								$elm$core$Array$repeat,
								c,
								_Utils_Tuple3(0, 0, 0)));
					}
				}
			}
		});
	var folder = F2(
		function (r, codes) {
			return (!r.hR) ? A2(loop1, r.gv, codes) : A3(
				loop2,
				r,
				r.gv - 1,
				A2(
					$elm$core$Array$push,
					_Utils_Tuple3(r.hR, 0, 0),
					codes));
		});
	return A3($elm$core$Array$foldl, folder, $elm$core$Array$empty, runLengths);
};
var $folkertdev$elm_flate$Huffman$getWidth = function (_v0) {
	var width = _v0.hW;
	return width;
};
var $folkertdev$elm_flate$Huffman$lookup = F2(
	function (symbol, _v0) {
		var array = _v0;
		return A2($elm$core$Array$get, symbol, array);
	});
var $folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths = F2(
	function (lengths, accum) {
		calculateRunLengths:
		while (true) {
			if (!lengths.b) {
				return A3($elm$core$List$foldr, $elm$core$Array$push, $elm$core$Array$empty, accum);
			} else {
				var _v1 = lengths.a;
				var e = _v1.a;
				var size = _v1.b;
				var rest = lengths.b;
				var list = A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					A2(
						$elm$core$List$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$folkertdev$elm_flate$Huffman$getWidth,
									A2($folkertdev$elm_flate$Huffman$lookup, x, e)));
						},
						A2($elm$core$List$range, 0, size - 1)));
				var folder = F2(
					function (_v3, runLengths) {
						var i = _v3.a;
						var c = _v3.b;
						if (!runLengths.b) {
							return A2(
								$elm$core$List$cons,
								{gv: 1, hR: c},
								runLengths);
						} else {
							var last = runLengths.a;
							var remaining = runLengths.b;
							return _Utils_eq(last.hR, c) ? A2(
								$elm$core$List$cons,
								{gv: last.gv + 1, hR: last.hR},
								remaining) : A2(
								$elm$core$List$cons,
								{gv: 1, hR: c},
								runLengths);
						}
					});
				var $temp$lengths = rest,
					$temp$accum = A3($elm$core$List$foldl, folder, accum, list);
				lengths = $temp$lengths;
				accum = $temp$accum;
				continue calculateRunLengths;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes = F3(
	function (literalCodeCount, distanceCodeCount, trees) {
		var runLengths = A2(
			$folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths,
			_List_fromArray(
				[
					_Utils_Tuple2(trees.aQ, literalCodeCount),
					_Utils_Tuple2(trees.aJ, distanceCodeCount)
				]),
			_List_Nil);
		return $folkertdev$elm_flate$Deflate$Symbol$calculateCodes(runLengths);
	});
var $folkertdev$elm_flate$Deflate$Symbol$positionLoop = F3(
	function (predicate, i, elements) {
		positionLoop:
		while (true) {
			if (!elements.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = elements.a;
				var xs = elements.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(i);
				} else {
					var $temp$predicate = predicate,
						$temp$i = i + 1,
						$temp$elements = xs;
					predicate = $temp$predicate;
					i = $temp$i;
					elements = $temp$elements;
					continue positionLoop;
				}
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$position = F2(
	function (predicate, elements) {
		return A3($folkertdev$elm_flate$Deflate$Symbol$positionLoop, predicate, 0, elements);
	});
var $folkertdev$elm_flate$Huffman$positionFromTheEnd = F2(
	function (predicated, array) {
		var folder = F2(
			function (element, _v1) {
				var index = _v1.a;
				var accum = _v1.b;
				if (!accum.$) {
					return _Utils_Tuple2(index, accum);
				} else {
					return predicated(element) ? _Utils_Tuple2(
						index,
						$elm$core$Maybe$Just(index)) : _Utils_Tuple2(index - 1, $elm$core$Maybe$Nothing);
				}
			});
		var finalIndex = $elm$core$Array$length(array) - 1;
		return A2(
			$elm$core$Maybe$map,
			function (v) {
				return finalIndex - v;
			},
			A3(
				$elm$core$Array$foldr,
				folder,
				_Utils_Tuple2(finalIndex, $elm$core$Maybe$Nothing),
				array).b);
	});
var $folkertdev$elm_flate$Huffman$usedMaxSymbol = function (_v0) {
	var array = _v0;
	return A2(
		$elm$core$Maybe$map,
		function (trailingZeros) {
			return ($elm$core$Array$length(array) - 1) - trailingZeros;
		},
		A2(
			$folkertdev$elm_flate$Huffman$positionFromTheEnd,
			function (_v1) {
				var value = _v1;
				return value.hW > 0;
			},
			array));
};
var $folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec = F2(
	function (trees, bitWriter) {
		var literal_code_count = A2(
			$elm$core$Basics$max,
			257,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.aQ)) + 1);
		var distance_code_count = A2(
			$elm$core$Basics$max,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.aJ)) + 1);
		var codes = A3(
			$folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes,
			literal_code_count,
			distance_code_count,
			{aJ: trees.aJ, aQ: trees.aQ});
		var codeCounts = A3(
			$elm$core$Array$foldl,
			function (_v2) {
				var i = _v2.a;
				return A2(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					i,
					function (v) {
						return v + 1;
					});
			},
			A2($elm$core$Array$repeat, 19, 0),
			codes);
		var bitWidthEncoder = A2($folkertdev$elm_flate$Huffman$fromFrequencies, codeCounts, 7);
		var bitwidthCodeCount = A2(
			$elm$core$Basics$max,
			4,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function (trailingZeros) {
						return 19 - trailingZeros;
					},
					A2(
						$folkertdev$elm_flate$Deflate$Symbol$position,
						function (i) {
							var _v1 = A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder);
							if (_v1.$ === 1) {
								return false;
							} else {
								var value = _v1.a;
								return $folkertdev$elm_flate$Huffman$getWidth(value) > 0;
							}
						},
						$elm$core$List$reverse($folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order)))));
		var v1 = function (writer) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (i, current) {
						var width = _Utils_eq(
							A2($elm$core$Array$get, i, codeCounts),
							$elm$core$Maybe$Just(0)) ? 0 : A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								$folkertdev$elm_flate$Huffman$getWidth,
								A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder)));
						return A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 3, width, current);
					}),
				writer,
				A2($elm$core$List$take, bitwidthCodeCount, $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order));
		};
		var v2 = function (writer) {
			return A3(
				$elm$core$Array$foldl,
				F2(
					function (_v0, current) {
						var code_ = _v0.a;
						var bits = _v0.b;
						var extra = _v0.c;
						return (bits > 0) ? A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							bits,
							extra,
							A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current)) : A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current);
					}),
				writer,
				codes);
		};
		return v2(
			v1(
				A3(
					$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
					4,
					bitwidthCodeCount - 4,
					A3(
						$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
						5,
						distance_code_count - 1,
						A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 5, literal_code_count - 257, bitWriter)))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		var huffmanTree = $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec(compressed);
		var huffmanTreeWriter = A2($folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec, huffmanTree, bitWriter);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTree, first);
				}),
			huffmanTreeWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBit = function (b) {
	if (!b) {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 0);
	} else {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 1);
	}
};
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				2,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $folkertdev$elm_flate$Deflate$BitWriter$flushLoop = F3(
	function (tag, bitsWritten, encoders) {
		flushLoop:
		while (true) {
			if (bitsWritten > 0) {
				var $temp$tag = tag >> 8,
					$temp$bitsWritten = A2($elm$core$Basics$max, 0, bitsWritten - 8),
					$temp$encoders = A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(tag),
					encoders);
				tag = $temp$tag;
				bitsWritten = $temp$bitsWritten;
				encoders = $temp$encoders;
				continue flushLoop;
			} else {
				return {S: bitsWritten, V: encoders, f_: tag};
			}
		}
	});
var $folkertdev$elm_flate$Deflate$BitWriter$flush = function (state) {
	return A3($folkertdev$elm_flate$Deflate$BitWriter$flushLoop, state.f_, state.S, state.V);
};
var $folkertdev$elm_flate$Deflate$BitWriter$run = function (state) {
	return $elm$core$List$reverse(state.V);
};
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamic = F2(
	function (windowSize, buffer) {
		var encodedChunks = A2(
			$elm$core$List$map,
			$folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock(windowSize),
			A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer));
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return chunk(first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							encodedChunks)))));
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size = 65535;
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						u: _List_Nil,
						q: 0,
						t: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $folkertdev$elm_flate$ByteArray$fasterEncodeFolderR = F2(
	function (_byte, _v0) {
		var bytesOnAccum = _v0.a;
		var accum = _v0.b;
		var encoders = _v0.c;
		switch (bytesOnAccum) {
			case 0:
				var value = 255 & _byte;
				return _Utils_Tuple3(1, value, encoders);
			case 1:
				var value = accum | ((255 & _byte) << 8);
				return _Utils_Tuple3(2, value, encoders);
			case 2:
				var value = accum | ((255 & _byte) << 16);
				return _Utils_Tuple3(3, value, encoders);
			default:
				var value = accum | ((255 & _byte) << 24);
				return _Utils_Tuple3(
					0,
					0,
					A2(
						$elm$core$List$cons,
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, value),
						encoders));
		}
	});
var $folkertdev$elm_flate$ByteArray$fasterEncodeR = function (_v0) {
	var bytesOnAccum = _v0.a;
	var accum = _v0.b;
	var otherEncoders = _v0.c;
	var encoders = function () {
		switch (bytesOnAccum) {
			case 0:
				return otherEncoders;
			case 1:
				return A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(accum),
					otherEncoders);
			case 2:
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, accum),
					otherEncoders);
			default:
				var otherBytes = accum >> 8;
				var firstByte = 255 & accum;
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, otherBytes),
					A2(
						$elm$core$List$cons,
						$elm$bytes$Bytes$Encode$unsignedInt8(firstByte),
						otherEncoders));
		}
	}();
	return encoders;
};
var $folkertdev$elm_flate$ByteArray$toBytes = function (array) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$ByteArray$fasterEncodeR(
				A3(
					$elm$core$Array$foldr,
					$folkertdev$elm_flate$ByteArray$fasterEncodeFolderR,
					_Utils_Tuple3(0, 0, _List_Nil),
					array))));
};
var $folkertdev$elm_flate$Deflate$BitWriter$writeEncoder = F2(
	function (encoder, state) {
		return {
			S: state.S,
			V: A2($elm$core$List$cons, encoder, state.V),
			f_: state.f_
		};
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeRawBlock = F2(
	function (_v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		var byteArray = $folkertdev$elm_flate$ByteArray$fromBytes(buffer);
		var size = A2(
			$elm$core$Basics$min,
			$elm$core$Array$length(byteArray),
			$folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size);
		var sliced = A3($elm$core$Array$slice, 0, size, byteArray);
		return A2(
			$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
			$elm$bytes$Bytes$Encode$bytes(
				$folkertdev$elm_flate$ByteArray$toBytes(sliced)),
			A2(
				$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, ~size),
				A2(
					$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, size),
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							2,
							0,
							A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter))))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeRaw = function (buffer) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$Deflate$BitWriter$run(
				A3(
					$elm$core$List$foldl,
					F2(
						function (chunk, first) {
							return A2($folkertdev$elm_flate$Deflate$Internal$encodeRawBlock, chunk, first);
						}),
					$folkertdev$elm_flate$Deflate$BitWriter$empty,
					A2(
						$folkertdev$elm_flate$Deflate$Internal$chunks,
						A2($elm$core$Basics$min, $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size, $folkertdev$elm_flate$Deflate$Internal$default_block_size),
						buffer)))));
};
var $folkertdev$elm_flate$Huffman$fromList = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$core$Array$fromList),
	$elm$core$List$map($folkertdev$elm_flate$Huffman$codeFromRecord));
var $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree = {
	aJ: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{aG: 0, hW: 5},
				{aG: 16, hW: 5},
				{aG: 8, hW: 5},
				{aG: 24, hW: 5},
				{aG: 4, hW: 5},
				{aG: 20, hW: 5},
				{aG: 12, hW: 5},
				{aG: 28, hW: 5},
				{aG: 2, hW: 5},
				{aG: 18, hW: 5},
				{aG: 10, hW: 5},
				{aG: 26, hW: 5},
				{aG: 6, hW: 5},
				{aG: 22, hW: 5},
				{aG: 14, hW: 5},
				{aG: 30, hW: 5},
				{aG: 1, hW: 5},
				{aG: 17, hW: 5},
				{aG: 9, hW: 5},
				{aG: 25, hW: 5},
				{aG: 5, hW: 5},
				{aG: 21, hW: 5},
				{aG: 13, hW: 5},
				{aG: 29, hW: 5},
				{aG: 3, hW: 5},
				{aG: 19, hW: 5},
				{aG: 11, hW: 5},
				{aG: 27, hW: 5},
				{aG: 7, hW: 5},
				{aG: 23, hW: 5}
			])),
	aQ: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{aG: 12, hW: 8},
				{aG: 140, hW: 8},
				{aG: 76, hW: 8},
				{aG: 204, hW: 8},
				{aG: 44, hW: 8},
				{aG: 172, hW: 8},
				{aG: 108, hW: 8},
				{aG: 236, hW: 8},
				{aG: 28, hW: 8},
				{aG: 156, hW: 8},
				{aG: 92, hW: 8},
				{aG: 220, hW: 8},
				{aG: 60, hW: 8},
				{aG: 188, hW: 8},
				{aG: 124, hW: 8},
				{aG: 252, hW: 8},
				{aG: 2, hW: 8},
				{aG: 130, hW: 8},
				{aG: 66, hW: 8},
				{aG: 194, hW: 8},
				{aG: 34, hW: 8},
				{aG: 162, hW: 8},
				{aG: 98, hW: 8},
				{aG: 226, hW: 8},
				{aG: 18, hW: 8},
				{aG: 146, hW: 8},
				{aG: 82, hW: 8},
				{aG: 210, hW: 8},
				{aG: 50, hW: 8},
				{aG: 178, hW: 8},
				{aG: 114, hW: 8},
				{aG: 242, hW: 8},
				{aG: 10, hW: 8},
				{aG: 138, hW: 8},
				{aG: 74, hW: 8},
				{aG: 202, hW: 8},
				{aG: 42, hW: 8},
				{aG: 170, hW: 8},
				{aG: 106, hW: 8},
				{aG: 234, hW: 8},
				{aG: 26, hW: 8},
				{aG: 154, hW: 8},
				{aG: 90, hW: 8},
				{aG: 218, hW: 8},
				{aG: 58, hW: 8},
				{aG: 186, hW: 8},
				{aG: 122, hW: 8},
				{aG: 250, hW: 8},
				{aG: 6, hW: 8},
				{aG: 134, hW: 8},
				{aG: 70, hW: 8},
				{aG: 198, hW: 8},
				{aG: 38, hW: 8},
				{aG: 166, hW: 8},
				{aG: 102, hW: 8},
				{aG: 230, hW: 8},
				{aG: 22, hW: 8},
				{aG: 150, hW: 8},
				{aG: 86, hW: 8},
				{aG: 214, hW: 8},
				{aG: 54, hW: 8},
				{aG: 182, hW: 8},
				{aG: 118, hW: 8},
				{aG: 246, hW: 8},
				{aG: 14, hW: 8},
				{aG: 142, hW: 8},
				{aG: 78, hW: 8},
				{aG: 206, hW: 8},
				{aG: 46, hW: 8},
				{aG: 174, hW: 8},
				{aG: 110, hW: 8},
				{aG: 238, hW: 8},
				{aG: 30, hW: 8},
				{aG: 158, hW: 8},
				{aG: 94, hW: 8},
				{aG: 222, hW: 8},
				{aG: 62, hW: 8},
				{aG: 190, hW: 8},
				{aG: 126, hW: 8},
				{aG: 254, hW: 8},
				{aG: 1, hW: 8},
				{aG: 129, hW: 8},
				{aG: 65, hW: 8},
				{aG: 193, hW: 8},
				{aG: 33, hW: 8},
				{aG: 161, hW: 8},
				{aG: 97, hW: 8},
				{aG: 225, hW: 8},
				{aG: 17, hW: 8},
				{aG: 145, hW: 8},
				{aG: 81, hW: 8},
				{aG: 209, hW: 8},
				{aG: 49, hW: 8},
				{aG: 177, hW: 8},
				{aG: 113, hW: 8},
				{aG: 241, hW: 8},
				{aG: 9, hW: 8},
				{aG: 137, hW: 8},
				{aG: 73, hW: 8},
				{aG: 201, hW: 8},
				{aG: 41, hW: 8},
				{aG: 169, hW: 8},
				{aG: 105, hW: 8},
				{aG: 233, hW: 8},
				{aG: 25, hW: 8},
				{aG: 153, hW: 8},
				{aG: 89, hW: 8},
				{aG: 217, hW: 8},
				{aG: 57, hW: 8},
				{aG: 185, hW: 8},
				{aG: 121, hW: 8},
				{aG: 249, hW: 8},
				{aG: 5, hW: 8},
				{aG: 133, hW: 8},
				{aG: 69, hW: 8},
				{aG: 197, hW: 8},
				{aG: 37, hW: 8},
				{aG: 165, hW: 8},
				{aG: 101, hW: 8},
				{aG: 229, hW: 8},
				{aG: 21, hW: 8},
				{aG: 149, hW: 8},
				{aG: 85, hW: 8},
				{aG: 213, hW: 8},
				{aG: 53, hW: 8},
				{aG: 181, hW: 8},
				{aG: 117, hW: 8},
				{aG: 245, hW: 8},
				{aG: 13, hW: 8},
				{aG: 141, hW: 8},
				{aG: 77, hW: 8},
				{aG: 205, hW: 8},
				{aG: 45, hW: 8},
				{aG: 173, hW: 8},
				{aG: 109, hW: 8},
				{aG: 237, hW: 8},
				{aG: 29, hW: 8},
				{aG: 157, hW: 8},
				{aG: 93, hW: 8},
				{aG: 221, hW: 8},
				{aG: 61, hW: 8},
				{aG: 189, hW: 8},
				{aG: 125, hW: 8},
				{aG: 253, hW: 8},
				{aG: 19, hW: 9},
				{aG: 275, hW: 9},
				{aG: 147, hW: 9},
				{aG: 403, hW: 9},
				{aG: 83, hW: 9},
				{aG: 339, hW: 9},
				{aG: 211, hW: 9},
				{aG: 467, hW: 9},
				{aG: 51, hW: 9},
				{aG: 307, hW: 9},
				{aG: 179, hW: 9},
				{aG: 435, hW: 9},
				{aG: 115, hW: 9},
				{aG: 371, hW: 9},
				{aG: 243, hW: 9},
				{aG: 499, hW: 9},
				{aG: 11, hW: 9},
				{aG: 267, hW: 9},
				{aG: 139, hW: 9},
				{aG: 395, hW: 9},
				{aG: 75, hW: 9},
				{aG: 331, hW: 9},
				{aG: 203, hW: 9},
				{aG: 459, hW: 9},
				{aG: 43, hW: 9},
				{aG: 299, hW: 9},
				{aG: 171, hW: 9},
				{aG: 427, hW: 9},
				{aG: 107, hW: 9},
				{aG: 363, hW: 9},
				{aG: 235, hW: 9},
				{aG: 491, hW: 9},
				{aG: 27, hW: 9},
				{aG: 283, hW: 9},
				{aG: 155, hW: 9},
				{aG: 411, hW: 9},
				{aG: 91, hW: 9},
				{aG: 347, hW: 9},
				{aG: 219, hW: 9},
				{aG: 475, hW: 9},
				{aG: 59, hW: 9},
				{aG: 315, hW: 9},
				{aG: 187, hW: 9},
				{aG: 443, hW: 9},
				{aG: 123, hW: 9},
				{aG: 379, hW: 9},
				{aG: 251, hW: 9},
				{aG: 507, hW: 9},
				{aG: 7, hW: 9},
				{aG: 263, hW: 9},
				{aG: 135, hW: 9},
				{aG: 391, hW: 9},
				{aG: 71, hW: 9},
				{aG: 327, hW: 9},
				{aG: 199, hW: 9},
				{aG: 455, hW: 9},
				{aG: 39, hW: 9},
				{aG: 295, hW: 9},
				{aG: 167, hW: 9},
				{aG: 423, hW: 9},
				{aG: 103, hW: 9},
				{aG: 359, hW: 9},
				{aG: 231, hW: 9},
				{aG: 487, hW: 9},
				{aG: 23, hW: 9},
				{aG: 279, hW: 9},
				{aG: 151, hW: 9},
				{aG: 407, hW: 9},
				{aG: 87, hW: 9},
				{aG: 343, hW: 9},
				{aG: 215, hW: 9},
				{aG: 471, hW: 9},
				{aG: 55, hW: 9},
				{aG: 311, hW: 9},
				{aG: 183, hW: 9},
				{aG: 439, hW: 9},
				{aG: 119, hW: 9},
				{aG: 375, hW: 9},
				{aG: 247, hW: 9},
				{aG: 503, hW: 9},
				{aG: 15, hW: 9},
				{aG: 271, hW: 9},
				{aG: 143, hW: 9},
				{aG: 399, hW: 9},
				{aG: 79, hW: 9},
				{aG: 335, hW: 9},
				{aG: 207, hW: 9},
				{aG: 463, hW: 9},
				{aG: 47, hW: 9},
				{aG: 303, hW: 9},
				{aG: 175, hW: 9},
				{aG: 431, hW: 9},
				{aG: 111, hW: 9},
				{aG: 367, hW: 9},
				{aG: 239, hW: 9},
				{aG: 495, hW: 9},
				{aG: 31, hW: 9},
				{aG: 287, hW: 9},
				{aG: 159, hW: 9},
				{aG: 415, hW: 9},
				{aG: 95, hW: 9},
				{aG: 351, hW: 9},
				{aG: 223, hW: 9},
				{aG: 479, hW: 9},
				{aG: 63, hW: 9},
				{aG: 319, hW: 9},
				{aG: 191, hW: 9},
				{aG: 447, hW: 9},
				{aG: 127, hW: 9},
				{aG: 383, hW: 9},
				{aG: 255, hW: 9},
				{aG: 511, hW: 9},
				{aG: 0, hW: 7},
				{aG: 64, hW: 7},
				{aG: 32, hW: 7},
				{aG: 96, hW: 7},
				{aG: 16, hW: 7},
				{aG: 80, hW: 7},
				{aG: 48, hW: 7},
				{aG: 112, hW: 7},
				{aG: 8, hW: 7},
				{aG: 72, hW: 7},
				{aG: 40, hW: 7},
				{aG: 104, hW: 7},
				{aG: 24, hW: 7},
				{aG: 88, hW: 7},
				{aG: 56, hW: 7},
				{aG: 120, hW: 7},
				{aG: 4, hW: 7},
				{aG: 68, hW: 7},
				{aG: 36, hW: 7},
				{aG: 100, hW: 7},
				{aG: 20, hW: 7},
				{aG: 84, hW: 7},
				{aG: 52, hW: 7},
				{aG: 116, hW: 7},
				{aG: 3, hW: 8},
				{aG: 131, hW: 8},
				{aG: 67, hW: 8},
				{aG: 195, hW: 8},
				{aG: 35, hW: 8},
				{aG: 163, hW: 8},
				{aG: 99, hW: 8},
				{aG: 227, hW: 8}
			]))
};
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var huffmanTrees = $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree;
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTrees, first);
				}),
			bitWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				1,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStatic = F2(
	function (windowSize, buffer) {
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return A3($folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock, windowSize, chunk, first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer))))));
	});
var $folkertdev$elm_flate$Flate$deflateWithOptions = F2(
	function (encoding, buffer) {
		switch (encoding.$) {
			case 0:
				return $folkertdev$elm_flate$Deflate$Internal$encodeRaw(buffer);
			case 2:
				if (!encoding.a.$) {
					var _v1 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeStatic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeStatic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
			default:
				if (!encoding.a.$) {
					var _v2 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeDynamic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeDynamic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
		}
	});
var $folkertdev$elm_flate$Flate$deflateGZipWithOptions = F2(
	function (encoding, buffer) {
		var encodedTrailer = _List_fromArray(
			[
				A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				0,
				$folkertdev$elm_flate$Checksum$Crc32$crc32(buffer)),
				A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				0,
				A2(
					$elm$core$Basics$modBy,
					4294967296,
					$elm$bytes$Bytes$width(buffer)))
			]);
		var encodedHeader = _List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(31),
				$elm$bytes$Bytes$Encode$unsignedInt8(139),
				$elm$bytes$Bytes$Encode$unsignedInt8(8),
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 0, 0),
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$elm$bytes$Bytes$Encode$unsignedInt8(255)
			]);
		var data = A2($folkertdev$elm_flate$Flate$deflateWithOptions, encoding, buffer);
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_Utils_ap(
					encodedHeader,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$bytes$Bytes$Encode$bytes(data)
							]),
						encodedTrailer))));
	});
var $folkertdev$elm_flate$LZ77$max_distance = 32768;
var $folkertdev$elm_flate$LZ77$maxWindowSize = $folkertdev$elm_flate$LZ77$max_distance;
var $folkertdev$elm_flate$Flate$deflateGZip = $folkertdev$elm_flate$Flate$deflateGZipWithOptions(
	$folkertdev$elm_flate$Flate$Dynamic(
		$folkertdev$elm_flate$Flate$WithWindowSize($folkertdev$elm_flate$LZ77$maxWindowSize)));
var $danfishgold$base64_bytes$Decode$lowest6BitsMask = 63;
var $elm$core$Char$fromCode = _Char_fromCode;
var $danfishgold$base64_bytes$Decode$unsafeToChar = function (n) {
	if (n <= 25) {
		return $elm$core$Char$fromCode(65 + n);
	} else {
		if (n <= 51) {
			return $elm$core$Char$fromCode(97 + (n - 26));
		} else {
			if (n <= 61) {
				return $elm$core$Char$fromCode(48 + (n - 52));
			} else {
				switch (n) {
					case 62:
						return '+';
					case 63:
						return '/';
					default:
						return '\u0000';
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$bitsToChars = F2(
	function (bits, missing) {
		var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits >>> 18);
		switch (missing) {
			case 0:
				return A2(
					$elm$core$String$cons,
					p,
					A2(
						$elm$core$String$cons,
						q,
						A2(
							$elm$core$String$cons,
							r,
							$elm$core$String$fromChar(s))));
			case 1:
				return A2(
					$elm$core$String$cons,
					p,
					A2(
						$elm$core$String$cons,
						q,
						A2($elm$core$String$cons, r, '=')));
			case 2:
				return A2(
					$elm$core$String$cons,
					p,
					A2($elm$core$String$cons, q, '=='));
			default:
				return '';
		}
	});
var $danfishgold$base64_bytes$Decode$bitsToCharSpecialized = F4(
	function (bits1, bits2, bits3, accum) {
		var z = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var y = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var x = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 >>> 18);
		var w = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 >>> 18);
		var d = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var c = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var b = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var a = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 >>> 18);
		return A2(
			$elm$core$String$cons,
			x,
			A2(
				$elm$core$String$cons,
				y,
				A2(
					$elm$core$String$cons,
					z,
					A2(
						$elm$core$String$cons,
						w,
						A2(
							$elm$core$String$cons,
							a,
							A2(
								$elm$core$String$cons,
								b,
								A2(
									$elm$core$String$cons,
									c,
									A2(
										$elm$core$String$cons,
										d,
										A2(
											$elm$core$String$cons,
											p,
											A2(
												$elm$core$String$cons,
												q,
												A2(
													$elm$core$String$cons,
													r,
													A2($elm$core$String$cons, s, accum))))))))))));
	});
var $danfishgold$base64_bytes$Decode$decode18Help = F5(
	function (a, b, c, d, e) {
		var combined6 = ((255 & d) << 16) | e;
		var combined5 = d >>> 8;
		var combined4 = 16777215 & c;
		var combined3 = ((65535 & b) << 8) | (c >>> 24);
		var combined2 = ((255 & a) << 16) | (b >>> 16);
		var combined1 = a >>> 8;
		return A4(
			$danfishgold$base64_bytes$Decode$bitsToCharSpecialized,
			combined3,
			combined2,
			combined1,
			A4($danfishgold$base64_bytes$Decode$bitsToCharSpecialized, combined6, combined5, combined4, ''));
	});
var $danfishgold$base64_bytes$Decode$u16BE = $elm$bytes$Bytes$Decode$unsignedInt16(1);
var $danfishgold$base64_bytes$Decode$u32BE = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $danfishgold$base64_bytes$Decode$decode18Bytes = A6($elm$bytes$Bytes$Decode$map5, $danfishgold$base64_bytes$Decode$decode18Help, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u16BE);
var $elm$bytes$Bytes$Decode$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		return F2(
			function (bites, offset) {
				var _v3 = A2(decodeA, bites, offset);
				var aOffset = _v3.a;
				var a = _v3.b;
				var _v4 = A2(decodeB, bites, aOffset);
				var bOffset = _v4.a;
				var b = _v4.b;
				var _v5 = A2(decodeC, bites, bOffset);
				var cOffset = _v5.a;
				var c = _v5.b;
				return _Utils_Tuple2(
					cOffset,
					A3(func, a, b, c));
			});
	});
var $danfishgold$base64_bytes$Decode$loopHelp = function (_v0) {
	var remaining = _v0.dR;
	var string = _v0.ef;
	if (remaining >= 18) {
		return A2(
			$elm$bytes$Bytes$Decode$map,
			function (result) {
				return $elm$bytes$Bytes$Decode$Loop(
					{
						dR: remaining - 18,
						ef: _Utils_ap(string, result)
					});
			},
			$danfishgold$base64_bytes$Decode$decode18Bytes);
	} else {
		if (remaining >= 3) {
			var helper = F3(
				function (a, b, c) {
					var combined = ((a << 16) | (b << 8)) | c;
					return $elm$bytes$Bytes$Decode$Loop(
						{
							dR: remaining - 3,
							ef: _Utils_ap(
								string,
								A2($danfishgold$base64_bytes$Decode$bitsToChars, combined, 0))
						});
				});
			return A4($elm$bytes$Bytes$Decode$map3, helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
		} else {
			if (!remaining) {
				return $elm$bytes$Bytes$Decode$succeed(
					$elm$bytes$Bytes$Decode$Done(string));
			} else {
				if (remaining === 2) {
					var helper = F2(
						function (a, b) {
							var combined = (a << 16) | (b << 8);
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									A2($danfishgold$base64_bytes$Decode$bitsToChars, combined, 1)));
						});
					return A3($elm$bytes$Bytes$Decode$map2, helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
				} else {
					return A2(
						$elm$bytes$Bytes$Decode$map,
						function (a) {
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									A2($danfishgold$base64_bytes$Decode$bitsToChars, a << 16, 2)));
						},
						$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$decoder = function (width) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		{dR: width, ef: ''},
		$danfishgold$base64_bytes$Decode$loopHelp);
};
var $danfishgold$base64_bytes$Decode$fromBytes = function (bytes) {
	return A2(
		$elm$bytes$Bytes$Decode$decode,
		$danfishgold$base64_bytes$Decode$decoder(
			$elm$bytes$Bytes$width(bytes)),
		bytes);
};
var $danfishgold$base64_bytes$Base64$fromBytes = $danfishgold$base64_bytes$Decode$fromBytes;
var $author$project$Utils$Base64Url$fromBytes = function (bytes) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$String$replace, '/', '_'),
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$String$replace, '+', '-'),
			$danfishgold$base64_bytes$Base64$fromBytes(bytes)));
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$base64QueryParameter = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$string,
			key,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Utils$Base64Url$fromBytes(
					$folkertdev$elm_flate$Flate$deflateGZip(
						$elm$bytes$Bytes$Encode$encode(
							$elm$bytes$Bytes$Encode$string(
								A2($elm$json$Json$Encode$encode, 0, value)))))));
	});
var $author$project$Page$QuoteBuilderV3$Quote$Total = F3(
	function (subscription, purchase, subscriptionOnly) {
		return {jC: purchase, jY: subscription, ei: subscriptionOnly};
	});
var $author$project$Page$QuoteBuilderV3$Quote$applyDiscount = F2(
	function (discount, initialAmount) {
		var _v0 = discount.aH;
		if (!_v0.$) {
			var subscription = _v0.a.jY;
			var purchase = _v0.a.jC;
			var value = F2(
				function (percentage, price) {
					return $elm$core$Basics$round((percentage / 100) * price);
				});
			var subscriptionAmount = A2(value, subscription, initialAmount.jY + initialAmount.ei);
			var purchaseAmount = A2(value, purchase, initialAmount.jC);
			return A3($author$project$Page$QuoteBuilderV3$Quote$Total, initialAmount.jY - subscriptionAmount, initialAmount.jC - purchaseAmount, 0);
		} else {
			var subscription = _v0.a.jY;
			var purchase = _v0.a.jC;
			return A3($author$project$Page$QuoteBuilderV3$Quote$Total, initialAmount.jY - subscription, initialAmount.jC - purchase, 0);
		}
	});
var $author$project$Page$QuoteBuilderV3$Quote$compareDiscount = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a.aH, b.aH);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				return A2($elm$core$Basics$compare, a.jg, b.jg);
			} else {
				return 2;
			}
		} else {
			if (!_v0.b.$) {
				return 0;
			} else {
				return A2($elm$core$Basics$compare, a.jg, b.jg);
			}
		}
	});
var $author$project$Page$QuoteBuilderV3$Quote$addPriceToTotal = F2(
	function (price, total) {
		if (!price.$) {
			var subscription = price.a.jY;
			var purchase = price.a.jC;
			return _Utils_update(
				total,
				{jC: total.jC + purchase, jY: total.jY + subscription});
		} else {
			var subscription = price.a.jY;
			return _Utils_update(
				total,
				{ei: total.ei + subscription});
		}
	});
var $author$project$Page$QuoteBuilderV3$Quote$en = {
	Q: 'Additional Brain',
	R: 'Advanced Climate Sensor Upgrade',
	T: 'Chief grower',
	U: 'Disease Prevention',
	W: 'Fan Ventilation',
	X: 'Heating',
	Y: 'Helper',
	Z: 'Humidity Conservation',
	_: 'Irrigation',
	aa: 'Mobile Internet Access',
	aS: 'None',
	ad: function (currency) {
		if (!currency) {
			return 'Get Orisha in the greenhouse';
		} else {
			return 'Get Orisha in the tunnel';
		}
	},
	dt: 'Outdoor Climate Sensor',
	ah: 'Rain Protection',
	ai: 'Range Extension Kit',
	aj: 'Ridge Ventilation',
	ak: 'Side Ventilation',
	ed: 'Solar Sensor',
	eq: 'Thermal Screen',
	am: 'Wind Protection'
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Page$QuoteBuilderV3$Quote$fr = {
	Q: 'Cerveau additionnel',
	R: 'Option capteur de climat avancé',
	T: 'Chef de culture',
	U: 'Prévention des maladies',
	W: 'Ventilation par ventilateurs',
	X: 'Chauffage',
	Y: 'Assistant',
	Z: 'Conservation de l\'humidité',
	_: 'Irrigation',
	aa: 'Accès internet mobile',
	aS: 'Aucun',
	ad: $elm$core$Basics$always('Orisha dans la serre'),
	dt: 'Capteur de climat extérieur',
	ah: 'Protection contre la pluie',
	ai: 'Kit de prolongation de la portée',
	aj: 'Ventilation des toits',
	ak: 'Ventilation des côtés',
	ed: 'Capteur solaire',
	eq: 'Toile thermique',
	am: 'Protection contre le vent'
};
var $author$project$Page$QuoteBuilderV3$Quote$cad = {
	Q: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 55, 2100),
	R: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 15, 350),
	T: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 290, 11600),
	U: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 45, 1700),
	W: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 40, 1300),
	X: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1200),
	Y: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 180, 7200),
	Z: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1200),
	_: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1200),
	aa: $author$project$Page$QuoteBuilderV3$Quote$subscriptionOnly(35),
	aS: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 0, 0),
	ad: $elm$core$Basics$always(
		A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 55, 1300)),
	dt: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1100),
	ah: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1700),
	ai: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 10, 60),
	aj: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1600),
	ak: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 140, 4400),
	ed: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 55, 1900),
	eq: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 55, 2300),
	am: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1700)
};
var $author$project$Page$QuoteBuilderV3$Quote$usd = {
	Q: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 45, 1700),
	R: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 15, 230),
	T: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 220, 8800),
	U: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1200),
	W: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 1000),
	X: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 920),
	Y: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 130, 5200),
	Z: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 920),
	_: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 920),
	aa: $author$project$Page$QuoteBuilderV3$Quote$subscriptionOnly(30),
	aS: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 0, 0),
	ad: $elm$core$Basics$always(
		A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 45, 1200)),
	dt: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 920),
	ah: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 1300),
	ai: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 10, 60),
	aj: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 30, 1200),
	ak: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 110, 3500),
	ed: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 50, 1700),
	eq: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 45, 2100),
	am: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 25, 1300)
};
var $author$project$Page$QuoteBuilderV3$Quote$getPricing = function (currency) {
	if (!currency) {
		return $author$project$Page$QuoteBuilderV3$Quote$cad;
	} else {
		return $author$project$Page$QuoteBuilderV3$Quote$usd;
	}
};
var $author$project$Theme$Icon$lte = A2($author$project$Theme$Icon$faIcon, 'signal', $author$project$Theme$Color$blue);
var $author$project$Page$QuoteBuilderV3$Quote$linkToSolutionPage = F2(
	function (label, name) {
		var url = 'https://www.orisha.io/how-it-works-' + name;
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href(url),
					$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Quote$precisionEn = function () {
	var link = $author$project$Page$QuoteBuilderV3$Quote$linkToSolutionPage('click here for more details');
	return {
		Q: $author$project$S$empty,
		R: $author$project$S$empty,
		T: $author$project$S$empty,
		U: link('disease-prevention'),
		W: link('advanced-ventilation'),
		X: link('heating'),
		Y: $author$project$S$empty,
		Z: $author$project$S$empty,
		_: link('irrigation'),
		aa: $author$project$S$empty,
		aS: $author$project$S$empty,
		ad: $elm$core$Basics$always($author$project$S$empty),
		dt: $author$project$S$empty,
		ah: link('rain-protection'),
		ai: $author$project$S$empty,
		aj: link('advanced-ventilation'),
		ak: link('side-ventilation'),
		ed: $author$project$S$empty,
		eq: $author$project$S$empty,
		am: link('wind-protection')
	};
}();
var $author$project$Page$QuoteBuilderV3$Quote$precisionFr = function () {
	var link = $author$project$Page$QuoteBuilderV3$Quote$linkToSolutionPage('cliquez ici pour plus de détails');
	return {
		Q: $author$project$S$empty,
		R: $author$project$S$empty,
		T: $author$project$S$empty,
		U: link('disease-prevention'),
		W: link('advanced-ventilation'),
		X: link('heating'),
		Y: $author$project$S$empty,
		Z: $author$project$S$empty,
		_: link('irrigation'),
		aa: $author$project$S$empty,
		aS: $author$project$S$empty,
		ad: $elm$core$Basics$always($author$project$S$empty),
		dt: $author$project$S$empty,
		ah: link('rain-protection'),
		ai: $author$project$S$empty,
		aj: link('advanced-ventilation'),
		ak: link('side-ventilation'),
		ed: $author$project$S$empty,
		eq: $author$project$S$empty,
		am: link('wind-protection')
	};
}();
var $author$project$Page$QuoteBuilderV3$Quote$productDetails = F3(
	function (language, currency, addOn) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Quote$en, iI: $author$project$Page$QuoteBuilderV3$Quote$fr});
		var pricing = $author$project$Page$QuoteBuilderV3$Quote$getPricing(currency);
		var precision = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Quote$precisionEn, iI: $author$project$Page$QuoteBuilderV3$Quote$precisionFr});
		switch (addOn) {
			case 0:
				return {
					iV: $author$project$Theme$Icon$controller,
					jg: translation.ad(currency),
					jy: precision.ad(currency),
					jz: pricing.ad(currency)
				};
			case 1:
				return {iV: $author$project$Theme$Icon$sideCurtain, jg: translation.ak, jy: precision.ak, jz: pricing.ak};
			case 2:
				return {iV: $author$project$Theme$Icon$humidity, jg: translation.U, jy: precision.U, jz: pricing.U};
			case 3:
				return {iV: $author$project$Theme$Icon$valve, jg: translation._, jy: precision._, jz: pricing._};
			case 4:
				return {iV: $author$project$Theme$Icon$fan, jg: translation.W, jy: precision.W, jz: pricing.W};
			case 5:
				return {iV: $author$project$Theme$Icon$fan, jg: translation.aj, jy: precision.aj, jz: pricing.aj};
			case 6:
				return {iV: $author$project$Theme$Icon$heater, jg: translation.X, jy: precision.X, jz: pricing.X};
			case 7:
				return {iV: $author$project$Theme$Icon$mister, jg: translation.Z, jy: precision.Z, jz: pricing.Z};
			case 8:
				return {iV: $author$project$Theme$Icon$dryWetSensor, jg: translation.R, jy: precision.R, jz: pricing.R};
			case 9:
				return {iV: $author$project$Theme$Icon$thermalScreen, jg: translation.eq, jy: precision.eq, jz: pricing.eq};
			case 10:
				return {iV: $author$project$Theme$Icon$rainSensor, jg: translation.ah, jy: precision.ah, jz: pricing.ah};
			case 11:
				return {iV: $author$project$Theme$Icon$windSensor, jg: translation.am, jy: precision.am, jz: pricing.am};
			case 12:
				return {iV: $author$project$Theme$Icon$solarSensor, jg: translation.ed, jy: precision.ed, jz: pricing.ed};
			case 13:
				return {iV: $author$project$Theme$Icon$custom, jg: translation.ai, jy: precision.ai, jz: pricing.ai};
			case 14:
				return {iV: $author$project$Theme$Icon$controller, jg: translation.Q, jy: precision.Q, jz: pricing.Q};
			case 15:
				return {iV: $author$project$Theme$Icon$thermometer, jg: translation.dt, jy: precision.dt, jz: pricing.dt};
			case 16:
				return {iV: $author$project$Theme$Icon$lte, jg: translation.aa, jy: precision.aa, jz: pricing.aa};
			case 17:
				return {iV: $author$project$Theme$Icon$controller, jg: translation.Y, jy: precision.Y, jz: pricing.Y};
			default:
				return {iV: $author$project$Theme$Icon$controller, jg: translation.T, jy: precision.T, jz: pricing.T};
		}
	});
var $author$project$Page$QuoteBuilderV3$Quote$grossTotal = function (quote) {
	var withQuote = function (fn) {
		return A2(fn, quote.bx.i$, quote.bx.ik);
	};
	var greenhousePrices = function (g) {
		var products = A2(
			$elm$core$List$map,
			function ($) {
				return $.jz;
			},
			A2(
				$elm$core$List$map,
				withQuote($author$project$Page$QuoteBuilderV3$Quote$productDetails),
				g.jA));
		var customProducts = A2(
			$elm$core$List$concatMap,
			function (p) {
				return A2($elm$core$List$repeat, p.jD, p.jz);
			},
			g.il);
		return _Utils_ap(products, customProducts);
	};
	var greenhousesPrices = A2($elm$core$List$concatMap, greenhousePrices, quote.ay);
	var farmPrices = function () {
		var products = A2(
			$elm$core$List$map,
			function ($) {
				return $.jz;
			},
			A2(
				$elm$core$List$map,
				withQuote($author$project$Page$QuoteBuilderV3$Quote$productDetails),
				quote.av.jA));
		var customProducts = A2(
			$elm$core$List$concatMap,
			function (p) {
				return A2($elm$core$List$repeat, p.jD, p.jz);
			},
			quote.av.il);
		return _Utils_ap(products, customProducts);
	}();
	var prices = _Utils_ap(farmPrices, greenhousesPrices);
	return A3(
		$elm$core$List$foldl,
		$author$project$Page$QuoteBuilderV3$Quote$addPriceToTotal,
		A3($author$project$Page$QuoteBuilderV3$Quote$Total, 0, 0, 0),
		prices);
};
var $elmcraft$core_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $author$project$Page$QuoteBuilderV3$Quote$discountAmount = F2(
	function (quote, discount) {
		var total = $author$project$Page$QuoteBuilderV3$Quote$grossTotal(quote);
		var totalBeforeDiscount = A3(
			$elm$core$List$foldl,
			$author$project$Page$QuoteBuilderV3$Quote$applyDiscount,
			total,
			A2(
				$elmcraft$core_extra$List$Extra$takeWhile,
				function (d) {
					return !A2($author$project$Page$QuoteBuilderV3$Quote$compareDiscount, d, discount);
				},
				A2($elm$core$List$sortWith, $author$project$Page$QuoteBuilderV3$Quote$compareDiscount, quote.it)));
		var totalAfterDiscount = A2($author$project$Page$QuoteBuilderV3$Quote$applyDiscount, discount, totalBeforeDiscount);
		return A3($author$project$Page$QuoteBuilderV3$Quote$Total, totalAfterDiscount.jY - totalBeforeDiscount.jY, totalAfterDiscount.jC - totalBeforeDiscount.jC, 0);
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$discountAmount = F3(
	function (plan, quote, discount) {
		var amount = A2($author$project$Page$QuoteBuilderV3$Quote$discountAmount, quote, discount);
		if (!plan) {
			return amount.jC;
		} else {
			return amount.jY;
		}
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$currencyEncoder = function (currency) {
	if (!currency) {
		return $elm$json$Json$Encode$string('cad');
	} else {
		return $elm$json$Json$Encode$string('usd');
	}
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$discountEncoder = F3(
	function (plan, quote, discount) {
		var duration = function () {
			var _v0 = _Utils_Tuple2(discount.au, discount.aF);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if (_v0.b.$ === 1) {
						var months = _v0.a.a;
						var _v1 = _v0.b;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'duration',
								$elm$json$Json$Encode$string('repeating')),
								_Utils_Tuple2(
								'duration_in_months',
								$elm$json$Json$Encode$int(months))
							]);
					} else {
						break _v0$2;
					}
				} else {
					if (!_v0.b.$) {
						var _v2 = _v0.a;
						var validUntil = _v0.b.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'duration',
								$elm$json$Json$Encode$string('repeating')),
								_Utils_Tuple2(
								'valid_until',
								$elm$json$Json$Encode$string(validUntil))
							]);
					} else {
						break _v0$2;
					}
				}
			}
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'duration',
					$elm$json$Json$Encode$string('repeating')),
					_Utils_Tuple2(
					'duration_in_months',
					$elm$json$Json$Encode$int(12000000))
				]);
		}();
		var amountOff = A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$discountAmount, plan, quote, discount);
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'amount_off',
						$elm$json$Json$Encode$int(
							100 * $elm$core$Basics$abs(amountOff))),
						_Utils_Tuple2(
						'currency',
						$author$project$Page$QuoteBuilderV3$Preview$Checkout$currencyEncoder(quote.bx.ik)),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(discount.jg)),
						_Utils_Tuple2(
						'metadata',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'projectId',
									$elm$json$Json$Encode$string(quote.dH))
								])))
					]),
				duration));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$discounts = F2(
	function (plan, quote) {
		return A2(
			$elm$json$Json$Encode$list,
			A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$discountEncoder, plan, quote),
			A2(
				$elm$core$List$filter,
				function (d) {
					return !(!A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$discountAmount, plan, quote, d));
				},
				quote.it));
	});
var $author$project$Page$QuoteBuilderV3$Quote$allProducts = _List_fromArray(
	[17, 18, 0, 2, 7, 1, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$customProductToLineItem = function (customProduct) {
	return (customProduct.jD > 0) ? $elm$core$Maybe$Just(
		{jg: customProduct.jg, jz: customProduct.jz, jD: customProduct.jD}) : $elm$core$Maybe$Nothing;
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$lineItemEncoder = F3(
	function (plan, quote, lineItem) {
		var perMonth = _List_fromArray(
			[
				_Utils_Tuple2(
				'recurring',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'interval',
							$elm$json$Json$Encode$string('month')),
							_Utils_Tuple2(
							'interval_count',
							$elm$json$Json$Encode$int(1))
						])))
			]);
		var once = _List_Nil;
		var _v0 = function () {
			var _v1 = lineItem.jz;
			if (!_v1.$) {
				var subscription = _v1.a.jY;
				var purchase = _v1.a.jC;
				if (!plan) {
					return _Utils_Tuple2(purchase, once);
				} else {
					return _Utils_Tuple2(subscription, perMonth);
				}
			} else {
				var subscription = _v1.a.jY;
				return _Utils_Tuple2(subscription, perMonth);
			}
		}();
		var unitAmount = _v0.a;
		var recurring = _v0.b;
		var priceData = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'currency',
					$author$project$Page$QuoteBuilderV3$Preview$Checkout$currencyEncoder(quote.bx.ik)),
					_Utils_Tuple2(
					'product_data',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(lineItem.jg))
							]))),
					_Utils_Tuple2(
					'tax_behavior',
					$elm$json$Json$Encode$string('exclusive')),
					_Utils_Tuple2(
					'unit_amount',
					$elm$json$Json$Encode$int(100 * unitAmount))
				]),
			recurring);
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'price_data',
					$elm$json$Json$Encode$object(priceData)),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(lineItem.jD))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$localeEncoder = function (language) {
	if (!language) {
		return $elm$json$Json$Encode$string('en');
	} else {
		return $elm$json$Json$Encode$string('fr');
	}
};
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.hZ;
		var month = _v0.g6;
		var day = _v0.im;
		var hour = _v0.iT;
		var minute = _v0.i9;
		var second = _v0.jQ;
		var millisecond = _v0.i6;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$planEncoder = function (plan) {
	return $elm$json$Json$Encode$string(
		function () {
			if (!plan) {
				return 'payment';
			} else {
				return 'subscription';
			}
		}());
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$quoteProducts = function (quote) {
	return A2(
		$elm$core$List$append,
		quote.av.jA,
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.jA;
			},
			quote.ay));
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantity = F2(
	function (quote, product) {
		return A2(
			$elmcraft$core_extra$List$Extra$count,
			$elm$core$Basics$eq(product),
			$author$project$Page$QuoteBuilderV3$Preview$Checkout$quoteProducts(quote));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$productToLineItem = F2(
	function (quote, product) {
		var quantity = A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantity, quote, product);
		var details = A3($author$project$Page$QuoteBuilderV3$Quote$productDetails, quote.bx.i$, quote.bx.ik, product);
		return (quantity > 0) ? $elm$core$Maybe$Just(
			{jg: details.jg, jz: details.jz, jD: quantity}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$greenhouseProducts = F2(
	function (quote, greenhouseIndex) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jA;
				},
				A2($elmcraft$core_extra$List$Extra$getAt, greenhouseIndex, quote.ay)));
	});
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$isImplementedInTechnicalDiscovery = function (product) {
	switch (product) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return false;
		case 13:
			return false;
		case 14:
			return false;
		case 15:
			return false;
		case 16:
			return false;
		case 17:
			return true;
		default:
			return true;
	}
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse = F3(
	function (quote, greenhouseIndex, product) {
		return A2(
			$elmcraft$core_extra$List$Extra$count,
			$elm$core$Basics$eq(product),
			A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$greenhouseProducts, quote, greenhouseIndex));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$quoteCustomProducts = function (quote) {
	return A2(
		$elm$core$List$append,
		quote.av.il,
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.il;
			},
			quote.ay));
};
var $author$project$Utils$Bool$toNumber = function (bool) {
	return bool ? 1 : 0;
};
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$successUrl = function (quote) {
	var windProtection = A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantity, quote, 11);
	var sideVentilationEncoder = function (greenhouseIndex) {
		return A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse, quote, greenhouseIndex, 1);
	};
	var ridgeVentilationEncoder = function (greenhouseIndex) {
		return A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse, quote, greenhouseIndex, 5);
	};
	var rainProtection = A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantity, quote, 10);
	var projectId = quote.dH;
	var lteController = A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantity, quote, 16);
	var irrigationEncoder = function (greenhouseIndex) {
		return A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse, quote, greenhouseIndex, 3);
	};
	var id = function () {
		var _v0 = quote.bx.i$;
		if (!_v0) {
			return 'roRLoV4Nnwus';
		} else {
			return 'uhuvL7gGwfus';
		}
	}();
	var heatingEncoder = function (greenhouseIndex) {
		return A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse, quote, greenhouseIndex, 6);
	};
	var hasProductAndExtraInSameGreenhouse = A2(
		$elm$core$List$member,
		true,
		A2(
			$elm$core$List$map,
			function (products) {
				var hasProduct = A2($elm$core$List$member, 18, products) || A2($elm$core$List$member, 17, products);
				var hasExtra = A2($elm$core$List$member, 1, products) || (A2($elm$core$List$member, 6, products) || (A2($elm$core$List$member, 3, products) || (A2($elm$core$List$member, 4, products) || (A2($elm$core$List$member, 5, products) || A2($elm$core$List$member, 2, products)))));
				return hasProduct && hasExtra;
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jA;
				},
				quote.ay)));
	var hasNonImplementedProducts = A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Page$QuoteBuilderV3$Preview$Checkout$isImplementedInTechnicalDiscovery),
		$author$project$Page$QuoteBuilderV3$Preview$Checkout$quoteProducts(quote));
	var hasMoreThanThreeGreenhouses = $elm$core$List$length(quote.ay) > 3;
	var hasCustomProducts = !$elm$core$List$isEmpty(
		$author$project$Page$QuoteBuilderV3$Preview$Checkout$quoteCustomProducts(quote));
	var greenhouseEncoder = function (greenhouseIndex) {
		var products = A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$greenhouseProducts, quote, greenhouseIndex);
		return A2($elm$core$List$member, 18, products) ? 'chief' : (A2($elm$core$List$member, 17, products) ? 'helper' : ($elm$core$List$isEmpty(products) ? 'none' : 'extra'));
	};
	var greenhouse3Index = 2;
	var greenhouse2Index = 1;
	var greenhouse1Index = 0;
	var forceCustom = $author$project$Utils$Bool$toNumber(hasCustomProducts || (hasNonImplementedProducts || (hasMoreThanThreeGreenhouses || hasProductAndExtraInSameGreenhouse)));
	var farmName = quote.bx.iG;
	var farmAddress = quote.bx.iF;
	var fanVentilationEncoder = function (greenhouseIndex) {
		return A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse, quote, greenhouseIndex, 4);
	};
	var email = quote.bx.ix;
	var diseasePreventionEncoder = function (greenhouseIndex) {
		return A3($author$project$Page$QuoteBuilderV3$Preview$Checkout$productQuantityInGreenhouse, quote, greenhouseIndex, 2);
	};
	return A3(
		$elm$url$Url$Builder$crossOrigin,
		'https://forms.fillout.com',
		_List_fromArray(
			['t', id]),
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'email', email),
				A2($elm$url$Url$Builder$string, 'project_id', projectId),
				A2($elm$url$Url$Builder$string, 'farm_name', farmName),
				A2($elm$url$Url$Builder$string, 'farm_address', farmAddress),
				A2($elm$url$Url$Builder$int, 'force_custom', forceCustom),
				A2(
				$elm$url$Url$Builder$string,
				'greenhouse1',
				greenhouseEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$string,
				'greenhouse2',
				greenhouseEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$string,
				'greenhouse3',
				greenhouseEncoder(greenhouse3Index)),
				A2(
				$elm$url$Url$Builder$int,
				'side_ventilation1',
				sideVentilationEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$int,
				'side_ventilation2',
				sideVentilationEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$int,
				'side_ventilation3',
				sideVentilationEncoder(greenhouse3Index)),
				A2(
				$elm$url$Url$Builder$int,
				'heating1',
				heatingEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$int,
				'heating2',
				heatingEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$int,
				'heating3',
				heatingEncoder(greenhouse3Index)),
				A2(
				$elm$url$Url$Builder$int,
				'irrigation1',
				irrigationEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$int,
				'irrigation2',
				irrigationEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$int,
				'irrigation3',
				irrigationEncoder(greenhouse3Index)),
				A2(
				$elm$url$Url$Builder$int,
				'fan_ventilation1',
				fanVentilationEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$int,
				'fan_ventilation2',
				fanVentilationEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$int,
				'fan_ventilation3',
				fanVentilationEncoder(greenhouse3Index)),
				A2(
				$elm$url$Url$Builder$int,
				'ridge_ventilation1',
				ridgeVentilationEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$int,
				'ridge_ventilation2',
				ridgeVentilationEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$int,
				'ridge_ventilation3',
				ridgeVentilationEncoder(greenhouse3Index)),
				A2(
				$elm$url$Url$Builder$int,
				'disease_prevention1',
				diseasePreventionEncoder(greenhouse1Index)),
				A2(
				$elm$url$Url$Builder$int,
				'disease_prevention2',
				diseasePreventionEncoder(greenhouse2Index)),
				A2(
				$elm$url$Url$Builder$int,
				'disease_prevention3',
				diseasePreventionEncoder(greenhouse3Index)),
				A2($elm$url$Url$Builder$int, 'rain_protection', rainProtection),
				A2($elm$url$Url$Builder$int, 'wind_protection', windProtection),
				A2($elm$url$Url$Builder$int, 'lte', lteController)
			]));
};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Utils$Maybe$when = F2(
	function (predicate, value) {
		return predicate ? $elm$core$Maybe$Just(value) : $elm$core$Maybe$Nothing;
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$sessionInfo = F4(
	function (here, now, plan, quote) {
		var timeParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, here, now);
		var products = A2(
			$elm$core$List$map,
			$author$project$Page$QuoteBuilderV3$Preview$Checkout$productToLineItem(quote),
			$author$project$Page$QuoteBuilderV3$Quote$allProducts);
		var nextMarch1stInUnixTimestamp = function (t) {
			return (t / 1000) | 0;
		}(
			$elm$time$Time$posixToMillis(
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$elm$time$Time$utc,
					_Utils_update(
						timeParts,
						{im: 1, iT: 12, i6: 0, i9: 0, g6: 2, jQ: 0, hZ: timeParts.hZ + 1}))));
		var metadata = _Utils_Tuple2(
			'metadata',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'projectId',
						$elm$json$Json$Encode$string(quote.dH))
					])));
		var subscriptionData = $elm$json$Json$Encode$object(
			$elmcraft$core_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(metadata),
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'billing_mode',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$string('flexible'))
									])))),
						A2(
						$author$project$Utils$Maybe$when,
						A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$isInTrialPeriod, here, now),
						_Utils_Tuple2(
							'trial_end',
							$elm$json$Json$Encode$int(nextMarch1stInUnixTimestamp)))
					])));
		var invoiceCreation = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'enabled',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'invoice_data',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[metadata])))
				]));
		var hasCustomerId = !$elm$core$String$isEmpty(quote.gw);
		var customProducts = A2(
			$elm$core$List$map,
			$author$project$Page$QuoteBuilderV3$Preview$Checkout$customProductToLineItem,
			A2(
				$elm$core$List$append,
				quote.av.il,
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.il;
					},
					quote.ay)));
		var lineItems = $elmcraft$core_extra$Maybe$Extra$values(
			_Utils_ap(products, customProducts));
		var areThereSubscriptionOnlyProducts = A2(
			$elm$core$List$any,
			function (price) {
				if (!price.$) {
					return false;
				} else {
					return true;
				}
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jz;
				},
				lineItems));
		var mode = areThereSubscriptionOnlyProducts ? $elm$json$Json$Encode$string('subscription') : $author$project$Page$QuoteBuilderV3$Preview$Checkout$planEncoder(plan);
		var isSubscription = _Utils_eq(
			mode,
			$elm$json$Json$Encode$string('subscription'));
		var paymentMethodTypes = ((!isSubscription) && (!quote.bx.ik)) ? _List_fromArray(
			['card', 'acss_debit']) : _List_fromArray(
			['card']);
		var acssMandateOptions = isSubscription ? $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_schedule',
					$elm$json$Json$Encode$string('interval')),
					_Utils_Tuple2(
					'transaction_type',
					$elm$json$Json$Encode$string('business')),
					_Utils_Tuple2(
					'interval_description',
					$elm$json$Json$Encode$string('Monthly billing'))
				])) : $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_schedule',
					$elm$json$Json$Encode$string('sporadic')),
					_Utils_Tuple2(
					'transaction_type',
					$elm$json$Json$Encode$string('business'))
				]));
		var info = _List_fromArray(
			[
				$elm$core$Maybe$Just(metadata),
				$elm$core$Maybe$Just(
				_Utils_Tuple2('mode', mode)),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'payment_method_types',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, paymentMethodTypes))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'consent_collection',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'terms_of_service',
								$elm$json$Json$Encode$string('required'))
							])))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'billing_address_collection',
					$elm$json$Json$Encode$string('required'))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'phone_number_collection',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(true))
							])))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'success_url',
					$elm$json$Json$Encode$string(
						$author$project$Page$QuoteBuilderV3$Preview$Checkout$successUrl(quote)))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'cancel_url',
					$elm$json$Json$Encode$string('https://orisha.io'))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'line_items',
					A2(
						$elm$json$Json$Encode$list,
						A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$lineItemEncoder, plan, quote),
						lineItems))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'currency',
					$author$project$Page$QuoteBuilderV3$Preview$Checkout$currencyEncoder(quote.bx.ik))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'automatic_tax',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(true))
							])))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'adaptive_pricing',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(false))
							])))),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'locale',
					$author$project$Page$QuoteBuilderV3$Preview$Checkout$localeEncoder(quote.bx.i$))),
				A2(
				$author$project$Utils$Maybe$when,
				!isSubscription,
				_Utils_Tuple2('invoice_creation', invoiceCreation)),
				$elm$core$Maybe$Just(
				_Utils_Tuple2(
					'payment_method_options',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'acss_debit',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2('mandate_options', acssMandateOptions)
										])))
							])))),
				A2(
				$author$project$Utils$Maybe$when,
				isSubscription,
				_Utils_Tuple2('subscription_data', subscriptionData)),
				A2(
				$author$project$Utils$Maybe$when,
				hasCustomerId,
				_Utils_Tuple2(
					'customer',
					$elm$json$Json$Encode$string(quote.gw))),
				A2(
				$author$project$Utils$Maybe$when,
				hasCustomerId,
				_Utils_Tuple2(
					'customer_update',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'address',
								$elm$json$Json$Encode$string('auto')),
								_Utils_Tuple2(
								'shipping',
								$elm$json$Json$Encode$string('auto'))
							]))))
			]);
		return $elm$json$Json$Encode$object(
			$elmcraft$core_extra$Maybe$Extra$values(info));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Checkout$url = F4(
	function (here, now, plan, quote) {
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			'https://checkout.orisha.io',
			_List_fromArray(
				['stripe']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'project_id', quote.dH),
					A2(
					$author$project$Page$QuoteBuilderV3$Preview$Checkout$base64QueryParameter,
					'session_info',
					A4($author$project$Page$QuoteBuilderV3$Preview$Checkout$sessionInfo, here, now, plan, quote)),
					A2(
					$author$project$Page$QuoteBuilderV3$Preview$Checkout$base64QueryParameter,
					'discounts',
					A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$discounts, plan, quote))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Common$buyNowButton = F3(
	function (here, now, quote) {
		var url = A4($author$project$Page$QuoteBuilderV3$Preview$Checkout$url, here, now, 0, quote);
		var language = quote.bx.i$;
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Preview$Common$en, iI: $author$project$Page$QuoteBuilderV3$Preview$Common$fr});
		return A2($author$project$Page$QuoteBuilderV3$Preview$Common$button, url, translation.b5);
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$firstArgumentsStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$cm(4.5))
		]));
var $rtfeldman$elm_css$Css$stretch = $rtfeldman$elm_css$Css$prop1('stretch');
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$infoStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$stretch),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$cm(0.3)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$cm(8))
		]));
var $author$project$Page$QuoteBuilderV3$Quote$discountTotal = function (quote) {
	return A3(
		$elm$core$List$foldl,
		$author$project$Page$QuoteBuilderV3$Quote$addPriceToTotal,
		A3($author$project$Page$QuoteBuilderV3$Quote$Total, 0, 0, 0),
		A2(
			$elm$core$List$map,
			function (amount) {
				return A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, amount.jY, amount.jC);
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$QuoteBuilderV3$Quote$discountAmount(quote),
				quote.it)));
};
var $author$project$Page$QuoteBuilderV3$Quote$netTotal = function (quote) {
	var t = $author$project$Page$QuoteBuilderV3$Quote$grossTotal(quote);
	var d = $author$project$Page$QuoteBuilderV3$Quote$discountTotal(quote);
	return {jC: t.jC + d.jC, jY: t.jY + d.jY, ei: t.ei + d.ei};
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$recommendedWhen = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$cm(0.3))
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(translation.dP)
			]));
};
var $rtfeldman$elm_css$Css$noWrap = {bA: 0, cA: 0, hR: 'nowrap', a0: 0};
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$titleStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$cm(0.75)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$cm(2)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
		]));
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Formatter$Number$formatInt = function (amount) {
	return (amount > 999) ? ($elm$core$String$fromInt((amount / 1000) | 0) + ('\u00A0' + A3(
		$elm$core$String$padLeft,
		3,
		'0',
		$elm$core$String$fromInt(amount % 1000)))) : ((amount < 0) ? function (x) {
		return '-\u00A0' + x;
	}(
		$elm$core$String$fromInt(-amount)) : $elm$core$String$fromInt(amount));
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStr = function (n) {
	return '$' + $author$project$Formatter$Number$formatInt(n);
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$cm(0.75)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$cm(0.5)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$cm(0.8))
		]));
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$lifetimeAccess = F4(
	function (translation, here, now, quote) {
		var netTotal = $author$project$Page$QuoteBuilderV3$Quote$netTotal(quote);
		return $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$block(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$titleStyle]))
						]),
					_List_fromArray(
						[
							$author$project$Page$QuoteBuilderV3$Preview$Common$title(translation.c_)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStyle]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStr(netTotal.jC))
								])),
							A2(
							$author$project$S$when,
							netTotal.ei > 0,
							A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
												$rtfeldman$elm_css$Css$bottom(
												$rtfeldman$elm_css$Css$em(0.5))
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										'+ ' + $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStr(netTotal.ei)),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(0.5))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(translation.bi)
											]))
									])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$infoStyle]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$firstArgumentsStyle]))
								]),
							_List_fromArray(
								[
									$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$arguments(
									_List_fromArray(
										[translation.dj, translation.cM, translation.c0]))
								])),
							$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$recommendedWhen(translation),
							$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$arguments(
							_List_fromArray(
								[translation.b6, translation.cz]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$buttonStyle]))
						]),
					_List_fromArray(
						[
							A3($author$project$Page$QuoteBuilderV3$Preview$Common$buyNowButton, here, now, quote)
						]))
				]));
	});
var $author$project$Domain$Quote$Plan$Subscription = 1;
var $author$project$Page$QuoteBuilderV3$Preview$Common$subscribeButton = F3(
	function (here, now, quote) {
		var url = A4($author$project$Page$QuoteBuilderV3$Preview$Checkout$url, here, now, 1, quote);
		var language = quote.bx.i$;
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Preview$Common$en, iI: $author$project$Page$QuoteBuilderV3$Preview$Common$fr});
		return A2($author$project$Page$QuoteBuilderV3$Preview$Common$button, url, translation.eg);
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$payAsYouGo = F4(
	function (translation, here, now, quote) {
		var netTotal = $author$project$Page$QuoteBuilderV3$Quote$netTotal(quote);
		var isInTrialPeriod = A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$isInTrialPeriod, here, now);
		var price = isInTrialPeriod ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$paddingTop(
							$rtfeldman$elm_css$Css$cm(0.5)),
							$rtfeldman$elm_css$Css$paddingBottom(
							$rtfeldman$elm_css$Css$cm(0.8))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$cm(0.75)),
									$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(translation.cC)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$cm(0.35))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.ev)
								])),
							$rtfeldman$elm_css$Html$Styled$text(translation.ep),
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStr(netTotal.jY + netTotal.ei)),
							$rtfeldman$elm_css$Html$Styled$text(translation.bi)
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStyle]))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$totalStr(netTotal.jY + netTotal.ei)),
					$rtfeldman$elm_css$Html$Styled$text(translation.bi)
				]));
		return $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$block(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$titleStyle]))
								]),
							_List_fromArray(
								[
									$author$project$Page$QuoteBuilderV3$Preview$Common$title(translation.dw)
								])),
							A2(
							$author$project$S$when,
							isInTrialPeriod,
							A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginTop(
												$rtfeldman$elm_css$Css$cm(-0.5)),
												$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$cm(0.35)),
												$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.eM)
									])))
						])),
					price,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$infoStyle]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$firstArgumentsStyle]))
								]),
							_List_fromArray(
								[
									$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$arguments(
									_List_fromArray(
										[translation.dk, translation.dh, translation.cO, translation.b7]))
								])),
							$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$recommendedWhen(translation),
							$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$arguments(
							_List_fromArray(
								[translation.c8, translation.cW, translation.c$]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$buttonStyle]))
						]),
					_List_fromArray(
						[
							A3($author$project$Page$QuoteBuilderV3$Preview$Common$subscribeButton, here, now, quote)
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$topText = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginBottom(
						$rtfeldman$elm_css$Css$cm(1))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$cm(1)),
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$cm(2))
							]))
					]),
				_List_fromArray(
					[
						$author$project$Page$QuoteBuilderV3$Preview$Common$title(translation.dx)
					]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$view = F3(
	function (here, now, quote) {
		var language = quote.bx.i$;
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$en, iI: $author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$fr});
		return $author$project$Page$QuoteBuilderV3$Preview$Common$page(
			_List_fromArray(
				[
					$author$project$Page$QuoteBuilderV3$Preview$Common$pageContent(
					_List_fromArray(
						[
							$author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$topText(translation),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$stretch),
											$author$project$Utils$Style$gap(
											$rtfeldman$elm_css$Css$cm(0.5))
										]))
								]),
							_List_fromArray(
								[
									A4($author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$payAsYouGo, translation, here, now, quote),
									A4($author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$lifetimeAccess, translation, here, now, quote)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
											$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
											$rtfeldman$elm_css$Css$marginTop(
											$rtfeldman$elm_css$Css$cm(1))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.cm),
									$author$project$Theme$Icon$caretDown
								]))
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Quote$customProductDetails = function (customProduct) {
	return {iV: $author$project$Theme$Icon$custom, jg: customProduct.jg, jy: $author$project$S$empty, jz: customProduct.jz};
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$entry = F3(
	function (translation, details, quantity) {
		var centered = function (str) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(str)
					]));
		};
		var _v0 = function () {
			var _v1 = details.jz;
			if (!_v1.$) {
				var subscription = _v1.a.jY;
				var purchase = _v1.a.jC;
				return _Utils_Tuple2(
					$author$project$Formatter$Number$formatInt(quantity * subscription),
					$author$project$Formatter$Number$formatInt(quantity * purchase));
			} else {
				var subscription = _v1.a.jY;
				return _Utils_Tuple2(
					$author$project$Formatter$Number$formatInt(quantity * subscription),
					function (n) {
						return _Utils_ap(n, translation.bi);
					}(
						$author$project$Formatter$Number$formatInt(quantity * subscription)));
			}
		}();
		var subscriptionCell = _v0.a;
		var purchaseCell = _v0.b;
		return (quantity > 0) ? _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
												$author$project$Utils$Style$gap(
												$rtfeldman$elm_css$Css$em(1))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$displayFlex,
														$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
														$rtfeldman$elm_css$Css$width(
														$rtfeldman$elm_css$Css$em(2))
													]))
											]),
										_List_fromArray(
											[details.iV])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(details.jg)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$fontSize(
																$rtfeldman$elm_css$Css$em(0.6)),
																$rtfeldman$elm_css$Css$opacity(
																$rtfeldman$elm_css$Css$num(0.8))
															]))
													]),
												_List_fromArray(
													[details.jy]))
											]))
									]))
							])),
						centered(subscriptionCell),
						centered(purchaseCell)
					]))
			]) : _List_Nil;
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$customProductEntry = F2(
	function (translation, c) {
		return A3(
			$author$project$Page$QuoteBuilderV3$Preview$Page$Price$entry,
			translation,
			$author$project$Page$QuoteBuilderV3$Quote$customProductDetails(c),
			c.jD);
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$discountRow = F2(
	function (quote, discount) {
		var priceCell = function (value) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Formatter$Number$formatInt(value))
					]));
		};
		var discountAmount = A2($author$project$Page$QuoteBuilderV3$Quote$discountAmount, quote, discount);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(discount.jg)
								])),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$S$empty,
							A2(
								$elm$core$Maybe$map,
								function (precision) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(0.8)),
														$rtfeldman$elm_css$Css$fontWeight(
														$rtfeldman$elm_css$Css$int(200))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(precision)
											]));
								},
								discount.jy))
						])),
					priceCell(discountAmount.jY),
					priceCell(discountAmount.jC)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$en = {cB: 'For the farm', ft: 'In Canadian Dollars', cL: 'In American Dollars', c_: 'Lifetime access ($)', dw: 'Pay as you go ($/month)', bi: '/month', dF: 'Product'};
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$fr = {cB: 'Pour la ferme', ft: 'En Dollars Canadiens', cL: 'En Dollars Américains', c_: 'Accès à vie ($)', dw: 'Sans engagement ($/mois)', bi: '/mois', dF: 'Produit'};
var $elmcraft$core_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$tableHeader = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$important(
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$orishaGreen)),
						$author$project$S$exactPrint
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$white))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.dF)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$white)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$em(12)),
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.dw)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$white)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$em(12)),
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.c_)
					]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$pages = F5(
	function (translation, here, now, quote, lines) {
		var maxNumberOfLines = 17;
		var currencyFootnote = function () {
			var _v1 = quote.bx.ik;
			if (!_v1) {
				return translation.ft;
			} else {
				return translation.cL;
			}
		}();
		var buttons = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$cm(1))
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Page$QuoteBuilderV3$Preview$Common$subscribeButton, here, now, quote),
					A3($author$project$Page$QuoteBuilderV3$Preview$Common$buyNowButton, here, now, quote)
				]));
		var page = F2(
			function (l, isLastPage) {
				return $author$project$Page$QuoteBuilderV3$Preview$Common$page(
					_List_fromArray(
						[
							$author$project$Page$QuoteBuilderV3$Preview$Common$pageContent(
							_List_fromArray(
								[
									A2(
									$author$project$S$table,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$rem(0.9))
												]))
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Page$QuoteBuilderV3$Preview$Page$Price$tableHeader(translation),
										l)),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$displayFlex,
													$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
													$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$em(0.8))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(currencyFootnote)
										])),
									A2($author$project$S$when, isLastPage, buttons)
								]))
						]));
			});
		var _v0 = A2($elmcraft$core_extra$List$Extra$splitAt, maxNumberOfLines, lines);
		if (!_v0.b.b) {
			var l = _v0.a;
			return _List_fromArray(
				[
					A2(page, l, true)
				]);
		} else {
			var l = _v0.a;
			var xs = _v0.b;
			return A2(
				$elm$core$List$cons,
				A2(page, l, false),
				A5($author$project$Page$QuoteBuilderV3$Preview$Page$Price$pages, translation, here, now, quote, xs));
		}
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$productEntry = F4(
	function (translation, quote, count, product) {
		var details = A3($author$project$Page$QuoteBuilderV3$Quote$productDetails, quote.bx.i$, quote.bx.ik, product);
		return A3(
			$author$project$Page$QuoteBuilderV3$Preview$Page$Price$entry,
			translation,
			details,
			count(product));
	});
var $author$project$Page$QuoteBuilderV3$Preview$Page$Price$view = F3(
	function (here, now, quote) {
		var sectionHeader = function (label) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$colspan(3),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$sectionBlue)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]))
						]))
				]);
		};
		var netTotal = $author$project$Page$QuoteBuilderV3$Quote$netTotal(quote);
		var netTotalFormatted = $author$project$Formatter$Number$formatInt(netTotal.jC);
		var language = quote.bx.i$;
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Preview$Page$Price$en, iI: $author$project$Page$QuoteBuilderV3$Preview$Page$Price$fr});
		var greenhouseSection = function (g) {
			return $elm$core$List$concat(
				_List_fromArray(
					[
						sectionHeader(g.jg),
						A2(
						$elm$core$List$concatMap,
						A3(
							$author$project$Page$QuoteBuilderV3$Preview$Page$Price$productEntry,
							translation,
							quote,
							function (p) {
								return A2(
									$elmcraft$core_extra$List$Extra$count,
									$elm$core$Basics$eq(p),
									g.jA);
							}),
						A2($elm$core$List$filter, $author$project$Page$QuoteBuilderV3$Quote$isPerGreenhouse, $author$project$Page$QuoteBuilderV3$Quote$allProducts)),
						A2(
						$elm$core$List$concatMap,
						$author$project$Page$QuoteBuilderV3$Preview$Page$Price$customProductEntry(translation),
						g.il)
					]));
		};
		var farmSection = $elm$core$List$concat(
			_List_fromArray(
				[
					($elm$core$List$isEmpty(quote.av.jA) && $elm$core$List$isEmpty(quote.av.il)) ? _List_Nil : sectionHeader(translation.cB),
					A2(
					$elm$core$List$concatMap,
					A3(
						$author$project$Page$QuoteBuilderV3$Preview$Page$Price$productEntry,
						translation,
						quote,
						function (p) {
							return A2(
								$elmcraft$core_extra$List$Extra$count,
								$elm$core$Basics$eq(p),
								quote.av.jA);
						}),
					A2($elm$core$List$filter, $author$project$Page$QuoteBuilderV3$Quote$isPerFarm, $author$project$Page$QuoteBuilderV3$Quote$allProducts)),
					A2(
					$elm$core$List$concatMap,
					$author$project$Page$QuoteBuilderV3$Preview$Page$Price$customProductEntry(translation),
					quote.av.il)
				]));
		var centered = function (str) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(str)
					]));
		};
		var lifetimeAccessPriceFormatted = centered(
			(netTotal.ei > 0) ? (netTotalFormatted + (' + ' + ($author$project$Formatter$Number$formatInt(netTotal.ei) + translation.bi))) : netTotalFormatted);
		return A5(
			$author$project$Page$QuoteBuilderV3$Preview$Page$Price$pages,
			translation,
			here,
			now,
			quote,
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2($elm$core$List$concatMap, greenhouseSection, quote.ay),
						farmSection,
						A2(
						$elm$core$List$map,
						$author$project$Page$QuoteBuilderV3$Preview$Page$Price$discountRow(quote),
						quote.it),
						_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Total')
										])),
									centered(
									$author$project$Formatter$Number$formatInt(netTotal.jY + netTotal.ei)),
									lifetimeAccessPriceFormatted
								]))
						])
					])));
	});
var $author$project$Page$QuoteBuilderV3$Preview$View$view = F4(
	function (here, now, url, model) {
		var quote = $author$project$Page$QuoteBuilderV3$Update$toQuote(model);
		var language = model.bx.i$;
		var confidencePage = function () {
			if (!language) {
				return $author$project$Page$QuoteBuilderV3$Preview$Page$EnglishConfidence$view;
			} else {
				return $author$project$Page$QuoteBuilderV3$Preview$Page$FrenchConfidence$view;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Style$Grid$displayGrid,
							$author$project$Style$Grid$justifyItems('center'),
							$author$project$Style$Grid$rowGap(
							$rtfeldman$elm_css$Css$rem(2)),
							$rtfeldman$elm_css$Css$paddingTop(
							$rtfeldman$elm_css$Css$rem(5)),
							$rtfeldman$elm_css$Css$paddingBottom(
							$rtfeldman$elm_css$Css$rem(5)),
							$author$project$Theme$Font$poppins,
							$author$project$S$onPrint(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
									$rtfeldman$elm_css$Css$padding(
									$rtfeldman$elm_css$Css$px(0))
								]))
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A4($author$project$Page$QuoteBuilderV3$Preview$Page$Cover$view, here, now, url, quote),
							A2(
							$author$project$S$when,
							A2($author$project$Page$QuoteBuilderV3$Preview$Checkout$isInTrialPeriod, here, now),
							$author$project$Page$QuoteBuilderV3$Preview$Page$HeadStart$view(quote)),
							A3($author$project$Page$QuoteBuilderV3$Preview$Page$PlanChoice$view, here, now, quote)
						]),
						A3($author$project$Page$QuoteBuilderV3$Preview$Page$Price$view, here, now, quote),
						_List_fromArray(
						[confidencePage])
					])));
	});
var $author$project$Page$QuoteBuilderV3$Total$discountTotal = F2(
	function (translation, quote) {
		var total = $author$project$Page$QuoteBuilderV3$Quote$discountTotal(quote);
		var subscription = total.jY + total.ei;
		var purchase = total.jC;
		var cell = function (n) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$em(6)),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right),
								$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Formatter$Number$formatInt(n * (-1)))
					]));
		};
		return A2(
			$author$project$S$when,
			(!(!subscription)) || (!(!purchase)),
			A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.gy)
									]))
							])),
						cell(subscription),
						cell(purchase)
					])));
	});
var $author$project$Page$QuoteBuilderV3$Total$en = {gy: 'Discount', jC: 'Purchase', d5: 'Service', ek: 'System price', et: 'Total'};
var $author$project$Page$QuoteBuilderV3$Total$fr = {gy: 'Rabais', jC: 'Achat', d5: 'Service', ek: 'Prix du système', et: 'Total'};
var $author$project$Page$QuoteBuilderV3$Total$totalView = F2(
	function (str, total) {
		var cell = function (value) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Formatter$Number$formatInt(value))
					]));
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$fontWeight(
							$rtfeldman$elm_css$Css$int(600))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(str)
						])),
					cell(total.jY + total.ei),
					cell(total.jC)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Total$view = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Total$en, iI: $author$project$Page$QuoteBuilderV3$Total$fr});
		var quote = $author$project$Page$QuoteBuilderV3$Update$toQuote(model);
		return A2(
			$author$project$S$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$colgroup,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$col,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(60))
										]))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$col,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(20))
										]))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$col,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(20))
										]))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$th, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.d5)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.jC)
								]))
						])),
					A2(
					$author$project$Page$QuoteBuilderV3$Total$totalView,
					translation.ek,
					$author$project$Page$QuoteBuilderV3$Quote$grossTotal(quote)),
					A2($author$project$Page$QuoteBuilderV3$Total$discountTotal, translation, quote),
					A2(
					$author$project$Page$QuoteBuilderV3$Total$totalView,
					translation.et,
					$author$project$Page$QuoteBuilderV3$Quote$netTotal(quote))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Update$ClientMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Update$SetCustomerId = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$Update$SetProjectId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$QuoteBuilderV3$View$en = {gw: 'Customer ID', dg: 'New greenhouse', dC: 'Amount ($)', dD: 'Amount ($/month)', jA: 'Products', dH: 'Project ID', jD: 'Quantity'};
var $author$project$Page$QuoteBuilderV3$View$fr = {gw: 'Customer ID', dg: 'Nouvelle serre', dC: 'Prix ($)', dD: 'Prix ($/mois)', jA: 'Produit', dH: 'Project ID', jD: 'Quantité'};
var $author$project$Page$QuoteBuilderV3$Update$DiscountMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$QuoteBuilderV3$Update$FarmMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$QuoteBuilderV3$Update$GreenhouseMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$QuoteBuilderV3$Update$AddGreenhouse = {$: 0};
var $author$project$Page$QuoteBuilderV3$View$greenhouseAddition = function (translation) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$important(
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$sectionBlue))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
										$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
										$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Update$AddGreenhouse)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.dg),
								A2($author$project$S$addButton, '', _List_Nil)
							]))
					]))
			]));
};
var $author$project$Page$QuoteBuilderV3$View$tableHeader = function (translation) {
	var centeredTitle = F2(
		function (widthInEm, str) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$em(widthInEm)),
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)),
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(200)))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(str)
					]));
		});
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$rem(1.1))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(2),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontWeight(
									$rtfeldman$elm_css$Css$int(200)))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(translation.jA)
					])),
				A2(centeredTitle, 7, translation.jD),
				A2(centeredTitle, 7, translation.dD),
				A2(centeredTitle, 7, translation.dC)
			]));
};
var $author$project$Page$QuoteBuilderV3$Discount$Update$Add = {$: 4};
var $author$project$Page$QuoteBuilderV3$Discount$Update$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Update$Remove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Update$StartEdition = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$View$amountCell = function (value) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$td,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$important(
						$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Formatter$Number$formatInt(value))
					]))
			]));
};
var $author$project$Theme$Icon$discountTag = A2($author$project$Theme$Icon$faIcon, 'tag', $author$project$Theme$Color$red);
var $author$project$Page$QuoteBuilderV3$Discount$View$editedView = F3(
	function (quote, index, discount) {
		var amount = A2($author$project$Page$QuoteBuilderV3$Quote$discountAmount, quote, discount);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[$author$project$Theme$Icon$discountTag])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$colspan(2)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(discount.jg)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$S$editButton,
									'',
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(1)))
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$QuoteBuilderV3$Discount$Update$StartEdition(index))
										])),
									A2(
									$author$project$S$removeButton,
									'',
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(1)))
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$QuoteBuilderV3$Discount$Update$Remove(index))
										]))
								]))
						])),
					$author$project$Page$QuoteBuilderV3$Discount$View$amountCell(amount.jY),
					$author$project$Page$QuoteBuilderV3$Discount$View$amountCell(amount.jC)
				]));
	});
var $author$project$Page$QuoteBuilderV3$Discount$Update$CancelEdition = {$: 2};
var $author$project$Page$QuoteBuilderV3$Discount$Update$ConfirmEdition = {$: 1};
var $author$project$Page$QuoteBuilderV3$Discount$View$editionButtons = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$S$okButton,
			'',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1)))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Discount$Update$ConfirmEdition)
				])),
			A2(
			$author$project$S$cancelButton,
			'',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1)))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Discount$Update$CancelEdition)
				]))
		]));
var $elmcraft$core_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$Amount = 0;
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$Percentage = 1;
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetDiscountType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetDurationInMonths = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetPurchase = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetSubscription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetValidUntil = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$View$discountTypeToString = function (discountType) {
	if (!discountType) {
		return '$';
	} else {
		return '%';
	}
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$View$en = {au: 'Duration in months', jC: 'Purchase', jY: 'Subscription', aF: 'Valid until'};
var $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node('form');
var $author$project$Page$QuoteBuilderV3$Discount$Form$View$fr = {au: 'Nombre de mois', jC: 'Achat', jY: 'Abonnement', aF: 'Valide jusqu\'à'};
var $author$project$Page$QuoteBuilderV3$Discount$Form$View$view = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Discount$Form$View$en, iI: $author$project$Page$QuoteBuilderV3$Discount$Form$View$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$author$project$Utils$Style$gap(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$S$labeled,
							'Description',
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-autofocus', ''),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.jg),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Discount$Form$Update$Name)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$labeled,
							'Type',
							_List_fromArray(
								[
									A5(
									$author$project$S$select,
									model.aH,
									_List_fromArray(
										[1, 0]),
									$author$project$Page$QuoteBuilderV3$Discount$Form$View$discountTypeToString,
									$author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetDiscountType,
									_List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$S$labeled,
							translation.jY,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.jY),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetSubscription)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$labeled,
							translation.jC,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.jC),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetPurchase)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$labeled,
							translation.au,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.au),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetDurationInMonths)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$labeled,
							translation.aF,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$type_('date'),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(model.aF),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Discount$Form$Update$SetValidUntil)
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Discount$View$customDiscountsView = F2(
	function (quote, model) {
		var editionRow = function (discount) {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$colspan(4),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$maxWidth(
									$rtfeldman$elm_css$Css$rem(2))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Page$QuoteBuilderV3$Discount$Update$FormMsg,
							A2($author$project$Page$QuoteBuilderV3$Discount$Form$View$view, quote.bx.i$, discount))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[$author$project$Page$QuoteBuilderV3$Discount$View$editionButtons]))
				]);
		};
		var _v0 = model.H;
		if (!_v0.$) {
			var index = _v0.a;
			var discount = _v0.b;
			return function (rows) {
				return _Utils_ap(
					rows,
					editionRow(discount));
			}(
				A2(
					$elm$core$List$indexedMap,
					$author$project$Page$QuoteBuilderV3$Discount$View$editedView(quote),
					A2($elmcraft$core_extra$List$Extra$removeAt, index, model.ch)));
		} else {
			return A2(
				$elm$core$List$indexedMap,
				$author$project$Page$QuoteBuilderV3$Discount$View$editedView(quote),
				model.ch);
		}
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $author$project$Page$QuoteBuilderV3$Discount$View$en = {cn: 'Discount'};
var $author$project$Page$QuoteBuilderV3$Discount$View$fr = {cn: 'Rabais'};
var $rtfeldman$elm_css$Html$Styled$tbody = $rtfeldman$elm_css$Html$Styled$node('tbody');
var $author$project$Page$QuoteBuilderV3$Discount$View$view = F4(
	function (language, user, quote, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Discount$View$en, iI: $author$project$Page$QuoteBuilderV3$Discount$View$fr});
		var addDisabled = !$elm$core$List$isEmpty(model.ch);
		return _List_fromArray(
			[
				A2(
				$author$project$Theme$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$th,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
												$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(translation.cn)
											])),
										A2(
										$author$project$S$when,
										$author$project$Domain$User$isOrisha(user),
										A2(
											$author$project$S$addButton,
											'',
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$important(
															$rtfeldman$elm_css$Css$fontSize(
																$rtfeldman$elm_css$Css$em(1.1))),
															A2(
															$author$project$Utils$Style$styleIf,
															addDisabled,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Css$opacity(
																	$rtfeldman$elm_css$Css$num(0.3)),
																	$rtfeldman$elm_css$Css$hover(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$opacity(
																			$rtfeldman$elm_css$Css$num(0.3))
																		])),
																	$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
																]))
														])),
													$rtfeldman$elm_css$Html$Styled$Attributes$disabled(addDisabled),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Discount$Update$Add)
												])))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$tbody,
				_List_Nil,
				A2($author$project$Page$QuoteBuilderV3$Discount$View$customDiscountsView, quote, model))
			]);
	});
var $author$project$Page$QuoteBuilderV3$Farm$Update$AddProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Farm$Update$CustomFieldMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$Farm$Update$RemoveProduct = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Farm$View$en = {ct: 'Extras', cB: 'For the farm'};
var $author$project$Page$QuoteBuilderV3$Farm$Update$ToggleShowExtras = {$: 2};
var $author$project$Theme$Icon$chevronDown = A2($author$project$Theme$Icon$faIcon, 'chevron-down', $rtfeldman$elm_css$Css$inherit);
var $author$project$Theme$Icon$chevronUp = A2($author$project$Theme$Icon$faIcon, 'chevron-up', $rtfeldman$elm_css$Css$inherit);
var $author$project$Page$QuoteBuilderV3$Farm$View$extrasHeader = F2(
	function (translation, model) {
		var chevron = model.bK ? $author$project$Theme$Icon$chevronUp : $author$project$Theme$Icon$chevronDown;
		return _List_fromArray(
			[
				$author$project$Theme$Table$subHeader(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Farm$Update$ToggleShowExtras)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.ct)
									])),
								chevron
							]))
					]))
			]);
	});
var $author$project$Page$QuoteBuilderV3$Farm$View$fr = {ct: 'Extras', cB: 'Pour toute la ferme'};
var $author$project$Page$QuoteBuilderV3$Quote$isUnique = function (product) {
	switch (product) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return true;
		case 8:
			return false;
		case 9:
			return false;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		case 13:
			return false;
		case 14:
			return false;
		case 15:
			return false;
		case 16:
			return true;
		case 17:
			return true;
		default:
			return true;
	}
};
var $author$project$Page$QuoteBuilderV3$Entry$centered = $rtfeldman$elm_css$Html$Styled$td(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]))
		]));
var $author$project$Page$QuoteBuilderV3$Entry$iconCell = function (details) {
	return $author$project$Page$QuoteBuilderV3$Entry$centered(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1.7))
							]))
					]),
				_List_fromArray(
					[details.iV]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Entry$nameCell = function (details) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$td,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(details.jg)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(0.6)),
								$rtfeldman$elm_css$Css$opacity(
								$rtfeldman$elm_css$Css$num(0.8))
							]))
					]),
				_List_fromArray(
					[details.jy]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Entry$priceStr = F2(
	function (quantity, price) {
		if (!price.$) {
			var subscription = price.a.jY;
			var purchase = price.a.jC;
			return _Utils_Tuple2(
				$author$project$Formatter$Number$formatInt(quantity * subscription),
				$author$project$Formatter$Number$formatInt(quantity * purchase));
		} else {
			var subscription = price.a.jY;
			return _Utils_Tuple2(
				$author$project$Formatter$Number$formatInt(quantity * subscription),
				'-');
		}
	});
var $author$project$Page$QuoteBuilderV3$Entry$quantityView = F5(
	function (details, quantity, onRemove, onAdd, attrs) {
		var buttonSize = $rtfeldman$elm_css$Css$em(0.9);
		var _v0 = A2($author$project$Page$QuoteBuilderV3$Entry$priceStr, quantity, details.jz);
		var subscriptionStr = _v0.a;
		var purchaseStr = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			attrs,
			_List_fromArray(
				[
					$author$project$Page$QuoteBuilderV3$Entry$iconCell(details),
					$author$project$Page$QuoteBuilderV3$Entry$nameCell(details),
					$author$project$Page$QuoteBuilderV3$Entry$centered(
					_List_fromArray(
						[
							A2(
							$author$project$S$minusButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(buttonSize)),
											(!quantity) ? $rtfeldman$elm_css$Css$batch(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$opacity(
														$rtfeldman$elm_css$Css$num(0)))
												])) : $author$project$S$noStyle
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(onRemove)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$margin2,
											$rtfeldman$elm_css$Css$px(0),
											$rtfeldman$elm_css$Css$em(1))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromInt(quantity))
								])),
							A2(
							$author$project$S$addButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(buttonSize))
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(onAdd)
								]))
						])),
					$author$project$Page$QuoteBuilderV3$Entry$centered(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(subscriptionStr)
						])),
					$author$project$Page$QuoteBuilderV3$Entry$centered(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(purchaseStr)
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Entry$toggleView = F4(
	function (details, isAdded, onToggle, attrs) {
		var quantity = isAdded ? 1 : 0;
		var _v0 = A2($author$project$Page$QuoteBuilderV3$Entry$priceStr, quantity, details.jz);
		var subscriptionStr = _v0.a;
		var purchaseStr = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			attrs,
			_List_fromArray(
				[
					$author$project$Page$QuoteBuilderV3$Entry$iconCell(details),
					$author$project$Page$QuoteBuilderV3$Entry$nameCell(details),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$S$checkbox,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$checked(isAdded),
											$rtfeldman$elm_css$Html$Styled$Events$onCheck(onToggle)
										]),
									_List_Nil)
								]))
						])),
					$author$project$Page$QuoteBuilderV3$Entry$centered(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(subscriptionStr)
						])),
					$author$project$Page$QuoteBuilderV3$Entry$centered(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(purchaseStr)
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$CustomField$Update$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$Update$Remove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$Update$StartEdition = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$View$editedView = F4(
	function (index, name, price, quantity) {
		var priceCell = function (p) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Formatter$Number$formatInt(p))
							]))
					]));
		};
		var _v0 = function () {
			if (!price.$) {
				var subscription = price.a.jY;
				var purchase = price.a.jC;
				return _Utils_Tuple2(subscription, purchase);
			} else {
				var subscription = price.a.jY;
				return _Utils_Tuple2(subscription, 0);
			}
		}();
		var subscriptionInt = _v0.a;
		var purchaseInt = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$important(
									$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$marginLeft(
												$rtfeldman$elm_css$Css$em(-0.15)))
										]))
								]),
							_List_fromArray(
								[$author$project$Theme$Icon$custom]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(name)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$S$editButton,
									'',
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(1)))
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$QuoteBuilderV3$CustomField$Update$StartEdition(index))
										])),
									A2(
									$author$project$S$removeButton,
									'',
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$important(
													$rtfeldman$elm_css$Css$fontSize(
														$rtfeldman$elm_css$Css$em(1)))
												])),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Page$QuoteBuilderV3$CustomField$Update$Remove(index))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(quantity))
						])),
					priceCell(quantity * subscriptionInt),
					priceCell(quantity * purchaseInt)
				]));
	});
var $author$project$Page$QuoteBuilderV3$CustomField$Update$CancelEdition = {$: 2};
var $author$project$Page$QuoteBuilderV3$CustomField$Update$ConfirmEdition = {$: 1};
var $author$project$Page$QuoteBuilderV3$CustomField$View$editionButtons = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$S$okButton,
			'',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1))),
							$rtfeldman$elm_css$Css$marginLeft(
							$rtfeldman$elm_css$Css$em(1))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$CustomField$Update$ConfirmEdition)
				])),
			A2(
			$author$project$S$cancelButton,
			'',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$important(
							$rtfeldman$elm_css$Css$fontSize(
								$rtfeldman$elm_css$Css$em(1)))
						])),
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$CustomField$Update$CancelEdition)
				]))
		]));
var $author$project$Page$QuoteBuilderV3$CustomField$Form$Update$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$Form$Update$PurchaseAmount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$Form$Update$Quantity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$Form$Update$SubscriptionAmount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$CustomField$Form$View$en = {dI: 'Purchase ($)', jD: 'Quantity', ej: 'Subscription ($/month)'};
var $author$project$Page$QuoteBuilderV3$CustomField$Form$View$fr = {dI: 'Achat ($)', jD: 'Quantité', ej: 'Abonnement ($/mois)'};
var $author$project$Page$QuoteBuilderV3$CustomField$Form$View$view = F2(
	function (language, customProduct) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$CustomField$Form$View$en, iI: $author$project$Page$QuoteBuilderV3$CustomField$Form$View$fr});
		var _v0 = function () {
			var _v1 = customProduct.jz;
			if (!_v1.$) {
				var subscription = _v1.a.jY;
				var purchase = _v1.a.jC;
				return _Utils_Tuple2(subscription, purchase);
			} else {
				var subscription = _v1.a.jY;
				return _Utils_Tuple2(subscription, 0);
			}
		}();
		var subscriptionInt = _v0.a;
		var purchaseInt = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
							$author$project$Utils$Style$gap(
							$rtfeldman$elm_css$Css$rem(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$S$labeled,
							'Description',
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$vw(20))
												])),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(customProduct.jg),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-autofocus', ''),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$CustomField$Form$Update$Name)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$labeled,
							translation.jD,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$vw(7.5))
												])),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(customProduct.jD)),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$CustomField$Form$Update$Quantity)
										]),
									_List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$rem(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$S$labeled,
							translation.ej,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$vw(7.5))
												])),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$author$project$Formatter$Number$formatInt(subscriptionInt)),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$CustomField$Form$Update$SubscriptionAmount)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$labeled,
							translation.dI,
							_List_fromArray(
								[
									A2(
									$author$project$S$input,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$vw(7.5))
												])),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$author$project$Formatter$Number$formatInt(purchaseInt)),
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$CustomField$Form$Update$PurchaseAmount)
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$CustomField$View$editionView = F2(
	function (language, model) {
		var _v0 = model.H;
		if (!_v0.$) {
			var customProduct = _v0.b;
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$td,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$displayFlex,
													$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
													$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
													$rtfeldman$elm_css$Css$padding(
													$rtfeldman$elm_css$Css$em(0.5))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$map,
											$author$project$Page$QuoteBuilderV3$CustomField$Update$FormMsg,
											A2($author$project$Page$QuoteBuilderV3$CustomField$Form$View$view, language, customProduct)),
											$author$project$Page$QuoteBuilderV3$CustomField$View$editionButtons
										]))
								]))
						]))
				]);
		} else {
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, c) {
						return A4($author$project$Page$QuoteBuilderV3$CustomField$View$editedView, index, c.jg, c.jz, c.jD);
					}),
				model.il);
		}
	});
var $author$project$Page$QuoteBuilderV3$CustomField$View$en = {ci: 'Custom Device'};
var $author$project$Page$QuoteBuilderV3$CustomField$View$fr = {ci: 'Équipement sur mesure'};
var $author$project$Page$QuoteBuilderV3$CustomField$Update$Add = {$: 4};
var $author$project$Page$QuoteBuilderV3$CustomField$View$section = function (translation) {
	return _List_fromArray(
		[
			$author$project$Theme$Table$subHeader(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.ci)
								])),
							A2(
							$author$project$S$addButton,
							'',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$important(
											$rtfeldman$elm_css$Css$fontSize(
												$rtfeldman$elm_css$Css$em(0.9))),
											$rtfeldman$elm_css$Css$marginRight(
											$rtfeldman$elm_css$Css$rem(0.5))
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$CustomField$Update$Add)
								]))
						]))
				]))
		]);
};
var $author$project$Page$QuoteBuilderV3$CustomField$View$view = F3(
	function (language, user, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$CustomField$View$en, iI: $author$project$Page$QuoteBuilderV3$CustomField$View$fr});
		return $author$project$Domain$User$isOrisha(user) ? $elm$core$List$concat(
			_List_fromArray(
				[
					$author$project$Page$QuoteBuilderV3$CustomField$View$section(translation),
					A2($author$project$Page$QuoteBuilderV3$CustomField$View$editionView, language, model)
				])) : _List_fromArray(
			[$author$project$S$empty]);
	});
var $author$project$Page$QuoteBuilderV3$Farm$View$view = F4(
	function (language, user, client, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Farm$View$en, iI: $author$project$Page$QuoteBuilderV3$Farm$View$fr});
		var productView = function (product) {
			var details = A3($author$project$Page$QuoteBuilderV3$Quote$productDetails, language, client.ik, product);
			return $author$project$Page$QuoteBuilderV3$Quote$isUnique(product) ? A4(
				$author$project$Page$QuoteBuilderV3$Entry$toggleView,
				details,
				A2($elm$core$List$member, product, model.jA),
				function (checked) {
					return checked ? $author$project$Page$QuoteBuilderV3$Farm$Update$AddProduct(product) : $author$project$Page$QuoteBuilderV3$Farm$Update$RemoveProduct(product);
				},
				_List_Nil) : A5(
				$author$project$Page$QuoteBuilderV3$Entry$quantityView,
				details,
				A2(
					$elmcraft$core_extra$List$Extra$count,
					$elm$core$Basics$eq(product),
					model.jA),
				$author$project$Page$QuoteBuilderV3$Farm$Update$RemoveProduct(product),
				$author$project$Page$QuoteBuilderV3$Farm$Update$AddProduct(product),
				_List_Nil);
		};
		var farmProducts = A2($elm$core$List$filter, $author$project$Page$QuoteBuilderV3$Quote$isPerFarm, $author$project$Page$QuoteBuilderV3$Quote$allProducts);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Theme$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.cB)
									]))
							]))
					]),
					A2(
					$elm$core$List$map,
					productView,
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Page$QuoteBuilderV3$Quote$isExtra),
						farmProducts)),
					A2($author$project$Page$QuoteBuilderV3$Farm$View$extrasHeader, translation, model),
					model.bK ? A2(
					$elm$core$List$map,
					productView,
					A2($elm$core$List$filter, $author$project$Page$QuoteBuilderV3$Quote$isExtra, farmProducts)) : _List_Nil,
					A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Page$QuoteBuilderV3$Farm$Update$CustomFieldMsg),
					A3($author$project$Page$QuoteBuilderV3$CustomField$View$view, language, user, model.a6))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$AddProduct = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$CustomFieldMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$RemoveProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$en = {ct: 'Extras'};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$ToggleShowExtras = {$: 2};
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$extrasHeader = F2(
	function (translation, model) {
		var chevron = model.bK ? $author$project$Theme$Icon$chevronUp : $author$project$Theme$Icon$chevronDown;
		return _List_fromArray(
			[
				$author$project$Theme$Table$subHeader(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Greenhouse$Update$ToggleShowExtras)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center)
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(translation.ct)
									])),
								chevron
							]))
					]))
			]);
	});
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$fr = {ct: 'Extras'};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Clone = {$: 9};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Remove = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$CancelNameEdition = {$: 7};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$ConfirmNameEdition = {$: 6};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Name = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$nameEditionView = function (initial) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$S$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$value(initial),
						$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Greenhouse$Update$Name),
						$author$project$Utils$Events$onEnter($author$project$Page$QuoteBuilderV3$Greenhouse$Update$ConfirmNameEdition)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$S$okButton,
						'',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$important(
										$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$em(1))),
										$rtfeldman$elm_css$Css$marginLeft(
										$rtfeldman$elm_css$Css$em(1))
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Greenhouse$Update$ConfirmNameEdition)
							])),
						A2(
						$author$project$S$cancelButton,
						'',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$important(
										$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$em(1)))
									])),
								$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Greenhouse$Update$CancelNameEdition)
							]))
					]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$StartNameEdition = {$: 4};
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$nameView = function (greenhouseName) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$p,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$displayFlex,
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
						$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
						$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(greenhouseName),
				A2(
				$author$project$S$editButton,
				'',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$important(
								$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(0.8))),
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$em(1))
							])),
						$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Greenhouse$Update$StartNameEdition)
					]))
			]));
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$greenhouseHeader = F2(
	function (language, model) {
		var nameDisplay = function () {
			var _v0 = model.jg;
			switch (_v0.$) {
				case 0:
					var input = _v0.a.fu;
					return $author$project$Page$QuoteBuilderV3$Greenhouse$View$nameEditionView(input);
				case 1:
					var greenhouseName = _v0.a;
					return $author$project$Page$QuoteBuilderV3$Greenhouse$View$nameView(greenhouseName);
				default:
					return $author$project$Page$QuoteBuilderV3$Greenhouse$View$nameView(
						A2($author$project$Page$QuoteBuilderV3$Greenhouse$Update$defaultName, language, model));
			}
		}();
		return A2(
			$author$project$Theme$Table$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$th,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$colspan(5)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
										]))
								]),
							_List_fromArray(
								[
									nameDisplay,
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$S$cloneButton,
											'',
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$important(
															$rtfeldman$elm_css$Css$fontSize(
																$rtfeldman$elm_css$Css$rem(1.1))),
															$rtfeldman$elm_css$Css$marginRight(
															$rtfeldman$elm_css$Css$rem(1))
														])),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Page$QuoteBuilderV3$Greenhouse$Update$Clone)
												])),
											A2(
											$author$project$S$removeButton,
											'',
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$important(
															$rtfeldman$elm_css$Css$fontSize(
																$rtfeldman$elm_css$Css$rem(1.1)))
														])),
													$rtfeldman$elm_css$Html$Styled$Events$onClick(
													$author$project$Page$QuoteBuilderV3$Greenhouse$Update$Remove(model.cN))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Greenhouse$View$view = F4(
	function (language, client, user, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Greenhouse$View$en, iI: $author$project$Page$QuoteBuilderV3$Greenhouse$View$fr});
		var productView = function (product) {
			var details = A3($author$project$Page$QuoteBuilderV3$Quote$productDetails, language, client.ik, product);
			return $author$project$Page$QuoteBuilderV3$Quote$isUnique(product) ? A4(
				$author$project$Page$QuoteBuilderV3$Entry$toggleView,
				details,
				A2($elm$core$List$member, product, model.jA),
				function (checked) {
					return checked ? $author$project$Page$QuoteBuilderV3$Greenhouse$Update$AddProduct(product) : $author$project$Page$QuoteBuilderV3$Greenhouse$Update$RemoveProduct(product);
				},
				_List_Nil) : A5(
				$author$project$Page$QuoteBuilderV3$Entry$quantityView,
				details,
				A2(
					$elmcraft$core_extra$List$Extra$count,
					$elm$core$Basics$eq(product),
					model.jA),
				$author$project$Page$QuoteBuilderV3$Greenhouse$Update$RemoveProduct(product),
				$author$project$Page$QuoteBuilderV3$Greenhouse$Update$AddProduct(product),
				_List_Nil);
		};
		var greenhouseProducts = A2($elm$core$List$filter, $author$project$Page$QuoteBuilderV3$Quote$isPerGreenhouse, $author$project$Page$QuoteBuilderV3$Quote$allProducts);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($author$project$Page$QuoteBuilderV3$Greenhouse$View$greenhouseHeader, client.i$, model)
					]),
					A2(
					$elm$core$List$map,
					productView,
					A2(
						$elm$core$List$filter,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Page$QuoteBuilderV3$Quote$isExtra),
						greenhouseProducts)),
					A2($author$project$Page$QuoteBuilderV3$Greenhouse$View$extrasHeader, translation, model),
					model.bK ? A2(
					$elm$core$List$map,
					productView,
					A2($elm$core$List$filter, $author$project$Page$QuoteBuilderV3$Quote$isExtra, greenhouseProducts)) : _List_Nil,
					A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$Html$Styled$map($author$project$Page$QuoteBuilderV3$Greenhouse$Update$CustomFieldMsg),
					A3($author$project$Page$QuoteBuilderV3$CustomField$View$view, language, user, model.a6))
				]));
	});
var $author$project$Page$QuoteBuilderV3$View$tableView = F4(
	function (language, translation, user, model) {
		var quote = $author$project$Page$QuoteBuilderV3$Update$toQuote(model);
		return A2(
			$author$project$S$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(5))
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$colgroup,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$col,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(5))
												]))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$col,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(50))
												]))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$col,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(15))
												]))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$col,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(15))
												]))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$col,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$pct(15))
												]))
										]),
									_List_Nil)
								])),
							$author$project$Page$QuoteBuilderV3$View$tableHeader(translation)
						]),
						$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (index) {
								return $elm$core$List$map(
									$rtfeldman$elm_css$Html$Styled$map(
										$author$project$Page$QuoteBuilderV3$Update$GreenhouseMsg(index)));
							},
							A2(
								$elm$core$List$map,
								A3($author$project$Page$QuoteBuilderV3$Greenhouse$View$view, language, model.bx, user),
								model.ay))),
						_List_fromArray(
						[
							$author$project$Page$QuoteBuilderV3$View$greenhouseAddition(translation)
						]),
						A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Page$QuoteBuilderV3$Update$FarmMsg),
						A4($author$project$Page$QuoteBuilderV3$Farm$View$view, language, user, model.bx, model.av)),
						A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$map($author$project$Page$QuoteBuilderV3$Update$DiscountMsg),
						A4($author$project$Page$QuoteBuilderV3$Discount$View$view, language, user, quote, model.gy))
					])));
	});
var $author$project$Page$QuoteBuilderV3$Client$Email = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$QuoteBuilderV3$Client$FarmAddress = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$QuoteBuilderV3$Client$FarmName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$QuoteBuilderV3$Client$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Client$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Style$Grid$columnGap = function (length) {
	return A2($rtfeldman$elm_css$Css$property, 'column-gap', length.hR);
};
var $author$project$Page$QuoteBuilderV3$Client$CurrencySelection = function (a) {
	return {$: 6, a: a};
};
var $author$project$Domain$Total$Amount$currencyToString = function (currency) {
	if (!currency) {
		return 'CAD';
	} else {
		return 'USD';
	}
};
var $author$project$Page$QuoteBuilderV3$Client$currencyView = F2(
	function (translation, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(50))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$S$labeled,
					translation.dK,
					_List_fromArray(
						[
							A5(
							$author$project$S$select,
							model.ik,
							_List_fromArray(
								[0, 1]),
							$author$project$Domain$Total$Amount$currencyToString,
							$author$project$Page$QuoteBuilderV3$Client$CurrencySelection,
							_List_Nil)
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Client$en = {ix: 'Email', iy: 'English', iF: 'Farm Address', iG: 'Farm name', gG: 'First name', iI: 'French', g3: 'Last name', dK: 'Quote Currency', dL: 'Quote Language'};
var $author$project$Page$QuoteBuilderV3$Client$fr = {ix: 'Email', iy: 'Anglais', iF: 'Adresse de la ferme', iG: 'Nom de la ferme', gG: 'Prénom', iI: 'Français', g3: 'Nom de famille', dK: 'Devise du devis', dL: 'Langue du devis'};
var $author$project$Page$QuoteBuilderV3$Client$LanguageSelection = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$QuoteBuilderV3$Client$languageToString = F2(
	function (translation, language) {
		if (!language) {
			return translation.iy;
		} else {
			return translation.iI;
		}
	});
var $author$project$Page$QuoteBuilderV3$Client$languageSelectionView = F2(
	function (translation, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(50))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$S$labeled,
					translation.dL,
					_List_fromArray(
						[
							A5(
							$author$project$S$select,
							model.i$,
							_List_fromArray(
								[1, 0]),
							$author$project$Page$QuoteBuilderV3$Client$languageToString(translation),
							$author$project$Page$QuoteBuilderV3$Client$LanguageSelection,
							_List_Nil)
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$Client$view = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$Client$en, iI: $author$project$Page$QuoteBuilderV3$Client$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$Style$Grid$displayGrid,
							$author$project$Style$Grid$gridTemplateColumns('1fr 1fr'),
							$author$project$Style$Grid$columnGap(
							$rtfeldman$elm_css$Css$rem(3)),
							$author$project$Style$Grid$rowGap(
							$rtfeldman$elm_css$Css$rem(2)),
							$rtfeldman$elm_css$Css$marginTop(
							$rtfeldman$elm_css$Css$rem(4))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$S$labeled,
					translation.gG,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.gG),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Client$FirstName)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$S$labeled,
					translation.g3,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.g3),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Client$LastName)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$S$labeled,
					translation.iG,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.iG),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Client$FarmName)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$Page$QuoteBuilderV3$Client$languageSelectionView, translation, model),
							A2($author$project$Page$QuoteBuilderV3$Client$currencyView, translation, model)
						])),
					A2(
					$author$project$S$labeled,
					translation.iF,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.iF),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Client$FarmAddress)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$right(
											$rtfeldman$elm_css$Css$em(0.5)),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$em(0.5)),
											$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('∗')
								]))
						])),
					A2(
					$author$project$S$labeled,
					translation.ix,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.ix),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Client$Email)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$right(
											$rtfeldman$elm_css$Css$em(0.5)),
											$rtfeldman$elm_css$Css$top(
											$rtfeldman$elm_css$Css$em(0.5)),
											$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('∗')
								]))
						]))
				]));
	});
var $author$project$Page$QuoteBuilderV3$View$view = F3(
	function (language, user, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Page$QuoteBuilderV3$View$en, iI: $author$project$Page$QuoteBuilderV3$View$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$map,
					$author$project$Page$QuoteBuilderV3$Update$ClientMsg,
					A2($author$project$Page$QuoteBuilderV3$Client$view, language, model.bx)),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$author$project$Utils$Style$gap(
									$rtfeldman$elm_css$Css$rem(2)),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$rem(2))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$S$labeled,
							translation.dH,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$displayFlex,
													$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
													$author$project$Utils$Style$gap(
													$rtfeldman$elm_css$Css$em(0.3))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('PRJ -')
												])),
											A2(
											$author$project$S$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(model.dH),
													$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Update$SetProjectId)
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
															$rtfeldman$elm_css$Css$right(
															$rtfeldman$elm_css$Css$em(0.5)),
															$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('∗')
												]))
										]))
								])),
							A2(
							$author$project$S$labeled,
							translation.gw,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$displayFlex,
													$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$S$input,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(model.gw),
													$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Page$QuoteBuilderV3$Update$SetCustomerId)
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
															$rtfeldman$elm_css$Css$right(
															$rtfeldman$elm_css$Css$em(0.5)),
															$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('∗')
												]))
										]))
								]))
						])),
					A4($author$project$Page$QuoteBuilderV3$View$tableView, language, translation, user, model)
				]));
	});
var $author$project$View$content = F2(
	function (user, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			model.i$,
			{iy: $author$project$View$en, iI: $author$project$View$fr});
		var quoteV3 = $author$project$Page$QuoteBuilderV3$Update$toQuote(model.ag);
		var errorView = function (error) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$padding(
								$rtfeldman$elm_css$Css$em(5)),
								$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$white),
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$vh(20)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$vw(30)),
								$rtfeldman$elm_css$Css$maxWidth(
								$rtfeldman$elm_css$Css$vw(60)),
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
								$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontSize(
										$rtfeldman$elm_css$Css$em(2)),
										$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red),
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$em(0.7))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.bz)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$em(0.5))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.b3)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$em(0.5))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(translation.cP)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
										$rtfeldman$elm_css$Css$color($author$project$Theme$Color$red)
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(error)
							]))
					]));
		};
		var discovery = $author$project$Page$Discovery$Update$toQuote(model.aI);
		var body = function () {
			var _v0 = _Utils_Tuple2(model.fe, model.ff);
			if (!_v0.a.$) {
				var error = _v0.a.a;
				return errorView(
					A2($author$project$Route$Quote$Discovery$Error$errorMessage, model.i$, error));
			} else {
				if (!_v0.b.$) {
					var error = _v0.b.a;
					return errorView(
						A2($author$project$Route$Quote$Discovery$QuoteBuilder$Common$errorMessage, model.i$, error));
				} else {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					var _v3 = model.bG;
					switch (_v3) {
						case 0:
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$View$mainBox,
										model.i$,
										A2(
											$rtfeldman$elm_css$Html$Styled$map,
											$author$project$Update$DiscoveryMsg,
											A3($author$project$Page$Discovery$View$view, model.i$, model.aI, user)))
									]));
						case 1:
							var saveButtonLabel = function () {
								var _v4 = model.d2;
								switch (_v4) {
									case 0:
										return translation.bJ;
									case 1:
										return translation.d1;
									default:
										return translation.bJ;
								}
							}();
							var noProjectId = $elm$core$String$isEmpty(model.ag.dH);
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$author$project$S$onPrint(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$View$mainBox,
												model.i$,
												A2(
													$rtfeldman$elm_css$Html$Styled$map,
													$author$project$Update$QuoteBuilderV3Msg,
													A3($author$project$Page$QuoteBuilderV3$View$view, model.i$, user, model.ag))),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
																$rtfeldman$elm_css$Css$top(
																$rtfeldman$elm_css$Css$vh(2.5)),
																$rtfeldman$elm_css$Css$right(
																$rtfeldman$elm_css$Css$vw(3))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$box),
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Css$width(
																		$rtfeldman$elm_css$Css$vw(20))
																	]))
															]),
														_List_fromArray(
															[
																A2($author$project$Page$QuoteBuilderV3$Total$view, model.i$, model.ag)
															])),
														A2(
														$author$project$S$saveButton,
														saveButtonLabel,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$box),
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Css$padding(
																		$rtfeldman$elm_css$Css$rem(0.5)),
																		$rtfeldman$elm_css$Css$opacity(
																		$rtfeldman$elm_css$Css$num(1)),
																		$rtfeldman$elm_css$Css$zIndex(
																		$rtfeldman$elm_css$Css$int(10)),
																		$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$white),
																		A2(
																		$author$project$Utils$Style$styleIf,
																		noProjectId || (model.d2 === 1),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Css$opacity(
																				$rtfeldman$elm_css$Css$num(0.5)),
																				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
																			]))
																	])),
																$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Update$SaveQuote)
															])),
														A2(
														$author$project$S$when,
														$elmcraft$core_extra$Maybe$Extra$isJust(model.bH),
														A2(
															$author$project$S$saveButton,
															translation.cp,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class($author$project$Style$Bulma$box),
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$padding(
																			$rtfeldman$elm_css$Css$rem(0.5)),
																			$rtfeldman$elm_css$Css$opacity(
																			$rtfeldman$elm_css$Css$num(1)),
																			$rtfeldman$elm_css$Css$zIndex(
																			$rtfeldman$elm_css$Css$int(10)),
																			$rtfeldman$elm_css$Css$backgroundColor($author$project$Theme$Color$white)
																		])),
																	$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Update$DownloadQuote)
																]))),
														A2(
														$author$project$S$when,
														noProjectId,
														A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
																		]))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(translation.dA)
																]))),
														A2(
														$author$project$S$when,
														model.d2 === 2,
														A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
																		]))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(translation.cu)
																])))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$displayFlex,
																$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
																$rtfeldman$elm_css$Css$fontSize(
																$rtfeldman$elm_css$Css$rem(4)),
																$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
																$rtfeldman$elm_css$Css$color($author$project$Theme$Color$orishaGreen),
																A2($rtfeldman$elm_css$Css$property, '-webkit-text-stroke', '2px black'),
																$rtfeldman$elm_css$Css$marginTop(
																$rtfeldman$elm_css$Css$rem(4)),
																$author$project$Theme$Font$rubik,
																$author$project$S$onPrint(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
																	]))
															]))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Preview')
													])),
												A2(
												$elm$core$Maybe$withDefault,
												$author$project$S$empty,
												A3(
													$elm$core$Maybe$map2,
													F2(
														function (here, now) {
															return A4($author$project$Page$QuoteBuilderV3$Preview$View$view, here, now, model.bS, model.ag);
														}),
													model.er,
													model.dn))
											]))
									]));
						default:
							return A2(
								$author$project$View$printLayout,
								model,
								A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$View$mainBox,
											model.i$,
											A2(
												$rtfeldman$elm_css$Html$Styled$map,
												$author$project$Update$PackingSlipMsg,
												A5($author$project$Page$PackingSlip$view, model.bS, discovery, quoteV3, true, model.dv))),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$author$project$S$notOnPrint(
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
																])),
															$author$project$S$onPrint(
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Css$property, 'break-before', 'always'),
																	A2($rtfeldman$elm_css$Css$property, 'break-inside', 'avoid')
																]))
														]))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$map,
													$author$project$Update$PackingSlipMsg,
													A5($author$project$Page$PackingSlip$view, model.bS, discovery, quoteV3, false, model.dv))
												]))
										])));
					}
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Menu$view, model.i$, user, model.bG),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$marginLeft(
									$rtfeldman$elm_css$Css$vw(24)),
									$author$project$S$onPrint(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginLeft(
											$rtfeldman$elm_css$Css$px(0))
										]))
								]))
						]),
					_List_fromArray(
						[body]))
				]));
	});
var $rtfeldman$elm_css$Css$cover = {az: 0, hR: 'cover'};
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $author$project$Update$LoginMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Login$Page$ComponentsMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$Page$Submit = {$: 1};
var $author$project$Login$Page$en = {dl: 'No user with these informations', ea: 'Sign in'};
var $author$project$Login$Page$fr = {dl: 'Aucun collaborateur avec ces informations', ea: 'Se connecter'};
var $rtfeldman$elm_css$Html$Styled$Attributes$alt = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('alt');
var $author$project$Login$Components$en = {hg: 'Password', dM: 'Quoting tool', hQ: 'Username'};
var $author$project$Login$Components$fr = {hg: 'Mot de passe', dM: 'Outil de devis', hQ: 'Nom d\'utilisateur'};
var $rtfeldman$elm_css$Css$overflowX = $rtfeldman$elm_css$Css$prop1('overflow-x');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $author$project$Login$Components$layout = F2(
	function (language, body) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Login$Components$en, iI: $author$project$Login$Components$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$flex(
							$rtfeldman$elm_css$Css$int(1)),
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
									$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
									$rtfeldman$elm_css$Css$backgroundColor(
									A2($author$project$Theme$Color$withOpacity, 0.7, $author$project$Theme$Color$white)),
									$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
									$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden),
									$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
									$rtfeldman$elm_css$Css$height(
									$rtfeldman$elm_css$Css$vh(100)),
									A4(
									$rtfeldman$elm_css$Css$padding4,
									$rtfeldman$elm_css$Css$rem(4),
									$rtfeldman$elm_css$Css$rem(18),
									$rtfeldman$elm_css$Css$rem(6),
									$rtfeldman$elm_css$Css$rem(18))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$px(300)),
											$rtfeldman$elm_css$Css$paddingBottom(
											$rtfeldman$elm_css$Css$rem(2.5))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$Theme$ImgPath$logo),
											$rtfeldman$elm_css$Html$Styled$Attributes$alt('Orisha\'s logo')
										]),
									_List_Nil)
								])),
							A2(
							$author$project$S$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.dM)
								])),
							body
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$em = $rtfeldman$elm_css$Html$Styled$node('em');
var $author$project$Style$Status$errorLine = function (errorMsg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$em,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$fontSize(
						$rtfeldman$elm_css$Css$em(0.8)),
						$rtfeldman$elm_css$Css$color($author$project$Theme$Color$brightRed)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(errorMsg)
			]));
};
var $author$project$Style$Status$maybeErrorLine = function (errorMsg) {
	return A2(
		$elm$core$Maybe$withDefault,
		$rtfeldman$elm_css$Html$Styled$text(''),
		A2($elm$core$Maybe$map, $author$project$Style$Status$errorLine, errorMsg));
};
var $author$project$S$maybeErrorLine = $author$project$Style$Status$maybeErrorLine;
var $rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Login$Components$Password = function (a) {
	return {$: 1, a: a};
};
var $author$project$Login$Components$passwordField = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Login$Components$en, iI: $author$project$Login$Components$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$em(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.hg)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$S$input,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hg),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('password'),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$em(10)),
											$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
										])),
									$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Login$Components$Password)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Style$Buttons$blueButton = $rtfeldman$elm_css$Css$color($author$project$Theme$Color$linkBlue);
var $rtfeldman$elm_css$Css$textDecoration = $rtfeldman$elm_css$Css$prop1('text-decoration');
var $author$project$Style$Buttons$submitButton = F2(
	function (buttonText, attrs) {
		return A4(
			$rtfeldman$elm_css$Html$Styled$styled,
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]),
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
				attrs),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$fontSize(
									$rtfeldman$elm_css$Css$em(2)),
									$author$project$Style$Buttons$blueButton,
									$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
									$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(buttonText)
						]))
				]));
	});
var $author$project$S$submitButton = $author$project$Style$Buttons$submitButton;
var $author$project$Login$Page$translateError = F2(
	function (language, _v0) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Login$Page$en, iI: $author$project$Login$Page$fr});
		return translation.dl;
	});
var $author$project$Login$Components$Username = function (a) {
	return {$: 0, a: a};
};
var $author$project$Login$Components$usernameField = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Login$Components$en, iI: $author$project$Login$Components$fr});
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$displayFlex,
							$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
							$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$em(1))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginRight(
									$rtfeldman$elm_css$Css$em(1))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$label,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(translation.hQ)
								]))
						])),
					A2(
					$author$project$S$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(model.hQ),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$em(10)),
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
								])),
							$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Login$Components$Username)
						]),
					_List_Nil)
				]));
	});
var $author$project$Login$Page$view = F2(
	function (language, model) {
		var translation = A2(
			$author$project$Language$getTranslation,
			language,
			{iy: $author$project$Login$Page$en, iI: $author$project$Login$Page$fr});
		return A2(
			$author$project$Login$Components$layout,
			language,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(300))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onSubmit($author$project$Login$Page$Submit)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
												$rtfeldman$elm_css$Css$marginTop(
												$rtfeldman$elm_css$Css$rem(6))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Login$Page$ComponentsMsg,
										A2($author$project$Login$Components$usernameField, language, model.at)),
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Login$Page$ComponentsMsg,
										A2($author$project$Login$Components$passwordField, language, model.at))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
												$rtfeldman$elm_css$Css$paddingTop(
												$rtfeldman$elm_css$Css$rem(2))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
													]))
											]),
										_List_fromArray(
											[
												$author$project$S$maybeErrorLine(
												A2(
													$elm$core$Maybe$map,
													$author$project$Login$Page$translateError(language),
													model.bz))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$marginTop(
														$rtfeldman$elm_css$Css$rem(1)),
														$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
													]))
											]),
										_List_fromArray(
											[
												A2($author$project$S$submitButton, translation.ea, _List_Nil)
											]))
									]))
							]))
					])));
	});
var $author$project$View$loginView = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$map,
		$author$project$Update$LoginMsg,
		A2($author$project$Login$Page$view, model.i$, model.c2));
};
var $author$project$Update$topAnchor = 'top';
var $rtfeldman$elm_css$Css$url = function (urlValue) {
	return {a2: 0, hR: 'url(' + (urlValue + ')')};
};
var $author$project$View$view = function (model) {
	var page = function (f) {
		return f(model);
	}(
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$View$loginView,
			A2($elm$core$Maybe$map, $author$project$View$content, model.bT)));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id($author$project$Update$topAnchor)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
								$rtfeldman$elm_css$Css$backgroundImage(
								$rtfeldman$elm_css$Css$url($author$project$Theme$ImgPath$background)),
								$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$pct(100)),
								$rtfeldman$elm_css$Css$zIndex(
								$rtfeldman$elm_css$Css$int(-10))
							]))
					]),
				_List_Nil),
				page
			]));
};
var $author$project$Main$mainView = function (model) {
	return {
		ic: _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				$author$project$View$view(model))
			]),
		j2: 'Orisha - Soumission'
	};
};
var $author$project$Update$ReceiveHtml = function (a) {
	return {$: 8, a: a};
};
var $author$project$Update$UserLoggedIn = function (a) {
	return {$: 14, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Port$In$receiveHtml = _Platform_incomingPort('receiveHtml', $elm$json$Json$Decode$string);
var $author$project$Port$In$sessionSaved = _Platform_incomingPort('sessionSaved', $elm$json$Json$Decode$string);
var $author$project$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Port$In$sessionSaved($author$project$Update$UserLoggedIn),
			$author$project$Port$In$receiveHtml($author$project$Update$ReceiveHtml)
		]));
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm_community$easing_functions$Ease$flip = F2(
	function (easing, time) {
		return 1 - easing(1 - time);
	});
var $elm_community$easing_functions$Ease$inQuint = function (time) {
	return A2($elm$core$Basics$pow, time, 5);
};
var $elm_community$easing_functions$Ease$outQuint = $elm_community$easing_functions$Ease$flip($elm_community$easing_functions$Ease$inQuint);
var $linuss$smooth_scroll$SmoothScroll$defaultConfig = {fi: $elm_community$easing_functions$Ease$outQuint, c: 12, jV: 200};
var $author$project$Port$Out$deleteSession = _Platform_outgoingPort(
	'deleteSession',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elmcraft$core_extra$String$Diacritics$lookupList = _List_fromArray(
	[
		_Utils_Tuple2('Ⓐ', 'A'),
		_Utils_Tuple2('Ａ', 'A'),
		_Utils_Tuple2('À', 'A'),
		_Utils_Tuple2('Á', 'A'),
		_Utils_Tuple2('Â', 'A'),
		_Utils_Tuple2('Ầ', 'A'),
		_Utils_Tuple2('Ấ', 'A'),
		_Utils_Tuple2('Ẫ', 'A'),
		_Utils_Tuple2('Ẩ', 'A'),
		_Utils_Tuple2('Ã', 'A'),
		_Utils_Tuple2('Ā', 'A'),
		_Utils_Tuple2('Ă', 'A'),
		_Utils_Tuple2('Ằ', 'A'),
		_Utils_Tuple2('Ắ', 'A'),
		_Utils_Tuple2('Ẵ', 'A'),
		_Utils_Tuple2('Ẳ', 'A'),
		_Utils_Tuple2('Ȧ', 'A'),
		_Utils_Tuple2('Ǡ', 'A'),
		_Utils_Tuple2('Ä', 'A'),
		_Utils_Tuple2('Ǟ', 'A'),
		_Utils_Tuple2('Ả', 'A'),
		_Utils_Tuple2('Å', 'A'),
		_Utils_Tuple2('Ǻ', 'A'),
		_Utils_Tuple2('Ǎ', 'A'),
		_Utils_Tuple2('Ȁ', 'A'),
		_Utils_Tuple2('Ȃ', 'A'),
		_Utils_Tuple2('Ạ', 'A'),
		_Utils_Tuple2('Ậ', 'A'),
		_Utils_Tuple2('Ặ', 'A'),
		_Utils_Tuple2('Ḁ', 'A'),
		_Utils_Tuple2('Ą', 'A'),
		_Utils_Tuple2('Ⱥ', 'A'),
		_Utils_Tuple2('Ɐ', 'A'),
		_Utils_Tuple2('Ꜳ', 'AA'),
		_Utils_Tuple2('Æ', 'AE'),
		_Utils_Tuple2('Ǽ', 'AE'),
		_Utils_Tuple2('Ǣ', 'AE'),
		_Utils_Tuple2('Ꜵ', 'AO'),
		_Utils_Tuple2('Ꜷ', 'AU'),
		_Utils_Tuple2('Ꜹ', 'AV'),
		_Utils_Tuple2('Ꜻ', 'AV'),
		_Utils_Tuple2('Ꜽ', 'AY'),
		_Utils_Tuple2('Ⓑ', 'B'),
		_Utils_Tuple2('Ｂ', 'B'),
		_Utils_Tuple2('Ḃ', 'B'),
		_Utils_Tuple2('Ḅ', 'B'),
		_Utils_Tuple2('Ḇ', 'B'),
		_Utils_Tuple2('Ƀ', 'B'),
		_Utils_Tuple2('Ƃ', 'B'),
		_Utils_Tuple2('Ɓ', 'B'),
		_Utils_Tuple2('Ⓒ', 'C'),
		_Utils_Tuple2('Ｃ', 'C'),
		_Utils_Tuple2('Ć', 'C'),
		_Utils_Tuple2('Ĉ', 'C'),
		_Utils_Tuple2('Ċ', 'C'),
		_Utils_Tuple2('Č', 'C'),
		_Utils_Tuple2('Ç', 'C'),
		_Utils_Tuple2('Ḉ', 'C'),
		_Utils_Tuple2('Ƈ', 'C'),
		_Utils_Tuple2('Ȼ', 'C'),
		_Utils_Tuple2('Ꜿ', 'C'),
		_Utils_Tuple2('Ⓓ', 'D'),
		_Utils_Tuple2('Ｄ', 'D'),
		_Utils_Tuple2('Ḋ', 'D'),
		_Utils_Tuple2('Ď', 'D'),
		_Utils_Tuple2('Ḍ', 'D'),
		_Utils_Tuple2('Ḑ', 'D'),
		_Utils_Tuple2('Ḓ', 'D'),
		_Utils_Tuple2('Ḏ', 'D'),
		_Utils_Tuple2('Đ', 'D'),
		_Utils_Tuple2('Ƌ', 'D'),
		_Utils_Tuple2('Ɗ', 'D'),
		_Utils_Tuple2('Ɖ', 'D'),
		_Utils_Tuple2('Ꝺ', 'D'),
		_Utils_Tuple2('Ǳ', 'DZ'),
		_Utils_Tuple2('Ǆ', 'DZ'),
		_Utils_Tuple2('ǲ', 'Dz'),
		_Utils_Tuple2('ǅ', 'Dz'),
		_Utils_Tuple2('Ⓔ', 'E'),
		_Utils_Tuple2('Ｅ', 'E'),
		_Utils_Tuple2('È', 'E'),
		_Utils_Tuple2('É', 'E'),
		_Utils_Tuple2('Ê', 'E'),
		_Utils_Tuple2('Ề', 'E'),
		_Utils_Tuple2('Ế', 'E'),
		_Utils_Tuple2('Ễ', 'E'),
		_Utils_Tuple2('Ể', 'E'),
		_Utils_Tuple2('Ẽ', 'E'),
		_Utils_Tuple2('Ē', 'E'),
		_Utils_Tuple2('Ḕ', 'E'),
		_Utils_Tuple2('Ḗ', 'E'),
		_Utils_Tuple2('Ĕ', 'E'),
		_Utils_Tuple2('Ė', 'E'),
		_Utils_Tuple2('Ë', 'E'),
		_Utils_Tuple2('Ẻ', 'E'),
		_Utils_Tuple2('Ě', 'E'),
		_Utils_Tuple2('Ȅ', 'E'),
		_Utils_Tuple2('Ȇ', 'E'),
		_Utils_Tuple2('Ẹ', 'E'),
		_Utils_Tuple2('Ệ', 'E'),
		_Utils_Tuple2('Ȩ', 'E'),
		_Utils_Tuple2('Ḝ', 'E'),
		_Utils_Tuple2('Ę', 'E'),
		_Utils_Tuple2('Ḙ', 'E'),
		_Utils_Tuple2('Ḛ', 'E'),
		_Utils_Tuple2('Ɛ', 'E'),
		_Utils_Tuple2('Ǝ', 'E'),
		_Utils_Tuple2('Ⓕ', 'F'),
		_Utils_Tuple2('Ｆ', 'F'),
		_Utils_Tuple2('Ḟ', 'F'),
		_Utils_Tuple2('Ƒ', 'F'),
		_Utils_Tuple2('Ꝼ', 'F'),
		_Utils_Tuple2('Ⓖ', 'G'),
		_Utils_Tuple2('Ｇ', 'G'),
		_Utils_Tuple2('Ǵ', 'G'),
		_Utils_Tuple2('Ĝ', 'G'),
		_Utils_Tuple2('Ḡ', 'G'),
		_Utils_Tuple2('Ğ', 'G'),
		_Utils_Tuple2('Ġ', 'G'),
		_Utils_Tuple2('Ǧ', 'G'),
		_Utils_Tuple2('Ģ', 'G'),
		_Utils_Tuple2('Ǥ', 'G'),
		_Utils_Tuple2('Ɠ', 'G'),
		_Utils_Tuple2('Ꞡ', 'G'),
		_Utils_Tuple2('Ᵹ', 'G'),
		_Utils_Tuple2('Ꝿ', 'G'),
		_Utils_Tuple2('Ⓗ', 'H'),
		_Utils_Tuple2('Ｈ', 'H'),
		_Utils_Tuple2('Ĥ', 'H'),
		_Utils_Tuple2('Ḣ', 'H'),
		_Utils_Tuple2('Ḧ', 'H'),
		_Utils_Tuple2('Ȟ', 'H'),
		_Utils_Tuple2('Ḥ', 'H'),
		_Utils_Tuple2('Ḩ', 'H'),
		_Utils_Tuple2('Ḫ', 'H'),
		_Utils_Tuple2('Ħ', 'H'),
		_Utils_Tuple2('Ⱨ', 'H'),
		_Utils_Tuple2('Ⱶ', 'H'),
		_Utils_Tuple2('Ɥ', 'H'),
		_Utils_Tuple2('Ⓘ', 'I'),
		_Utils_Tuple2('Ｉ', 'I'),
		_Utils_Tuple2('Ì', 'I'),
		_Utils_Tuple2('Í', 'I'),
		_Utils_Tuple2('Î', 'I'),
		_Utils_Tuple2('Ĩ', 'I'),
		_Utils_Tuple2('Ī', 'I'),
		_Utils_Tuple2('Ĭ', 'I'),
		_Utils_Tuple2('İ', 'I'),
		_Utils_Tuple2('Ï', 'I'),
		_Utils_Tuple2('Ḯ', 'I'),
		_Utils_Tuple2('Ỉ', 'I'),
		_Utils_Tuple2('Ǐ', 'I'),
		_Utils_Tuple2('Ȉ', 'I'),
		_Utils_Tuple2('Ȋ', 'I'),
		_Utils_Tuple2('Ị', 'I'),
		_Utils_Tuple2('Į', 'I'),
		_Utils_Tuple2('Ḭ', 'I'),
		_Utils_Tuple2('Ɨ', 'I'),
		_Utils_Tuple2('Ⓙ', 'J'),
		_Utils_Tuple2('Ｊ', 'J'),
		_Utils_Tuple2('Ĵ', 'J'),
		_Utils_Tuple2('Ɉ', 'J'),
		_Utils_Tuple2('Ⓚ', 'K'),
		_Utils_Tuple2('Ｋ', 'K'),
		_Utils_Tuple2('Ḱ', 'K'),
		_Utils_Tuple2('Ǩ', 'K'),
		_Utils_Tuple2('Ḳ', 'K'),
		_Utils_Tuple2('Ķ', 'K'),
		_Utils_Tuple2('Ḵ', 'K'),
		_Utils_Tuple2('Ƙ', 'K'),
		_Utils_Tuple2('Ⱪ', 'K'),
		_Utils_Tuple2('Ꝁ', 'K'),
		_Utils_Tuple2('Ꝃ', 'K'),
		_Utils_Tuple2('Ꝅ', 'K'),
		_Utils_Tuple2('Ꞣ', 'K'),
		_Utils_Tuple2('Ⓛ', 'L'),
		_Utils_Tuple2('Ｌ', 'L'),
		_Utils_Tuple2('Ŀ', 'L'),
		_Utils_Tuple2('Ĺ', 'L'),
		_Utils_Tuple2('Ľ', 'L'),
		_Utils_Tuple2('Ḷ', 'L'),
		_Utils_Tuple2('Ḹ', 'L'),
		_Utils_Tuple2('Ļ', 'L'),
		_Utils_Tuple2('Ḽ', 'L'),
		_Utils_Tuple2('Ḻ', 'L'),
		_Utils_Tuple2('Ł', 'L'),
		_Utils_Tuple2('Ƚ', 'L'),
		_Utils_Tuple2('Ɫ', 'L'),
		_Utils_Tuple2('Ⱡ', 'L'),
		_Utils_Tuple2('Ꝉ', 'L'),
		_Utils_Tuple2('Ꝇ', 'L'),
		_Utils_Tuple2('Ꞁ', 'L'),
		_Utils_Tuple2('Ǉ', 'LJ'),
		_Utils_Tuple2('ǈ', 'Lj'),
		_Utils_Tuple2('Ⓜ', 'M'),
		_Utils_Tuple2('Ｍ', 'M'),
		_Utils_Tuple2('Ḿ', 'M'),
		_Utils_Tuple2('Ṁ', 'M'),
		_Utils_Tuple2('Ṃ', 'M'),
		_Utils_Tuple2('Ɱ', 'M'),
		_Utils_Tuple2('Ɯ', 'M'),
		_Utils_Tuple2('Ⓝ', 'N'),
		_Utils_Tuple2('Ｎ', 'N'),
		_Utils_Tuple2('Ǹ', 'N'),
		_Utils_Tuple2('Ń', 'N'),
		_Utils_Tuple2('Ñ', 'N'),
		_Utils_Tuple2('Ṅ', 'N'),
		_Utils_Tuple2('Ň', 'N'),
		_Utils_Tuple2('Ṇ', 'N'),
		_Utils_Tuple2('Ņ', 'N'),
		_Utils_Tuple2('Ṋ', 'N'),
		_Utils_Tuple2('Ṉ', 'N'),
		_Utils_Tuple2('Ƞ', 'N'),
		_Utils_Tuple2('Ɲ', 'N'),
		_Utils_Tuple2('Ꞑ', 'N'),
		_Utils_Tuple2('Ꞥ', 'N'),
		_Utils_Tuple2('Ǌ', 'NJ'),
		_Utils_Tuple2('ǋ', 'Nj'),
		_Utils_Tuple2('Ⓞ', 'O'),
		_Utils_Tuple2('Ｏ', 'O'),
		_Utils_Tuple2('Ò', 'O'),
		_Utils_Tuple2('Ó', 'O'),
		_Utils_Tuple2('Ô', 'O'),
		_Utils_Tuple2('Ồ', 'O'),
		_Utils_Tuple2('Ố', 'O'),
		_Utils_Tuple2('Ỗ', 'O'),
		_Utils_Tuple2('Ổ', 'O'),
		_Utils_Tuple2('Õ', 'O'),
		_Utils_Tuple2('Ṍ', 'O'),
		_Utils_Tuple2('Ȭ', 'O'),
		_Utils_Tuple2('Ṏ', 'O'),
		_Utils_Tuple2('Ō', 'O'),
		_Utils_Tuple2('Ṑ', 'O'),
		_Utils_Tuple2('Ṓ', 'O'),
		_Utils_Tuple2('Ŏ', 'O'),
		_Utils_Tuple2('Ȯ', 'O'),
		_Utils_Tuple2('Ȱ', 'O'),
		_Utils_Tuple2('Ö', 'O'),
		_Utils_Tuple2('Ȫ', 'O'),
		_Utils_Tuple2('Ỏ', 'O'),
		_Utils_Tuple2('Ő', 'O'),
		_Utils_Tuple2('Ǒ', 'O'),
		_Utils_Tuple2('Ȍ', 'O'),
		_Utils_Tuple2('Ȏ', 'O'),
		_Utils_Tuple2('Ơ', 'O'),
		_Utils_Tuple2('Ờ', 'O'),
		_Utils_Tuple2('Ớ', 'O'),
		_Utils_Tuple2('Ỡ', 'O'),
		_Utils_Tuple2('Ở', 'O'),
		_Utils_Tuple2('Ợ', 'O'),
		_Utils_Tuple2('Ọ', 'O'),
		_Utils_Tuple2('Ộ', 'O'),
		_Utils_Tuple2('Ǫ', 'O'),
		_Utils_Tuple2('Ǭ', 'O'),
		_Utils_Tuple2('Ø', 'O'),
		_Utils_Tuple2('Ǿ', 'O'),
		_Utils_Tuple2('Ɔ', 'O'),
		_Utils_Tuple2('Ɵ', 'O'),
		_Utils_Tuple2('Ꝋ', 'O'),
		_Utils_Tuple2('Ꝍ', 'O'),
		_Utils_Tuple2('Ƣ', 'OI'),
		_Utils_Tuple2('Ꝏ', 'OO'),
		_Utils_Tuple2('Ȣ', 'OU'),
		_Utils_Tuple2('\u008C', 'OE'),
		_Utils_Tuple2('Œ', 'OE'),
		_Utils_Tuple2('\u009C', 'oe'),
		_Utils_Tuple2('œ', 'oe'),
		_Utils_Tuple2('Ⓟ', 'P'),
		_Utils_Tuple2('Ｐ', 'P'),
		_Utils_Tuple2('Ṕ', 'P'),
		_Utils_Tuple2('Ṗ', 'P'),
		_Utils_Tuple2('Ƥ', 'P'),
		_Utils_Tuple2('Ᵽ', 'P'),
		_Utils_Tuple2('Ꝑ', 'P'),
		_Utils_Tuple2('Ꝓ', 'P'),
		_Utils_Tuple2('Ꝕ', 'P'),
		_Utils_Tuple2('Ⓠ', 'Q'),
		_Utils_Tuple2('Ｑ', 'Q'),
		_Utils_Tuple2('Ꝗ', 'Q'),
		_Utils_Tuple2('Ꝙ', 'Q'),
		_Utils_Tuple2('Ɋ', 'Q'),
		_Utils_Tuple2('Ⓡ', 'R'),
		_Utils_Tuple2('Ｒ', 'R'),
		_Utils_Tuple2('Ŕ', 'R'),
		_Utils_Tuple2('Ṙ', 'R'),
		_Utils_Tuple2('Ř', 'R'),
		_Utils_Tuple2('Ȑ', 'R'),
		_Utils_Tuple2('Ȓ', 'R'),
		_Utils_Tuple2('Ṛ', 'R'),
		_Utils_Tuple2('Ṝ', 'R'),
		_Utils_Tuple2('Ŗ', 'R'),
		_Utils_Tuple2('Ṟ', 'R'),
		_Utils_Tuple2('Ɍ', 'R'),
		_Utils_Tuple2('Ɽ', 'R'),
		_Utils_Tuple2('Ꝛ', 'R'),
		_Utils_Tuple2('Ꞧ', 'R'),
		_Utils_Tuple2('Ꞃ', 'R'),
		_Utils_Tuple2('Ⓢ', 'S'),
		_Utils_Tuple2('Ｓ', 'S'),
		_Utils_Tuple2('ẞ', 'S'),
		_Utils_Tuple2('Ś', 'S'),
		_Utils_Tuple2('Ṥ', 'S'),
		_Utils_Tuple2('Ŝ', 'S'),
		_Utils_Tuple2('Ṡ', 'S'),
		_Utils_Tuple2('Š', 'S'),
		_Utils_Tuple2('Ṧ', 'S'),
		_Utils_Tuple2('Ṣ', 'S'),
		_Utils_Tuple2('Ṩ', 'S'),
		_Utils_Tuple2('Ș', 'S'),
		_Utils_Tuple2('Ş', 'S'),
		_Utils_Tuple2('Ȿ', 'S'),
		_Utils_Tuple2('Ꞩ', 'S'),
		_Utils_Tuple2('Ꞅ', 'S'),
		_Utils_Tuple2('Ⓣ', 'T'),
		_Utils_Tuple2('Ｔ', 'T'),
		_Utils_Tuple2('Ṫ', 'T'),
		_Utils_Tuple2('Ť', 'T'),
		_Utils_Tuple2('Ṭ', 'T'),
		_Utils_Tuple2('Ț', 'T'),
		_Utils_Tuple2('Ţ', 'T'),
		_Utils_Tuple2('Ṱ', 'T'),
		_Utils_Tuple2('Ṯ', 'T'),
		_Utils_Tuple2('Ŧ', 'T'),
		_Utils_Tuple2('Ƭ', 'T'),
		_Utils_Tuple2('Ʈ', 'T'),
		_Utils_Tuple2('Ⱦ', 'T'),
		_Utils_Tuple2('Ꞇ', 'T'),
		_Utils_Tuple2('Ꜩ', 'TZ'),
		_Utils_Tuple2('Ⓤ', 'U'),
		_Utils_Tuple2('Ｕ', 'U'),
		_Utils_Tuple2('Ù', 'U'),
		_Utils_Tuple2('Ú', 'U'),
		_Utils_Tuple2('Û', 'U'),
		_Utils_Tuple2('Ũ', 'U'),
		_Utils_Tuple2('Ṹ', 'U'),
		_Utils_Tuple2('Ū', 'U'),
		_Utils_Tuple2('Ṻ', 'U'),
		_Utils_Tuple2('Ŭ', 'U'),
		_Utils_Tuple2('Ü', 'U'),
		_Utils_Tuple2('Ǜ', 'U'),
		_Utils_Tuple2('Ǘ', 'U'),
		_Utils_Tuple2('Ǖ', 'U'),
		_Utils_Tuple2('Ǚ', 'U'),
		_Utils_Tuple2('Ủ', 'U'),
		_Utils_Tuple2('Ů', 'U'),
		_Utils_Tuple2('Ű', 'U'),
		_Utils_Tuple2('Ǔ', 'U'),
		_Utils_Tuple2('Ȕ', 'U'),
		_Utils_Tuple2('Ȗ', 'U'),
		_Utils_Tuple2('Ư', 'U'),
		_Utils_Tuple2('Ừ', 'U'),
		_Utils_Tuple2('Ứ', 'U'),
		_Utils_Tuple2('Ữ', 'U'),
		_Utils_Tuple2('Ử', 'U'),
		_Utils_Tuple2('Ự', 'U'),
		_Utils_Tuple2('Ụ', 'U'),
		_Utils_Tuple2('Ṳ', 'U'),
		_Utils_Tuple2('Ų', 'U'),
		_Utils_Tuple2('Ṷ', 'U'),
		_Utils_Tuple2('Ṵ', 'U'),
		_Utils_Tuple2('Ʉ', 'U'),
		_Utils_Tuple2('Ⓥ', 'V'),
		_Utils_Tuple2('Ｖ', 'V'),
		_Utils_Tuple2('Ṽ', 'V'),
		_Utils_Tuple2('Ṿ', 'V'),
		_Utils_Tuple2('Ʋ', 'V'),
		_Utils_Tuple2('Ꝟ', 'V'),
		_Utils_Tuple2('Ʌ', 'V'),
		_Utils_Tuple2('Ꝡ', 'VY'),
		_Utils_Tuple2('Ⓦ', 'W'),
		_Utils_Tuple2('Ｗ', 'W'),
		_Utils_Tuple2('Ẁ', 'W'),
		_Utils_Tuple2('Ẃ', 'W'),
		_Utils_Tuple2('Ŵ', 'W'),
		_Utils_Tuple2('Ẇ', 'W'),
		_Utils_Tuple2('Ẅ', 'W'),
		_Utils_Tuple2('Ẉ', 'W'),
		_Utils_Tuple2('Ⱳ', 'W'),
		_Utils_Tuple2('Ⓧ', 'X'),
		_Utils_Tuple2('Ｘ', 'X'),
		_Utils_Tuple2('Ẋ', 'X'),
		_Utils_Tuple2('Ẍ', 'X'),
		_Utils_Tuple2('Ⓨ', 'Y'),
		_Utils_Tuple2('Ｙ', 'Y'),
		_Utils_Tuple2('Ỳ', 'Y'),
		_Utils_Tuple2('Ý', 'Y'),
		_Utils_Tuple2('Ŷ', 'Y'),
		_Utils_Tuple2('Ỹ', 'Y'),
		_Utils_Tuple2('Ȳ', 'Y'),
		_Utils_Tuple2('Ẏ', 'Y'),
		_Utils_Tuple2('Ÿ', 'Y'),
		_Utils_Tuple2('Ỷ', 'Y'),
		_Utils_Tuple2('Ỵ', 'Y'),
		_Utils_Tuple2('Ƴ', 'Y'),
		_Utils_Tuple2('Ɏ', 'Y'),
		_Utils_Tuple2('Ỿ', 'Y'),
		_Utils_Tuple2('Ⓩ', 'Z'),
		_Utils_Tuple2('Ｚ', 'Z'),
		_Utils_Tuple2('Ź', 'Z'),
		_Utils_Tuple2('Ẑ', 'Z'),
		_Utils_Tuple2('Ż', 'Z'),
		_Utils_Tuple2('Ž', 'Z'),
		_Utils_Tuple2('Ẓ', 'Z'),
		_Utils_Tuple2('Ẕ', 'Z'),
		_Utils_Tuple2('Ƶ', 'Z'),
		_Utils_Tuple2('Ȥ', 'Z'),
		_Utils_Tuple2('Ɀ', 'Z'),
		_Utils_Tuple2('Ⱬ', 'Z'),
		_Utils_Tuple2('Ꝣ', 'Z'),
		_Utils_Tuple2('ⓐ', 'a'),
		_Utils_Tuple2('ａ', 'a'),
		_Utils_Tuple2('ẚ', 'a'),
		_Utils_Tuple2('à', 'a'),
		_Utils_Tuple2('á', 'a'),
		_Utils_Tuple2('â', 'a'),
		_Utils_Tuple2('ầ', 'a'),
		_Utils_Tuple2('ấ', 'a'),
		_Utils_Tuple2('ẫ', 'a'),
		_Utils_Tuple2('ẩ', 'a'),
		_Utils_Tuple2('ã', 'a'),
		_Utils_Tuple2('ā', 'a'),
		_Utils_Tuple2('ă', 'a'),
		_Utils_Tuple2('ằ', 'a'),
		_Utils_Tuple2('ắ', 'a'),
		_Utils_Tuple2('ẵ', 'a'),
		_Utils_Tuple2('ẳ', 'a'),
		_Utils_Tuple2('ȧ', 'a'),
		_Utils_Tuple2('ǡ', 'a'),
		_Utils_Tuple2('ä', 'a'),
		_Utils_Tuple2('ǟ', 'a'),
		_Utils_Tuple2('ả', 'a'),
		_Utils_Tuple2('å', 'a'),
		_Utils_Tuple2('ǻ', 'a'),
		_Utils_Tuple2('ǎ', 'a'),
		_Utils_Tuple2('ȁ', 'a'),
		_Utils_Tuple2('ȃ', 'a'),
		_Utils_Tuple2('ạ', 'a'),
		_Utils_Tuple2('ậ', 'a'),
		_Utils_Tuple2('ặ', 'a'),
		_Utils_Tuple2('ḁ', 'a'),
		_Utils_Tuple2('ą', 'a'),
		_Utils_Tuple2('ⱥ', 'a'),
		_Utils_Tuple2('ɐ', 'a'),
		_Utils_Tuple2('ꜳ', 'aa'),
		_Utils_Tuple2('æ', 'ae'),
		_Utils_Tuple2('ǽ', 'ae'),
		_Utils_Tuple2('ǣ', 'ae'),
		_Utils_Tuple2('ꜵ', 'ao'),
		_Utils_Tuple2('ꜷ', 'au'),
		_Utils_Tuple2('ꜹ', 'av'),
		_Utils_Tuple2('ꜻ', 'av'),
		_Utils_Tuple2('ꜽ', 'ay'),
		_Utils_Tuple2('ⓑ', 'b'),
		_Utils_Tuple2('ｂ', 'b'),
		_Utils_Tuple2('ḃ', 'b'),
		_Utils_Tuple2('ḅ', 'b'),
		_Utils_Tuple2('ḇ', 'b'),
		_Utils_Tuple2('ƀ', 'b'),
		_Utils_Tuple2('ƃ', 'b'),
		_Utils_Tuple2('ɓ', 'b'),
		_Utils_Tuple2('ⓒ', 'c'),
		_Utils_Tuple2('ｃ', 'c'),
		_Utils_Tuple2('ć', 'c'),
		_Utils_Tuple2('ĉ', 'c'),
		_Utils_Tuple2('ċ', 'c'),
		_Utils_Tuple2('č', 'c'),
		_Utils_Tuple2('ç', 'c'),
		_Utils_Tuple2('ḉ', 'c'),
		_Utils_Tuple2('ƈ', 'c'),
		_Utils_Tuple2('ȼ', 'c'),
		_Utils_Tuple2('ꜿ', 'c'),
		_Utils_Tuple2('ↄ', 'c'),
		_Utils_Tuple2('ⓓ', 'd'),
		_Utils_Tuple2('ｄ', 'd'),
		_Utils_Tuple2('ḋ', 'd'),
		_Utils_Tuple2('ď', 'd'),
		_Utils_Tuple2('ḍ', 'd'),
		_Utils_Tuple2('ḑ', 'd'),
		_Utils_Tuple2('ḓ', 'd'),
		_Utils_Tuple2('ḏ', 'd'),
		_Utils_Tuple2('đ', 'd'),
		_Utils_Tuple2('ƌ', 'd'),
		_Utils_Tuple2('ɖ', 'd'),
		_Utils_Tuple2('ɗ', 'd'),
		_Utils_Tuple2('ꝺ', 'd'),
		_Utils_Tuple2('ǳ', 'dz'),
		_Utils_Tuple2('ǆ', 'dz'),
		_Utils_Tuple2('ⓔ', 'e'),
		_Utils_Tuple2('ｅ', 'e'),
		_Utils_Tuple2('è', 'e'),
		_Utils_Tuple2('é', 'e'),
		_Utils_Tuple2('ê', 'e'),
		_Utils_Tuple2('ề', 'e'),
		_Utils_Tuple2('ế', 'e'),
		_Utils_Tuple2('ễ', 'e'),
		_Utils_Tuple2('ể', 'e'),
		_Utils_Tuple2('ẽ', 'e'),
		_Utils_Tuple2('ē', 'e'),
		_Utils_Tuple2('ḕ', 'e'),
		_Utils_Tuple2('ḗ', 'e'),
		_Utils_Tuple2('ĕ', 'e'),
		_Utils_Tuple2('ė', 'e'),
		_Utils_Tuple2('ë', 'e'),
		_Utils_Tuple2('ẻ', 'e'),
		_Utils_Tuple2('ě', 'e'),
		_Utils_Tuple2('ȅ', 'e'),
		_Utils_Tuple2('ȇ', 'e'),
		_Utils_Tuple2('ẹ', 'e'),
		_Utils_Tuple2('ệ', 'e'),
		_Utils_Tuple2('ȩ', 'e'),
		_Utils_Tuple2('ḝ', 'e'),
		_Utils_Tuple2('ę', 'e'),
		_Utils_Tuple2('ḙ', 'e'),
		_Utils_Tuple2('ḛ', 'e'),
		_Utils_Tuple2('ɇ', 'e'),
		_Utils_Tuple2('ɛ', 'e'),
		_Utils_Tuple2('ǝ', 'e'),
		_Utils_Tuple2('ⓕ', 'f'),
		_Utils_Tuple2('ｆ', 'f'),
		_Utils_Tuple2('ḟ', 'f'),
		_Utils_Tuple2('ƒ', 'f'),
		_Utils_Tuple2('ꝼ', 'f'),
		_Utils_Tuple2('ⓖ', 'g'),
		_Utils_Tuple2('ｇ', 'g'),
		_Utils_Tuple2('ǵ', 'g'),
		_Utils_Tuple2('ĝ', 'g'),
		_Utils_Tuple2('ḡ', 'g'),
		_Utils_Tuple2('ğ', 'g'),
		_Utils_Tuple2('ġ', 'g'),
		_Utils_Tuple2('ǧ', 'g'),
		_Utils_Tuple2('ģ', 'g'),
		_Utils_Tuple2('ǥ', 'g'),
		_Utils_Tuple2('ɠ', 'g'),
		_Utils_Tuple2('ꞡ', 'g'),
		_Utils_Tuple2('ᵹ', 'g'),
		_Utils_Tuple2('ꝿ', 'g'),
		_Utils_Tuple2('ⓗ', 'h'),
		_Utils_Tuple2('ｈ', 'h'),
		_Utils_Tuple2('ĥ', 'h'),
		_Utils_Tuple2('ḣ', 'h'),
		_Utils_Tuple2('ḧ', 'h'),
		_Utils_Tuple2('ȟ', 'h'),
		_Utils_Tuple2('ḥ', 'h'),
		_Utils_Tuple2('ḩ', 'h'),
		_Utils_Tuple2('ḫ', 'h'),
		_Utils_Tuple2('ẖ', 'h'),
		_Utils_Tuple2('ħ', 'h'),
		_Utils_Tuple2('ⱨ', 'h'),
		_Utils_Tuple2('ⱶ', 'h'),
		_Utils_Tuple2('ɥ', 'h'),
		_Utils_Tuple2('ƕ', 'hv'),
		_Utils_Tuple2('ⓘ', 'i'),
		_Utils_Tuple2('ｉ', 'i'),
		_Utils_Tuple2('ì', 'i'),
		_Utils_Tuple2('í', 'i'),
		_Utils_Tuple2('î', 'i'),
		_Utils_Tuple2('ĩ', 'i'),
		_Utils_Tuple2('ī', 'i'),
		_Utils_Tuple2('ĭ', 'i'),
		_Utils_Tuple2('ï', 'i'),
		_Utils_Tuple2('ḯ', 'i'),
		_Utils_Tuple2('ỉ', 'i'),
		_Utils_Tuple2('ǐ', 'i'),
		_Utils_Tuple2('ȉ', 'i'),
		_Utils_Tuple2('ȋ', 'i'),
		_Utils_Tuple2('ị', 'i'),
		_Utils_Tuple2('į', 'i'),
		_Utils_Tuple2('ḭ', 'i'),
		_Utils_Tuple2('ɨ', 'i'),
		_Utils_Tuple2('ı', 'i'),
		_Utils_Tuple2('ⓙ', 'j'),
		_Utils_Tuple2('ｊ', 'j'),
		_Utils_Tuple2('ĵ', 'j'),
		_Utils_Tuple2('ǰ', 'j'),
		_Utils_Tuple2('ɉ', 'j'),
		_Utils_Tuple2('ⓚ', 'k'),
		_Utils_Tuple2('ｋ', 'k'),
		_Utils_Tuple2('ḱ', 'k'),
		_Utils_Tuple2('ǩ', 'k'),
		_Utils_Tuple2('ḳ', 'k'),
		_Utils_Tuple2('ķ', 'k'),
		_Utils_Tuple2('ḵ', 'k'),
		_Utils_Tuple2('ƙ', 'k'),
		_Utils_Tuple2('ⱪ', 'k'),
		_Utils_Tuple2('ꝁ', 'k'),
		_Utils_Tuple2('ꝃ', 'k'),
		_Utils_Tuple2('ꝅ', 'k'),
		_Utils_Tuple2('ꞣ', 'k'),
		_Utils_Tuple2('ⓛ', 'l'),
		_Utils_Tuple2('ｌ', 'l'),
		_Utils_Tuple2('ŀ', 'l'),
		_Utils_Tuple2('ĺ', 'l'),
		_Utils_Tuple2('ľ', 'l'),
		_Utils_Tuple2('ḷ', 'l'),
		_Utils_Tuple2('ḹ', 'l'),
		_Utils_Tuple2('ļ', 'l'),
		_Utils_Tuple2('ḽ', 'l'),
		_Utils_Tuple2('ḻ', 'l'),
		_Utils_Tuple2('ſ', 'l'),
		_Utils_Tuple2('ł', 'l'),
		_Utils_Tuple2('ƚ', 'l'),
		_Utils_Tuple2('ɫ', 'l'),
		_Utils_Tuple2('ⱡ', 'l'),
		_Utils_Tuple2('ꝉ', 'l'),
		_Utils_Tuple2('ꞁ', 'l'),
		_Utils_Tuple2('ꝇ', 'l'),
		_Utils_Tuple2('ǉ', 'lj'),
		_Utils_Tuple2('ⓜ', 'm'),
		_Utils_Tuple2('ｍ', 'm'),
		_Utils_Tuple2('ḿ', 'm'),
		_Utils_Tuple2('ṁ', 'm'),
		_Utils_Tuple2('ṃ', 'm'),
		_Utils_Tuple2('ɱ', 'm'),
		_Utils_Tuple2('ɯ', 'm'),
		_Utils_Tuple2('ⓝ', 'n'),
		_Utils_Tuple2('ｎ', 'n'),
		_Utils_Tuple2('ǹ', 'n'),
		_Utils_Tuple2('ń', 'n'),
		_Utils_Tuple2('ñ', 'n'),
		_Utils_Tuple2('ṅ', 'n'),
		_Utils_Tuple2('ň', 'n'),
		_Utils_Tuple2('ṇ', 'n'),
		_Utils_Tuple2('ņ', 'n'),
		_Utils_Tuple2('ṋ', 'n'),
		_Utils_Tuple2('ṉ', 'n'),
		_Utils_Tuple2('ƞ', 'n'),
		_Utils_Tuple2('ɲ', 'n'),
		_Utils_Tuple2('ŉ', 'n'),
		_Utils_Tuple2('ꞑ', 'n'),
		_Utils_Tuple2('ꞥ', 'n'),
		_Utils_Tuple2('ǌ', 'nj'),
		_Utils_Tuple2('ⓞ', 'o'),
		_Utils_Tuple2('ｏ', 'o'),
		_Utils_Tuple2('ò', 'o'),
		_Utils_Tuple2('ó', 'o'),
		_Utils_Tuple2('ô', 'o'),
		_Utils_Tuple2('ồ', 'o'),
		_Utils_Tuple2('ố', 'o'),
		_Utils_Tuple2('ỗ', 'o'),
		_Utils_Tuple2('ổ', 'o'),
		_Utils_Tuple2('õ', 'o'),
		_Utils_Tuple2('ṍ', 'o'),
		_Utils_Tuple2('ȭ', 'o'),
		_Utils_Tuple2('ṏ', 'o'),
		_Utils_Tuple2('ō', 'o'),
		_Utils_Tuple2('ṑ', 'o'),
		_Utils_Tuple2('ṓ', 'o'),
		_Utils_Tuple2('ŏ', 'o'),
		_Utils_Tuple2('ȯ', 'o'),
		_Utils_Tuple2('ȱ', 'o'),
		_Utils_Tuple2('ö', 'o'),
		_Utils_Tuple2('ȫ', 'o'),
		_Utils_Tuple2('ỏ', 'o'),
		_Utils_Tuple2('ő', 'o'),
		_Utils_Tuple2('ǒ', 'o'),
		_Utils_Tuple2('ȍ', 'o'),
		_Utils_Tuple2('ȏ', 'o'),
		_Utils_Tuple2('ơ', 'o'),
		_Utils_Tuple2('ờ', 'o'),
		_Utils_Tuple2('ớ', 'o'),
		_Utils_Tuple2('ỡ', 'o'),
		_Utils_Tuple2('ở', 'o'),
		_Utils_Tuple2('ợ', 'o'),
		_Utils_Tuple2('ọ', 'o'),
		_Utils_Tuple2('ộ', 'o'),
		_Utils_Tuple2('ǫ', 'o'),
		_Utils_Tuple2('ǭ', 'o'),
		_Utils_Tuple2('ø', 'o'),
		_Utils_Tuple2('ǿ', 'o'),
		_Utils_Tuple2('ɔ', 'o'),
		_Utils_Tuple2('ꝋ', 'o'),
		_Utils_Tuple2('ꝍ', 'o'),
		_Utils_Tuple2('ɵ', 'o'),
		_Utils_Tuple2('ƣ', 'oi'),
		_Utils_Tuple2('ȣ', 'ou'),
		_Utils_Tuple2('ꝏ', 'oo'),
		_Utils_Tuple2('ⓟ', 'p'),
		_Utils_Tuple2('ｐ', 'p'),
		_Utils_Tuple2('ṕ', 'p'),
		_Utils_Tuple2('ṗ', 'p'),
		_Utils_Tuple2('ƥ', 'p'),
		_Utils_Tuple2('ᵽ', 'p'),
		_Utils_Tuple2('ꝑ', 'p'),
		_Utils_Tuple2('ꝓ', 'p'),
		_Utils_Tuple2('ꝕ', 'p'),
		_Utils_Tuple2('ⓠ', 'q'),
		_Utils_Tuple2('ｑ', 'q'),
		_Utils_Tuple2('ɋ', 'q'),
		_Utils_Tuple2('ꝗ', 'q'),
		_Utils_Tuple2('ꝙ', 'q'),
		_Utils_Tuple2('ⓡ', 'r'),
		_Utils_Tuple2('ｒ', 'r'),
		_Utils_Tuple2('ŕ', 'r'),
		_Utils_Tuple2('ṙ', 'r'),
		_Utils_Tuple2('ř', 'r'),
		_Utils_Tuple2('ȑ', 'r'),
		_Utils_Tuple2('ȓ', 'r'),
		_Utils_Tuple2('ṛ', 'r'),
		_Utils_Tuple2('ṝ', 'r'),
		_Utils_Tuple2('ŗ', 'r'),
		_Utils_Tuple2('ṟ', 'r'),
		_Utils_Tuple2('ɍ', 'r'),
		_Utils_Tuple2('ɽ', 'r'),
		_Utils_Tuple2('ꝛ', 'r'),
		_Utils_Tuple2('ꞧ', 'r'),
		_Utils_Tuple2('ꞃ', 'r'),
		_Utils_Tuple2('ⓢ', 's'),
		_Utils_Tuple2('ｓ', 's'),
		_Utils_Tuple2('ß', 's'),
		_Utils_Tuple2('ś', 's'),
		_Utils_Tuple2('ṥ', 's'),
		_Utils_Tuple2('ŝ', 's'),
		_Utils_Tuple2('ṡ', 's'),
		_Utils_Tuple2('š', 's'),
		_Utils_Tuple2('ṧ', 's'),
		_Utils_Tuple2('ṣ', 's'),
		_Utils_Tuple2('ṩ', 's'),
		_Utils_Tuple2('ș', 's'),
		_Utils_Tuple2('ş', 's'),
		_Utils_Tuple2('ȿ', 's'),
		_Utils_Tuple2('ꞩ', 's'),
		_Utils_Tuple2('ꞅ', 's'),
		_Utils_Tuple2('ẛ', 's'),
		_Utils_Tuple2('ⓣ', 't'),
		_Utils_Tuple2('ｔ', 't'),
		_Utils_Tuple2('ṫ', 't'),
		_Utils_Tuple2('ẗ', 't'),
		_Utils_Tuple2('ť', 't'),
		_Utils_Tuple2('ṭ', 't'),
		_Utils_Tuple2('ț', 't'),
		_Utils_Tuple2('ţ', 't'),
		_Utils_Tuple2('ṱ', 't'),
		_Utils_Tuple2('ṯ', 't'),
		_Utils_Tuple2('ŧ', 't'),
		_Utils_Tuple2('ƭ', 't'),
		_Utils_Tuple2('ʈ', 't'),
		_Utils_Tuple2('ⱦ', 't'),
		_Utils_Tuple2('ꞇ', 't'),
		_Utils_Tuple2('ꜩ', 'tz'),
		_Utils_Tuple2('ⓤ', 'u'),
		_Utils_Tuple2('ｕ', 'u'),
		_Utils_Tuple2('ù', 'u'),
		_Utils_Tuple2('ú', 'u'),
		_Utils_Tuple2('û', 'u'),
		_Utils_Tuple2('ũ', 'u'),
		_Utils_Tuple2('ṹ', 'u'),
		_Utils_Tuple2('ū', 'u'),
		_Utils_Tuple2('ṻ', 'u'),
		_Utils_Tuple2('ŭ', 'u'),
		_Utils_Tuple2('ü', 'u'),
		_Utils_Tuple2('ǜ', 'u'),
		_Utils_Tuple2('ǘ', 'u'),
		_Utils_Tuple2('ǖ', 'u'),
		_Utils_Tuple2('ǚ', 'u'),
		_Utils_Tuple2('ủ', 'u'),
		_Utils_Tuple2('ů', 'u'),
		_Utils_Tuple2('ű', 'u'),
		_Utils_Tuple2('ǔ', 'u'),
		_Utils_Tuple2('ȕ', 'u'),
		_Utils_Tuple2('ȗ', 'u'),
		_Utils_Tuple2('ư', 'u'),
		_Utils_Tuple2('ừ', 'u'),
		_Utils_Tuple2('ứ', 'u'),
		_Utils_Tuple2('ữ', 'u'),
		_Utils_Tuple2('ử', 'u'),
		_Utils_Tuple2('ự', 'u'),
		_Utils_Tuple2('ụ', 'u'),
		_Utils_Tuple2('ṳ', 'u'),
		_Utils_Tuple2('ų', 'u'),
		_Utils_Tuple2('ṷ', 'u'),
		_Utils_Tuple2('ṵ', 'u'),
		_Utils_Tuple2('ʉ', 'u'),
		_Utils_Tuple2('ⓥ', 'v'),
		_Utils_Tuple2('ｖ', 'v'),
		_Utils_Tuple2('ṽ', 'v'),
		_Utils_Tuple2('ṿ', 'v'),
		_Utils_Tuple2('ʋ', 'v'),
		_Utils_Tuple2('ꝟ', 'v'),
		_Utils_Tuple2('ʌ', 'v'),
		_Utils_Tuple2('ꝡ', 'vy'),
		_Utils_Tuple2('ⓦ', 'w'),
		_Utils_Tuple2('ｗ', 'w'),
		_Utils_Tuple2('ẁ', 'w'),
		_Utils_Tuple2('ẃ', 'w'),
		_Utils_Tuple2('ŵ', 'w'),
		_Utils_Tuple2('ẇ', 'w'),
		_Utils_Tuple2('ẅ', 'w'),
		_Utils_Tuple2('ẘ', 'w'),
		_Utils_Tuple2('ẉ', 'w'),
		_Utils_Tuple2('ⱳ', 'w'),
		_Utils_Tuple2('ⓧ', 'x'),
		_Utils_Tuple2('ｘ', 'x'),
		_Utils_Tuple2('ẋ', 'x'),
		_Utils_Tuple2('ẍ', 'x'),
		_Utils_Tuple2('ⓨ', 'y'),
		_Utils_Tuple2('ｙ', 'y'),
		_Utils_Tuple2('ỳ', 'y'),
		_Utils_Tuple2('ý', 'y'),
		_Utils_Tuple2('ŷ', 'y'),
		_Utils_Tuple2('ỹ', 'y'),
		_Utils_Tuple2('ȳ', 'y'),
		_Utils_Tuple2('ẏ', 'y'),
		_Utils_Tuple2('ÿ', 'y'),
		_Utils_Tuple2('ỷ', 'y'),
		_Utils_Tuple2('ẙ', 'y'),
		_Utils_Tuple2('ỵ', 'y'),
		_Utils_Tuple2('ƴ', 'y'),
		_Utils_Tuple2('ɏ', 'y'),
		_Utils_Tuple2('ỿ', 'y'),
		_Utils_Tuple2('ⓩ', 'z'),
		_Utils_Tuple2('ｚ', 'z'),
		_Utils_Tuple2('ź', 'z'),
		_Utils_Tuple2('ẑ', 'z'),
		_Utils_Tuple2('ż', 'z'),
		_Utils_Tuple2('ž', 'z'),
		_Utils_Tuple2('ẓ', 'z'),
		_Utils_Tuple2('ẕ', 'z'),
		_Utils_Tuple2('ƶ', 'z')
	]);
var $elmcraft$core_extra$String$Diacritics$lookupTable = $elm$core$Dict$fromList($elmcraft$core_extra$String$Diacritics$lookupList);
var $elmcraft$core_extra$String$Diacritics$maxUnicode = 1114111;
var $elmcraft$core_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, max) {
				var fy = max.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : max;
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elmcraft$core_extra$String$Diacritics$maxCode = function () {
	var _v0 = A2(
		$elmcraft$core_extra$List$Extra$maximumBy,
		function (_v1) {
			var c = _v1.a;
			return $elm$core$Char$toCode(c);
		},
		$elmcraft$core_extra$String$Diacritics$lookupList);
	if (!_v0.$) {
		var _v2 = _v0.a;
		var c = _v2.a;
		return $elm$core$Char$toCode(c);
	} else {
		return $elmcraft$core_extra$String$Diacritics$maxUnicode;
	}
}();
var $elmcraft$core_extra$String$Diacritics$lookupArray = A2(
	$elm$core$Array$initialize,
	$elmcraft$core_extra$String$Diacritics$maxCode + 1,
	function (i) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$elm$core$Char$fromCode(i),
			$elmcraft$core_extra$String$Diacritics$lookupTable);
		if (_v0.$ === 1) {
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(i));
		} else {
			var str = _v0.a;
			return str;
		}
	});
var $elmcraft$core_extra$List$Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, min) {
				var fy = min.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) < 0) ? _Utils_Tuple2(x, fx) : min;
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						minBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elmcraft$core_extra$String$Diacritics$minCode = function () {
	var _v0 = A2(
		$elmcraft$core_extra$List$Extra$minimumBy,
		function (_v1) {
			var c = _v1.a;
			return $elm$core$Char$toCode(c);
		},
		$elmcraft$core_extra$String$Diacritics$lookupList);
	if (!_v0.$) {
		var _v2 = _v0.a;
		var c = _v2.a;
		return $elm$core$Char$toCode(c);
	} else {
		return 0;
	}
}();
var $elmcraft$core_extra$String$Extra$removeDiacritics = function (str) {
	var replace = F2(
		function (c, result) {
			if (_Utils_cmp(
				$elm$core$Char$toCode(c),
				$elmcraft$core_extra$String$Diacritics$minCode) < 0) {
				return _Utils_ap(
					result,
					$elm$core$String$fromChar(c));
			} else {
				var _v0 = A2(
					$elm$core$Array$get,
					$elm$core$Char$toCode(c),
					$elmcraft$core_extra$String$Diacritics$lookupArray);
				if (!_v0.$) {
					var candidate = _v0.a;
					return _Utils_ap(result, candidate);
				} else {
					return _Utils_ap(
						result,
						$elm$core$String$fromChar(c));
				}
			}
		});
	return A3($elm$core$String$foldl, replace, '', str);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.im;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.g6;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.fN;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		hT: 1 + (((rd - week1Day1) / 7) | 0),
		hU: wy,
		kb: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hT;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.hU;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.c9(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.fH(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.c9(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.fb(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.a$(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.a$(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.a$(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.f9(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.a$(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.a$(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {gt: col, ii: contextStack, hj: problem, ht: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.ht, s.gt, x, s.h));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.ht, s.gt, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{gt: newCol, h: s.h, i: s.i, c: newOffset, ht: newRow, b: s.b});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{gt: 1, h: s.h, i: s.i, c: s.c + 1, ht: s.ht + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{gt: s.gt + 1, h: s.h, i: s.i, c: newOffset, ht: s.ht, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{gt: col, h: s0.h, i: s0.i, c: offset, ht: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.ht, s.gt, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.b),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {gt: col, hj: problem, ht: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.ht, p.gt, p.hj);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{gt: 1, h: _List_Nil, i: 1, c: 0, ht: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	fb: $justinmimbs$date$Date$withOrdinalSuffix,
	fH: $justinmimbs$date$Date$monthToName,
	c9: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	f9: $justinmimbs$date$Date$weekdayToName,
	a$: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Update$pdfFilename = function (model) {
	var quote = function () {
		var _v0 = model.ag.bx.i$;
		if (!_v0) {
			return 'Quote';
		} else {
			return 'Soumission';
		}
	}();
	var farmName = $elmcraft$core_extra$String$Extra$removeDiacritics(model.ag.bx.iG);
	var date = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$toIsoString,
			A3($elm$core$Maybe$map2, $justinmimbs$date$Date$fromPosix, model.er, model.dn)));
	var base = 'Orisha';
	return A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			[base, quote, farmName, date]));
};
var $author$project$Port$Out$print = _Platform_outgoingPort('print', $elm$json$Json$Encode$string);
var $author$project$Update$print = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$Port$Out$print(
			$author$project$Update$pdfFilename(model)));
};
var $author$project$Update$resetForms = function (model) {
	return _Utils_update(
		model,
		{
			aI: A2($author$project$Page$Discovery$Update$initialModel, 1, $elm$core$Maybe$Nothing),
			ag: A2($author$project$Page$QuoteBuilderV3$Update$initialModel, model.bT, $elm$core$Maybe$Nothing)
		});
};
var $author$project$Update$SavedQuote = function (a) {
	return {$: 10, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Utils$Airtable$headers = function () {
	var accessToken = 'pat7ZjV4JzTRdINed.56c29af61423472d60db6e54a1be258c2c7e6bbd4a357e5d0c2dba86dbdd7842';
	return _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + accessToken)
		]);
}();
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{h3: false, ic: r.ic, fj: r.hs, gN: r.gN, g5: r.g5, hK: r.hK, hM: $elm$core$Maybe$Nothing, bS: r.bS});
};
var $author$project$Utils$Airtable$create = F3(
	function (base, table, fields) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			'https://api.airtable.com',
			_List_fromArray(
				['v0', base, table]),
			_List_Nil);
		var resolver = function (response) {
			switch (response.$) {
				case 0:
					var url_ = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadUrl(url_));
				case 1:
					return $elm$core$Result$Err($elm$http$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($elm$http$Http$NetworkError);
				case 3:
					var metadata = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadStatus(metadata.hE));
				default:
					return $elm$core$Result$Ok(0);
			}
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'records',
					A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'fields',
										$elm$json$Json$Encode$object(fields))
									]))
							])))
				]));
		return $elm$http$Http$task(
			{
				ic: $elm$http$Http$jsonBody(body),
				gN: $author$project$Utils$Airtable$headers,
				g5: 'POST',
				hs: $elm$http$Http$stringResolver(resolver),
				hK: $elm$core$Maybe$Nothing,
				bS: url
			});
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Utils$Airtable$getRecordId = F3(
	function (base, table, formula) {
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			'https://api.airtable.com',
			_List_fromArray(
				['v0', base, table]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'filterByFormula', formula),
					A2($elm$url$Url$Builder$int, 'maxRecords', 1)
				]));
		var resolver = function (response) {
			switch (response.$) {
				case 0:
					var url_ = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadUrl(url_));
				case 1:
					return $elm$core$Result$Err($elm$http$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($elm$http$Http$NetworkError);
				case 3:
					var metadata = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadStatus(metadata.hE));
				default:
					var body = response.b;
					var decoder = A2(
						$elm$json$Json$Decode$map,
						$elm$core$List$head,
						A2(
							$elm$json$Json$Decode$field,
							'records',
							$elm$json$Json$Decode$list(
								A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string))));
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						if (!_v1.a.$) {
							var recordId = _v1.a.a;
							return $elm$core$Result$Ok(recordId);
						} else {
							var _v2 = _v1.a;
							return $elm$core$Result$Err(
								$elm$http$Http$BadBody('No record found'));
						}
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(
								$elm$json$Json$Decode$errorToString(err)));
					}
			}
		};
		return $elm$http$Http$task(
			{
				ic: $elm$http$Http$emptyBody,
				gN: $author$project$Utils$Airtable$headers,
				g5: 'GET',
				hs: $elm$http$Http$stringResolver(resolver),
				hK: $elm$core$Maybe$Nothing,
				bS: url
			});
	});
var $author$project$Utils$PdfCo$print = F2(
	function (filename, html) {
		var url = 'https://api.pdf.co/v1/pdf/convert/from/html';
		var decoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
		var resolver = function (response) {
			switch (response.$) {
				case 0:
					var url_ = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadUrl(url_));
				case 1:
					return $elm$core$Result$Err($elm$http$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($elm$http$Http$NetworkError);
				case 3:
					var metadata = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadStatus(metadata.hE));
				default:
					var str = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, str);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(
								$elm$json$Json$Decode$errorToString(err)));
					}
			}
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'html',
					$elm$json$Json$Encode$string(html)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(filename)),
					_Utils_Tuple2(
					'paperSize',
					$elm$json$Json$Encode$string('Letter')),
					_Utils_Tuple2(
					'margins',
					$elm$json$Json$Encode$string('0px'))
				]));
		var apiKey = 'pap@orisha.io_NxVKX5g9LusAiryQOJoHvUQwegsEu29wJrcBisrBcPjtsnXZo2HYepumGnlebooG';
		var headers = _List_fromArray(
			[
				A2($elm$http$Http$header, 'x-api-key', apiKey),
				A2($elm$http$Http$header, 'Content-Type', 'application/json')
			]);
		return $elm$http$Http$task(
			{
				ic: $elm$http$Http$jsonBody(body),
				gN: headers,
				g5: 'POST',
				hs: $elm$http$Http$stringResolver(resolver),
				hK: $elm$core$Maybe$Nothing,
				bS: url
			});
	});
var $author$project$Update$saveQuote = function (model) {
	var quote = $author$project$Page$QuoteBuilderV3$Update$toQuote(model.ag);
	var quoteBuilderUrl = $author$project$Page$QuoteBuilderV3$Preview$Checkout$successUrl(quote);
	var quoteUrl = A2($author$project$Page$QuoteBuilderV3$QuoteUrl$urlFromQuote, model.bS, quote);
	var netTotal = $author$project$Page$QuoteBuilderV3$Quote$netTotal(quote);
	var saveToAirtable = F2(
		function (projectRecordId, pdfUrl) {
			return A3(
				$author$project$Utils$Airtable$create,
				'appB4Fehk9jYd4s4B',
				'tblSBw2Hfa8tcxPjz',
				_List_fromArray(
					[
						_Utils_Tuple2(
						'fldk9hhUMffodBJNd',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$string(projectRecordId)
								]))),
						_Utils_Tuple2(
						'fldbChbwODSyEThsG',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'url',
											$elm$json$Json$Encode$string(pdfUrl))
										]))
								]))),
						_Utils_Tuple2(
						'fldzD3FfkNjQGwDC9',
						$elm$json$Json$Encode$string(quoteUrl)),
						_Utils_Tuple2(
						'fld19yGmL592K0fUj',
						$elm$json$Json$Encode$string(quoteBuilderUrl)),
						_Utils_Tuple2(
						'fldpmYQa1QYLcmiOV',
						$elm$json$Json$Encode$int(netTotal.jY)),
						_Utils_Tuple2(
						'fldxclHYJFZFDEXWl',
						$elm$json$Json$Encode$int(netTotal.jC))
					]));
		});
	var getProjectRecordId = A3($author$project$Utils$Airtable$getRecordId, 'appB4Fehk9jYd4s4B', 'tbl2Lh4KLVgHcRIZP', '{fldRzhmCVBQ72YZZ6}=' + quote.dH);
	return A2(
		$elm$core$Task$attempt,
		$author$project$Update$SavedQuote,
		A2(
			$elm$core$Task$andThen,
			function (projectRecordId) {
				return A2(
					$elm$core$Task$andThen,
					function (pdfUrl) {
						return A2(
							$elm$core$Task$map,
							function (_v0) {
								return pdfUrl;
							},
							A2(saveToAirtable, projectRecordId, pdfUrl));
					},
					A2(
						$author$project$Utils$PdfCo$print,
						$author$project$Update$pdfFilename(model),
						model.cH));
			},
			getProjectRecordId));
};
var $linuss$smooth_scroll$Internal$SmoothScroll$animationSteps = F4(
	function (speed, easing, start, stop) {
		var operator = (_Utils_cmp(start, stop) > 0) ? $elm$core$Basics$sub : $elm$core$Basics$add;
		var diff = $elm$core$Basics$abs(start - stop);
		var frames = A2(
			$elm$core$Basics$max,
			1,
			($elm$core$Basics$round(diff) / speed) | 0);
		var framesFloat = frames;
		var weights = A2(
			$elm$core$List$map,
			function (i) {
				return easing(i / framesFloat);
			},
			A2($elm$core$List$range, 0, frames));
		return ((speed <= 0) || _Utils_eq(start, stop)) ? _List_Nil : A2(
			$elm$core$List$map,
			function (weight) {
				return A2(operator, start, weight * diff);
			},
			weights);
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $linuss$smooth_scroll$SmoothScroll$scrollToWithOptions = F2(
	function (config, id) {
		var tasks = F2(
			function (from, to) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						$elm$browser$Browser$Dom$setViewport(0),
						A4($linuss$smooth_scroll$Internal$SmoothScroll$animationSteps, config.jV, config.fi, from, to - config.c)));
			});
		return A2(
			$elm$core$Task$andThen,
			function (_v0) {
				var viewport = _v0.a.hS;
				var element = _v0.b.iw;
				return A2(tasks, viewport.hY, element.hY);
			},
			A3(
				$elm$core$Task$map2,
				$elm$core$Tuple$pair,
				$elm$browser$Browser$Dom$getViewport,
				$elm$browser$Browser$Dom$getElement(id)));
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Login$Page$UnaccreditedUser = 0;
var $author$project$Domain$User$encode = function (user) {
	return $elm$core$String$fromInt(user.cJ);
};
var $author$project$Login$Page$getUser = F2(
	function (username, password) {
		var compareUserCredentials = function (accreditedUser) {
			return _Utils_eq(
				_Utils_Tuple2(
					$elm$core$String$toLower(accreditedUser.hQ),
					$elm$core$String$toLower(accreditedUser.hg)),
				_Utils_Tuple2(
					$elm$core$String$toLower(username),
					$elm$core$String$toLower(password)));
		};
		return $elm$core$List$head(
			A2($elm$core$List$filter, compareUserCredentials, $author$project$Domain$User$accreditedUsers));
	});
var $author$project$Port$Out$saveSession = _Platform_outgoingPort('saveSession', $elm$json$Json$Encode$string);
var $author$project$Login$Components$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var input = msg.a;
			return _Utils_update(
				model,
				{hQ: input});
		} else {
			var input = msg.a;
			return _Utils_update(
				model,
				{hg: input});
		}
	});
var $author$project$Login$Page$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						at: A2($author$project$Login$Components$update, subMsg, model.at)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var username = model.at.hQ;
			var password = model.at.hg;
			var _v1 = A2($author$project$Login$Page$getUser, username, password);
			if (!_v1.$) {
				var user = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: $elm$core$Maybe$Nothing}),
					$author$project$Port$Out$saveSession(
						$author$project$Domain$User$encode(user)));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: $elm$core$Maybe$Just(0)
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $elmcraft$core_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elmcraft$core_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elmcraft$core_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Page$Discovery$CustomField$Update$Edit = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$Discovery$CustomField$Form$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_update(
					model,
					{jg: name});
			case 1:
				var quantity = msg.a;
				var formattedQuantity = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(quantity));
				return _Utils_update(
					model,
					{jD: formattedQuantity});
			default:
				var quantity = msg.a;
				var formattedQuantity = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(quantity));
				return _Utils_update(
					model,
					{jH: formattedQuantity});
		}
	});
var $author$project$Page$Discovery$CustomField$Update$update = F2(
	function (msg, model) {
		var initialCustomProduct = {is: 0, jg: '', jz: $author$project$Domain$Total$Amount$free, jD: 0, jH: 0};
		var customProducts = model.il;
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var customProduct = A2($elmcraft$core_extra$List$Extra$getAt, index, customProducts);
				if (!customProduct.$) {
					var c = customProduct.a;
					return _Utils_update(
						model,
						{
							H: A2($author$project$Page$Discovery$CustomField$Update$Edit, index, c)
						});
				} else {
					return model;
				}
			case 1:
				var _v2 = model.H;
				if (!_v2.$) {
					var index = _v2.a;
					var edited = _v2.b;
					return _Utils_update(
						model,
						{
							il: A3($elmcraft$core_extra$List$Extra$setAt, index, edited, customProducts),
							H: $author$project$Page$Discovery$CustomField$Update$Edited
						});
				} else {
					return model;
				}
			case 2:
				var _v3 = model.H;
				if (!_v3.$) {
					var index = _v3.a;
					var possibleNewCustomProduct = A2($elmcraft$core_extra$List$Extra$getAt, index, customProducts);
					return (!_Utils_eq(
						possibleNewCustomProduct,
						$elm$core$Maybe$Just(initialCustomProduct))) ? _Utils_update(
						model,
						{H: $author$project$Page$Discovery$CustomField$Update$Edited}) : _Utils_update(
						model,
						{
							il: A2($elmcraft$core_extra$List$Extra$removeAt, index, customProducts),
							H: $author$project$Page$Discovery$CustomField$Update$Edited
						});
				} else {
					return model;
				}
			case 3:
				var index = msg.a;
				return _Utils_update(
					model,
					{
						il: A2($elmcraft$core_extra$List$Extra$removeAt, index, customProducts)
					});
			case 4:
				var updatedCustomProducts = _Utils_ap(
					customProducts,
					_List_fromArray(
						[initialCustomProduct]));
				var index = $elm$core$List$length(customProducts);
				return _Utils_update(
					model,
					{
						il: updatedCustomProducts,
						H: A2($author$project$Page$Discovery$CustomField$Update$Edit, index, initialCustomProduct)
					});
			default:
				var subMsg = msg.a;
				var _v4 = model.H;
				if (!_v4.$) {
					var index = _v4.a;
					var customProduct = _v4.b;
					return function (m) {
						return _Utils_update(
							model,
							{
								H: A2($author$project$Page$Discovery$CustomField$Update$Edit, index, m)
							});
					}(
						A2($author$project$Page$Discovery$CustomField$Form$Update$update, subMsg, customProduct));
				} else {
					return model;
				}
		}
	});
var $author$project$Page$Discovery$Farm$Update$updateWeatherBox = function (model) {
	if (model.bq) {
		return model;
	} else {
		var withoutWeatherBox = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(7),
			model.jA);
		var hasASensor = A2($elm$core$List$member, 5, model.jA) || (A2($elm$core$List$member, 4, model.jA) || A2($elm$core$List$member, 6, model.jA));
		return _Utils_update(
			model,
			{
				jA: hasASensor ? A2($elm$core$List$cons, 7, withoutWeatherBox) : withoutWeatherBox
			});
	}
};
var $author$project$Page$Discovery$Farm$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var product = msg.a;
			var isChecked = msg.b;
			var withoutProduct = A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(product),
				model.jA);
			var weatherBoxIndependent = model.bq || (product === 7);
			var newModel = isChecked ? _Utils_update(
				model,
				{
					jA: A2($elm$core$List$cons, product, withoutProduct)
				}) : _Utils_update(
				model,
				{jA: withoutProduct});
			return $author$project$Page$Discovery$Farm$Update$updateWeatherBox(
				_Utils_update(
					newModel,
					{bq: weatherBoxIndependent}));
		} else {
			var subMsg = msg.a;
			return function (m) {
				return _Utils_update(
					model,
					{a6: m});
			}(
				A2($author$project$Page$Discovery$CustomField$Update$update, subMsg, model.a6));
		}
	});
var $author$project$Page$Discovery$Greenhouse$Update$InEdition = function (a) {
	return {$: 0, a: a};
};
var $elmcraft$core_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elmcraft$core_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elmcraft$core_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elmcraft$core_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elmcraft$core_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$Edited = 2;
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$InEdition = 1;
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove = function (quantity) {
	return A2($elm$core$Basics$max, 0, quantity - 1);
};
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var hardware = msg.a;
			switch (hardware) {
				case 3:
					return _Utils_update(
						model,
						{jU: model.jU + 1});
				case 4:
					return _Utils_update(
						model,
						{h_: model.h_ + 1});
				case 5:
					return _Utils_update(
						model,
						{h$: model.h$ + 1});
				case 6:
					return _Utils_update(
						model,
						{jd: model.jd + 1});
				case 7:
					return _Utils_update(
						model,
						{je: model.je + 1});
				case 8:
					return _Utils_update(
						model,
						{j4: model.j4 + 1});
				case 13:
					return _Utils_update(
						model,
						{jI: model.jI + 1});
				default:
					return model;
			}
		} else {
			var hardware = msg.a;
			switch (hardware) {
				case 3:
					return _Utils_update(
						model,
						{
							jU: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.jU)
						});
				case 4:
					return _Utils_update(
						model,
						{
							h_: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.h_)
						});
				case 5:
					return _Utils_update(
						model,
						{
							h$: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.h$)
						});
				case 6:
					return _Utils_update(
						model,
						{
							jd: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.jd)
						});
				case 7:
					return _Utils_update(
						model,
						{
							je: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.je)
						});
				case 8:
					return _Utils_update(
						model,
						{
							j4: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.j4)
						});
				case 13:
					return _Utils_update(
						model,
						{
							jI: $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$remove(model.jI)
						});
				default:
					return model;
			}
		}
	});
var $author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var edited = msg.a;
				var _v1 = model.H;
				if (_v1 === 1) {
					return _Utils_update(
						model,
						{
							H: 2,
							aR: $elm$core$Maybe$Just(edited)
						});
				} else {
					return model;
				}
			case 1:
				var _v2 = model.H;
				if (_v2 === 1) {
					return _Utils_update(
						model,
						{H: 0, aR: $elm$core$Maybe$Nothing});
				} else {
					return model;
				}
			case 2:
				var manualAdjustment = msg.a;
				return _Utils_update(
					model,
					{
						H: 1,
						aR: $elm$core$Maybe$Just(manualAdjustment)
					});
			default:
				var subMsg = msg.a;
				var _v3 = model.aR;
				if (!_v3.$) {
					var subModel = _v3.a;
					return function (m) {
						return _Utils_update(
							model,
							{
								aR: $elm$core$Maybe$Just(m)
							});
					}(
						A2($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Form$Update$update, subMsg, subModel));
				} else {
					return model;
				}
		}
	});
var $author$project$Page$Discovery$Greenhouse$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var product = msg.a;
				return _Utils_update(
					model,
					{
						jA: A2($elm$core$List$cons, product, model.jA)
					});
			case 1:
				var product = msg.a;
				return _Utils_update(
					model,
					{
						jA: A2($elmcraft$core_extra$List$Extra$remove, product, model.jA)
					});
			case 2:
				var toEdition = function (n) {
					return _Utils_update(
						model,
						{
							jg: $author$project$Page$Discovery$Greenhouse$Update$InEdition(
								{bC: n, fu: n})
						});
				};
				var _v1 = model.jg;
				switch (_v1.$) {
					case 0:
						return model;
					case 1:
						var n = _v1.a;
						return toEdition(n);
					default:
						return toEdition(
							$author$project$Page$Discovery$Greenhouse$Update$defaultName(model));
				}
			case 3:
				var newName = msg.a;
				var _v2 = model.jg;
				switch (_v2.$) {
					case 0:
						var initial = _v2.a.bC;
						return _Utils_update(
							model,
							{
								jg: $author$project$Page$Discovery$Greenhouse$Update$InEdition(
									{bC: initial, fu: newName})
							});
					case 1:
						return model;
					default:
						return model;
				}
			case 4:
				var _v3 = model.jg;
				switch (_v3.$) {
					case 0:
						var input = _v3.a.fu;
						return _Utils_update(
							model,
							{
								jg: $author$project$Page$Discovery$Greenhouse$Update$Edited(input)
							});
					case 1:
						return model;
					default:
						return model;
				}
			case 5:
				var _v4 = model.jg;
				switch (_v4.$) {
					case 0:
						var initial = _v4.a.bC;
						return _Utils_update(
							model,
							{
								jg: $author$project$Page$Discovery$Greenhouse$Update$Edited(initial)
							});
					case 1:
						return model;
					default:
						return model;
				}
			case 6:
				return model;
			case 7:
				return model;
			case 8:
				var subMsg = msg.a;
				return function (m) {
					return _Utils_update(
						model,
						{a6: m});
				}(
					A2($author$project$Page$Discovery$CustomField$Update$update, subMsg, model.a6));
			default:
				var subMsg = msg.a;
				return function (m) {
					return _Utils_update(
						model,
						{aR: m});
				}(
					A2($author$project$Page$Discovery$Greenhouse$ManualAdjustment$Update$update, subMsg, model.aR));
		}
	});
var $author$project$Page$Discovery$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = $elm$core$List$length(model.ay);
				var newGreenhouse = A2($author$project$Page$Discovery$Greenhouse$Update$initialModel, model.i$, index);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ay: _Utils_ap(
								model.ay,
								_List_fromArray(
									[newGreenhouse]))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var index = msg.a;
				var subMsg = msg.b;
				var greenhouse = A2($elmcraft$core_extra$List$Extra$getAt, index, model.ay);
				switch (subMsg.$) {
					case 6:
						var i = subMsg.a;
						var updatedGreenhouses = A2(
							$elm$core$List$filter,
							function (g) {
								return !_Utils_eq(g.cN, i);
							},
							model.ay);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ay: updatedGreenhouses}),
							$elm$core$Platform$Cmd$none);
					case 7:
						if (!greenhouse.$) {
							var g = greenhouse.a;
							var newIndex = $elm$core$List$length(model.ay);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ay: _Utils_ap(
											model.ay,
											_List_fromArray(
												[
													_Utils_update(
													g,
													{cN: newIndex})
												]))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					default:
						if (!greenhouse.$) {
							var g = greenhouse.a;
							var updatedGreenhouse = A2($author$project$Page$Discovery$Greenhouse$Update$update, subMsg, g);
							var updatedGreenhouses = A3($elmcraft$core_extra$List$Extra$setAt, index, updatedGreenhouse, model.ay);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ay: updatedGreenhouses}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
				}
			case 2:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							av: A2($author$project$Page$Discovery$Farm$Update$update, subMsg, model.av)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var actuator = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a1: actuator}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Port$Out$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Page$PackingSlip$update = F2(
	function (model, msg) {
		var snippet = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cf: true}),
			$author$project$Port$Out$copyToClipboard(snippet));
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {cN: index, i5: match, jp: number, jX: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{$8: false, jf: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elmcraft$core_extra$String$Extra$regexFromString = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString(str));
};
var $elmcraft$core_extra$String$Extra$cleanRegex = $elmcraft$core_extra$String$Extra$regexFromString('\\s+');
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$String$trim = _String_trim;
var $elmcraft$core_extra$String$Extra$clean = function (string) {
	return $elm$core$String$trim(
		A3(
			$elm$regex$Regex$replace,
			$elmcraft$core_extra$String$Extra$cleanRegex,
			$elm$core$Basics$always(' '),
			string));
};
var $elmcraft$core_extra$String$Extra$rightOf = F2(
	function (pattern, string) {
		var _v0 = A2($elm$core$String$indexes, pattern, string);
		if (!_v0.b) {
			return '';
		} else {
			var firstIndex = _v0.a;
			return A3(
				$elm$core$String$slice,
				$elm$core$String$length(pattern) + firstIndex,
				$elm$core$String$length(string),
				string);
		}
	});
var $author$project$Page$QuoteBuilderV3$Client$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var firstName = msg.a;
				return _Utils_update(
					model,
					{gG: firstName});
			case 1:
				var lastName = msg.a;
				return _Utils_update(
					model,
					{g3: lastName});
			case 2:
				var farmName = msg.a;
				return _Utils_update(
					model,
					{iG: farmName});
			case 3:
				var farmAddress = msg.a;
				return _Utils_update(
					model,
					{iF: farmAddress});
			case 4:
				var email = msg.a;
				return _Utils_update(
					model,
					{ix: email});
			case 5:
				var language = msg.a;
				return _Utils_update(
					model,
					{i$: language});
			default:
				var currency = msg.a;
				return _Utils_update(
					model,
					{ik: currency});
		}
	});
var $author$project$Page$QuoteBuilderV3$Discount$Update$Edit = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elmcraft$core_extra$Maybe$Extra$andMap = F2(
	function (ma, mb) {
		if (!ma.$) {
			var o = ma.a;
			if (!mb.$) {
				var fn = mb.a;
				return $elm$core$Maybe$Just(
					fn(o));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$build = function (model) {
	var validUntil = $elm$core$String$isEmpty(model.aF) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.aF);
	var durationInMonths = $elm$core$String$isEmpty(model.au) ? $elm$core$Maybe$Nothing : $elm$core$String$toInt(model.au);
	var discountType = function () {
		var _v0 = model.aH;
		if (!_v0) {
			return A2(
				$elmcraft$core_extra$Maybe$Extra$andMap,
				$elm$core$String$toInt(model.jC),
				A2(
					$elmcraft$core_extra$Maybe$Extra$andMap,
					$elm$core$String$toInt(model.jY),
					$elm$core$Maybe$Just(
						F2(
							function (s, p) {
								return $author$project$Page$QuoteBuilderV3$Quote$Amount(
									{jC: p, jY: s});
							}))));
		} else {
			return A2(
				$elmcraft$core_extra$Maybe$Extra$andMap,
				$elm$core$String$toInt(model.jC),
				A2(
					$elmcraft$core_extra$Maybe$Extra$andMap,
					$elm$core$String$toInt(model.jY),
					$elm$core$Maybe$Just(
						F2(
							function (s, p) {
								return $author$project$Page$QuoteBuilderV3$Quote$Percentage(
									{jC: p, jY: s});
							}))));
		}
	}();
	return A2(
		$elm$core$Maybe$map,
		function (t) {
			return A5($author$project$Page$QuoteBuilderV3$Quote$Discount, model.jg, t, durationInMonths, validUntil, $elm$core$Maybe$Nothing);
		},
		discountType);
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$initialModel = {aH: 1, au: '', jg: '', jC: '0', jY: '0', aF: ''};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$fromDiscount = function (discount) {
	var named = _Utils_update(
		$author$project$Page$QuoteBuilderV3$Discount$Form$Update$initialModel,
		{
			au: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, discount.au)),
			jg: discount.jg,
			aF: A2($elm$core$Maybe$withDefault, '', discount.aF)
		});
	var _v0 = discount.aH;
	if (!_v0.$) {
		var subscription = _v0.a.jY;
		var purchase = _v0.a.jC;
		return _Utils_update(
			named,
			{
				aH: 1,
				jC: $elm$core$String$fromInt(purchase),
				jY: $elm$core$String$fromInt(subscription)
			});
	} else {
		var subscription = _v0.a.jY;
		var purchase = _v0.a.jC;
		return _Utils_update(
			named,
			{
				aH: 0,
				jC: $elm$core$String$fromInt(purchase),
				jY: $elm$core$String$fromInt(subscription)
			});
	}
};
var $author$project$Page$QuoteBuilderV3$Discount$Update$initialDiscount = {
	aH: $author$project$Page$QuoteBuilderV3$Quote$Percentage(
		{jC: 10, jY: 10}),
	au: $elm$core$Maybe$Nothing,
	jg: '',
	jy: $elm$core$Maybe$Nothing,
	aF: $elm$core$Maybe$Nothing
};
var $author$project$Page$QuoteBuilderV3$Discount$Form$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_update(
					model,
					{jg: name});
			case 1:
				var discountType = msg.a;
				return _Utils_update(
					model,
					{aH: discountType});
			case 2:
				var str = msg.a;
				return _Utils_update(
					model,
					{jY: str});
			case 3:
				var str = msg.a;
				return _Utils_update(
					model,
					{jC: str});
			case 4:
				var str = msg.a;
				return _Utils_update(
					model,
					{au: str, aF: ''});
			default:
				var str = msg.a;
				return _Utils_update(
					model,
					{au: '', aF: str});
		}
	});
var $author$project$Page$QuoteBuilderV3$Discount$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var discount = A2($elmcraft$core_extra$List$Extra$getAt, index, model.ch);
				if (!discount.$) {
					var d = discount.a;
					return function (m) {
						return _Utils_update(
							model,
							{
								H: A2($author$project$Page$QuoteBuilderV3$Discount$Update$Edit, index, m)
							});
					}(
						$author$project$Page$QuoteBuilderV3$Discount$Form$Update$fromDiscount(d));
				} else {
					return model;
				}
			case 1:
				var _v2 = model.H;
				if (!_v2.$) {
					var index = _v2.a;
					var edited = _v2.b;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_update(
							model,
							{H: $author$project$Page$QuoteBuilderV3$Discount$Update$Edited}),
						A2(
							$elm$core$Maybe$map,
							function (built) {
								return _Utils_update(
									model,
									{
										ch: A3($elmcraft$core_extra$List$Extra$setAt, index, built, model.ch),
										H: $author$project$Page$QuoteBuilderV3$Discount$Update$Edited
									});
							},
							$author$project$Page$QuoteBuilderV3$Discount$Form$Update$build(edited)));
				} else {
					return model;
				}
			case 2:
				var _v3 = model.H;
				if (!_v3.$) {
					var index = _v3.a;
					var possibleNewCustomDiscount = A2($elmcraft$core_extra$List$Extra$getAt, index, model.ch);
					return (!_Utils_eq(
						possibleNewCustomDiscount,
						$elm$core$Maybe$Just($author$project$Page$QuoteBuilderV3$Discount$Update$initialDiscount))) ? _Utils_update(
						model,
						{H: $author$project$Page$QuoteBuilderV3$Discount$Update$Edited}) : _Utils_update(
						model,
						{
							ch: A2($elmcraft$core_extra$List$Extra$removeAt, index, model.ch),
							H: $author$project$Page$QuoteBuilderV3$Discount$Update$Edited
						});
				} else {
					return model;
				}
			case 3:
				var index = msg.a;
				return _Utils_update(
					model,
					{
						ch: A2($elmcraft$core_extra$List$Extra$removeAt, index, model.ch)
					});
			case 4:
				var updatedCustomDiscounts = _Utils_ap(
					model.ch,
					_List_fromArray(
						[$author$project$Page$QuoteBuilderV3$Discount$Update$initialDiscount]));
				var index = $elm$core$List$length(model.ch);
				return _Utils_update(
					model,
					{
						ch: updatedCustomDiscounts,
						H: A2($author$project$Page$QuoteBuilderV3$Discount$Update$Edit, index, $author$project$Page$QuoteBuilderV3$Discount$Form$Update$initialModel)
					});
			default:
				var subMsg = msg.a;
				var _v4 = model.H;
				if (!_v4.$) {
					var index = _v4.a;
					var subModel = _v4.b;
					return function (m) {
						return _Utils_update(
							model,
							{
								H: A2($author$project$Page$QuoteBuilderV3$Discount$Update$Edit, index, m)
							});
					}(
						A2($author$project$Page$QuoteBuilderV3$Discount$Form$Update$update, subMsg, subModel));
				} else {
					return model;
				}
		}
	});
var $author$project$Page$QuoteBuilderV3$CustomField$Update$Edit = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$QuoteBuilderV3$CustomField$Form$Update$update = F2(
	function (msg, model) {
		var price = model.jz;
		var parse = function (str) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		};
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_update(
					model,
					{jg: name});
			case 1:
				var amount = msg.a;
				if (!price.$) {
					var purchase = price.a.jC;
					return _Utils_update(
						model,
						{
							jz: A2(
								$author$project$Page$QuoteBuilderV3$Quote$normalPrice,
								parse(amount),
								purchase)
						});
				} else {
					return _Utils_update(
						model,
						{
							jz: $author$project$Page$QuoteBuilderV3$Quote$subscriptionOnly(
								parse(amount))
						});
				}
			case 2:
				var amount = msg.a;
				if (!price.$) {
					var subscription = price.a.jY;
					return _Utils_update(
						model,
						{
							jz: A2(
								$author$project$Page$QuoteBuilderV3$Quote$normalPrice,
								subscription,
								parse(amount))
						});
				} else {
					return _Utils_update(
						model,
						{
							jz: $author$project$Page$QuoteBuilderV3$Quote$subscriptionOnly(
								parse(amount))
						});
				}
			default:
				var quantity = msg.a;
				return _Utils_update(
					model,
					{
						jD: parse(quantity)
					});
		}
	});
var $author$project$Page$QuoteBuilderV3$CustomField$Update$update = F2(
	function (msg, model) {
		var initialCustomProduct = {
			jg: '',
			jz: A2($author$project$Page$QuoteBuilderV3$Quote$normalPrice, 0, 0),
			jD: 0
		};
		var customProducts = model.il;
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var customProduct = A2($elmcraft$core_extra$List$Extra$getAt, index, customProducts);
				if (!customProduct.$) {
					var c = customProduct.a;
					return _Utils_update(
						model,
						{
							H: A2($author$project$Page$QuoteBuilderV3$CustomField$Update$Edit, index, c)
						});
				} else {
					return model;
				}
			case 1:
				var _v2 = model.H;
				if (!_v2.$) {
					var index = _v2.a;
					var edited = _v2.b;
					return _Utils_update(
						model,
						{
							il: A3($elmcraft$core_extra$List$Extra$setAt, index, edited, customProducts),
							H: $author$project$Page$QuoteBuilderV3$CustomField$Update$Edited
						});
				} else {
					return model;
				}
			case 2:
				var _v3 = model.H;
				if (!_v3.$) {
					var index = _v3.a;
					var possibleNewCustomProduct = A2($elmcraft$core_extra$List$Extra$getAt, index, customProducts);
					return (!_Utils_eq(
						possibleNewCustomProduct,
						$elm$core$Maybe$Just(initialCustomProduct))) ? _Utils_update(
						model,
						{H: $author$project$Page$QuoteBuilderV3$CustomField$Update$Edited}) : _Utils_update(
						model,
						{
							il: A2($elmcraft$core_extra$List$Extra$removeAt, index, customProducts),
							H: $author$project$Page$QuoteBuilderV3$CustomField$Update$Edited
						});
				} else {
					return model;
				}
			case 3:
				var index = msg.a;
				return _Utils_update(
					model,
					{
						il: A2($elmcraft$core_extra$List$Extra$removeAt, index, customProducts)
					});
			case 4:
				var updatedCustomProducts = _Utils_ap(
					customProducts,
					_List_fromArray(
						[initialCustomProduct]));
				var index = $elm$core$List$length(customProducts);
				return _Utils_update(
					model,
					{
						il: updatedCustomProducts,
						H: A2($author$project$Page$QuoteBuilderV3$CustomField$Update$Edit, index, initialCustomProduct)
					});
			default:
				var subMsg = msg.a;
				var _v4 = model.H;
				if (!_v4.$) {
					var index = _v4.a;
					var customProduct = _v4.b;
					return function (m) {
						return _Utils_update(
							model,
							{
								H: A2($author$project$Page$QuoteBuilderV3$CustomField$Update$Edit, index, m)
							});
					}(
						A2($author$project$Page$QuoteBuilderV3$CustomField$Form$Update$update, subMsg, customProduct));
				} else {
					return model;
				}
		}
	});
var $author$project$Page$QuoteBuilderV3$Farm$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var product = msg.a;
				return _Utils_update(
					model,
					{
						jA: A2($elmcraft$core_extra$List$Extra$remove, product, model.jA)
					});
			case 1:
				var product = msg.a;
				return _Utils_update(
					model,
					{
						jA: A2($elm$core$List$cons, product, model.jA)
					});
			case 2:
				return _Utils_update(
					model,
					{bK: !model.bK});
			default:
				var subMsg = msg.a;
				return function (m) {
					return _Utils_update(
						model,
						{a6: m});
				}(
					A2($author$project$Page$QuoteBuilderV3$CustomField$Update$update, subMsg, model.a6));
		}
	});
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$InEdition = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$QuoteBuilderV3$Greenhouse$Update$update = F3(
	function (client, msg, model) {
		switch (msg.$) {
			case 0:
				var product = msg.a;
				var updateProducts = function (products) {
					return _Utils_update(
						model,
						{
							jA: A2($elm$core$List$cons, product, products)
						});
				};
				var updateProductsWithout = function (unwanted) {
					return updateProducts(
						A2(
							$elm$core$List$filter,
							function (p) {
								return !_Utils_eq(p, unwanted);
							},
							model.jA));
				};
				switch (product) {
					case 17:
						return updateProductsWithout(18);
					case 18:
						return updateProductsWithout(17);
					default:
						return updateProducts(model.jA);
				}
			case 1:
				var product = msg.a;
				return _Utils_update(
					model,
					{
						jA: A2($elmcraft$core_extra$List$Extra$remove, product, model.jA)
					});
			case 2:
				return _Utils_update(
					model,
					{bK: !model.bK});
			case 3:
				var subMsg = msg.a;
				return function (m) {
					return _Utils_update(
						model,
						{a6: m});
				}(
					A2($author$project$Page$QuoteBuilderV3$CustomField$Update$update, subMsg, model.a6));
			case 4:
				var toEdition = function (n) {
					return _Utils_update(
						model,
						{
							jg: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$InEdition(
								{bC: n, fu: n})
						});
				};
				var _v2 = model.jg;
				switch (_v2.$) {
					case 0:
						return model;
					case 1:
						var n = _v2.a;
						return toEdition(n);
					default:
						return toEdition(
							A2($author$project$Page$QuoteBuilderV3$Greenhouse$Update$defaultName, client.i$, model));
				}
			case 5:
				var newName = msg.a;
				var _v3 = model.jg;
				switch (_v3.$) {
					case 0:
						var initial = _v3.a.bC;
						return _Utils_update(
							model,
							{
								jg: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$InEdition(
									{bC: initial, fu: newName})
							});
					case 1:
						return model;
					default:
						return model;
				}
			case 6:
				var _v4 = model.jg;
				switch (_v4.$) {
					case 0:
						var input = _v4.a.fu;
						return _Utils_update(
							model,
							{
								jg: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Edited(input)
							});
					case 1:
						return model;
					default:
						return model;
				}
			case 7:
				var _v5 = model.jg;
				switch (_v5.$) {
					case 0:
						var initial = _v5.a.bC;
						return _Utils_update(
							model,
							{
								jg: $author$project$Page$QuoteBuilderV3$Greenhouse$Update$Edited(initial)
							});
					case 1:
						return model;
					default:
						return model;
				}
			case 8:
				return model;
			default:
				return model;
		}
	});
var $author$project$Page$QuoteBuilderV3$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = $elm$core$List$length(model.ay);
				var newGreenhouse = $author$project$Page$QuoteBuilderV3$Greenhouse$Update$initialModel(index);
				return _Utils_update(
					model,
					{
						ay: _Utils_ap(
							model.ay,
							_List_fromArray(
								[newGreenhouse]))
					});
			case 1:
				var subMsg = msg.a;
				return _Utils_update(
					model,
					{
						bx: A2($author$project$Page$QuoteBuilderV3$Client$update, subMsg, model.bx)
					});
			case 2:
				var str = msg.a;
				var withoutPrefix = A2($elmcraft$core_extra$String$Extra$rightOf, 'PRJ-', str);
				var projectId = (!$elm$core$String$isEmpty(withoutPrefix)) ? withoutPrefix : str;
				return _Utils_update(
					model,
					{
						dH: $elmcraft$core_extra$String$Extra$clean(projectId)
					});
			case 3:
				var customerId = msg.a;
				return _Utils_update(
					model,
					{gw: customerId});
			case 4:
				var subMsg = msg.a;
				return _Utils_update(
					model,
					{
						gy: A2($author$project$Page$QuoteBuilderV3$Discount$Update$update, subMsg, model.gy)
					});
			case 5:
				var index = msg.a;
				var subMsg = msg.b;
				var greenhouse = A2($elmcraft$core_extra$List$Extra$getAt, index, model.ay);
				switch (subMsg.$) {
					case 8:
						var i = subMsg.a;
						var updatedGreenhouses = A2(
							$elm$core$List$filter,
							function (g) {
								return !_Utils_eq(g.cN, i);
							},
							model.ay);
						return _Utils_update(
							model,
							{ay: updatedGreenhouses});
					case 9:
						if (!greenhouse.$) {
							var g = greenhouse.a;
							var newIndex = $elm$core$List$length(model.ay);
							return _Utils_update(
								model,
								{
									ay: _Utils_ap(
										model.ay,
										_List_fromArray(
											[
												_Utils_update(
												g,
												{cN: newIndex})
											]))
								});
						} else {
							return model;
						}
					default:
						if (!greenhouse.$) {
							var g = greenhouse.a;
							var updatedGreenhouse = A3($author$project$Page$QuoteBuilderV3$Greenhouse$Update$update, model.bx, subMsg, g);
							var updatedGreenhouses = A3($elmcraft$core_extra$List$Extra$setAt, index, updatedGreenhouse, model.ay);
							return _Utils_update(
								model,
								{ay: updatedGreenhouses});
						} else {
							return model;
						}
				}
			default:
				var subMsg = msg.a;
				return _Utils_update(
					model,
					{
						av: A2($author$project$Page$QuoteBuilderV3$Farm$Update$update, subMsg, model.av)
					});
		}
	});
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Update$updateUrl = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var quoteV3Param = $author$project$Page$QuoteBuilderV3$QuoteUrl$queryParam(
		$author$project$Page$QuoteBuilderV3$Update$toQuote(model.ag));
	var discoveryParam = $author$project$Route$Quote$Entry$queryParam(
		$author$project$Page$Discovery$Update$toQuote(model.aI));
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{bH: $elm$core$Maybe$Nothing}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					A2(
					$elm$browser$Browser$Navigation$replaceUrl,
					model.fJ,
					A2(
						$elm$url$Url$Builder$absolute,
						_List_Nil,
						_List_fromArray(
							[discoveryParam, quoteV3Param])))
				])));
};
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var subMsg = msg.a;
				return $author$project$Update$updateUrl(
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Update$DiscoveryMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (m) {
								return _Utils_update(
									model,
									{aI: m});
							},
							A2($author$project$Page$Discovery$Update$update, subMsg, model.aI))));
			case 2:
				var subMsg = msg.a;
				return $author$project$Update$updateUrl(
					_Utils_Tuple2(
						function (m) {
							return _Utils_update(
								model,
								{ag: m});
						}(
							A2($author$project$Page$QuoteBuilderV3$Update$update, subMsg, model.ag)),
						$elm$core$Platform$Cmd$none));
			case 3:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Update$PackingSlipMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (m) {
							return _Utils_update(
								model,
								{dv: m});
						},
						A2($author$project$Page$PackingSlip$update, model.dv, subMsg)));
			case 4:
				var page = msg.a;
				if (_Utils_eq(model.bG, page)) {
					var _default = $linuss$smooth_scroll$SmoothScroll$defaultConfig;
					var scroll = A2(
						$linuss$smooth_scroll$SmoothScroll$scrollToWithOptions,
						_Utils_update(
							_default,
							{jV: 50}),
						$author$project$Update$topAnchor);
					var cmd = A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Update$NoOp),
						A2(
							$elm$core$Task$andThen,
							$elm$core$Basics$always(scroll),
							$elm$core$Process$sleep(10)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bG: page}),
						cmd);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bG: page}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				var now = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dn: $elm$core$Maybe$Just(now)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var zone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							er: $elm$core$Maybe$Just(zone)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Update$LoginMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (m) {
							return _Utils_update(
								model,
								{c2: m});
						},
						A2($author$project$Login$Page$update, subMsg, model.c2)));
			case 8:
				var html = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cH: html}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d2: 1}),
					$author$project$Update$saveQuote(model));
			case 10:
				var result = msg.a;
				var _v1 = function () {
					if (!result.$) {
						var url = result.a;
						return _Utils_Tuple2(
							0,
							$elm$core$Maybe$Just(url));
					} else {
						return _Utils_Tuple2(2, $elm$core$Maybe$Nothing);
					}
				}();
				var savingState = _v1.a;
				var pdfUrl = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bH: pdfUrl, d2: savingState}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $elm$file$File$Download$url, model.bH)));
			case 12:
				return $author$project$Update$print(model);
			case 13:
				var selectedLanguage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{i$: selectedLanguage}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var token = msg.a;
				var user = $author$project$Domain$User$decode(
					$elm$core$Maybe$Just(token));
				var language = A2(
					$elm$core$Maybe$withDefault,
					model.i$,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.i$;
						},
						user));
				var _v3 = function () {
					var _v4 = $author$project$Page$QuoteBuilderV3$QuoteUrl$quoteFromUrl(model.bS);
					if (!_v4.$) {
						if (!_v4.a.$) {
							var quoteV3 = _v4.a.a;
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(quoteV3),
								$elm$core$Maybe$Nothing);
						} else {
							var error = _v4.a.a;
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(error));
						}
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				}();
				var quoteV3FromUrl = _v3.a;
				var discoveryQuoteBuilderError = _v3.b;
				var clientLanguage = A2(
					$elm$core$Maybe$withDefault,
					1,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bx;
							},
							function ($) {
								return $.i$;
							}),
						quoteV3FromUrl));
				var _v5 = function () {
					var _v6 = $author$project$Route$Quote$Entry$parseQuote(model.bS);
					if (!_v6.$) {
						if (!_v6.a.$) {
							var quote = _v6.a.a;
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(quote),
								$elm$core$Maybe$Nothing);
						} else {
							var error = _v6.a.a;
							return _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								$elm$core$Maybe$Just(error));
						}
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				}();
				var quoteFromUrl = _v5.a;
				var discoveryError = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aI: A2($author$project$Page$Discovery$Update$initialModel, clientLanguage, quoteFromUrl),
							fe: discoveryError,
							ff: discoveryQuoteBuilderError,
							i$: language,
							ag: A2($author$project$Page$QuoteBuilderV3$Update$initialModel, user, quoteV3FromUrl),
							bT: user
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				return $author$project$Update$updateUrl(
					_Utils_Tuple2(
						$author$project$Update$resetForms(
							_Utils_update(
								model,
								{bT: $elm$core$Maybe$Nothing})),
						$author$project$Port$Out$deleteSession(0)));
			default:
				return $author$project$Update$updateUrl(
					_Utils_Tuple2(
						$author$project$Update$resetForms(model),
						$elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		iX: $author$project$Update$init,
		jr: function (_v0) {
			return $author$project$Update$NoOp;
		},
		js: function (_v1) {
			return $author$project$Update$NoOp;
		},
		jZ: function (_v2) {
			return $author$project$Subscriptions$subscriptions;
		},
		j6: $author$project$Update$update,
		ka: $author$project$Main$mainView
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (token) {
			return $elm$json$Json$Decode$succeed(
				{j3: token});
		},
		A2(
			$elm$json$Json$Decode$field,
			'token',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))))(0)}});}(this));